import { DateTime } from 'luxon';
import { BasicSelectOption, DefaultValueDict } from '../Interfaces/IApplicationForm';
import { AccExpSesssions, AccSecTypeClass, DashboardItems, DMSessionsResult, EMARKET_EQUITY_POOLS, EPayments, E_IQX_ACCOUNT_TYPES, E_IQX_POOLS, IMarginTiles, IMessage, MARKET_EQUITY_PAYMENT_POOLS, ProfileSesssions, PushNotification, SubIBs, TierClass, TreePathDefaultProfile, UserPermissionOBjectClass } from '../Interfaces/Interfaces';
import { ActionMessage, IPerms, PushNotificationStatus } from '../redux/constants';
import store from '../redux/store';
import { ExternalRoutes } from '../Routes';

declare var window: any;
const $ = require("jquery");
const _ = require('lodash');
const cloneDeep = require('lodash/cloneDeep');
declare var require: any
const timezones: any = require("compact-timezone-list");
const luxonIgnoredTimezones: any = {
    'Antarctica/DumontDUrville': true
};
const moment: any = require('moment');
var crypto = require('crypto');
export const VERSION = "2.10.1";
export const FILETYPE_SPREADSHEET = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
export const FILE_EXTENSION_XLSX = '.xlsx';
export function perOptFunction() {
    var perOpt = [
        { value: "hour", label: "Per Hour" },
        { value: "day", label: "Per Day" },
        { value: "mnth", label: "Per Month" },
        { value: "yr", label: "Per Year" }
    ];

    return perOpt;
}
export function ActionTypeOptFunction() {
    var ActionTypeOpt = [
        { value: "-1", label: "Choose Action Type" },
        { value: "Full", label: "Full" },
        { value: "Close Master Trades", label: "Close Master Trades" },
        { value: "Close Slave Trades", label: "Close Slave Trades" },
        { value: "Manage Investors Status", label: "Manage Investors Status" },
        { value: "Manage Allocation Rule Amount", label: "Manage Allocation Rule Amount" },
        { value: "Manage Allocation Rule", label: "Manage Allocation Rule" }
    ];
    return ActionTypeOpt;
}

export function RequestStatusOpFunction() {
    var RequestStatusOp = [
        { value: "1", label: "Approved" },
        { value: "-1", label: "Declined" }
    ];
    return RequestStatusOp;
}
export function RequestStatusOp2Function() {
    var RequestStatusOp = [
        { value: "0", label: "Queued Requests" },
        { value: "1", label: "Delayed Requests" }
    ];
    return RequestStatusOp;
}
export function RequestTypeOpFunction() {
    var RequestTypeOp = [
        { value: "Auto Copy", label: "Auto Copy" },
        { value: "Admin Account", label: "Admin Account" },
        { value: "Account Info", label: "Account Info" },
        { value: "Delete Account", label: "Delete Account" },
        { value: "Deposit", label: "Deposit" },
        { value: "External Transfer", label: "External Transfer" },
        { value: "Internal Transfer", label: "Internal Transfer" },
        { value: "Withdrawal", label: "Withdrawal" },
        { value: "New Account", label: "New Account" }];
    return RequestTypeOp;
}

export function CommisionOptionsFunction() {
    var CommisionOptions = [
        { value: "1", label: "Commission Trade Lot-CTL" },
        { value: "2", label: "Commission Trade Perc-CTP" },
        { value: "0", label: "Both" }
    ];
    return CommisionOptions;
}

export function AllMonthsOptionsFunction() {
    var monthOpt = [
        { value: "01", label: "January" },
        { value: "02", label: "February" },
        { value: "03", label: "March" },
        { value: "04", label: "April" },
        { value: "05", label: "May" },
        { value: "06", label: "June" },
        { value: "07", label: "July" },
        { value: "08", label: "August" },
        { value: "09", label: "September" },
        { value: "10", label: "October" },
        { value: "11", label: "November" },
        { value: "12", label: "December" },
    ];
    return monthOpt;
}
//translation add here 
export const MaritalStatusOpt = [
    { value: "Single", label: "Single" },
    { value: "Engaged", label: "Engaged" },
    { value: "Married", label: "Married" }
]
//#region Investor Options
export const EducationOptions = [
    { value: "-1", label: "Select" },
    { value: "High school", label: "High school" },
    { value: "College", label: "College" },
    { value: "Graduate", label: "Graduate" },
    { value: "Doctorate", label: "Doctorate" }
]
export const PreviousPositionOptions = [
    { value: "-1", label: "-Choose Position-" },
    { value: "Assistant", label: "Assistant" },
    { value: "Administrator", label: "Administrator" },
    { value: "Advisor", label: "Advisor" },
    { value: "Chairman", label: "Chairman" },
    { value: "Clerk", label: "Clerk" },
    { value: "Coordinator", label: "Coordinator" },
    { value: "Director", label: "Coordinator" },
    { value: "Executive", label: "Coordinator" },
    { value: "Head of Department", label: "Head of Department" },
    { value: "Manager", label: "Manager" },
    { value: "Supervisor", label: "Supervisor" },
]
export const IndustryCurrentEmploymentOptions = [
    { value: "-1", label: " -Choose Industry-" },
    { value: "AccountingAudit", label: "Accounting/audit" },
    { value: "Administrative", label: "Administrative" },
    { value: "Agriculture &amp; Agribusiness", label: "Agriculture &amp; Agribusiness" },
    { value: "Banking", label: "Banking" },
    { value: "Beauty &amp; Cosmetics", label: "Beauty &amp; Cosmetics" },
    { value: "Catering", label: "Catering" },
    { value: "Construction", label: "Construction" },
    { value: "Education", label: "Education" },
    { value: "Engineering", label: "Engineering" },
    { value: "Financial Services", label: "Financial Services" },
    { value: "Government", label: "Government" },
    { value: "Healthcare", label: "Healthcare" },
    { value: "Hospitality", label: "Hospitality" },
    { value: "HR", label: "HR" },
    { value: "IT", label: "IT" },
    { value: "Legal Services", label: "Legal Services" },
    { value: "Leisure", label: "Leisure" },
    { value: "Marketing", label: "Marketing" },
    { value: "Media &amp; Broadcasting", label: "Media &amp; Broadcasting" },
    { value: "Pharmaceuticals", label: "Pharmaceuticals" },
    { value: "Real Estate", label: "Real Estate" },
    { value: "Retail", label: "Retail" },
    { value: "Sales", label: "Sales" },
    { value: "SocialCare", label: "Social Care" },
    { value: "Telecommunications", label: "Telecommunications" },
    { value: "Travel and Tourism", label: "Travel and Tourism" },
    { value: "Other", label: "Other" }
]
export const unavailableTINtOptions = [
    { value: "-1", label: " -ChooseAnswer-" },
    { value: "CountryNotIssueTINToResidents", label: "CountryNotIssueTINToResidents" },
    { value: "NoTINRequiredInRegion", label: "NoTINRequiredInRegion" },
    { value: "Other", label: "Other" },

]
export const EmploymentStatusOptions = [
    { value: "-1", label: 'ChooseStatus' },
    { value: "EmployedPartTime", label: 'EmployedPartTime' },
    { value: "Employed", label: 'EmployedFullTimeNotSenior' },
    { value: "EmployedFullTimeSenior", label: 'EmployedFullTimeSenior' },
    { value: "Property owner", label: 'PropertyOwner' },
    { value: "Self-Employed", label: 'SelfEmployed' },
    { value: "Student", label: 'Student' },
    { value: "Retired", label: 'Retired' },
    { value: "Unemployed", label: 'Unemployed' },
]

//#endregion

// #region Trading Experience Options

export const MonthlyAverageVolumeOptions = [
    { value: "-1", label: 'ChooseAverage' },
    { value: "Less than 1 Million", label: 'LessThanOneMillion' },
    { value: "1-5 Million", label: 'OneToFiveMillion' },
    { value: "5-50 Million", label: 'FiveToFiftyMillion' },
    { value: "Over 50 Million", label: 'OverFiftyMillion' }
];

export const PurposeAndNatureOfTradingOptions = [
    { value: "-1", label: 'ChoosePurpose' },
    { value: "Speculative", label: 'Speculative' },
    { value: "Hedging", label: 'Hedging' },
    { value: "Investment", label: 'Investment' },
    { value: "Income", label: 'Income' },
    { value: "Other", label: 'Other' },
];

export const PurposeOfOpeningTheAccountOptions = [
    { value: "-1", label: 'ChoosePurpose' },
    { value: "Speculation", label: 'Speculation' },
    { value: "Hedging", label: 'Hedging' },
];

export const CurrentLevelOfKnowledgeOptions = [
    { value: "-1", label: 'ChooseLevel' },
    { value: "None/ Limited/ Basic experience", label: 'NoneLimitedBasicExperience' },
    { value: "Experience in mainstream financial products", label: 'ExperienceInMainstreamFinancialProducts' },
    { value: "Experience in most financial products", label: 'ExperienceInMostFinancialProducts' },
    { value: "Professional Investor or frequent traders", label: 'ProfessionalInvestorOrFrequentTraders' }
];

export const HowLongHaveYouTradedForexOptions = [
    { value: "-1", label: 'ChoosePeriod' },
    { value: "No experience", label: 'NoExperience' },
    { value: "Less than 1 Year", label: 'LessThanOneYear' },
    { value: "1-5 years", label: 'OneToFiveYears' },
    { value: "Greater than 5 years", label: 'GreaterThanFiveYears' }
];

export const HowManyTradesDoYouPlaceEachMonthOptions = [
    { value: "-1", label: 'ChoosePlacements' },
    { value: "0-3", label: "0 - 3 " },
    { value: "4-10", label: " 4 - 10 " },
    { value: "11-50", label: " 11 - 50" },
    { value: "greater than 50", label: 'GreaterThanFifty' }
];

export const OverWhatTimeframeHaveYouHeldPositionsOptions = [
    { value: "-1", label: 'ChooseTimeframe' },
    { value: "Always less than 1 month", label: 'AlwaysLessThanOneMonth' },
    { value: "Both less and more than 1 month", label: 'BothLessAndMoreThanOneMonth' },
    { value: "I have never traded before", label: 'IHaveNeverTradedBefore' }
];

export const StocksMutualFundsBondsEquitiesOptions = [
    { value: "-1", label: 'ChooseExtent' },
    { value: "Never or rarely", label: 'NeverOrRarely' },
    { value: "Occasionally (up to 25 trades per year)", label: 'Occasionally' },
    { value: "Regularly (between 25 to 100 trades per year)", label: 'Regularly' },
    { value: "Frequently (over 100 trades per year)", label: 'Frequently' },
];

export const DerivativesSuchAsFuturesOptionsSwapsOptions = [
    { value: "-1", label: 'ChooseExtent' },
    { value: "Never or rarely", label: 'NeverOrRarely' },
    { value: "Occasionally (up to 25 trades per year)", label: 'Occasionally' },
    { value: "Regularly (between 25 to 100 trades per year)", label: 'Regularly' },
    { value: "Frequently (over 100 trades per year)", label: 'Frequently' },
];

export const ForexRollingSpotFXSpreadBetsOptions = [
    { value: "-1", label: 'ChooseExtent' },
    { value: "Never or rarely", label: 'NeverOrRarely' },
    { value: "Occasionally(up to 25 trades per year)", label: 'Occasionally' },
    { value: "Regularly(between 25 to 100 trades per year)", label: 'Regularly' },
    { value: "Frequently (over 100 trades per year)", label: 'Frequently' },
];

export const WhatWasTheAverageYearlyVolumeOptions = [
    { value: "-1", label: 'ChooseAverage' },
    { value: "I never invested", label: 'I never invested' },
    { value: "Less than €1000", label: 'Less than €1000' },
    { value: "Between €1000 to €5,000", label: 'Between €1000 to €5, 000' },
    { value: "Between €5,000 to €25,000", label: 'Between €5, 000 to €25, 000' },
    { value: "Over €25,000", label: ' Over €25, 000' }

];

export const WhatWasTheAverageLevelOfLeverageOptions = [
    { value: "-1", label: 'ChooseAverage' },
    { value: 'I never used leverage', label: 'INeverUsedLeverage' },
    { value: 'Lower than 1:10', label: 'Lower than 1: 10' },
    { value: 'Between 1:10 - 1:25', label: ' Between 1: 10 - 1: 25' },
    { value: 'Between 1:25 - 1:50', label: ' Between 1: 25 - 1: 50' },
    { value: 'Between 1:50 - 1:100', label: ' Between 1: 50 - 1: 100' },
    { value: 'Higher than 1:100', label: ' Higher than 1: 100' }
];

export const MaximumLeverageUsedOptions = [
    { value: '-1', label: 'ChooseAverage' },
    { value: 'I have never used leverage', label: 'INeverUsedLeverage' },
    { value: 'Up to 5:1', label: ' Up to 5:1' },
    { value: 'Up to 30:1', label: ' Up to 30:1' },
    { value: 'Up to 100:1', label: ' Up to 100:1' },
    { value: '>100:1', label: '>100:1 ' },
];
// #endregion
//#region trading knowledge selects
export const EducationalQualificationOptions = [
    { value: '-1', label: 'ChooseQualification' },
    { value: 'University Degree or post graduate', label: 'UniversityDegreeOrPostGraduate' },
    { value: 'Seminars relevant to the CFDs leverage products', label: 'SeminarsRelevantToTheCFDs' },
    { value: 'Other', label: 'Other' },
    { value: 'Up to 100:1', label: 'Up to 100:1' },
    { value: 'None', label: 'None' },
];
export const TheStopLossOrderIsUsedToOptions = [
    { value: '-1', label: 'ChooseUsage' },
    { value: 'Reduce / Limit the loss', label: 'ReduceLimitTheLoss' },
    { value: 'Increase Loss', label: 'IncreaseLoss' },
];
export const InvestmentOptions = [
    { value: '-1', label: 'ChooseInvestment' },
    { value: 'CFDs', label: 'CFDs' },
    { value: 'ETFs', label: 'ETFs' },
    { value: 'Shares', label: 'Shares' },
    { value: 'Real estate', label: 'Realestate' },
    { value: 'Bank Bonds', label: 'BankBonds' },
];
export const HowMuchMarginIsRequiredOptions = [
    { value: '-1', label: 'ChooseMargin' },
    { value: '1,000 EUR', label: '1,000 EUR' },
    { value: '100 EUR', label: '100 EUR' },
    { value: '5,000 EUR', label: '5,000 EUR' },
    { value: '1,000 USD', label: '1,000 USD' }
];
export const TheMarketIsMovingAgainstYouOptions = [
    { value: '-1', label: 'ChooseSituation' },
    { value: 'The account equity reaches 50% of the used margin', label: 'The account equity reaches 50% of the used margin' },
    { value: 'The account equity reaches zero', label: 'The account equity reaches zero' },
    { value: 'The account equity reaches 50% of the account balance', label: 'The account equity reaches 50% of the account balance' },
    { value: 'None of the above', label: 'None of the above' }
];
export const WhenTradingWithHigherLeverageOptions = [
    { value: '-1', label: 'ChooseAnswer' },
    { value: 'Risk is reduced', label: 'RiskIsReduced' },
    { value: 'The profit and loss of a 1.00 lot position is multiplied', label: 'PositionIsMultiplied' },
    { value: 'Positions can be opened with more national exposure than available balance', label: 'PositionsCanBeOpened' }
];
export const StopOutBeTriggeredOptions = [
    { value: '-1', label: 'ChooseAnswer' },
    { value: 'When the equity reaches 500 USD', label: 'EquityReaches500' },
    { value: 'When the equity reaches 250 USD', label: 'EquityReaches250' },
    { value: 'When the equity goes negative', label: 'EquityGoesNegative' },
    { value: 'When the equity reaches 50 USD', label: 'EquityReaches50' }
];
export const KnowledgeLVLOptions = [
    { value: '-1', label: 'ChooseAnswer' },
    { value: 'None', label: 'None' },
    { value: 'Beginner', label: 'Beginner' },
    { value: 'Experienced', label: 'Experienced' }
];
export const HowManyTradesHaveYouExecutedOptions = [
    { value: '-1', label: 'ChooseRange' },
    { value: 'None', label: 'None' },
    { value: '1-25', label: '1-25' },
    { value: '26-50', label: '26-50' },
    { value: '51-75', label: '51-75' },
    { value: '100+', label: '100+' },
];
export const HowHaveYouTradedProductsOptions = [
    { value: '-1', label: 'ChooseAnswer' },
    { value: 'Not Applicable', label: 'NotApplicable' },
    { value: 'I made my own trading decisions', label: 'IMadeMyOwnTradingDecisions' },
    { value: 'My funds were managed and/or I took advice', label: 'MyFundsWereManaged' },
    { value: 'A combination of my own trading decisions and funds being managed', label: 'ACombinationOfMyOwnTradingDecisions' }
];
export const WhySpreadFloatingQnsOptions = [
    { value: "-1", label: ' -Choose Answer -' },
    { value: "The best bid and ask prices available on an ECN are streamed", label: ' The best bid and ask prices available on an ECN are streamed' },
    { value: "Multiple price feeds are aggregated", label: ' Multiple price feeds are aggregated' },
    { value: "The available liquidity in a security constantly changes", label: ' The available liquidity in a security constantly changes' },
    { value: "All of the above", label: 'All of the above' }
];
//#endregion
//#region ProfessionalClientStatusTab
export const RoleHoldWithEmployerOptions = [
    { value: '-1', label: 'SelectRole' },
    { value: 'Account Manager', label: 'AccountManager' },
    { value: 'Senior Manager', label: 'SeniorManager' },
    { value: 'Analyst/Researcher', label: 'Analyst/Researcher' },
    { value: 'Educator', label: 'Educator' },
    { value: 'Operational Manager', label: 'OperationalManager ' },
    { value: 'Risk Manager', label: 'RiskManager ' },
    { value: 'Other', label: 'Other ' },
];
export const ProvideAverageNumberOptions = [
    { value: '-1', label: 'SelectAverage' },
    { value: '30+', label: '30 +' },
    { value: '20-29', label: ' 20 - 29' },
    { value: '10-19', label: ' 10 - 19' },
    { value: '0-9', label: '0-9' },
];
//#endregion
//function to translate labels
export function translateSelectOptions(list: Array<BasicSelectOption>, t: Function) {//add the render to fixed 

    for (let i = 0; i < list.length; i++) {
        try {
            if (t(list[i].label)) {
                list[i].label = t(list[i].label)
            }
        }
        catch (e) {
            console.error(e)
            //list[i].label = list[i].label /*+ " -- Translation needed "*/;
        }
    }
    return list;
}
//#region client page
export const clientPageType = [ // check add Name attribute
    { value: 1, label: 1 },
    { value: 2, label: 2 },
    { value: 3, label: 3 },
    { value: 4, label: 4 },
    { value: 5, label: 5 },
];
//#endregion

export const RequestTypeOp = [
    { value: "Auto Copy", label: "Auto Copy" },
    { value: "Deposit", label: "Deposit" },
    { value: "Account Info", label: "Account Info" },
    { value: "Wallet Deposit", label: "Wallet Deposit" },
    { value: "Delete Account", label: "Delete Account" },
    { value: "Change Leverage", label: "Change Leverage" },
    { value: "Withdrawal", label: "Withdrawal" },
    { value: "Wallet Withdrawal", label: "Wallet Withdrawal" },
    { value: "External Transfer", label: "External Transfer" },
    { value: "Internal Transfer", label: "Internal Transfer" },
    { value: "External Wallet Transfer", label: "External Wallet Transfer" },
    { value: "Internal Wallet Transfer", label: "Internal Wallet Transfer" },
    { value: "New Account", label: "New Account" }
];
export const AccountRequestTypeOp = [
    { value: "Auto Copy", label: "Auto Copy" },
    { value: "Account Info", label: "Account Info" },
    { value: "Delete Account", label: "Delete Account" },
    { value: "Change Leverage", label: "Change Leverage" },
    { value: "New Account", label: "New Account" }
];

export const TransactionRequestTypeOp = [
    { value: "Deposit", label: "Deposit" },
    { value: "Wallet Deposit", label: "Wallet Deposit" },
    { value: "Withdrawal", label: "Withdrawal" },
    { value: "Wallet Withdrawal", label: "Wallet Withdrawal" },
    { value: "External Transfer", label: "External Transfer" },
    { value: "Internal Transfer", label: "Internal Transfer" },
    { value: "External Wallet Transfer", label: "External Wallet Transfer" },
    { value: "Internal Wallet Transfer", label: "Internal Wallet Transfer" },
];
export const RequestStatusOption = [
    { value: "1", label: "Approved" },
    { value: "-1", label: "Declined" }
]
export const PrivilegesOption = [
    { value: "-1", label: "-Select Privilege" },
    { value: "1", label: "Client" },
    { value: "2", label: "Back Office" },
    { value: "3", label: "Both" },
];
export function ValidateSelect(selected: any) {
    if (selected === null) return false;
    if (selected === undefined || selected.label === undefined || selected.value === undefined) return false;
    if (String(selected.value) === "-1") return false;
    return selected.value !== -1;
}
export function LogMessage(...allArgs: any) {
    try {
        let args: any = Array.prototype.slice.call(arguments);
        console.log.apply(console, args);
    }
    catch (e) {
        console.error(e);
    }
}
export function ValidateMultiSelect(selected: any[]) {
    if (selected === undefined || selected === null || selected.length === 0) return false;
    return true;
}
export function ValidateInput(value: string): boolean {//as !value can't check number
    return (value !== null && value !== undefined && value !== "");
}
export function validateCheckBoxIsTrue(value: boolean): boolean {
    return (value !== null && value !== undefined && value === true);
}
export function returnSelect(value: any): string {
    if (!value || String(value) === "-1" || String(value) === "undefined")
        return "Select"
    return value;
}
export function returnZero(value: any): string {
    if (String(value) === "-1")
        return "0"
    return value;
}
export function CastOptionsToScore(FieldID: string, BasicSelectOptions: BasicSelectOption[]) {
    let _castedObject: any[] = [...BasicSelectOptions];
    _castedObject = _castedObject
        .filter((item: BasicSelectOption) => String(item.value) !== "-1")
        .map((item: BasicSelectOption, index: number) => {
            return {
                SID: parseInt(String(index + 1), 10),
                FieldID: FieldID,
                Value: item.label,
                Score: 0,
                FieldIndex: String(index + 1),
            }
        })
    return _castedObject;
}
export function CastCheckBoxesToScore(FieldID: string, BasicSelectOptions: string[]) {
    let _castedObject: any[] = [...BasicSelectOptions];
    _castedObject = _castedObject.map((item: string, index: number) => {
        return {
            SID: parseInt(String(index + 1), 10),
            FieldID: FieldID,
            Value: item,
            Score: 0,
            FieldIndex: String(index + 1),
        }
    })
    return _castedObject;
}
export function isDate(date: string) {
    if (!date) return "2000-01-01";
    let dateReg: any = /^\d{4}([./-])\d{2}\1\d{2}$/;
    if (date.match(dateReg))//return null if not match 
        return date;
    return "2000-01-01";
}
export function validateDate(date: any): boolean {
    if (!date) return false;
    if (date === "0001-01-01T00:00:00") return false;
    if (date)
        date = date.split("T")[0];
    let dateReg: any = /^\d{4}([./-])\d{2}\1\d{2}$/;
    return date.match(dateReg) ? true : false;
}
export function validateDateAndInternval(date: Date, interval: any): boolean {
    if (!date) console.debug("error date");
    if (interval === undefined || interval === null) console.debug("error max");
    //console.log(typeof date);
    //console.log(typeof max);
    if (!date || (interval === undefined || interval === null)) return false;
    if (interval !== 0)
        return validateDateInterval(new Date(String(date)), interval);
    else
        return validateDateInterval(new Date(), new Date(String(date)));
}
export function validateDateIsValid(_date: Date, Start: Date, End: Date, isStart: boolean): boolean {
    // IsStart disabled as data not hardcoden now
    return _date >= Start && _date <= End;
}
export function validateDateAndReturnDate(date: any): string {//dont split date so it can be used
    return validateDate(date) ? moment(new Date(date.toString())).format('MM/DD/YY h:mm:ss A') : ' - ';
}
export function validateDateInterval(Start: Date, End: Date): boolean {
    return Start <= End;
}
export function validateDateRange(date: any): boolean {
    let fromDate: any = '';
    let toDate: any = '';
    if (date) {
        fromDate = date.split(',')[0];
        toDate = date.split(',')[1];
    }
    let dateReg: any = /^\d{4}([./-])\d{2}\1\d{2}$/;
    let from = fromDate.match(dateReg) ? true : false;
    let to = toDate.match(dateReg) ? true : false;
    return from && to;
}
export function SetUSAFirstCounty(CountryLists: any[]) {
    try {
        if (!CountryLists) return [];
        let _finalList: any = [];
        let _newList: any = [...CountryLists];
        let _USACountry: any = [];
        _USACountry = [..._newList.filter((item: any) => item.CountryName === "United States")];
        _newList = _newList.filter((item: any) => item.CountryName !== "United States");
        _finalList.push(..._USACountry);
        _finalList.push(..._newList);
        return _finalList;
    } catch (e) {
        console.error('SetUSAFirstCounty: ', e);
        return CountryLists;
    }
}
export function SetFirstCounty(CountryName: string, CountryLists: any[]) {
    try {
        if (!CountryLists) return [];
        let _finalList: any = [];
        let _newList: any = [...CountryLists];
        let _USACountry: any = [];
        _USACountry = [..._newList.filter((item: any) => item.CountryName === CountryName)];
        _newList = _newList.filter((item: any) => item.CountryName !== CountryName);
        _finalList.push(..._USACountry);
        _finalList.push(..._newList);
        return _finalList;
    } catch (e) {
        console.error('SetUSAFirstCounty: ', e);
        return CountryLists;
    }
}
export function validateEmail(email: any) {
    if (!email) return false;
    let regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
    return regex.test(email);
}
export function GetPushNoticationifOn(name: string, list: PushNotification[]) {
    try {
        if (!list) return false;
        let _allNotification: PushNotification[] = [...list];
        let _nameExist: boolean = [..._allNotification].some((item: PushNotification) => ((item && item.PNDescription) && (item.PNDescription.toLowerCase() === name.toLowerCase())));
        return _nameExist;
    } catch (e) {
        console.error(e);
        return true;
    }
}
export function GetPermValName(name: string, list: IPerms[]) {
    try {
        if (!list) return "Deny"
        let _allpermsList: IPerms[] = [...list];
        let _parentList: any[] = [..._allpermsList].filter((item: IPerms) => (item && item.PermName) && (item.PermName.toLowerCase() === name.toLowerCase()));
        let _name = _parentList.length === 0 ? "Deny" : _parentList[0].PermValName;
        return _name;
    } catch (e) {
        console.error(e);
        return "Deny"
    }
}
export function GetPermissionDetailsByName(name: string, list: IPerms[]) {
    try {
        if (!list)
            return {
                Allowed: false,
                Perms: []
            };
        let _allpermsList: IPerms[] = [...list];
        let _parentList: any[] = [..._allpermsList].filter((item: IPerms) => (item && item.PermName) && (item.PermName.toLowerCase() === name.toLowerCase()));
        let _parentID = _parentList.length === 0 ? 0 : _parentList[0].PermID;
        let _allowed = _parentList.length === 0 ? false : ((_parentList[0].PermValID ? true : false) && (_parentList[0].PermValID !== EPermissionValue.Deny) ? true : false);
        let _children = [...list].filter((item: IPerms) => item.ParentPermID === _parentID);
        return {
            Allowed: _allowed,
            Perms: _allowed ? [..._parentList, ..._children] : [] //as if deny no perm should be allowed 
        };
    } catch (e) {
        console.error(e);
        return {
            Allowed: false,
            Perms: []
        };
    }
}
export function CheckIfPermAlllowedByName(name: string, list: IPerms[]) {
    try {
        let _allpermsList: IPerms[] = [...list];
        let _nameList: any[] = [..._allpermsList].filter((item: IPerms) => (item && item.PermName) && item.PermName.toLowerCase() === name.toLowerCase());
        let _allowed = _nameList.length === 0 ? false : ((_nameList[0].PermValID ? true : false) && (_nameList[0].PermValID !== EPermissionValue.Deny) ? true : false);//if Null false && any is false //2 is deny
        return _allowed
    } catch (e) {
        console.error(e);
        return false;
    }
}
export function GetPermIDByPermName(name: string, list: IPerms[]) {
    try {
        let _allpermsList: IPerms[] = [...list];
        let _nameList: any[] = [..._allpermsList].filter((item: IPerms) => (item && item.PermName) && item.PermName.toLowerCase() === name.toLowerCase());
        let _allowed = _nameList.length === 0 ? false : ((_nameList[0].PermValID ? true : false) && (_nameList[0].PermValID !== EPermissionValue.Deny) ? true : false);
        return (_allowed && _nameList && _nameList[0]?.PermID) ? +(_nameList[0]?.PermID) : 0;
    } catch (e) {
        console.error(e);
        return 0;
    }
}
export function GetPermissionDetailsByNameAndID(name: string, list: IPerms[], PermID: number) {
    try {
        if (!list)
            return {
                Allowed: false,
                Perms: []
            };
        let _allpermsList: IPerms[] = [...list];
        let _parentList: any[] = [..._allpermsList].filter((item: IPerms) => ((item && item.PermName) && (item.PermName.toLowerCase() === name.toLowerCase()))
            && (String(item.PermID) === String(PermID))
        );
        let _parentID = _parentList.length === 0 ? 0 : _parentList[0].PermID;
        let _allowed = _parentList.length === 0 ? false : ((_parentList[0].PermValID ? true : false) && (_parentList[0].PermValID !== EPermissionValue.Deny) ? true : false);
        let _children = [...list].filter((item: IPerms) => item.ParentPermID === _parentID);
        return {
            Allowed: _allowed,
            Perms: _allowed ? [..._parentList, ..._children] : [] //as if deny no perm should be allowed 
        };
    } catch (e) {
        console.error(e);
        return {
            Allowed: false,
            Perms: []
        };
    }
}
export function TempGetPermissionDetailsByName(name: string, list: IPerms[]) {
    return {
        Allowed: true,
        Perms: []
    }
}
export function TempCheckIfPermAlllowedByName(name: string, list: IPerms[]) { return true }
export function deepCopyFunction(inObject: any) {
    let outObject: any, value: any, key: any;

    if (typeof inObject !== "object" || inObject === null) {
        return inObject // Return the value if inObject is not an object
    }

    // Create an array or object to hold the values
    outObject = Array.isArray(inObject) ? [] : {}

    for (key in inObject) {
        value = inObject[key]

        // Recursively (deep) copy for nested objects, including arrays
        outObject[key] = deepCopyFunction(value)
    }

    return outObject
}
export const ValidationTXT: any = ["error", "success", "validating", "warning", ""];
export function validateCommaSeparatedStrings(text: string) {
    //var regex = /[!@#$%^&*\-\_(),.? ":{}|<>1234567890]/g
    if (!text || text === "") return false;
    if (text === "*") return true;
    //var _regexComma = /^\w(,?\w)*$/;
    /* var _regexComma = /^[^,\s]\S*$/;//as special characters allowed*/
    if (text.startsWith(" ") || text.endsWith(" ")) return false;
    const allArray = text.split(",");
    return !allArray.some((item: string) => item.startsWith(" ") || item.endsWith(" "))
    //return text.match(_regexComma) ? true : false;
}
export function validateCommaSeparatedStringsSecuirties(text: string) {
    if (!text || text === "") return false;
    if (text === "*") return true;
    //var _regexComma = /^[^,\s].*$/;//all special and space
    //return text.match(_regexComma) ? true : false;
    if (text.startsWith(" ") || text.endsWith(" ")) return false;
    const allArray = text.split(",");
    return !allArray.some((item: string) => item.startsWith(" ") || item.endsWith(" "))
}
export function validateCommaSeparatedStringsTrue(text: string) {
    //var regex = /[!@#$%^&*\-\_(),.? ":{}|<>1234567890]/g
    if (!text || text === "") return true;
    if (text === "*") return true;
    /*only check is on spaces as special characters are different*/
    const list = text.split(',');
    for (let element of list) {
        if (element.startsWith(" ") || element.endsWith(" ")) {
            return false;
        }
    }
    return true;
    //var _regexComma = /^\w(,?\w)*$/;
    //var _regexComma = /^[^,\s]\S*$/;//as special characters allowed
    //return text.match(_regexComma) ? true : false;
}
export function validateCommaSeparatedNumberTrue(text: string) {
    if (!text || text === "") return true;
    if (text === "*") return true;
    var _regexComma = /^\d+(,\d+)*$/;
    return text.match(_regexComma) ? true : false;
}
export function validateCommaSeparatedTextTrue(text: string) {
    if (!text || text === "") return true;
    if (text === "*") return true;
    var _regexComma = /^[a-zA-z]+(,[a-zA-z]+)*$/;
    return text.match(_regexComma) ? true : false;
}

export function DisplayAllocationRules(list: any, Allowed: boolean, UserAllocationPermissions: IPerms[]): any[] {
    if (!Allowed) return [{ value: -1, label: "No Allocations" }];
    if (!list) return [];
    let ELS: string = CheckIfPermAlllowedByName('ELS', UserAllocationPermissions) ? 'ELS' : '';
    let ECS: string = CheckIfPermAlllowedByName('ECS', UserAllocationPermissions) ? 'ECS' : '';
    let EV: string = CheckIfPermAlllowedByName('EV', UserAllocationPermissions) ? 'EV' : '';
    let Percentage: string = CheckIfPermAlllowedByName('Percentage', UserAllocationPermissions) ? 'Percentage' : '';
    let Multiplier: string = CheckIfPermAlllowedByName('Multiplier', UserAllocationPermissions) ? 'Multiplier' : '';
    let BLS: string = CheckIfPermAlllowedByName('BLS', UserAllocationPermissions) ? 'BLS' : '';
    let FixedLot: string = CheckIfPermAlllowedByName('Fixed Lot', UserAllocationPermissions) ? 'Fixed Lot' : '';
    let Equity: string = CheckIfPermAlllowedByName('% of Equity', UserAllocationPermissions) ? '% of Equity' : '';
    //console.log({ list, Allowed, UserAllocationPermissions })
    //console.log(ELS || ECS || EV || Percentage || Multiplier || BLS || FixedLot || Equity)
    let _newAllocationRuleList: any[] = [...list];
    _newAllocationRuleList = _newAllocationRuleList.filter((item: any) => (item && item.aRuleName && (item.aRuleName === ELS || item.aRuleName === ECS || item.aRuleName === EV
        || item.aRuleName === Percentage || item.aRuleName === Multiplier || item.aRuleName === BLS || item.aRuleName === FixedLot || item.aRuleName === Equity)));
    return _newAllocationRuleList;

}

export function DisplaySignalsAllocation(list: any) {
    if (!list) return [];
    let ELS: string = '';
    let ECS: string = '';
    let EV: string = 'EV';
    let Percentage: string = '';
    let Multiplier: string = '';
    let BLS: string = '';
    let FixedLot: string = 'Fixed Lot';
    let Equity: string = '% of Equity';
    let _newAllocationRuleList: any[] = [...list];
    _newAllocationRuleList = _newAllocationRuleList.filter((item: any) => (item && item.aRuleName && (item.aRuleName === ELS || item.aRuleName === ECS || item.aRuleName === EV
        || item.aRuleName === Percentage || item.aRuleName === Multiplier || item.aRuleName === BLS || item.aRuleName === FixedLot || item.aRuleName === Equity)));
    return _newAllocationRuleList;

}

export function dynamicSort(property: any) {
    var sortOrder = 1;
    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a: any, b: any) {
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    }
}
export function ConvertIntoDictionary(list: any[], key: any) {
    let _newDict: any = [...list].reduce((obj: any, item: any, index: number) => {
        obj[item[key]] = item
        return obj
    }, {});
    return _newDict;
}
export function ConvertIntoDictionaryWithSpecificValue(list: any[], key: any, value: any) {
    let _newDict: any = [...list].reduce((obj: any, item: any, index: number) => {
        obj[item[key]] = value
        return obj
    }, {});
    return _newDict;
}
export function checkIfTemplateExistInBothClientAdmin(emailTEmplateName: string) {
    let _list: any = [
        'User Reset Password ', // DB it includes sapce   
        'Demo Trading account added',
        'Live Trading Account added',
        'New Live Account Request',
        'Close Live Account Request',
        'Leverage Live Account Change Request',
        'Deposit Live Account request',
        'withdrawal Live Account request',
        'Internal Transfer Live Account request',
        'External Transfer Live Account request',
        'Application Requests',
        'Documents expired',
        'Subscribe/Unsubscribe To Signal Request',
        'Client Claimed Bonus']
    try {
        return _list.includes(emailTEmplateName);
    } catch (e) {
        console.error(e);
        return false;
    }

}
export function StringTemp(ServerType: any) {
    if (String(ServerType) === "MT4") return 'MT4';
    if (String(ServerType) === "MT5") return 'MT5';
    try {
        return String(ServerType) === "4" ? "MT4" : "MT5";
    } catch (e) {
        console.error(e);
        return 'MT4';
    }

}
export function isNumber(value: any) {
    return typeof value === 'number' && isFinite(value);
}
export function validateNumber(_number: any) {
    return _number !== undefined && _number !== null && isNumber(_number);
}
export const levelofeducationList =
    [{ value: "-1", label: "Select" },
    { value: "IHoldProfessionalQualification", label: "I HoldProfessional Qualification" },
    { value: "IReceivedHigherEducation", label: "I Received Higher Education" },
    { value: "IHoldABachelor", label: "I Hold A Bachelor" },
    { value: "InTheLastThreeYears", label: "In The Last Three Years" },
    { value: "NoneOfTheAbove", label: "None Of The Above" }];
export const SourceOfFundsList =
    [{ value: "BusinessOwnership", label: "Business Owner ship" },
    { value: "PropertyLandInvestments", label: "Property Land Investments" },
    { value: "FamilyIncomeRelationship", label: "Family Income Relationship" },
    { value: "PersonalSaving", label: "Personal Saving" },
    { value: "InsurancePayout", label: "Insurance Payout" },
    { value: "IncomeFromEmployment", label: "Income From Employment" },
    { value: "CommissionsRevenuesBonuses", label: "Commissions Revenues Bonuses" },
    { value: "ReturnOnInvestmentsSharesDividends", label: "Return OnInvestments Shares Dividends" },
    { value: "BankingFacilities", label: "Banking Facilities" },
    { value: "Inheritance", label: "Inheritance" },
    { value: "Other", label: "Other" },
    ];
export function ValidateAndReturnInput(input: string): string {
    if (!input) return "";
    return input;
}
export function CheckIfNotificationIsEnabledByID(PNID: number, list: PushNotificationStatus[]): boolean {
    let _list: any[] = [...list];
    let _isEnabled: boolean = _list.some((item: PushNotificationStatus) => +(item.PNID) === +(PNID));
    return _isEnabled;
}
export function CheckIfNotificationIsEnabledByName(PNDescription: string, list: PushNotificationStatus[]): boolean {
    let _list: any[] = [...list];
    let _isEnabled: boolean = _list.some((item: PushNotificationStatus) => String(item.PNDescription) === String(PNDescription));
    return _isEnabled;
}
export function password_generator(len: any) {
    let length = (len) ? (len) : (10);
    let string = "abcdefghijklmnopqrstuvwxyz"; //to upper
    let numeric = '0123456789';
    let punctuation = '!@#$%^&';
    let password = "";
    let character = "";
    while (password.length < length) {
        let _string = Math.ceil(string.length * Math.random() * Math.random());
        let _numbers = Math.ceil(numeric.length * Math.random() * Math.random());
        let _specialCharacters = Math.ceil(punctuation.length * Math.random() * Math.random());
        let _captialLetter = string.charAt(_string);//captial letter
        _captialLetter = (password.length % 2 === 0) ? (_captialLetter.toUpperCase()) : (_captialLetter);
        character += _captialLetter;
        character += numeric.charAt(_numbers);
        character += punctuation.charAt(_specialCharacters);
        password = character;
    }
    password = password.split('').sort(function () { return 0.5 - Math.random() }).join('');
    return password.substr(0, len);
}
export function UpperCaseExists(password: string): boolean {
    let UpperCase = /^(?=.*[A-Z])/;
    if (password.match(UpperCase)) {
        return true;
    }
    return false;
}
export function LowerCaseExists(password: string): boolean {
    let lowerCase = /^(?=.*[a-z])/;
    if (password.match(lowerCase)) {
        return true;
    }
    return false;
}
export function NumberExists(password: string): boolean {
    let numbers = /^(?=.*[0-9])/;
    if (password.match(numbers)) {
        return true;
    }
    return false;
}
export function SpecialCharacterExists(password: string): boolean {
    let special = /^(?=.*[$@$!%*#?&])/;
    if (password.match(special)) {
        return true;
    }
    return false;
}
export function CheckPasswordStrength(password: string) {
    ////if textBox is empty
    //if (password.length === 0) {
    //    return -1;
    //}
    ////Regular Expressions
    //var regex: any[] = [];
    //regex.push("[A-Z]"); //For Uppercase Alphabet
    //regex.push("[a-z]"); //For Lowercase Alphabet
    //regex.push("[0-9]"); //For Numeric Digits
    //regex.push("[$@$!%*#?&]"); //For Special Characters
    //var passed = 0;
    ////Validation for each Regular Expression
    //for (var i = 0; i < regex.length; i++) {
    //    if ((new RegExp(regex[i])).test(password)) {
    //        passed++;
    //    }
    //}
    ////Validation for Length of Password
    //if (passed > 2 && password.length > 8) {
    //    passed++;
    //}
    //return passed;
    if (!password || password.length === 0) {
        return -1;
    }
    let passed = 0;
    if (UpperCaseExists(password)) {//TODO replace match with reusable methods
        passed++;//1
    }
    if (NumberExists(password)) {
        passed++;//2
    }
    if (SpecialCharacterExists(password)) {
        passed++;//3
    }
    if (password.length > 7) {
        passed++;//4
    }
    if (LowerCaseExists(password)) {
        passed++;//5
    }
    return passed;
}
export function ReturnActionMessage(Message: ActionMessage, t: Function): IMessage {
    console.log("🚀 ReturnActionMessage");
    if (Message.actionType === "Task assigned to you") {
        Message.messageTitle = t('NewTask');
        Message.messageContent = Message.task + t('Task') + " " + t('WasAssignedToYouBy') + " " + Message.admin + ".";
    }
    else if (Message.actionType === "Client claimed Bonus added") {
        Message.messageTitle = t('BonusAdded');
        Message.messageContent = t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + t('BonusAddedTo') + t('Login') + ": " + Message.login + "-" + Message.server + t('Login') + Message.amount + " " + Message.currency + ".";
    }
    else if (Message.actionType === "Subscribe/unSubscribe to Strategy MAM") {
        if (Message.subType === "Subscribe") {
            Message.messageTitle = t('Subscription');
            Message.messageContent = "to be filled";
        }
        else if (Message.subType === "unSubscribe") {
            Message.messageTitle = "Unsubscription";
            Message.messageContent = "to be filled";
        }
    }
    else if (Message.actionType === "Client Auto-linked to IB") {
        Message.messageTitle = t('AutoLinkedToIb');
        Message.messageContent = t('ClientID') + ": " + Message.clientID + " , " + Message.clientName + " , " + t('Login') + ": " + Message.login + " , " + Message.server + " " + t('AutoLinkedToIb') + " " + Message.ibName + " , " + Message.ibCode + ".";
    }
    else if (Message.actionType === "Application Requests") {
        if (Message.subType === "Request Application") {
            Message.messageTitle = t('ApplicationRequests');
            Message.messageContent = t('ClientID') + ": " + Message.clientID + " , " + Message.clientName + " " + t('SubmittedApplicationForm');
        }
        else if (Message.subType === "Decline Application Request") {
            Message.messageTitle = t('DeclineApplicationRequest');
            Message.messageContent = Message.admin + t('DeclinedApplicationFormSubmittedBy') + t('ClientID') + ": " + Message.clientID + ".";
        }
        else if (Message.subType === "Approve Application Request") {
            Message.messageTitle = t('ApproveApplicationRequest');
            Message.messageContent = Message.admin + + t('AprrovedApplicationFormSubmittedBy') + t('ClientID') + ": " + Message.clientID + ".";
        }

    }
    else if (Message.subType === "Application Changes") {
        Message.messageTitle = t('ApplicationChanges');
        Message.messageContent = t('ClientID') + ": " + Message.clientID + " , " + Message.clientName + t('MadeChangesToApplicationForm');
    }
    else if (Message.actionType === "Clients assigned to you") {
        Message.messageTitle = t('NewClient');
        Message.messageContent = Message.clientName + " " + t('WasAssignedToYouBy') + " " + Message.admin + ".";
    }
    else if (Message.actionType === "Ticket assigned to you") {
        Message.messageTitle = t('NewTicket');
        Message.messageContent = Message.ticket + "  " + t('TicketAssignedToYouBy') + " " + Message.admin + ".";
    }
    else if (Message.actionType === "Task reminder") {
        Message.messageTitle = t('Reminder');
        Message.messageContent = Message.ticket + t('Reminder') + ".";
    }
    else if (Message.actionType === "Expired Documents") {
        Message.messageTitle = t('ExpiredDocuments');
        Message.messageContent = Message.listEmails + " " + t('ExpiredDocumentsIn') + " " + Message.date + ".";
    }
    else if (Message.actionType === "Lead assiged to you") {
        Message.messageTitle = t('NewLead');
        Message.messageContent = Message.lead + " " + t('WasAssignedToYouBy') + " " + Message.admin + ".";
    }
    else if (Message.actionType === "Contact assigned to you") {
        Message.messageTitle = t('NewContact');
        Message.messageContent = Message.contact + " " + t('WasAssignedToYouBy') + " " + Message.admin + ".";
    }
    else if (Message.actionType === "Deposits/Withdrawals/Transfers") {
        if (Message.subType === "Request Deposit") {
            Message.messageTitle = t('NewDeposits');
            Message.messageContent = t('ClientID') + ": " + Message.clientID + " , " + Message.clientName + " " + t('RequestedToDeposit') + " " + Message.amount + "-" + Message.currency + " " + t('OnThrePreposition') + t('Login') + ": " + Message.login + " , " + Message.server + ".";
        }
        else if (Message.subType === "Decline Deposit Request") {
            Message.messageTitle = t('DeclineDeposit');
            Message.messageContent = Message.admin + " " + t('DeclinedToDeposit') + " " + Message.amount + "-" + Message.currency + " " + t('OnThrePreposition') + t('Login') + ": " + Message.login + ", " + Message.server + " " + t('SubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Approve Deposit Request") {
            Message.messageTitle = t('ApproveDeposit');
            Message.messageContent = Message.admin + " " + t('ApprovedToDeposit') + " " + Message.amount + "-" + Message.currency + " " + t('OnThrePreposition') + " " + t('Login') + ": " + Message.login + ", " + Message.server + " " + t('SubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Request Withdrawal") {
            Message.messageTitle = t('NewWithdrawal');
            Message.messageContent = t('ClientID') + ": " + Message.clientID + " , " + Message.clientName + " " + t('RequestedToWithdraw') + " " + Message.amount + "-" + Message.currency + " " + t('OnThrePreposition') + t('Login') + ": " + Message.login + " , " + Message.server + ".";
        }
        else if (Message.subType === "Decline Withdrawal Request") {
            Message.messageTitle = t('DeclineWithdrawal');
            Message.messageContent = Message.admin + " " + t('DeclinedToWithdraw') + " " + Message.amount + "-" + Message.currency + " " + t('OnThrePreposition') + t('Login') + ": " + Message.login + ", " + Message.server + " " + t('SubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Approve Withdrawal Request") {
            Message.messageTitle = t('ApproveWithdrawal');
            Message.messageContent = Message.admin + " " + t('ApprovedToWithdraw') + " " + Message.amount + "-" + Message.currency + " " + t('OnThrePreposition') + t('Login') + ": " + Message.login + ", " + Message.server + " " + t('SubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Request Transfer") {
            Message.messageTitle = t('NewTransfer');
            Message.messageContent = t('ClientID') + ": " + Message.clientID + " , " + Message.clientName + " " + t('RequestedToTransfer') + " " + Message.amount + "-" + Message.currency + " " + t('From') + t('Login') + ": " + Message.fromLogin + " , " + Message.fromServer + " " + t('ToPreposition') + t('Login') + ": " + Message.toLogin + " , " + Message.toServer + ".";
        }
        else if (Message.subType === "Decline Transfer Request") {
            Message.messageTitle = t('DeclineTransfer');
            Message.messageContent = Message.admin + " " + t('DeclinedToTransfer') + " " + Message.amount + "-" + Message.currency + " " + t('From') + t('Login') + ": " + Message.fromLogin + " , " + Message.fromServer + " " + t('ToPreposition') + t('Login') + ": " + Message.toLogin + " , " + Message.toServer + " " + t('SubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Approve Transfer Request") {
            Message.messageTitle = t('ApproveTransfer');
            Message.messageContent = Message.admin + " " + t('ApprovedToTransfer') + " " + Message.amount + "-" + Message.currency + " " + t('From') + t('Login') + ": " + Message.fromLogin + " , " + Message.fromServer + " " + t('ToPreposition') + t('Login') + ": " + Message.toLogin + " , " + Message.toServer + " " + t('SubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
    }
    else if (Message.actionType === "Trading Accounts added or Closed") {
        if (Message.subType === "Request Live Account") {
            Message.messageTitle = t('NewAccountRequest');
            Message.messageContent = t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + " " + t('RequestedToOpenANewLiveTradingAccount');
        }
        else if (Message.subType === "Approve New Account") {
            Message.messageTitle = t('ApproveNewAccount');
            Message.messageContent = Message.admin + " " + t('ApprovedOpeningANewLiveTradingAccountTo') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Decline New Account") {
            Message.messageTitle = t('DeclinedNewAccount');
            Message.messageContent = Message.admin + " " + t('DeclinedOpeningANewLiveTradingAccountTo') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Add Live Account") {
            Message.messageTitle = t('NewLiveAccountAdded');
            Message.messageContent = t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + " " + t('NewLiveTradingAccountAdded') + " " + t('Login') + ": " + Message.login + ", " + Message.server + ".";
        }
        else if (Message.subType === "Add Demo Account") {
            Message.messageTitle = t('NewDemoAccountAdded');
            Message.messageContent = (Message.clientID === "" ? Message.clientName : (t('ClientID') + ": " + Message.clientID + ", " + Message.clientName)) + " " + t('NewDemoTradingAccountAdded') + " " + t('Login') + ": " + Message.login + ", " + Message.server + ".";
        }
        else if (Message.subType === "Request Close Account") {
            Message.messageTitle = t('CloseAccountRequest');
            Message.messageContent = t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + " " + t('RequestedToCloseLiveTradingAccount') + " " + t('Login') + ": " + Message.login + ", " + Message.server + ".";
        }
        else if (Message.subType === "Decline close Account") {
            Message.messageTitle = t('DeclinedCloseAccount');
            Message.messageContent = Message.admin + " " + t('DeclinedToCloseLiveTradingAccountTo') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Approve Close Account") {
            Message.messageTitle = t('ApprovedCloseAccount');
            Message.messageContent = Message.admin + " " + t('ApproveToCloseLiveTradingAccountTo') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
    }
    else if (Message.actionType === "Client Bonus to balance reached") {
        Message.messageTitle = t('ClaimBonus');
        Message.messageContent = t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + t('ReachedCashBonusonLogin') + " " + Message.login + Message.server + " Lots reached: " + Message.lots + ".";
    }
    else if (Message.actionType === "Trading Accounts Request Changes") {
        if (Message.subType === "Request Change Leverage") {
            Message.messageTitle = t('RequestChangeLeverage');
            Message.messageContent = t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + " " + t('RequestedToChangeLevergeOnLiveTradingAccount') + " " + t('OnLowerCase') + " " + t('Login') + ": " + Message.login + ", " + Message.server + ".";
        }
        else if (Message.subType === "Decline Leverage Request") {
            Message.messageTitle = t('DeclineLeverageRequest');
            Message.messageContent = Message.admin + " " + t('DeclinedToChangeLeverageOn') + " " + t('Login') + ": " + Message.login + ", " + Message.server + " " + t('SubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Approve Leverage Request") {
            Message.messageTitle = t('ApproveLeverageRequest');
            Message.messageContent = Message.admin + " " + t('ApprovedToChangeLeverageOn') + " " + t('Login') + ": " + Message.login + ", " + Message.server + " " + t('SubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Request Change Account Info") {
            Message.messageTitle = t('RequestChangeAccountInfo');
            Message.messageContent = t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + " " + t('RequestedToChangeAccountInfoOnLiveTradingAccount') + " " + t('Login') + ": " + Message.login + ", " + Message.server + ".";
        }
        else if (Message.subType === "Decline Account Info Request") {
            Message.messageTitle = t('Decline') + t('AccountInfo') + t('Request');
            Message.messageContent = Message.admin + " " + t('DeclinedToChangeAccountInfoSubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Approve Account Info Request") {
            Message.messageTitle = t('ApproveAccountInfoRequest');
            Message.messageContent = Message.admin + " " + t('ApprovedToChangeAccountInfoSubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
    }
    else if (Message.actionType === "Ticket Request Changes") {
        Message.messageTitle = t('TicketUpdate');
        Message.messageContent = Message.ticket + t('TicketUpdate') + ".";
    }
    else if (Message.actionType === "Ticket assigned to you") {
        Message.messageTitle = t('NewTicket');
        Message.messageContent = Message.ticket + " " + t('TicketAssignedToYouBy') + " " + Message.admin + ".";
    }
    else if (Message.actionType === "Subscribe/unSubscribe to Strategy Signal") {
        if (Message.subType === "Request Autocopy") {
            Message.messageTitle = t('RequestAutocopy');
            Message.messageContent = t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ", " + t('From') + " " + t('Login') + ": " + Message.fromLogin + ", " + Message.fromServer + " " + t('RequestedToCopyTradingAccount') + " " + t('ToPreposition') + " " + t('Login') + ": " + Message.toLogin + ", " + Message.toServer + ".";
        }
        else if (Message.subType === "Decline Autocopy Request") {
            Message.messageTitle = t('DeclineAutocopyRequest');
            Message.messageContent = Message.admin + " " + t('DeclinedToCopyTradingAccount') + " " + t('From') + " " + t('Login') + ": " + Message.fromLogin + ", " + Message.fromServer + " " + t('SubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Approve Autocopy Request") {
            Message.messageTitle = t('ApproveAutocopyRequest');
            Message.messageContent = Message.admin + " " + t('ApprovedToCopyTradingAccount') + " " + t('From') + " " + t('Login') + ": " + Message.fromLogin + ", " + Message.fromServer + " " + t('SubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
    }
    else if (Message.actionType === "Client Auto-linked to MAM") {
        Message.messageTitle = t('ClientAutoLinkedToMam');
        Message.messageContent = t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + " ," + t('Login') + ": " + Message.login + ", " + Message.server + "  " + t('AutoLinkedUnderStrategyName') + " " + Message.name + ", " + t('MAMName') + ": " + Message.mamName + t('MAMLogin') + ": " + Message.mamLogin + ", " + Message.server + ".";
    }
    else if (Message.actionType === "Add symbol profile") {
        Message.messageTitle = t('AddSymbolProfile');
        Message.messageContent = `${t('SymbolProfile')} ${Message?.profileName || ""} of ${t('ID')} ${Message?.profileID || ""} ${t('WasSuccessfullyAdded')}`;
    }
    else if (Message.actionType === "Update symbol profile") {
        Message.messageTitle = t('UpdateSymbolProfile');
        Message.messageContent = `${t('SymbolProfile')} ${Message?.profileName || ""} of ${t('ID')} ${Message?.profileID || ""} ${t('WasSuccessfullyUpdated')}`;
    }
    else if (Message.actionType === "Delete symbol profile") {
        Message.messageTitle = t('DeleteSymbolProfile');
        Message.messageContent = `${t('SymbolProfile')} ${Message?.profileName || ""} of ${t('ID')} ${Message?.profileID || ""} ${t('WasSuccessfullyDeleted')}`;
    }
    else if (Message.actionType === "Add account exposure profile") {
        Message.messageTitle = t('AddAccountExposureProfile');
        Message.messageContent = `${t('AccountProfile')} ${Message?.profileName || ""} of ${t('ID')} ${Message?.profileID || ""} ${t('WasSuccessfullyAdded')}`;
    }
    else if (Message.actionType === "Update account exposure profile") {
        Message.messageTitle = t('UpdateAccountExposureProfile');
        Message.messageContent = `${t('AccountProfile')} ${Message?.profileName || ""} of ${t('ID')} ${Message?.profileID || ""} ${t('WasSuccessfullyUpdated')}`;
    }
    else if (Message.actionType === "Delete account exposure profile") {
        Message.messageTitle = t('DeleteAccountExposureProfile');
        Message.messageContent = `${t('AccountProfile')} ${Message?.profileName || ""} of ${t('ID')} ${Message?.profileID || ""} ${t('WasSuccessfullyDeleted')}`;
    }
    return {
        title: Message.messageTitle,
        content: Message.messageContent
    }

}
export function ReturnTranslation(key: string, t: Function) {
    return t(key);
}
export function CheckIfAUIDIsEnabled(AUID: string, AUIDs: string[] | any) {
    if (!AUID || !AUIDs || AUIDs.length === 0) return false;
    try {
        return AUIDs.includes(AUID) ? true : false;
    } catch (e) {
        console.error(e);
        return false;
    }
}
export function checkifPdf(_type: any) {
    try {
        if (!_type) return false;
        _type = _type !== null && _type !== "" ? _type.split(".").pop() : "-1";
        if (_type === "pdf")
            return true;
    }
    catch (e) {
        console.error("checkifPdf", _type, e)
    }
    return false;
}
export function isPDF_Binary(binary: string) {//as here it is sent as binary
    try {
        if (binary?.split(";")[0]?.toLowerCase()?.endsWith("pdf"))
            return true;
    }
    catch (e) {
        console.error("isPDF_Binary", binary, e)
    }
    return false;
}
export function GetDashboardItemByName(name: string, list: DashboardItems[]) {
    try {
        if (!list)
            return new DashboardItems();
        let _item: any[] = [...list].filter((item: DashboardItems) => (item && item.ItemName) && (item.ItemName.toLowerCase() === name.toLowerCase()));
        return _item && _item.length > 0 ? _item[0] : new DashboardItems();
    } catch (e) {
        console.error(e);
        return new DashboardItems();
    }
}
export function ReturnDistinctList(list: any[], PropertyName: string) {
    if (!list || list.length === 0) return [];
    return list.filter((thing: any, i: number, arr: any) => {
        return arr.indexOf(arr.find((t: any) => t[PropertyName] === thing[PropertyName])) === i;
    });
}
export function ReturnActivity(Type: string, t: Function) {
    if (!Type) return ' - ';//if want to add transation add language or return key of lang
    switch (Type) {
        case "Trader": {
            return t('CreatedTraderAccount');
        }
        case "Client": {
            return t('CreatedClient');
        }
        case "Contact": {
            return t('CreatedContactAccount');
        }
        case "Lead": {
            return t('CreatedLead');
        }
        case "Task": {
            return t('CreatedNewTask');
        }
        case "Note": {
            return t('CreatedNewNote');
        }
        case "ConvertContact": {
            return t('ConvertedContactToClient');
        }
        case "ConvertLead": {
            return t('ConvertedLeadToContact');
        }
        default: {
            return ' - '
        }
    }
}
export function escapeRegExp(text: string) {
    return text.replace(/[-[\]{}()*+?.,!%^$|\s~]/g, '\\$&');
}
export function ValidateMultiSelectwithOther(selected: any[], input: string) {
    if (!selected || selected.length === 0) return false
    let _list: any = selected ? selected.map((item: any) => item.value).toString() : "";
    if (_list.includes("Other"))//case sensitive
        return ValidateInput(input);
    return true;
}

export function ReturnAllocationsLabel(AruleName: string, signal?: boolean) {
    if (!AruleName) return ' - ';
    switch (AruleName) {
        case "ELS": {
            return "ELS (Equity Lot Share)";
        }
        case "ECS": {
            return "ECS (Equity Cash Share)";
        }
        case "EV": {
            return "EV  (Equal Volume)";
        }
        case "Percentage": {
            return "Percentage";
        }
        case "Multiplier": {
            return "Multiplier";
        }
        case "BLS": {
            return "BLS (Balance Lot Share)";
        }
        case "Fixed Lot": {
            return "Fixed Lot";
        }
        case "% of Equity": {
            if (signal) {
                return "Percentage of Equity";
            }
            return "% of Equity (Percentage of Equity)";
        }
        default: {
            return AruleName;
        }
    }
}
export function ReturnValuesForMultiSelect(list: any[]) {
    if (!list || list.length === 0) return [];
    return list.map((item: any) => item.value);
}
export function ReturnValuesForMultiSelectAsString(list: any[]) {
    if (!list || list.length === 0) return [];
    return list.map((item: any) => String(item.value));
}
export function ReturnValuesForMultiSelectAsExcluded(list: any[]) {
    if (!list || list.length === 0) return [];
    return list.map((item: any) => `!${item.value}`);
}
export function ReturnLabelsForMultiSelectAsExcluded(list: any[]) {
    if (!list || list.length === 0) return [];
    return list.map((item: any) => `!${item.label}`);
}
export function ReturnExcludedIncludedOptions(includelist: BasicSelectOption[], excludedList: BasicSelectOption[]) {
    try {
        if (!ValidateMultiSelect(includelist) && !ValidateMultiSelect(excludedList)) return null;
        let _included = ValidateMultiSelect(includelist) ? ReturnValuesForMultiSelect(includelist).toString() : "";
        let _excluded = ValidateMultiSelect(excludedList) ? ReturnValuesForMultiSelectAsExcluded(excludedList).toString() : "";
        return `${_included}${_included ? ',' : ''}${_excluded}`;

    } catch (e) {
        console.error(e);
        return null;
    }
}
export function ReturnExcludedIncludedOptionsLabels(includelist: BasicSelectOption[], excludedList: BasicSelectOption[]) {
    try {
        if (!ValidateMultiSelect(includelist) && !ValidateMultiSelect(excludedList)) return null;
        let _included = ValidateMultiSelect(includelist) ? ReturnLabelsForMultiSelect(includelist).toString() : "";
        let _excluded = ValidateMultiSelect(excludedList) ? ReturnLabelsForMultiSelectAsExcluded(excludedList).toString() : "";
        return `${_included}${_included ? ',' : ''}${_excluded}`;

    } catch (e) {
        console.error(e);
        return null;
    }
}
export function ValidateOneOfOptionsExists(visibleIfkey: string, list: any, ActionParams: any) {
    try {
        let _dict: any = { ...ActionParams };
        if (!_dict[visibleIfkey]?.Data?.isVisible) return false;//edit check if main element is visible 
        if (!CheckIfVisibleIF(_dict[visibleIfkey]?.Data, ActionParams)) return false;//check parent is visible /recurive
        let _selectedOption: string = String(_dict[visibleIfkey].value.value);
        //console.log({ _selectedOption, list })
        return list.includes(_selectedOption);
    } catch (e) {
        console.error(e);
        return false;
    }
}
export function ValidateOneOfElementsIsVisible(visibleIfKeys: string[], ActionParams: any) {
    try {
        let _dict: any = { ...ActionParams };
        //console.log({ visibleIfKeys });
        for (let i: number = 0; i < visibleIfKeys.length; i++) {
            if (_dict[visibleIfKeys[i]]?.Data?.isVisible && CheckIfVisibleIF(_dict[visibleIfKeys[i]]?.Data, ActionParams)) {
                return true;
            }
        }
        return false;
    } catch (e) {
        console.error(e);
        return false;
    }
}
export function ValidateAndReturnDataAsType(value: any, type: string) {
    try {
        switch (type) {
            case 'input':
            case 'radiogroup':
                {
                    if (typeof value === "string")
                        return value;
                    return DefaultValueDict[type];
                }
            case 'date':
                {
                    if (value instanceof Date || typeof value === "string")
                        return value;
                    return DefaultValueDict[type];
                }
            case 'dropdown':
            case 'dynamicDropdown': {
                if (value.value)
                    return value;
                return DefaultValueDict[type];
            }
            case 'multiDropdown': {
                if (value)
                    return value;
                return DefaultValueDict[type];
            }
            case 'boolean': {
                //console.log("boolean", { value });
                return value ? true : false;
            }
            //case 'file': {
            //    if (value typeof FileType)
            //    return value;
            //    return DefaultValueDict[type];
            //}
            default: {
                return value;
            }
        }
    } catch (e) {
        console.error(e);
        return;
    }
}
export function ValidateOneOfOptionsExistsInMultiSelect(visibleIfkey: string, list: any, ActionParams: any) {
    try {
        let _dict: any = { ...ActionParams };//.Data as need Value
        if (!_dict[visibleIfkey]?.Data?.isVisible) return false;//edit check if main element is visible 
        if (!CheckIfVisibleIF(_dict[visibleIfkey]?.Data, ActionParams)) return false;
        let _selectedOptions: string[] = ReturnValuesForMultiSelectAsString(_dict[visibleIfkey].value);
        //console.log({ _selectedOptions, list })
        for (let i = 0; i < _selectedOptions.length; i++) {
            if (list.includes(_selectedOptions[i]))
                return true;
        }
        return false;
    } catch (e) {
        console.error(e);
        return false;
    }
}
export function ValidateRadioGroupSelectedAsStatus(visibleIfkey: string, Status: any, ActionParams: any) {
    //console.log("📓 📓 📓 📓 📓📓 📓 ", visibleIfkey);
    try {
        let _dict: any = { ...ActionParams };
        //console.log("📘 ", _dict[visibleIfkey]);
        let _selectedOption: string = String(_dict[visibleIfkey].value);
        //console.log("📓 📘 ", String(_dict[visibleIfkey].value));
        if (!_dict[visibleIfkey] || !_dict[visibleIfkey].Data || !_dict[visibleIfkey].Data.isVisible) return false;
        if (!CheckIfVisibleIF(_dict[visibleIfkey]?.Data, ActionParams)) return false;
        //console.log("!_dict[visibleIfkey] || !_dict[visibleIfkey].Data || !_dict[visibleIfkey].Data.isVisible");
        try {
            if (_dict[visibleIfkey].type === "radiogroup") {
                //console.log("_dict[visibleIfkey].type === radiogroup");
                let _choices: any = _dict[visibleIfkey].Data && _dict[visibleIfkey].Data.choices ? _dict[visibleIfkey].Data.choices : [];
                _choices = _choices.filter((item: any) => item.isVisible).map((item: any) => item.value);
                //if (visibleIfkey && visibleIfkey === "IDType" /*&& element.key === "CountryOfIssuancePassport"*/) {
                //    console.log("📘 _choices", _choices);
                //    console.log("📘 Status", Status);
                //    console.log("📓 _selectedOption", _selectedOption);
                //}
                return (Status.includes(_selectedOption) && _choices.includes(_selectedOption));
            }
            //if (visibleIfkey && visibleIfkey === "IDType" /*&& element.key === "CountryOfIssuancePassport"*/) {
            //    console.log("📘 bot radio  waht Status", Status);
            //    console.log("📓 _selectedOption", _selectedOption);
            //}
        } catch (e) {
            console.error(e);
        }
        //if (visibleIfkey && visibleIfkey === "IDType" /*&& element.key === "CountryOfIssuancePassport"*/) {
        //    console.log("📘at z End Status", Status);
        //    console.log("📓 _selectedOption", _selectedOption);
        //}
        return Status.includes(_selectedOption);
    } catch (e) {
        console.error(e);
        return false;
    }
}
export function ValidateRadioGroupisVisibleAsStatus(visibleIfkey: string, Status: any, ActionParams: any) {
    try {
        let _dict: any = { ...ActionParams };
        if (!_dict[visibleIfkey] || !_dict[visibleIfkey].Data || !_dict[visibleIfkey].Data.isVisible) return false;
        try {
            if (_dict[visibleIfkey].type === "radiogroup") {
                let _choices: any = _dict[visibleIfkey].Data && _dict[visibleIfkey].Data.choices ? _dict[visibleIfkey].Data.choices : [];
                _choices = _choices.filter((item: any) => item.isVisible).map((item: any) => item.value);
                return _choices.length > 0;
            }
        } catch (e) {
            console.error(e);
        }
        return false;
    } catch (e) {
        console.error(e);
        return false;
    }
}
export function ValidateBooleanSelectedAsStatus(visibleIfkey: string, Status: boolean, ActionParams: any) {
    try {
        let _dict: any = { ...ActionParams };
        //console.log('**enter _dict[visibleIfkey]', visibleIfkey, _dict[visibleIfkey])
        if (!_dict[visibleIfkey] || !_dict[visibleIfkey].Data || !_dict[visibleIfkey]?.Data?.isVisible) return false;
        if (!CheckIfVisibleIF(_dict[visibleIfkey]?.Data, ActionParams)) return false;
        //console.log(_dict[visibleIfkey].value, Status)
        //console.log('**passed _dict[visibleIfkey]', visibleIfkey, _dict[visibleIfkey])
        return _dict[visibleIfkey].value === Status;
    } catch (e) {
        //console.error(visibleIfkey, e);
        return false;
    }
}
/**
 * 
 * @param element
 * @param ActionParams
 * @param choices
 * @param settings allow settings to appear even it element is not visible
 */
export function CheckIfVisibleIF(element: any, ActionParams: any, choices?: any, settings?: any) {
    try {
        //not required , not optional , isVisible and option selected
        if (!settings && (!element || !element.isVisible)) return false;
        if (!element.visibleIfKey) return true;//have no condition  
        switch (element.visibleIfType) {//visibleIfType ,not the type
            case "dropdown": {
                //console.log("dropdown");
                return ValidateOneOfOptionsExists(element.visibleIfKey, element.visibleIfList, ActionParams);
            }
            case "label": {//just for dsiplay
                return ValidateOneOfElementsIsVisible(element.visibleIfKey, ActionParams);
            }
            case "multiDropdown": {
                //console.log("multiDropdown");
                return ValidateOneOfOptionsExistsInMultiSelect(element.visibleIfKey, element.visibleIfList, ActionParams);
            }
            case "boolean": {
                //console.log("boolean");

                return ValidateBooleanSelectedAsStatus(element.visibleIfKey, element.visibleIfStatus, ActionParams);
            }
            case "radiogroup": {
                //console.log("radiogroup");
                return ValidateRadioGroupSelectedAsStatus(element.visibleIfKey, element.visibleIfStatus, ActionParams);
            }
            //case "radiogroupCardElement": {//TODO check ifnot needed anymore 
            //    console.log("radiogroupCardElement");
            //    return ValidateRadioGroupisVisibleAsStatus(element.visibleIfKey, element.visibleIfStatus, ActionParams);
            //}
            default: {
                return false;
            }
        }

    } catch (e) {
        console.error(e);
        return false;
    }
}
export function CheckIfSubElement(element: any) {
    try {
        if (element.visibleIfKey) return true;
    } catch (e) {
        console.error(e);
        return false;
    }
}
export function ValidateByType(value: any, type: string) {//new fields must be added
    try {
        switch (type) {
            case "dropdown": {
                return ValidateSelect(value);
            }
            case "dynamicDropdown": {
                //must check All must have values dynaimic by default and check on manage 
                return ValidateSelect(value);
            }
            case "multiDropdown": {
                return ValidateMultiSelect(value);
            }
            case "date": {
                return validateDateAndInternval(value.date, value.Interval);
            }
            case "input":
            case "file":
                {
                    return ValidateInput(value);
                }
            case "radiogroup":
                {
                    return ValidateInput(value);
                }
            case "boolean"://TODO add all cases need no validation
            case "html":
                //case "radiogroupCardElement":
                {
                    return true;
                }
            case "inputDescription":
                {
                    return true;
                }
            case "checkbox": {
                return validateCheckBoxIsTrue(value);
            }
            default: {
                return false;
            }
        }

    } catch (e) {
        console.error(e);
        return false;
    }
}
export function ReturnLabelsForMultiSelect(list: any[]) {
    if (!list || list.length === 0) return [];
    return list.map((item: any) => item.label);
}
export function ValidateSelectAndReturnValue(selected: any) {
    if (!ValidateSelect(selected)) return " _ ";
    return selected.value;
}
export function ValidateSelectAndReturnValueID(selected: any) {
    if (!ValidateSelect(selected)) return null;
    return selected.value;
}
export const dictStatus: any = {
    '0': "Pending",
    '1': "Completed",
    '-1': "Rejected",
    '2': "Not Completed",
};
export function ReturnPlaceHolderStatement(title: string, multiSelectValue: any[], Options: any[]) {
    try {
        if (Options?.length === 0) return `No ${title} options`;
        if (multiSelectValue?.length === Options?.length) return `All ${title} selected`;
        else if (multiSelectValue && multiSelectValue.length > 0)
            return `${multiSelectValue.length} ${title} selected`;
        else
            return title;
    } catch (e) {
        return title;
    }
}
export function CheckList(list: any) {
    return list && list.length > 0;
}
export function CastTreePathForAction(list: any) {
    let _newlist: any = [...list];
    _newlist = _newlist.map((item: TreePathDefaultProfile) => {
        return {
            Depth: +(item.Depth),
            ClientID: item.ClientID,
        }
    })
    return _newlist;
}
export function CheckIflastNode(PathIndex: string, Path: any, value: string) {
    return Path.length !== 0 && String(PathIndex) !== String(Path.length - 1) ? value : "";
}
export function ReturnIBTreePaths(SelectOpt: any) {
    let _options: any = [];
    //console.log({ SelectOpt })
    for (let Opt of SelectOpt) {
        //Path PathID
        if (Opt.Path) {
            let _IBCodes = '', _clientIDs = '';
            let _maxDepth = Opt.Path.length ? Opt.Path.length : 0;
            //console.log('Opt.Path', Opt.Path)
            for (let PathIndex in Opt.Path) {
                //console.log('SelectOpt:', Opt.Path[PathIndex])
                if (Opt.Path[PathIndex]) {
                    _clientIDs += `${Opt.Path[PathIndex].ClientID}${CheckIflastNode(PathIndex, Opt.Path, '-')}`;
                    _IBCodes += `${Opt.Path[PathIndex].IBCode ? Opt.Path[PathIndex].IBCode : "None"}${CheckIflastNode(PathIndex, Opt.Path, '>')}`;
                }
                //console.log({ _IBCodes, _maxDepth, _clientIDs });
            }
            _options.push({
                value: _clientIDs,
                label: _IBCodes,
                maxDepth: _maxDepth,
                Data: Opt.Path
            });
            //console.log({ _options });
        }
    }
    if (_options.length > 0)
        return _options;
    return [];
};
export function ReturnIBTreePathKey(Path: any) {
    if (Path) {
        let _clientIDs = '';
        for (let PathIndex in Path) {
            if (Path[PathIndex]) {
                _clientIDs += `${Path[PathIndex].ClientID}${CheckIflastNode(PathIndex, Path, '-')}`;
            }
        }
        //console.log({ _clientIDs });
        return _clientIDs;
    }
}
export const OptionNone = { value: -1, label: "None" };
export function TranslateSelectOptionsAndReturnKey(list: Array<BasicSelectOption | any>, t: Function) {//add the render to fixed 
    try {
        let _list = [...list];
        for (let i = 0; i < _list.length; i++) {

            //_list[i].translationKey = String(list[i].label);//order before chnage
            //_list[i].label = t(_list[i].label);//it changes value as clone deep

            _list[i] = {
                ...list[i],
                translationKey: String(list[i].label),
                label: t(_list[i].label)
            }
        }
        //console.log({ _list })
        return _list;
    }
    catch (e) {
        console.error(e)
        return [];//or orginal
    }
}
export function TranslateSelectOption(value: BasicSelectOption | any, t: Function) {//add the render to fixed 
    try {
        //console.log("TranslateSelectOption", { value });

        let _value = {
            ...value,
            label: t(value.translationKey ? value.translationKey : value.label) //as old didnt have 
        };
        return _value;
    }
    catch (e) {
        console.error('TranslateSelectOption', e)
        return {};
    }
}
export function TranslateSelectOptions(list: Array<BasicSelectOption | any>, t: Function) {//add the didmount to fixed 
    try {
        let _list = [...list];
        for (let i = 0; i < _list.length; i++) {

            _list[i] = {
                ...list[i],
                label: t(_list[i].translationKey ? _list[i].translationKey : _list[i].label)
            }
        }
        return _list;
    }
    catch (e) {
        console.error(e)
        return [];//or orginal
    }
}
export function RevertTranslateSelectOptions(list: Array<BasicSelectOption | any>) {//lib now support option for transaltion
    try {
        if (!list || list.length === 0) return [];
        let _list = [...list];
        for (let i = 0; i < _list.length; i++) {

            _list[i] = {
                ...list[i],///TODO urgent check this 
                label: _list[i].translationKey ? _list[i].translationKey : _list[i].label
            }
        }
        return _list;
    }
    catch (e) {
        console.error(e)
        return [];//or orginal
    }
}
//#region payments
export const bankwirePayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/bankwirePayment.png`;
export const cashPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/cashPayment.png`;
export const cashuPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/cashuPayment.png`;
export const NetellerPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/netellerPayment.png`;
export const rpncupPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/rpnPay.png`;
export const rpnp2pPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/rpnPay.png`;
export const skrillEURPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/skrillPayment.png`;
export const skrillGBPPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/skrillPayment.png`;
export const skrillJPYPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/skrillPayment.png`;
export const skrillPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/skrillPayment.png`;
export const sticpayPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/sticpayPayment.png`;
export const tapUSDPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/tappay.png`;
export const tapKWDPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/tappay.png`;
export const tapKnetPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/tappay.png`;;


export const DepositClientUniquePayments: string[] = ['bankwire', 'bankwire2', 'bankwire_a', 'bankwire2_a', 'skrill', 'skrill_a', 'skrill-usd', 'skrill-gbp', 'skrill-eur', 'skrill-jpy', 'sticpay', 'tappay-creditcard-usd', 'tappay-creditcard-usd_a', 'tappay-creditcard-usd-wg', 'tappay-creditcard-usd wg_a', 'tappay-creditcard-kwd', 'tappay-creditcard-kwd-wg', 'neteller', 'tappay-knet', 'tappay-knet-wg', 'cashu', 'rpn-p2p', 'rpn-cup', 'cash', 'ecommpay', 'paysafeneteller', 'paysafeneteller_a', 'fasapay', 'bridgerpay', 'alogateway', 'powercash', 'vaultspay', 'cryptopay', 'gbprimepay', 'paystack', 'ibfskrill', 'ibfbitcoin', 'espiral', 'hayvn', 'b2binpay', 'zain cash', 'asiahawala', 'switch', 'local transfer', 'easypay', 'trustpayments', 'zaha', 'virtualpay', 'virtualpay-card', 'virtualpay-card_a', 'virtualpay-mobile', 'dusupay', 'dusupayv2', 'surepay', 'stripe', 'fast2pays', 'nowpayments', 'nowpayments_2', "match2pay", "help2pay", "match2paycreditcard", "capitalwallet", "ozow", "gatetopay", "gatetopay_a", "nace", "myfatoorah-knet", "myfatoorah_a-knet", "myfatoorah-credit card", "myfatoorah_a-credit card", 'others', 'flutterwave', 'eupaymentz', 'cryptopayment', 'oneglobal', 'oneglobal-knet', 'hesabe', 'hesabe-knet', 'hesabe-wg', 'hesabe-wg_a', 'hesabe-knet-wg_a', 'hesabe-knet-wg', 'cryptotransaction', 'cfx', 'upay', "ngnbanktransfer", 'dusupay-bank', 'dusupay-mobile', 'dusupayv2-bank', 'dusupayv2-mobile', 'asiapayment', 'whishmoney', "suyool", "suyool-mobile", "knet", "knetsecondary", "knettertiary", "capitecpay", "unipayment", "transvoucher", "casheerpay", "casheerpay_visacard", "casheerpay_kent", "overchain"];//BigPay not unique
export const ClientWithdrawalUniquePayments: string[] = ['cash', 'bankwire', 'bankwire2', 'bankwire_a', 'bankwire2_a', 'ecommpay', 'rpn-p2p', 'skrill', 'skrill_a', 'sticpay', 'neteller', 'alogateway', 'unionpay', 'fxbit', 'thunderpay', 'globepay', 'gbprimepay', 'ibfskrill', 'ibfbitcoin', 'perfectmoney', 'cryptopay', 'b2binpay', 'easywire', 'zain cash', 'asiahawala', 'switch', 'local transfer', 'easypay', 'zaha', 'surepay', 'fast2pays', 'ninepay', 'match2pay', "bigpay", "bigpayv2", "ozow", "nowpayments", "nowpayments_2", "gatetopay", "gatetopay_a", "capitalwallet", "bridgerpay", "others", "fasapay", "other1", "other2", "other3", "other4", "other5", "other6", "other7", "other8", "flutterwave", "crypto", "vndpayment", 'cryptotransaction', 'upay', 'dusupay-bank', 'dusupay-mobile', 'dusupayv2-bank', 'dusupayv2-mobile', 'asiapayment', "overchain"];
//#region IB images 
export const IBFSkrill = require("../../src/Assets/imgs/Skrill.png") as string;
export const IBFBitcoin = require("../../src/Assets/imgs/BitCoin.png") as string;
export const BitCoinWallet = '1NihS7yo31Ly14C63G2eNynvbCb4EwnXTX';
//#endregion
//#region Alogateway withdrawal
export const ChineseBankNames: any = [
    {
        "BankCode": "BJRCB",
        "BankNameEN": "Beijing Rural Commerical Bank",
        "BankNameCN": "北京农商银行"
    },
    {
        "BankCode": "CBHB",
        "BankNameEN": "China Bohai Bank",
        "BankNameCN": "渤海银行"
    },
    {
        "BankCode": "SJBANK",
        "BankNameEN": "Shengjing Bank",
        "BankNameCN": "盛京银行"
    },
    {
        "BankCode": "FUDIAN",
        "BankNameEN": "Fudian Bank",
        "BankNameCN": "富滇银行"
    },
    {
        "BankCode": "CQC",
        "BankNameEN": "Bank Of Chongqing",
        "BankNameCN": "重庆银行"
    },
    {
        "BankCode": "NCB",
        "BankNameEN": "Nanyang Commerical bank (CHINA) Limited",
        "BankNameCN": "南洋商业银行"
    },
    {
        "BankCode": "BOD",
        "BankNameEN": "Bank Of Dongguan",
        "BankNameCN": "东莞银行"
    },
    {
        "BankCode": "TZB",
        "BankNameEN": "Bank Of Taizhou",
        "BankNameCN": "台州银行"
    },
    {
        "BankCode": "HFB",
        "BankNameEN": "Evergrowing Bank",
        "BankNameCN": "恒丰银行"
    },
    {
        "BankCode": "HSBC",
        "BankNameEN": "HSBC China",
        "BankNameCN": "汇丰银行"
    },
    {
        "BankCode": "ZJTLCB",
        "BankNameEN": "ZhejiangTailong Commercial Bank",
        "BankNameCN": "浙江泰隆商业银行"
    },
    {
        "BankCode": "URCB",
        "BankNameEN": "Hangzhou United Bank",
        "BankNameCN": "杭州联合银行"
    },
    {
        "BankCode": "YKRS",
        "BankNameEN": "Yingkou Rongsheng Rural Commercial Bank",
        "BankNameCN": "营口融生农村商业银行"
    },
    {
        "BankCode": "LZB",
        "BankNameEN": "Bank of Lanzhou",
        "BankNameCN": "兰州银行"
    },
    {
        "BankCode": "UCCB",
        "BankNameEN": "Urumqi City Commercial Bank",
        "BankNameCN": "乌鲁木齐市商业银行"
    },
    {
        "BankCode": "CITIBANK",
        "BankNameEN": "Citibank China",
        "BankNameCN": "花旗银行"
    },
    {
        "BankCode": "BSB",
        "BankNameEN": "Baoshang Bank",
        "BankNameCN": "包商银行"
    },
    {
        "BankCode": "HZB",
        "BankNameEN": "Bank of Hangzhou",
        "BankNameCN": "杭州银行"
    },
    {
        "BankCode": "MIZUHO",
        "BankNameEN": "Mizuho Financial Group",
        "BankNameCN": "瑞穗实业银行(中国)有限公司"
    },
    {
        "BankCode": "GZCB",
        "BankNameEN": "Bank of Guangzhou",
        "BankNameCN": "广州银行"
    },
    {
        "BankCode": "SZRUCOMM",
        "BankNameEN": "Shenzhen Rural Commercial Bank",
        "BankNameCN": "深圳农村商业银行"
    },
    {
        "BankCode": "SRCB",
        "BankNameEN": "Shanghai Rural Commercial Bank",
        "BankNameCN": "上海农商银行"
    },
    {
        "BankCode": "HSB",
        "BankNameEN": "Huishang Bank",
        "BankNameCN": "徽商银行"
    },
    {
        "BankCode": "SHB",
        "BankNameEN": "Bank of Shanghai",
        "BankNameCN": "上海银行"
    },
    {
        "BankCode": "CZCB",
        "BankNameEN": "Zhejiang Chouzhou Commercial Bank",
        "BankNameCN": "浙江稠州商业银行"
    },
    {
        "BankCode": "CQRCB",
        "BankNameEN": "Chongqing Rural Commercial Bank",
        "BankNameCN": "重庆农村商业银行"
    },
    {
        "BankCode": "BOFS",
        "BankNameEN": "Bank of Fushun",
        "BankNameCN": "抚顺银行"
    },
    {
        "BankCode": "ICBC",
        "BankNameEN": "Industry and Commercial Bank of China",
        "BankNameCN": "中国工商银行"
    },
    {
        "BankCode": "ABC",
        "BankNameEN": "Agricultural Bank of China",
        "BankNameCN": "中国农业银行"
    },
    {
        "BankCode": "BOC",
        "BankNameEN": "Bank of China",
        "BankNameCN": "中国银行"
    },
    {
        "BankCode": "CCB",
        "BankNameEN": "China ConstructionBank",
        "BankNameCN": "中国建设银行"
    },
    {
        "BankCode": "BCOM",
        "BankNameEN": "Bank of Communications",
        "BankNameCN": "交通银行"
    },
    {
        "BankCode": "CMB",
        "BankNameEN": "China Merchants Bank",
        "BankNameCN": "招商银行"
    },
    {
        "BankCode": "CMBC",
        "BankNameEN": "China Mingsheng Banking",
        "BankNameCN": "中国民生银行"
    },
    {
        "BankCode": "CIB",
        "BankNameEN": "Industrial Bank",
        "BankNameCN": "兴业银行"
    },
    {
        "BankCode": "China Debit Card Processing – API Specification"
    },
    {
        "BankCode": "13"
    },
    {
        "BankCode": "SPDB",
        "BankNameEN": "Shanghai Pudong Development Bank",
        "BankNameCN": "浦发银行"
    },
    {
        "BankCode": "PSBC",
        "BankNameEN": "Postal Savings Bank of China",
        "BankNameCN": "中国邮政储蓄银行"
    },
    {
        "BankCode": "BEA",
        "BankNameEN": "The Bank of East Asia(China) Limited",
        "BankNameCN": "东亚银行"
    },
    {
        "BankCode": "HXB",
        "BankNameEN": "Huaxia Bank",
        "BankNameCN": "华夏银行"
    },
    {
        "BankCode": "CITIC",
        "BankNameEN": "China CITIC Bank",
        "BankNameCN": "中信银行"
    },
    {
        "BankCode": "CEB",
        "BankNameEN": "China Everbright Bank",
        "BankNameCN": "中国光大银行"
    },
    {
        "BankCode": "CGB",
        "BankNameEN": "China Guangfa Bank",
        "BankNameCN": "广发银行"
    },
    {
        "BankCode": "PINGAN",
        "BankNameEN": "Ping An Bank",
        "BankNameCN": "平安银行"
    },
    {
        "BankCode": "NBCB",
        "BankNameEN": "Bank of Ningbo",
        "BankNameCN": "宁波银行"
    },
    {
        "BankCode": "BOB",
        "BankNameEN": "Bank of Beijing",
        "BankNameCN": "北京银行"
    },
    {
        "BankCode": "CDRCB",
        "BankNameEN": "Chengdu Rural Commercial Bank",
        "BankNameCN": "成都农商银行"
    },
    {
        "BankCode": "BHB",
        "BankNameEN": "Bank of Hebei",
        "BankNameCN": "河北银行"
    },
    {
        "BankCode": "BYK",
        "BankNameEN": "Bank of Yingkou",
        "BankNameCN": "营口银行"
    },
    {
        "BankCode": "BOT",
        "BankNameEN": "Bank of Tianjin",
        "BankNameCN": "天津银行"
    },
    {
        "BankCode": "BNC",
        "BankNameEN": "Bank of Nanchang",
        "BankNameCN": "南昌银行"
    },
    {
        "BankCode": "FJHX",
        "BankNameEN": "Fujian Haixia Bank",
        "BankNameCN": "福建海峡银行"
    },
    {
        "BankCode": "BOJZ",
        "BankNameEN": "Bank of Jinzhou",
        "BankNameCN": "锦州银行"
    },
    {
        "BankCode": "ZSBANK",
        "BankNameEN": "China Zheshang Bank",
        "BankNameCN": "浙商银行"
    },
    {
        "BankCode": "WZCB",
        "BankNameEN": "Bank of Wenzhou",
        "BankNameCN": "温州银行"
    },
    {
        "BankCode": "WHCCB",
        "BankNameEN": "Weihai City CommercialBank",
        "BankNameCN": "威海市商业银行"
    },
    {
        "BankCode": "SXCCB",
        "BankNameEN": "Bank of Shaoxing",
        "BankNameCN": "绍兴银行"
    },
    {
        "BankCode": "CABANK",
        "BankNameEN": "Chang'an Bank",
        "BankNameCN": "长安银行"
    },
    {
        "BankCode": "ZJMTCOMM",
        "BankNameEN": "Zhejiang Mintai Commercial Bank",
        "BankNameCN": "浙江民泰商业银行"
    },
    {
        "BankCode": "QDCCB",
        "BankNameEN": "Bank of Qingdao",
        "BankNameCN": "青岛银行"
    },
    {
        "BankCode": "BOXI",
        "BankNameEN": "Bank of Xi'an",
        "BankNameCN": "西安银行"
    },
    {
        "BankCode": "ADBC",
        "BankNameEN": "Agricultural Development Bank of China",
        "BankNameCN": "中国农业发展银行"
    },
    {
        "BankCode": "KEB",
        "BankNameEN": "KEB Bank(China)",
        "BankNameCN": "外换银行（中国）有限公司"
    },
    {
        "BankCode": "BODL",
        "BankNameEN": "Bank of Dalian",
        "BankNameCN": "大连银行"
    },
    {
        "BankCode": "NJCB",
        "BankNameEN": "Bank of Nanjing",
        "BankNameCN": "南京银行"
    }

]
export const CNProvince: any = {
    "110000": "北京市",
    "120000": "天津市",
    "130000": "河北省",
    "140000": "山西省",
    "150000": "内蒙古自治区",
    "210000": "辽宁省",
    "220000": "吉林省",
    "230000": "黑龙江省",
    "310000": "上海市",
    "320000": "江苏省",
    "330000": "浙江省",
    "340000": "安徽省",
    "350000": "福建省",
    "360000": "江西省",
    "370000": "山东省",
    "410000": "河南省",
    "420000": "湖北省",
    "430000": "湖南省",
    "440000": "广东省",
    "450000": "广西壮族自治区",
    "460000": "海南省",
    "500000": "重庆市",
    "510000": "四川省",
    "520000": "贵州省",
    "530000": "云南省",
    "540000": "西藏自治区",
    "610000": "陕西省",
    "620000": "甘肃省",
    "630000": "青海省",
    "640000": "宁夏回族自治区",
    "650000": "新疆维吾尔自治区"
}
export const CNCity: any = {
    "110100": "北京市",
    "120100": "天津市",
    "130100": "石家庄市",
    "130200": "唐山市",
    "130300": "秦皇岛市",
    "130400": "邯郸市",
    "130500": "邢台市",
    "130600": "保定市",
    "130700": "张家口市",
    "130800": "承德市",
    "130900": "沧州市",
    "131000": "廊坊市",
    "131100": "衡水市",
    "140100": "太原市",
    "140200": "大同市",
    "140300": "阳泉市",
    "140400": "长治市",
    "140500": "晋城市",
    "140600": "朔州市",
    "140700": "晋中市",
    "140800": "运城市",
    "140900": "忻州市",
    "141000": "临汾市",
    "141100": "吕梁市",
    "150100": "呼和浩特市",
    "150200": "包头市",
    "150300": "乌海市",
    "150400": "赤峰市",
    "150500": "通辽市",
    "150600": "鄂尔多斯市",
    "150700": "呼伦贝尔市",
    "150800": "巴彦淖尔市",
    "150900": "乌兰察布市",
    "152200": "兴安盟",
    "152500": "锡林郭勒盟",
    "152900": "阿拉善盟",
    "210100": "沈阳市",
    "210200": "大连市",
    "210300": "鞍山市",
    "210400": "抚顺市",
    "210500": "本溪市",
    "210600": "丹东市",
    "210700": "锦州市",
    "210800": "营口市",
    "210900": "阜新市",
    "211000": "辽阳市",
    "211100": "盘锦市",
    "211200": "铁岭市",
    "211300": "朝阳市",
    "211400": "葫芦岛市",
    "220100": "长春市",
    "220200": "吉林市",
    "220300": "四平市",
    "220400": "辽源市",
    "220500": "通化市",
    "220600": "白山市",
    "220700": "松原市",
    "220800": "白城市",
    "222400": "延边朝鲜族自治州",
    "230100": "哈尔滨市",
    "230200": "齐齐哈尔市",
    "230300": "鸡西市",
    "230400": "鹤岗市",
    "230500": "双鸭山市",
    "230600": "大庆市",
    "230700": "伊春市",
    "230800": "佳木斯市",
    "230900": "七台河市",
    "231000": "牡丹江市",
    "231100": "黑河市",
    "231200": "绥化市",
    "232700": "大兴安岭地区",
    "310100": "上海市",
    "320100": "南京市",
    "320200": "无锡市",
    "320300": "徐州市",
    "320400": "常州市",
    "320500": "苏州市",
    "320600": "南通市",
    "320700": "连云港市",
    "320800": "淮安市",
    "320900": "盐城市",
    "321000": "扬州市",
    "321100": "镇江市",
    "321200": "泰州市",
    "321300": "宿迁市",
    "330100": "杭州市",
    "330200": "宁波市",
    "330300": "温州市",
    "330400": "嘉兴市",
    "330500": "湖州市",
    "330600": "绍兴市",
    "330700": "金华市",
    "330800": "衢州市",
    "330900": "舟山市",
    "331000": "台州市",
    "331100": "丽水市",
    "340100": "合肥市",
    "340200": "芜湖市",
    "340300": "蚌埠市",
    "340400": "淮南市",
    "340500": "马鞍山市",
    "340600": "淮北市",
    "340700": "铜陵市",
    "340800": "安庆市",
    "341000": "黄山市",
    "341100": "滁州市",
    "341200": "阜阳市",
    "341300": "宿州市",
    "341500": "六安市",
    "341600": "亳州市",
    "341700": "池州市",
    "341800": "宣城市",
    "350100": "福州市",
    "350200": "厦门市",
    "350300": "莆田市",
    "350400": "三明市",
    "350500": "泉州市",
    "350600": "漳州市",
    "350700": "南平市",
    "350800": "龙岩市",
    "350900": "宁德市",
    "360100": "南昌市",
    "360200": "景德镇市",
    "360300": "萍乡市",
    "360400": "九江市",
    "360500": "新余市",
    "360600": "鹰潭市",
    "360700": "赣州市",
    "360800": "吉安市",
    "360900": "宜春市",
    "361000": "抚州市",
    "361100": "上饶市",
    "370100": "济南市",
    "370200": "青岛市",
    "370300": "淄博市",
    "370400": "枣庄市",
    "370500": "东营市",
    "370600": "烟台市",
    "370700": "潍坊市",
    "370800": "济宁市",
    "370900": "泰安市",
    "371000": "威海市",
    "371100": "日照市",
    "371200": "莱芜市",
    "371300": "临沂市",
    "371400": "德州市",
    "371500": "聊城市",
    "371600": "滨州市",
    "371700": "菏泽市",
    "410100": "郑州市",
    "410200": "开封市",
    "410300": "洛阳市",
    "410400": "平顶山市",
    "410500": "安阳市",
    "410600": "鹤壁市",
    "410700": "新乡市",
    "410800": "焦作市",
    "410900": "濮阳市",
    "411000": "许昌市",
    "411100": "漯河市",
    "411200": "三门峡市",
    "411300": "南阳市",
    "411400": "商丘市",
    "411500": "信阳市",
    "411600": "周口市",
    "411700": "驻马店市",
    "420100": "武汉市",
    "420200": "黄石市",
    "420300": "十堰市",
    "420500": "宜昌市",
    "420600": "襄阳市",
    "420700": "鄂州市",
    "420800": "荆门市",
    "420900": "孝感市",
    "421000": "荆州市",
    "421100": "黄冈市",
    "421200": "咸宁市",
    "421300": "随州市",
    "422800": "恩施土家族苗族自治州",
    "429006": "天门市",
    "430100": "长沙市",
    "430200": "株洲市",
    "430300": "湘潭市",
    "430400": "衡阳市",
    "430500": "邵阳市",
    "430600": "岳阳市",
    "430700": "常德市",
    "430800": "张家界市",
    "430900": "益阳市",
    "431000": "郴州市",
    "431100": "永州市",
    "431200": "怀化市",
    "431300": "娄底市",
    "433100": "湘西土家族苗族自治州",
    "440100": "广州市",
    "440200": "韶关市",
    "440300": "深圳市",
    "440400": "珠海市",
    "440500": "汕头市",
    "440600": "佛山市",
    "440700": "江门市",
    "440800": "湛江市",
    "440900": "茂名市",
    "441200": "肇庆市",
    "441300": "惠州市",
    "441400": "梅州市",
    "441500": "汕尾市",
    "441600": "河源市",
    "441700": "阳江市",
    "441800": "清远市",
    "441900": "东莞市",
    "442000": "中山市",
    "445100": "潮州市",
    "445200": "揭阳市",
    "445300": "云浮市",
    "450100": "南宁市",
    "450200": "柳州市",
    "450300": "桂林市",
    "450400": "梧州市",
    "450500": "北海市",
    "450600": "防城港市",
    "450700": "钦州市",
    "450800": "贵港市",
    "450900": "玉林市",
    "451000": "百色市",
    "451100": "贺州市",
    "451200": "河池市",
    "451300": "来宾市",
    "451400": "崇左市",
    "460100": "海口市",
    "460200": "三亚市",
    "460300": "三沙市",
    "469000": "省直辖县级行政区划",
    "500100": "重庆市",
    "510100": "成都市",
    "510300": "自贡市",
    "510400": "攀枝花市",
    "510500": "泸州市",
    "510600": "德阳市",
    "510700": "绵阳市",
    "510800": "广元市",
    "510900": "遂宁市",
    "511000": "内江市",
    "511100": "乐山市",
    "511300": "南充市",
    "511400": "眉山市",
    "511500": "宜宾市",
    "511600": "广安市",
    "511700": "达州市",
    "511800": "雅安市",
    "511900": "巴中市",
    "512000": "资阳市",
    "513200": "阿坝藏族羌族自治州",
    "513300": "甘孜藏族自治州",
    "513400": "凉山彝族自治州",
    "520100": "贵阳市",
    "520200": "六盘水市",
    "520300": "遵义市",
    "520400": "安顺市",
    "520500": "毕节市",
    "520600": "铜仁市",
    "522300": "黔西南布依族苗族自治州",
    "522600": "黔东南苗族侗族自治州",
    "522700": "黔南布依族苗族自治州",
    "530100": "昆明市",
    "530300": "曲靖市",
    "530400": "玉溪市",
    "530500": "保山市",
    "530600": "昭通市",
    "530700": "丽江市",
    "530800": "普洱市",
    "530900": "临沧市",
    "532300": "楚雄彝族自治州",
    "532500": "红河哈尼族彝族自治州",
    "532600": "文山壮族苗族自治州",
    "532800": "西双版纳傣族自治州",
    "532900": "大理白族自治州",
    "533100": "德宏傣族景颇族自治州",
    "533300": "怒江傈僳族自治州",
    "533400": "迪庆藏族自治州",
    "540100": "拉萨市",
    "542100": "昌都地区",
    "542200": "山南地区",
    "542300": "日喀则地区",
    "542400": "那曲地区",
    "542500": "阿里地区",
    "542600": "林芝地区",
    "610100": "西安市",
    "610200": "铜川市",
    "610300": "宝鸡市",
    "610400": "咸阳市",
    "610500": "渭南市",
    "610600": "延安市",
    "610700": "汉中市",
    "610800": "榆林市",
    "610900": "安康市",
    "611000": "商洛市",
    "620100": "兰州市",
    "620200": "嘉峪关市",
    "620300": "金昌市",
    "620400": "白银市",
    "620500": "天水市",
    "620600": "武威市",
    "620700": "张掖市",
    "620800": "平凉市",
    "620900": "酒泉市",
    "621000": "庆阳市",
    "621100": "定西市",
    "621200": "陇南市",
    "622900": "临夏回族自治州",
    "623000": "甘南藏族自治州",
    "630100": "西宁市",
    "632100": "海东地区",
    "632200": "海北藏族自治州",
    "632300": "黄南藏族自治州",
    "632500": "海南藏族自治州",
    "632600": "果洛藏族自治州",
    "632700": "玉树藏族自治州",
    "632800": "海西蒙古族藏族自治州",
    "640100": "银川市",
    "640200": "石嘴山市",
    "640300": "吴忠市",
    "640400": "固原市",
    "640500": "中卫市",
    "650100": "乌鲁木齐市",
    "650200": "克拉玛依市",
    "652100": "吐鲁番地区",
    "652200": "哈密地区",
    "652300": "昌吉回族自治州",
    "652700": "博尔塔拉蒙古自治州",
    "652800": "巴音郭楞蒙古自治州",
    "652900": "阿克苏地区",
    "653000": "克孜勒苏柯尔克孜自治州",
    "653100": "喀什地区",
    "653200": "和田地区",
    "654000": "伊犁哈萨克自治州",
    "654200": "塔城地区",
    "654300": "阿勒泰地区"
}
//#endregion
//#region GBPrime withdrawal
export const GBPRIME_BANK_CODES = [
    { value: "001", label: "Bank of Thailand" },
    { value: "002", label: "Bangkok Bank Public Company Limited" },
    { value: "004", label: "Kasikornbank Public CompanyLimited" },
    { value: "005", label: "The Royal Bank of Scotland N.V." },
    { value: "006", label: "Krung Thai Bank Public Company Limited" },
    { value: "008", label: "JP Morgan Chase Bank" },
    { value: "011", label: "TTB Bank" },
    { value: "014", label: "Siam Commercial Bank Public Company Limited" },
    { value: "017", label: "Citibank N.A." },
    { value: "018", label: "Sumitomo Mitsui Banking Corporation" },
    { value: "020", label: "Standard Chartered Bank (Thai) Public Company Limited" },
    { value: "022", label: "CIMB Thai Bank Public Company Limited" },
    { value: "024", label: "United Overseas Bank (Thai) PCL" },
    { value: "025", label: "Bank of Ayudhya Public Company Limited" },
    { value: "026", label: "Mega International Commercial Bank PCL" },
    { value: "027", label: "Bank of America National Association" },
    { value: "030", label: "Government Saving Bank" },
    { value: "031", label: "Hong Kong & Shanghai Corporation Limited" },
    { value: "032", label: "Deutsche Bank Aktiengesellschaft" },
    { value: "033", label: "Government Housing Bank" },
    { value: "034", label: "Bank for Agriculture and Agricultural Cooperatives" },
    { value: "039", label: "Mizuho Corporate Bank Limited" },
    { value: "045", label: "BNP Paribas Bank" },
    { value: "052", label: "Bank of China ( Thai ) Public Company Limited" },
    { value: "066", label: "Islamic Bank of Thailand" },
    { value: "067", label: "Tisco Bank Public Company Limited" },
    { value: "069", label: "Kiatnakin Bank Public Company Limited" },
    { value: "070", label: "ICBC Thai Commercial Bank" },
    { value: "071", label: "The Thai Credit Retail Bank Public Company Limited" },
    { value: "073", label: "Land and Houses Bank Public Company Limited" },
    { value: "079", label: "ANZ Bank (Thai) Public Company Limited" },
]
//#endregion
export function CheckTextIsSimplifiedChinese(inputText: string) {
    let reqChinese = /^[\u4E00-\u9FCC]+$/;
    return reqChinese.test(inputText);
}
export function toDataUrl(url: any, callback: any) {
    var xhr: any = new XMLHttpRequest();
    xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
            callback(reader.result);
        }
        reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
}
export function ReturnPaymentIndexsGroupedBy3(list: any) {
    let _paymentIndexs: any = [];
    if (!list || list.length === 0) return _paymentIndexs;
    if (list.length <= 3) {
        _paymentIndexs.push({ start: 0, end: list.length });
        return _paymentIndexs;
    }
    let _count = 0;
    for (let i = 0; i < list.length; i++) {
        if (++_count === 3 || (i === list.length - 1)) {
            _paymentIndexs.push({ start: _paymentIndexs.length * 3, end: i });//_paymentIndexs.length is each round 3
            _count = 0;
        }
    }
    return _paymentIndexs;
}
export const IBGroupingOptionsDict: any = {
    "ib": 'IB',
    "account": 'Account',
    "symbol": 'Symbol',
    "all": 'ViewAll'
}
export function getBase64Image(url: any) {
    // Initialize the XMLHttpRequest and wait until file is loaded
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
        // Create a Uint8Array from ArrayBuffer
        var codes: any = new Uint8Array(xhr.response);

        // Get binary string from UTF-16 code units
        var bin = String.fromCharCode.apply(null, codes);

        // Convert binary to Base64
        var b64 = btoa(bin);
        //console.log(b64); //-> "R0lGODdhAQABAPAAAP8AAAAAACwAAAAAAQABAAACAkQBADs="

    };

    // Send HTTP request and fetch file as ArrayBuffer
    xhr.open('GET', url);
    xhr.responseType = 'arraybuffer';
    xhr.send();
}
export function ReturnSecuirtyTypeTitle(SecuirtyType: string) {
    if (!SecuirtyType) return ' - ';
    switch (SecuirtyType) {
        case "FX": {
            return "FX - Leverage";
        } case "Futures": {
            return "Futures - Multipler";
        } case "CFD": {
            return "CFD - Percentage";
        } case "INX": {
            return "INX - Percentage";
        } case "CFDLEV": {
            return "CFDLEV - Percentage";
        }
        default: {
            return SecuirtyType;
        }
    }
}

export const SecuirtyTypes = {
    "FX - Leverage": "FX",
    "Futures - Multipler": "Futures",
    "CFD - Percentage": "CFD",
    "INX - Percentage": "INX",
    "CFDLEV - Percentage": "CFDLEV"
}
export function parseFloatIfValid(number: any) {
    if (!number) return 0;
    return number;
}
export function getProperty(obj: any, prop: any) {
    try {
        let _prop = prop.replace('?', '');//as in links ? 
        let key;
        for (key in obj) {
            if (key.replace('?', '').toLowerCase() === _prop.toLowerCase()) {
                return obj[key];
            }
        }
        return "";
    } catch (e) {
        return "";
    }
}
export function ReturnLinkName(Type: any, PoolID: any) {
    try {
        switch (Type) {
            case "Demo Account": {
                return `DemoAccountWrapper${PoolID ? '-' + PoolID : ''}`;
            } case "Real Account": {
                return `RealAccountWrapper${PoolID ? '-' + PoolID : ''}`;
            }
            default: {
                return ''
            }
        }
    } catch (e) {
        return "";
    }
}
export function ReturnIframeName(Type: any) {
    try {
        switch (Type) {
            case "Demo Account": {
                return `DemoAccountIFrame`;
            } case "Real Account": {
                return `RealAccountIframe`;
            }
            default: {
                return ''
            }
        }
    } catch (e) {
        return "";
    }
}
export function CheckGUIDisValid(GUIDString: any) {
    if (!GUIDString || GUIDString === "null") return false;
    if (GUIDString !== "00000000-0000-0000-0000-000000000000") return false;
    return true;
}
export function ReturnValuesForMultiSelectWithTranslation(list: any[], t: Function) {
    if (!list || list.length === 0) return [];
    return list.map((item: any) => t(item.value));
}
export function ReturnTitlesWithTranslation(list: any[], t: Function) {
    if (!list || list.length === 0) return [];
    return list.map((item: any) => t(item));
}
export function ReturnValidStock(jsonString: string) {
    if (!jsonString) return [];
    let _result: any = [];
    try { _result = JSON.parse(jsonString) }
    catch (error) {
        console.error('ReturnValidStock', error);
        return [];
    }
    return _result;
}
export function ReturnValidJson(jsonString: string, Default: any) {
    if (!jsonString) return Default;
    let _result: any = Default;
    try { _result = JSON.parse(jsonString) }
    catch (error) {
        console.error('ReturnValidJson', error);
        return Default;
    }
    return _result;
}
export const BIGCHARTS: string[] = ["BestWorstTrade", "NetAssetValue", "ROIChart"];
export const SMALLCHARTS: string[] = ["GainTest", "NetAssetNumber", "AverageLoss", "AverageGain", "ROI", "MeanReturn"];
export const BIGCHARTSDict: any = {
    "BestWorstTrade": true,
    "NetAssetValue": true,
    "ROIChart": true
};
export const SMALLCHARTSDict: any = {
    "GainTest": true,
    "NetAssetNumber": true,
    "AverageLoss": true,
    "AverageGain": true,
    "ROI": true,
    "MeanReturn": true,
    //"AccountSummaryStatus1": true,
    //"AccountSummaryStatus2": true,
};
//#region Logs 
export const ActionNames: any = [
    { value: "Full", label: "Full", ModuleName: "Full", PermissionType: "Full" },
    { value: "Register New Client", label: "Register New Client", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage Client", label: "Manage Client", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Upload Clients CSV", label: "Upload Clients CSV", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Register Demo Account", label: "Register Demo Account", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage Wallet", label: "Manage Wallet", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage Contact", label: "Manage Contact", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Assign Contact to Client", label: "Assign Contact to Client", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Convert Contact to Client", label: "Convert Contact to Client", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage Lead", label: "Manage Lead", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Convert Lead to Contact", label: "Convert Lead to Contact", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage Task", label: "Manage Task", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage Note", label: "Manage Note", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage Wallet Currencies", label: "Manage Wallet Currencies", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage IBCode Range", label: "Manage IBCode Range", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage App Form", label: "Manage App Form", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage User", label: "Manage User", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage Pool", label: "Manage Pool", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage ClientID Range", label: "Manage ClientID Range", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage Countries", label: "Manage Countries", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Request Reset Password", label: "Request Reset Password", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Confirm Reset Password", label: "Confirm Reset Password", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Validate User Email", label: "Validate User Email", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Manage User", label: "Manage User", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Update User Password", label: "Update User Password", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Block/Unblock User", label: "Block/Unblock User", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Validate User", label: "Validate User", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Sync Groups", label: "Sync Groups", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Manage Company Setting", label: "Manage Company Setting", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Manage Payment", label: "Manage Payment", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Manage Affiliate Settings", label: "Manage Affiliate Settings", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Manage Team", label: "Manage Team", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Manage Role", label: "Manage Role", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Manage MAM Profile", label: "Manage MAM Profile", ModuleName: "MAMPortal", PermissionType: "MAM" },
    { value: "Bulk Manage MAM Profile", label: "Bulk Manage MAM Profile", ModuleName: "MAMPortal", PermissionType: "MAM" },
    { value: "Force Performance Fee", label: "Force Performance Fee", ModuleName: "MAMPortal", PermissionType: "MAM" },
    { value: "Sync Groups", label: "Sync Groups", ModuleName: "MAMPortal", PermissionType: "MAM" },
    { value: "Registration Fee", label: "Registration Fee", ModuleName: "MAMPortal", PermissionType: "MAM" },
    { value: "Management Fee", label: "Management Fee", ModuleName: "MAMPortal", PermissionType: "MAM" },
    { value: "Manage Signal Profile", label: "Manage Signal Profile", ModuleName: "Signal", PermissionType: "MAM" },
    { value: "Link IB Accounts", label: "Link IB Accounts", ModuleName: "IBPortal", PermissionType: "IB" },
    { value: "IBDefaultProfile", label: "IB Default Profile", ModuleName: "IBPortal", PermissionType: "IB" },
    { value: "Manage IB Allocation", label: "Manage IB Allocation", ModuleName: "IBPortal", PermissionType: "IB" },
    { value: "Validate App Form", label: "Validate App Form", ModuleName: "OnBoarding", PermissionType: "OnBoarding" },
    { value: "Manage DM Profile", label: "Manage Dynamic Profile", ModuleName: "DMPortal", PermissionType: "DynamicMargin" },
    { value: "Delete DM Profiles", label: "Delete Symbol Profiles", ModuleName: "DMPortal", PermissionType: "DynamicMargin" },
    { value: "Delete DM Exposure", label: "Delete Account Exposure Profiles", ModuleName: "DMPortal", PermissionType: "DynamicMargin" },
    { value: "Upload Bonus CSV", label: "Upload Bonus CSV", ModuleName: "BonusService", PermissionType: "Bonus" },
    { value: "Deposit Bonus", label: "Deposit Bonus", ModuleName: "BonusService", PermissionType: "Bonus" },
    { value: "Withdrawal", label: "Withdrawal", ModuleName: "BonusService", PermissionType: "Bonus" },
    { value: "Add Bonus Credit", label: "Add Bonus Credit", ModuleName: "BonusService", PermissionType: "Bonus" },
    { value: "StopOut", label: "StopOut", ModuleName: "BonusService", PermissionType: "Bonus" },
    { value: "App/Dec App Form Request", label: "App/Dec App Form Request", ModuleName: "BackOffice", PermissionType: "BackOffice" },
    { value: "Manage Compliance Answers", label: "Manage Compliance Answers", ModuleName: "BackOffice", PermissionType: "BackOffice" },
    { value: "Add Demo Account", label: "Add Demo Account", ModuleName: "Trader", PermissionType: "Trader" },
    { value: "Manage Trading Account", label: "Manage Trading Account", ModuleName: "Trader", PermissionType: "Trader" },
    { value: "Manage Trader Request", label: "Manage Trader Request", ModuleName: "Trader", PermissionType: "Trader" },
    { value: "Link Account to Client", label: "Link Account to Client", ModuleName: "Trader", PermissionType: "Trader" },
    { value: "Manage Registration Group", label: "Manage Registration Group", ModuleName: "Trader", PermissionType: "Trader" },
    { value: "Manage Currencies", label: "Manage Currencies", ModuleName: "Trader", PermissionType: "Trader" },
    { value: "Manage Account Type", label: "Manage Account Type", ModuleName: "Trader", PermissionType: "Trader" },
    { value: "Manage Login Range", label: "Manage Login Range", ModuleName: "Trader", PermissionType: "Trader" },
    { value: "Manage Leverage", label: "Manage Leverage", ModuleName: "Trader", PermissionType: "Trader" },
    { value: "Allocate Trading Account", label: "Allocate Trading Account (Bonus)", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Allocate Cash Account", label: "Allocate Cash Account", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Allocate Client", label: "Allocate Client (Bonus)", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Unallocate Client", label: "Unallocate Client", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Upload CSV Bonus", label: "Upload CSV Bonus", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Claim Bonus", label: "Claim Bonus", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Delete Promotion", label: "Delete Promotion", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Add Cash Bonus", label: "Add Cash Bonus", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Add New Promotion", label: "Add New Promotion", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Update Promotion", label: "Update Promotion", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Update Cash Bonus", label: "Update Cash Bonus", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Add RPConfig", label: "Add RPConfig", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Update Bonus Settings", label: "Update Bonus Settings", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Generate Bonus Token", label: "Generate Bonus Token", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Add Priority Group", label: "Add Priority Group", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Update Priority Group", label: "Update Priority Group", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Delete Priority Group", label: "Delete Priority Group", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Generate Client Promo Code", label: "Generate Client Promo Code", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Add Bonus Credit", label: "Add Bonus Credit", ModuleName: "BonusPortal", PermissionType: "Bonus" },
]
export const ModuleNames: any = [
    { value: "Full", label: "Full", PermissionType: "Full" },
    { value: "Clients", label: "Clients", PermissionType: "Client" },
    { value: "OnBoarding", label: "On Boarding", PermissionType: "OnBoarding" },
    { value: "Trader", label: "Trader", PermissionType: "Trader" },
    { value: "IBPortal", label: "Partners", PermissionType: "IB" },
    { value: "MAMPortal", label: "MAM", PermissionType: "MAM" },
    { value: "Signal", label: "Signal", PermissionType: "MAM" },
    { value: "DMPortal", label: "Dyanmic Margin", PermissionType: "DynamicMargin" },
    { value: "BackOffice", label: "Back Office", PermissionType: "BackOffice" },
    { value: "BonusPortal", label: "Bonus", PermissionType: "Bonus" },
    { value: "BonusService", label: "Bonus Service", PermissionType: "Bonus" },
    { value: "Users/Configuration", label: "Users/Configuration", PermissionType: "Full" }]
//#endregion

//#region KYC Json //for testing as some fields nullable//TODO check if add class 
export interface IKYCJson {
    tabs: TabsEntity[];
}
export interface TabsEntity {
    key: string;
    isVisible: boolean;
    title: string;
    picture: string;
    description: string;
    hasScore: boolean;
    TabPermissionTitle: string;
    PermissionTitle: string;
    cards: CardsEntity[];
    IsDocument: boolean;
    IsFillDocumentRequired: boolean;
    ClientCards: (string)[];
}
export interface CardsEntity {
    key: string;
    isVisible: boolean;
    title: string;
    description: string;
    elements: (ElementsEntity)[];
    noSubmit: boolean;
    isAdminElement: boolean;
}
export interface ElementsEntity {
    type: string;
    md: number;
    key: string;
    title: string;
    isRequired: boolean;
    hasSub: boolean;
    hasScore: boolean;
    isVisible: boolean;
    isSearchable: boolean;
    choices: (ChoicesEntity)[];
    min: number;
    visibleIfType: string;
    visibleIfKey: (string)[] | string | string | (string)[];
    visibleIfStatus: boolean | (string)[];
    visibleIfList: (string)[];
    html: string;
    list: (ListEntity | string)[];
    description: string;
    ClientDocuments: boolean;
    Card: string;
    placeholder: string;
    imgsrc: string;
    acceptedTypes: string;
    maxSize: number;
    isOptional: boolean;
} //every element have chocie and vice versa///  3 levels
export interface ChoicesEntity {
    value: string | number | boolean;
    label: string;
    Score: number;
    key: string | number;
    type: string;
    hasSub: boolean;
    status: string;
    description: string;
    isVisible: boolean;
    isRequired: boolean;
    picture: string;
    ClientTitle: string;
    elements: (ElementsEntity1)[];
    isOptional: boolean;
}
export interface ElementsEntity1 {
    type: string;
    Card: string;
    key: string;
    title: string;
    description: string;
    isVisible: boolean;
    isRequired: boolean;
    choices: (ChoicesEntity1)[];
    isOptional: boolean;
    md: number;
    hasScore: boolean;
    placeholder: string;
    imgsrc: string;
    maxSize: number;
    html: string;
    visibleIfType: string;
    visibleIfKey: (string)[];
}
export interface ChoicesEntity1 {
    status: string;
    type: string;
    key: string;
    value: string;
    label: string;
    description: string;
    isVisible: boolean;
    isRequired: boolean;
    picture: string;
    elements: (ElementsEntity2)[];
}
export interface ElementsEntity2 {
    type: string;
    md: number;
    hasScore: boolean;
    key: string;
    title: string;
    isRequired: boolean;
    isVisible: boolean;
    visibleIfType: string;
    visibleIfKey: string;
    isOptional: boolean;
    visibleIfList: (string)[];
    choices: (ChoicesEntity2)[];
    visibleIfStatus: (string)[];
    min: number;
    placeholder: string;
    imgsrc: string;
    acceptedTypes: string;
    maxSize: number;
}
export interface ChoicesEntity2 {
    value: number;
    label: string;
    Score: number;
}
export interface ListEntity {
    type: string;
    md: number;
    hasScore: boolean;
    key: string;
    title: string;
    isRequired: boolean;
    isVisible: boolean;
}
//#endregion
export function ReturnLanguageOptionsHtML(languagesOptions: BasicSelectOption[]) {
    let _languages: string = ''; // can add to props 
    for (let lang of languagesOptions) {
        _languages +=
            `<label class="RadioLabel d-block mt-2 mb-2 ant-radio-wrapper">
                <input name="languageChecked" type="radio" value="${lang.value}">
                    <span class="LabelCreate2 ml-1 font14">${lang.label}
                    </span>
                </label>`;
    }
    return _languages;
}
export function ReturnSelectOptions(SelectOpt: any, value: string, label: string, preview?: any) {
    try {
        if (!SelectOpt) return [];
        let _options: any = [];
        for (var k = 0; k < SelectOpt.length; k++) {
            _options.push({ value: SelectOpt[k][value], label: preview ? preview(SelectOpt[k]) : SelectOpt[k][label], Data: SelectOpt[k], ...SelectOpt[k] });
        }
        if (!_options || _options.length === 0)
            return [];
        else {
            return _options;
        }
    } catch (e) {
        return [];
    }
};
export function ReturnNumberFixedBY(value: number | string, decmialPoints?: number): any {
    if (!value || isNaN(+(value))) return 0.00;
    else {
        try {
            return parseFloat(String(value)).toFixed(decmialPoints ? decmialPoints : 2);
        } catch (e) {
            console.log(e, "ReturnNumberFixedBY")
            return 0.00;
        }
    }
}
export function RenturnSplitedRange(_date: string): { from: any, to: any } {
    try {
        if (!_date) return { from: moment(), to: moment() };
        let _dateRanges = _date.split(',');
        if (!_dateRanges || !_dateRanges[0] || !_dateRanges[1])
            return { from: moment(), to: moment() };
        return { from: moment(_dateRanges[0]), to: moment(_dateRanges[1]) }
    } catch (e) {
        console.log('splitDate', e)
        return { from: moment(), to: moment() };
    }
}
export function disabledDate(current: any) {//rename
    return (current && current > moment().endOf('day'));
}
//#region DM 

export function ReturnSymbolSecType(Type: string) {
    if (!Type) return ' - ';
    switch (Type) {
        case "FX":
        case "CFDLEVERAGE":
            {
                return 'Leverage';
            }
        case "CFD":
        case "INX":
        case "CFDLEV":
            {
                return 'Percentage';
            }
        case "Futures": {
            return 'Multiplier';
        }
        default: {
            return ' - '
        }
    }
}
export function ReturnAccSecType(Type: string) {
    if (!Type) return ' - ';
    switch (Type) {
        case "FX": {
            return 'FX-Leverage';
        }
        case "CFD": {
            return 'CFD-Percentage';
        }
        case "Futures": {
            return 'Futures-Multiplier';
        } case "INX": {
            return 'INX-Percentage';
        } case "CFDLEV": {
            return 'CFDLEV-Percentage';
        }
        case "CFDLEVERAGE": {
            return 'CFDLEVERAGE-Leverage';
        }
        default: {
            return ' - '
        }
    }
}
//#endregion
export function ReturnFilterValue(PageName: string, dict: any) {
    return function (value: any, elementName: string, StaticValue?: any) {
        try {
            if (dict[PageName] && dict[PageName][elementName])
                return dict[PageName][elementName];
        } catch (e) {
            console.error('ReturnFilterValue', e);
        }
        return value;
    }
}
export function ReturnFilterSelectedOptions(PageName: string, dict: any) {
    return function (_options: any, elementName: string, StaticValue?: any) {
        try {
            if (dict[PageName] && dict[PageName][elementName] && dict[PageName][elementName].length > 0)
                return dict[PageName][elementName];
        } catch (e) {
            console.error('ReturnFilterSelectedOptions', e);
        }
        return _options && _options.length > 0 ? (StaticValue ? _options : ReturnValuesForMultiSelect(_options)) : [];
    }
}
export function UpdateSelectedFiltrationValues(dict: any, PageName: string, Values: any, UpdateFiltrationDict: any) {
    try {
        let _TableFiltrationDict = { ...dict }
        if (_TableFiltrationDict[PageName])
            _TableFiltrationDict[PageName] = {
                ..._TableFiltrationDict[PageName],
                ...Values
            };
        else
            _TableFiltrationDict[PageName] = Values;
        UpdateFiltrationDict({ ..._TableFiltrationDict });
    } catch (e) {
        console.error('UpdateSelectedFiltrationValues', e)
    }
}
//#endregion
//#region Auth
//Auth
export enum EPermissionValue {
    Allow = 1,
    Deny = 2,
    Team = 3,
    Owned = 4
}
//#endregion


export function ReturnCountryCode(Code: string) {
    try {
        if (!Code) return "";
        switch (Code) {
            case "ID": {
                return "Indonesia";
            }
            default: {
                return Code
            }
        }
    } catch (e) {
        console.error('ReturnCountryCode', e);
        return "";
    }
}
export function TimeZonesOptions(t: Function) {//@point check if can remove luxon or can benfit from it 
    return timezones.default.filter((t: any) => !luxonIgnoredTimezones[t.tzCode] && t.tzCode !== 'Etc/GMT').map((timezone: any) => {

        //const offset = new Date().getTimezoneOffset();//only will get our cuurent need set time zone 
        const zoneTime = DateTime.local().setZone(timezone.tzCode);
        //const offset = new Date().getTimezoneOffset();
        const offset = zoneTime.offset;
        const offsetSign = offset > 0 ? '+' : offset < 0 ? '-' : '';
        const offsetNormalized = offset !== 0 ? Math.abs(offset / 60) : '';
        const offsetText = `(GMT${offsetSign}${offsetNormalized})`;

        const tzRegion = timezone.tzCode.split('/')[0];
        return {
            //text: `${timezone.label.replace(/\(.*\)/, offsetText)} - ${t(tzRegion)}`,
            text: `${offsetText} ${t(timezone.tzCode)} - ${t(tzRegion)}`,
            offset,
            tzCode: timezone.tzCode
        };
    })
        .sort((a: any, b: any) => a.offset - b.offset || a.text.localeCompare(b.text));
}
export function GetColumWitdh(Dict: any, pageName: any) {
    return function (StaticWidth: string, index: number) {
        try {
            let _TableFiltrationDict: any = { ...Dict };
            let Columns = _TableFiltrationDict[pageName]?.Columns ? _TableFiltrationDict[pageName]?.Columns : [];
            return Columns[index]?.width && (parseInt(Columns[index]?.width?.toLowerCase().replace('px', ''), 10) > 20) ? String(Columns[index]?.width) : (StaticWidth === "auto" ? "100px" : StaticWidth);
        } catch (e) {
            console.error('GetColumWitdh', e);
            return StaticWidth;
        }
    }
}
export function ValidateExpLimit(value: any): boolean {
    return value !== undefined && value !== null && String(value) !== "";
}
export function ReturnMultiSelectedFiltrationValuesToUpdate(selectedValues: any[], Options: any[]) {
    try {
        return ((selectedValues?.length && Options?.length) && selectedValues.length !== Options?.length) ? selectedValues : null;
    } catch (e) {
        console.error('ReturnSelectedOptionsForSaveFiltration', e);
        return selectedValues;
    }
}
export function ReturnOptionByValue(value: any, list: any[]) {
    if (!list || list.length === 0) return { value: -1, label: "No Data" };
    for (let i: number = 0; i < list.length; i++) {
        if (String(value)?.toLowerCase()?.trim() === String(list[i].value)?.toLowerCase()?.trim()) //icons on icon
            return list[i];
    }
    return { value: -1, label: "Select" };
}
export function ReturnOptionByLabel(label: any, list: any[]) {
    if (!list || list.length === 0) return { value: -1, label: "No Data" };
    for (let i: number = 0; i < list.length; i++) {
        if (String(label)?.toLowerCase() === String(list[i].label)?.toLowerCase())
            return list[i];
    }
    return { value: -1, label: "Select" };
}
export function ReturnFirstValue(list: any[]) {
    try {
        if (!!list && list.length !== 0) {
            return list[0];
        }
        else {
            return { value: -1, label: "No Data" };
        }
    } catch (e) {
        console.error(e, 'RETURN_FIRST_VALUE');
    }
}
export function ReturnOptionByField(label: any, list: any, field: string) {
    if (!list || list.length === 0) return { value: -1, label: "No Data" };
    for (let i: number = 0; i < list.length; i++) {
        if (String(label)?.toLowerCase() === String(list?.[i]?.[field])?.toLowerCase())
            return list[i];
    }
    return { value: -1, label: "Select" };
}
export function ReturnValidJsonAppforms(JsonString: any): any {
    if (!JsonString) return {};
    try {
        return JSON.parse(JsonString);//as effect correct ones
    } catch (e) {
        console.error('unvalidJson: ', e);
        try {
            let myEscapedJSONString = JsonString.replace(/\n/g, " ");
            return JSON.parse(myEscapedJSONString) //to remove control character as enter  great
        } catch (e) {
            console.error('Unvalid stringfy: ', e);
            return {};
        }
    }
}
export const NODATA = { value: -1, label: "No Data" };
export const NONESELECTED = { value: -1, label: "Select" };
export function SetValueOfIndex(list: any[], callBack: any, index: number) {
    if (list && list.length >= index && list[index])
        callBack(list[index]);
    else
        callBack(NONESELECTED);
}
export function ReturnValidLink(link: string) {
    if (!link) return '_';
    if (!link.endsWith('/')) {
        return `${link}/`;
    }
    return link;
}
export function ValidateValue(value: any): boolean {
    return value !== undefined && value !== null;
}
export function toFixedNoRounding(num: number) {
    if (!num || !isNumber(num)) return 0;
    return (parseInt(String(num * 100), 10) / 100);
}
export function toFixedNoRoundingDigits(num: number, Digits: number) {
    try {
        if (!num || !isNumber(num)) return 0;
        if (!Digits) return num;
        return (parseInt(String(num * Math.pow(10, Digits)), 10) / Math.pow(10, Digits));
    } catch (e) {
        console.error('toFixedNoRoundingDigits', e);
        return 0;
    }
}
export function RoundingDigit(num: number, Digits: number) {
    try {
        if (!num || !isNumber(num)) return 0;
        if (!Digits) return num;
        return +(num.toFixed(Digits));
    } catch (e) {
        console.error('toFixedNoRoundingDigits', e);
        return 0;
    }
}
export function ReturnParamString(text: any): string {
    return text?.includes('?') ? '&' : '?';
}
export function ReturnSlashString(text: any): string {
    return text?.endsWith('/') ? '' : '/';
}
//#region multibank Payments
export const BeneficiaryBankName: BasicSelectOption[] = [
    { value: "Standard Chartered (Thai)", label: "Standard Chartered (Thai)" },
    { value: "Government Savings Bank", label: "Government Savings Bank" },
    { value: "TMB Bank", label: "TMB Bank" },
    { value: "United Overseas Bank (Thai)", label: "United Overseas Bank (Thai)" },
    { value: "CIMB Thai Bank", label: "CIMB Thai Bank" },
    { value: "Citibank", label: "Citibank" },
    { value: "Thanachart Bank", label: "Thanachart Bank" },
    { value: "Kasikornbank", label: "Kasikornbank" },
    { value: "Siam Commercial Bank", label: "Siam Commercial Bank" },
    { value: "Bangkok Bank", label: "Bangkok Bank" },
    { value: "Bank of Ayudhya (Krungsri)", label: "Bank of Ayudhya (Krungsri)" },
    { value: "ABA Bank (Cambodia)", label: "ABA Bank (Cambodia)" },
    { value: "FNB (South Africa)", label: "FNB (South Africa)" },
    { value: "Kanbawza Bank (Myanmar)", label: "Kanbawza Bank (Myanmar)" },
    { value: "Krungthai Bank", label: "Krungthai Bank" },
    { value: "BCEL", label: "BCEL" }
]
export const ThunderPayPaymentCurrency: BasicSelectOption[] = [
    { value: "KHR", label: "KHR" },
    { value: "LAK", label: "LAK" },
    { value: "THB", label: "THB" },
    { value: "MMK", label: "MMK" }]
export const CryptoPaymentCurrency: BasicSelectOption[] = [
    { value: "BTC", label: "BTC" },
    { value: "USDT", label: "USDT" },
    { value: "ETH", label: "ETH" }];
export const FXBitPaymentCurrency: BasicSelectOption[] = [
    //{ value: "BTC", label: "BTC" },
    { value: "USDTTRC20", label: "USDTTRC20" },
    { value: "USDTERC20", label: "USDTERC20" },
    { value: "USDCERC20", label: "USDCERC20" },
    { value: "USDTBEP20", label: "USDTBEP20" },
]
//Endregion
export function ReturnNameAfterDash(str: string): string {
    try {
        return str.split("-")[1];
    } catch (e) {
        console.log("ReturnNameAfterDash", e);
        return str ? str : "";
    }
}
export function ReturnAllocationFormula(str: string): string {
    try {
        switch (str) {
            case "EV": {
                return "CopierAccountWiilBeFollowingTheSignalAccountAccordingToTheDefinedPercentageSetByEachCopierAccount";
            }
            case "Fixed Lot": {
                return "CopierAccountWillBeFollowingTheSignalAccountAccordingToTheDefinedFixedLotAmount";
            }
            case "% of Equity": {
                return "CopierAccountWillBeFollowingTheSignalAccountToEquity";
            }
            default: {
                return ' - '
            }
        }
    } catch (e) {
        console.log("Return Allocation Formula", e);
        return ' - '
    }
}
export function validateRef(ref: string): boolean {
    if (!ref) return false;
    let regex = /^[\w-]+$/;
    return ref.match(regex) ? true : false;
}
//#region Layout
export function RemoveSpacesNLastSemicolon(emails: string) {
    return emails?.replace(/\s/g, '')?.replace(/;$/g, '');
}
export function ValidateEmailList(emails: string): boolean {
    try {
        if (emails == "") return false;
        let _emailList: string[] = RemoveSpacesNLastSemicolon(emails)?.split(";");//TODO add in 1 replace
        for (let email of _emailList) {
            if (email == "" || !validateEmail(email)) {
                return false;
            }
        }
        return true;
    } catch (e) {
        console.log(e, "ValidateEmailList");
        return false;
    };
}
//#endregion

export function ReturnOptionByComma_Separated_Values(Comma_Separated_Values: any, list: any[]) {
    let _finallist: any[] = [];
    if (!Comma_Separated_Values) return _finallist;
    for (let item of list) {
        if (Comma_Separated_Values.includes(`${item?.value}`)) {
            _finallist.push(item);
        }
    }
    return _finallist;
}
export function ConvertListToTree(data: any, parent: any) { //recursive
    const result =
        data.filter((d: SubIBs) => (d.ParentClientID === parent));

    if (!result || !result.length) {
        return null;
    }

    return result.map(({ ClientID, ClientName, IBCode }: any) =>
        ({ ClientID, label: ` ${ClientName} - ${IBCode}`, children: ConvertListToTree(data, ClientID), expanded: true }))
}
//#region Document Expiration
enum EDocumentTypes {
    IDType = "IDType",
    IDType2 = "IDType2",
}
export function GetDocuments(_dict: any) {
    try {
        let _Documents = cloneDeep(_dict);
        _Documents = _.pickBy(_Documents, (value: any) => (value?._inTab === "Documents"));
        return _Documents;
    } catch (e) {
        console.log('GetDocuments', e);
        return cloneDeep(_dict);
    }
}
export function GetExpirationList(_Documents: any) {
    try {
        let expirations = [];
        let _IDType = _Documents[EDocumentTypes.IDType];
        let _IDType2 = _Documents[EDocumentTypes.IDType2];
        if (_IDType && _Documents[`ExpiryDate${_IDType}`]) {
            expirations.push({
                Type: EDocumentTypes.IDType,
                ExpiryDate: _Documents[`ExpiryDate${_IDType}`],
                Selected: _IDType
            });
        }
        if (_IDType2 && _Documents[`ExpiryDate2${_IDType2}`]) {
            expirations.push({
                Type: EDocumentTypes.IDType2,
                ExpiryDate: _Documents[`ExpiryDate2${_IDType2}`],
                Selected: _IDType2
            });
        }
        return expirations;
    } catch (e) {
        console.error('GetExpirationList', e);
        return [];
    }
}
export function GetDocumentValues(_Documents: any, key: string, _dict: any) {
    try {
        //_dict[key]?.Data?.isVisible for document check All dict as it is outside
        if (_Documents[key] && _dict[key]?.Data?.isVisible) { //take value for Visible
            return _Documents[key]?.value;
        } else {
            return null;
        }
    } catch (e) {
        console.error('GetDocumentValues', e)
        return {};
    }
}
//#endregion
//#region Enums
//KYC Status
export enum EKYCStatus {
    Pending = '0',
    Completed = '1',
    Rejected = '-1',
    NotCompleted = '2',
}
//Platforms
export enum EPlatforms {
    MT5 = "MT5",
    MT4 = "MT4",
}
//#endRegion
export const GBPrimePayPaymentOptions = [
    { value: 'text', label: 'Text' },
    { value: 'img', label: 'Image' },
];
var _isZendDeskDisplay = "";//locatroge will stay after reload//not our practice
export function DisplayZendDeskChat(isVisble: boolean) {
    //if (window?.zE) {
    //    if (_isZendDeskDisplay !== `${isVisble}`) {
    //        window.zE('messenger:set', 'cookies', isVisble);
    //        _isZendDeskDisplay = `${isVisble}`;
    //    }
    //}
}
export function CheckIfIsExternalPage(href: any): boolean {
    if (!href) return false;
    for (let route of ExternalRoutes) {
        //console.log(href.toLowerCase(), "route.path.toLowerCase()", route.path.toLowerCase(), window.location.pathname)
        //if (href && href.toLowerCase().includes(route.path.toLowerCase())) { /demoaccount /Manage/DemoAccounts wont work 
        if (window?.location?.pathname?.toLowerCase() === route?.path?.toLowerCase()) {
            return true;
        }
    }
    return false;
}
//#region New Permissions
export function GetReportsPerms(ReportsUserPerms: UserPermissionOBjectClass): { BonusReportsPerm: boolean; CRMREports: boolean; IBReports: boolean; DLReports: boolean; BackofficeReports: boolean; MAMReports: boolean; } {
    //BonusReportsPerm Perm as suffix as component named same 
    let BackofficeReports: boolean = CheckIfPermAlllowedByName('Backoffice Reports', ReportsUserPerms.Perms);
    let MAMReports: boolean = CheckIfPermAlllowedByName('MAM Reports', ReportsUserPerms.Perms);
    let BonusReportsPerm: boolean = CheckIfPermAlllowedByName('Bonus Reports', ReportsUserPerms.Perms);
    let CRMREports: boolean = CheckIfPermAlllowedByName('CRM REports', ReportsUserPerms.Perms);
    let IBReports: boolean = CheckIfPermAlllowedByName('IB Reports', ReportsUserPerms.Perms);
    let DLReports: boolean = CheckIfPermAlllowedByName('DL Reports', ReportsUserPerms.Perms);
    return { BonusReportsPerm, CRMREports, IBReports, DLReports, BackofficeReports, MAMReports };
}
export function OneOFReportsEnabled({ BonusReportsPerm, CRMREports, IBReports, DLReports, BackofficeReports, MAMReports }: any) {
    return (BonusReportsPerm || CRMREports || IBReports || DLReports || BackofficeReports || MAMReports);
}
//#endregion
export const groupByCustomValue = (key: any, value: any) => (array: any) => {
    try {
        return array.reduce((item: any, obj: any) => {
            const property = obj[key];
            item[property] = item[property] || [];
            item[property].push(obj[value]?.toString());
            return item;
        }, {});
    } catch (e) {
        console.error('groupBy', e);
        return {};
    }
}
//#region webhooks
export function GenerateKey(length?: number) {//like GUID
    function convertDecimalToHexa(dec: any) {
        return dec.toString(16).padStart(2, "0");
    }
    let arr = new Uint8Array((length || 40) / 2)
    window.crypto.getRandomValues(arr)
    return Array.from(arr, convertDecimalToHexa).join('')
}
export function GenerateRandomKey() {
    let charset = "abcdefghijklmnopqrstuvwxyz",
        Captial = "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
        numeric = '0123456789',
        SpecialSet = "!@#$%^&",
        retVal = "";
    let _nbofChars: number = 0;
    addlowercase(4);
    addCaptial(4);
    addNumeric(4);
    addSpecialCharacters(3);
    return retVal.split('').sort(() => Math.random() - 0.5).join(''); //return them shuffled 


    function addSpecialCharacters(amount: number) {
        for (let i = _nbofChars, n = SpecialSet.length; i < _nbofChars + amount; ++i) {
            retVal += SpecialSet.charAt(Math.floor(Math.random() * n));
        }
    }

    function addNumeric(amount: number) {
        for (let i = _nbofChars, n = numeric.length; i < _nbofChars + amount; ++i) {
            retVal += numeric.charAt(Math.floor(Math.random() * n));
        }
    }

    function addCaptial(amount: number) {
        for (let i = _nbofChars, n = Captial.length; i < _nbofChars + amount; ++i) {
            retVal += Captial.charAt(Math.floor(Math.random() * n));
        }
    }

    function addlowercase(amount: number) {
        for (let i = 0, n = charset.length; i < (_nbofChars + amount); ++i) {
            retVal += charset.charAt(Math.floor(Math.random() * n));
        }
    }
}
///#endregion
export const PRAXIS_LANGUAGES: any = {
    "ar": "ar-SA",
    "cn": "zh-CN",
    "ct": "zh-TW",
    "en": "en-GB",
    "fr": "fr-FR",
    "jp": "ja-JP",
    "pl": "pl-PL",
    "th": "th-TH",
    "vn": "vi-VN",
    "cs": "cs-CZ",
    "nl": "nl-NL",
    "tl": "tl-PH",
    "fi": "fi-FI",
    "de": "de-DE",
    "el": "el-GR",
    "he": "he-IL",
    "hi": "hi-IN",
    "hu": "hu-HU",
    "it": "it-IT",
    "id": "id-ID",
    "ko": "ko-KR",
    "lt": "lt-LT",
    "ms": "ms-MY",
    "pt": "pt-PT",
    "ru": "ru-RU",
    "sk": "sk-SK",
    "es": "es-ES",
    "sv": "sv-SE",
    "tr": "tr-TR",
    "hy": "hy-AM",
    "bg": "bg-BG",
    "kh": "kh-KH",
    "da": "da-DK",
    "et": "et-EE",
    "ka": "ka-GE",
    "lv": "lv-LV",
    "nn": "nn-NO",
    "sr": "sr-RS",
    "sl": "sl-SI",
    "ta": "ta-IN",
    "uk": "uk-UA",
    "sq": "sq-AL",
}

export function getImagesURL_IGain(BannerCDNURL: any, CompanyName: any, DefaultURL: any) {
    if (CompanyName?.toLowerCase() === "igain") return `${BannerCDNURL}igain/themes/greenGrey/`;
    if (CompanyName?.toLowerCase() === "primex") return `${BannerCDNURL}primex/themes/primexOrange/`;
    return `${DefaultURL}imgs/`;
}
export function getImagesURL_LDN(BannerCDNURL: any, CompanyName: any, DefaultURL: any) {
    if (CompanyName?.toLowerCase() === "ldn") return `${BannerCDNURL}ldn/themes/orangeBlack/`;
    if (CompanyName?.toLowerCase() === "primex") return `${BannerCDNURL}primex/themes/primexOrange/`;
    return `${DefaultURL}imgs/`;
}
export function getImagesURL_IGain_LDN(BannerCDNURL: any, CompanyName: any, DefaultURL: any) {
    if (CompanyName?.toLowerCase() === "igain") return `${BannerCDNURL}igain/themes/greenGrey/`;
    if (CompanyName?.toLowerCase() === "ldn") return `${BannerCDNURL}ldn/themes/orangeBlack/`;
    if (CompanyName?.toLowerCase() === "primex") return `${BannerCDNURL}primex/themes/primexOrange/`;
    return `${DefaultURL}imgs/`;
}

//#region Igain images 
export const BTC_BITCOIN = require("../../src/Assets/imgs/BTC(Bitcoin).jpeg") as string;
export const BTC_BITCOIN_txt = "1MJuptJgHs32nXydjTuPnHs2vyEFGCSD3v";
export const ETH_ERC20 = require("../../src/Assets/imgs/ETH(ERC20).jpeg") as string;
export const ETH_ERC20_txt = "0x24a1997ed78a7743765a9390c511430bea0171dc";
export const USDT_ERC20 = require("../../src/Assets/imgs/USDT(ERC20).jpeg") as string;
export const USDT_ERC20_txt = "0x24a1997ed78a7743765a9390c511430bea0171dc";
export const USDT_TRC20 = require("../../src/Assets/imgs/USDT(TRC20).jpeg") as string;
export const USDT_TRC20_txt = "TKefq2rcp1R6Ra7zkww9nxELu6ts8T2i6T";
//#endregion

export function CheckIfCompanyIs(CompanyName: string) {
    return store?.getState()?.CompanyData?.CompanyCode?.toLowerCase() === CompanyName?.toLowerCase();
}
export function ReturnLDNImage(img: string): string {
    if (CheckIfCompanyIs("LDN")) {
        return `${getImagesURL_IGain_LDN(store?.getState()?.CompanyData?.BannerCDNURL, store?.getState()?.CompanyData?.CompanyCode, store?.getState()?.CompanyData?.CDNURL)}NoData.png`;
    }
    return img;
}
//#region Dynamic Margin
export function CheckIFTrenchesIntervalIsValid(MarginTiles: IMarginTiles[]) {//for sessions we must Validate them otherwise no need to build 
    if (!MarginTiles || MarginTiles?.length === 0) return /*ValidateExpLimit(ProfileExpLimit) && +(ProfileExpLimit) > -1 ? true :*/ false;//true as check levels before it
    for (let i = 0; i < MarginTiles?.length; i++) {
        if (i > 0) {
            let _PreviousTrenches = parseFloat(String(MarginTiles[i - 1].Trenches || 0));
            if (_PreviousTrenches >= parseFloat(String(MarginTiles[i].Trenches || 0))) {//must be bigger
                return false;
            }
        }
    }
    return true;
}
function ReturnFromTierDate(_tier: TierClass) {
    const _FromDay = +(_tier.FromDay) > 9 ? _tier.FromDay : `0${_tier.FromDay}`;
    return new Date(`October ${_FromDay}, 2022 ${_tier.FromHour}:${_tier.FromMinute}:00`)
}
function ReturnToTierDate(_tier: TierClass) {
    const ToDay = +(_tier.ToDay) > 9 ? _tier.ToDay : `0${_tier.ToDay}`;
    return new Date(`October ${ToDay}, 2022 ${_tier.ToHour}:${_tier.ToMinute}:00`)
}
export function SortSessions(a: TierClass, b: TierClass): 1 | -1 {
    return ReturnFromTierDate(a)?.getTime() > ReturnFromTierDate(b)?.getTime() ? 1 : -1;
}
export function ConvertMarginIntoDictionary(list: any[]) {//same key will be eliminated
    let _newDict: any = [...list].reduce((obj: any, item: any, index: number) => {
        //console.log("ConvertMarginIntoDictionary: ", item, moment(ReturnFromTierDate(item)).format('MM/DD/YY hh:mm'));
        if (!!obj[moment(ReturnFromTierDate(item)).format('MM/DD/YY hh:mm')]) { //comparator
            obj[`${moment(ReturnFromTierDate(item)).format('MM/DD/YY hh:mm')}_Duplicate`] = item;
        } else {
            obj[moment(ReturnFromTierDate(item)).format('MM/DD/YY hh:mm')] = item;
        };
        return obj
    }, {});
    return _newDict;
}
export function ValidateDMTiers(Tiers: TierClass[]) { // CANT SORET SESSION AS WILL CUZ ISSUE IN INDEX unless use dict
    try {
        let TiersDict = ConvertMarginIntoDictionary(Tiers);//no need as new Structure
        let PrevTier: any = null;
        for (const key in TiersDict) {//validate leverage
            if (key.includes('_Duplicate')) {
                console.log("_Duplicate no valid ", key);
                return false;
            }
            const tier = TiersDict[key];
            if (!CheckIFTrenchesIntervalIsValid(tier.MarginTiles)) {//ProfileExpLimit no need 
                console.log("CHECK_IF_TRENCHES_INTERVAL_IS_VALID ", tier);
                return false;
            }

            if (!ValidateTierDate(tier, PrevTier)) {
                console.log("VALIDATETIER_DATE no valid ", tier, PrevTier)
                return false;
            }
            PrevTier = tier;
        }
        return true;
    } catch (e) {
        console.error("ValidateTiers", e);
        return false;
    }
    //validate Date in loop function for all 
    function ValidateTierDate(_tier: TierClass, PrevTier: TierClass | null) {
        //CREATE Date FROM DATA YOU HAVE and ADD AS Dictionary 

        const _fromDate = ReturnFromTierDate(_tier);
        const _toDate = ReturnToTierDate(_tier);
        _fromDate?.setSeconds(0);
        _toDate?.setSeconds(0);

        if (_fromDate.getTime() >= _toDate.getTime()) {//as same time will not even work 
            console.log("error _fromDate", _fromDate, _toDate);
            return false;
        }
        if (!!PrevTier) {
            const PervFromDate = ReturnFromTierDate(PrevTier);
            const PervToDate = ReturnToTierDate(PrevTier);
            /*if (!(key === index) && //byPass current one
            compare with `October ${item.FromDay}, 2022 ${item.FromHour}:${item.FromMinute}:00`*/
            if (CheckDateInBetween(_fromDate, PervToDate, PervFromDate) || CheckDateInBetween(_toDate, PervToDate, PervFromDate)) {
                console.log("PrevTier: ", PervFromDate, PervToDate, CheckDateInBetween(_fromDate, PervToDate, PervFromDate), CheckDateInBetween(_toDate, PervToDate, PervFromDate));
                return false;
            }
        }
        return true;
        function CheckDateInBetween(check: Date, to: Date, from: Date) {
            check.setSeconds(0);
            to.setSeconds(0);
            from.setSeconds(0);
            return (check.getTime() <= to.getTime() && check.getTime() >= from.getTime());
        }
    }
}

export function ValidateAccountExposureTiers(Tiers: TierClass[]) { // CANT SORET SESSION AS WILL CUZ ISSUE IN INDEX unless use dict
    try {
        let TiersDict = ConvertMarginIntoDictionary(Tiers);//no need as new Structure
        let PrevTier: any = null;
        for (const key in TiersDict) {//validate leverage
            if (key.includes('_Duplicate')) {
                console.log("_Duplicate no valid ", key);
                return false;
            }
            const tier = TiersDict[key];
            if (!CheckIFTrenchesIntervalIsValid(tier.MarginTiles)) {
                console.log("checkIfIntervalIsValid ", tier);
                return false;
            }

            if (!ValidateTierDate(tier, PrevTier)) {
                console.log("ValidateTierDate no valid ", tier, PrevTier)
                return false;
            }
            PrevTier = tier;
        }
        return true;
    } catch (e) {
        console.error("ValidateTiers", e);
        return false;
    }
    //validate Date in loop function for all 
    function ValidateTierDate(_tier: TierClass, PrevTier: TierClass | null) {
        //CREATE Date FROM DATA YOU HAVE and ADD AS Dictionary 

        const _fromDate = ReturnFromTierDate(_tier);
        const _toDate = ReturnToTierDate(_tier);
        _fromDate?.setSeconds(0);
        _toDate?.setSeconds(0);

        if (_fromDate.getTime() >= _toDate.getTime()) {//as same time will not even work 
            console.log("_fromDate");
            return false;
        }
        if (!!PrevTier) {
            const PervFromDate = ReturnFromTierDate(PrevTier);
            const PervToDate = ReturnToTierDate(PrevTier);
            /*if (!(key === index) && //byPass current one
            compare with `October ${item.FromDay}, 2022 ${item.FromHour}:${item.FromMinute}:00`*/
            if (CheckDateInBetween(_fromDate, PervToDate, PervFromDate) || CheckDateInBetween(_toDate, PervToDate, PervFromDate)) {
                console.log("PrevTier: ", PervFromDate, PervToDate, CheckDateInBetween(_fromDate, PervToDate, PervFromDate), CheckDateInBetween(_toDate, PervToDate, PervFromDate));
                return false;
            }
        }
        return true;
        function CheckDateInBetween(check: Date, to: Date, from: Date) {
            check.setSeconds(0);
            to.setSeconds(0);
            from.setSeconds(0);
            return (check.getTime() <= to.getTime() && check.getTime() >= from.getTime());
        }
    }
}
export const DAY_OPTIONS = [
    { value: 0, label: "Sunday" },
    { value: 1, label: "Monday" },
    { value: 2, label: "Tuesday" },
    { value: 3, label: "Wednesday" },
    { value: 4, label: "Thursday" },
    { value: 5, label: "Friday" },
    { value: 6, label: "Saturday" },
];
export const DAY_DICTIONARY: any = {
    0: "Sunday",
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
};
export function ReturnAccSecTypesIfMarginIsEmpty(AccExpID: number, selectedSecuitries: BasicSelectOption[]) {
    let _AccSecTypesList: any[] = [];
    try {
        let _SecTypes = [...(selectedSecuitries || [])];
        for (let secTypeID of _SecTypes) {
            _AccSecTypesList.push({ AccExpID, SecTypeID: secTypeID.value, MargTiers: '' });
        }
    } catch (e) {
        console.error('GetAccSecTypesIfMarginIsEmpty', e);
    }
    return _AccSecTypesList;
}
export function ReturnAccSecTypesList(MarginTiles: any, selectedSecurities: BasicSelectOption[]) {//_marginTiersList
    let _AccSecTypesList: any[] = [];
    if (selectedSecurities && selectedSecurities?.length > 0 && MarginTiles && MarginTiles.length > 0) {
        for (let i: number = 0; i < selectedSecurities.length; i++) {
            let _ID = +(selectedSecurities[i].value);
            let _margin: any = '';
            for (let k: number = 0; k < MarginTiles.length; k++) {
                _margin += `T${MarginTiles[k].level}=${MarginTiles[k].Trenches || 0}:${MarginTiles[k][selectedSecurities[i].label] || 0};`;
            }
            _AccSecTypesList.push({ AccExpID: 0, SecTypeID: _ID, MargTiers: _margin });
        }
    }
    //LogMessage('GenerateMarginTiers', _marginTiersList);
    return _AccSecTypesList;
}
export function ReturnAccExpMarginTiers(Tier: TierClass, selectedSecurities: BasicSelectOption[]) {// beascue secuirties may change 
    let _margins: any = "";
    let list: any = [...(Tier?.MarginTiles || [])];
    for (let margin of list) {
        _margins += `${margin.Trenches || 0}: `;
        for (let SecuitryType of selectedSecurities) {
            _margins += `${SecuitryType.value || 0}=${margin[SecuitryType.label] || 0},`
        }
        _margins += `;`;
    }
    _margins = _margins.replace(/\s/g, '');
    _margins = _margins.replace(/,;/g, ';');
    return _margins;
}
export function ReDrawMarginTilesForAllList(list: TierClass[], selectedSecurities: BasicSelectOption[]) {//For TiersJson
    let tiers = [...list];
    for (const index in tiers) {
        let currentTier = list?.[index];
        let _list: any[] = [];//dont take old as redraw new 
        for (let i: number = 0; i < parseInt(String(currentTier.levels), 10); i++) {
            let _itemsFromValue: any = selectedSecurities && selectedSecurities?.length > 0 ?
                ConvertIntoDictionaryWithSpecificValue(selectedSecurities, "label", "") : {};// label here check
            _list.push({ level: `${i}`, Trenches: "", ..._itemsFromValue });
        }
        currentTier.MarginTiles = _list;
    }
    return tiers;
}
export function castIntoSessions({ Tiers, ServerID, ProfileID, isAdd, isAccountExp, selectedSecuitries }
    : {
        Tiers: TierClass[], ServerID: number, ProfileID: number,
        isAdd: boolean, isAccountExp?: boolean,
        AccExpID?: number, selectedSecuitries?: BasicSelectOption[]
    }): ProfileSesssions[] | AccExpSesssions[] {
    const NewTiers = isAccountExp ? Tiers : Tiers;
    let newList: any[] = [...(NewTiers || [])];
    newList = newList.map((item: TierClass) => { //PermsLicList not getting same as class
        const ACC_SECTYPES_LIST: AccSecTypeClass[] = ReturnAccSecTypesList(item, selectedSecuitries || []);
        return {
            ServerID: ServerID,
            SessionID: (!isAdd && !!item?.isEdit) ? item.SessionID : 0,//add
            ProfileID: isAccountExp ? undefined : (isAdd ? 0 : ProfileID),
            AccExpID: !isAccountExp ? undefined : (isAdd ? 0 : ProfileID),
            FromDay: +(item.FromDay),
            ToDay: +(item.ToDay),
            FromHour: +(item.FromHour),
            ToHour: +(item.ToHour),
            FromMinute: +(item.FromMinute),
            ToMinute: +(item.ToMinute),
            Tiers: !isAccountExp ? item.MarginTiers : ReturnAccExpMarginTiers(item, selectedSecuitries || []),
            TiersJson: JSON.stringify(item?.MarginTiles || []),
            AccSecType: !isAccountExp ? undefined : (ACC_SECTYPES_LIST && ACC_SECTYPES_LIST?.length > 0 ? ACC_SECTYPES_LIST : ReturnAccSecTypesIfMarginIsEmpty(ProfileID || 0, selectedSecuitries || []))
        };
    });
    return newList;
}
export function ReturnMarginTiersWithTitles(AccSecTypeList: any[], SecurityTypeDict: any) {
    let list: any = "";
    for (let AccSecType of AccSecTypeList) {
        //"CFD-Percentage: T0=1:2;T1=4:5;INX - Percentage: T0=1:3;T1=4:6;"
        list += `${ReturnSecuirtyTypeTitle(SecurityTypeDict?.[AccSecType?.SecTypeID || 0]?.label)} : ${AccSecType?.MargTiers}\n`
    }
    return list;
}
export function castIntoTiers({ PSesssions, isAccountExp, AccSecTypeList, SecurityTypeDict, selectedSecuitries }:
    { PSesssions: DMSessionsResult[], isAccountExp?: boolean, AccSecTypeList?: any[], SecurityTypeDict?: any, selectedSecuitries?: BasicSelectOption[] }): TierClass[] {
    let newList: any[] = [...PSesssions];
    newList = newList.map((item: DMSessionsResult) => { //PermsLicList not getting same as class
        const MARGIN_TILES = JSON.parse(item.TiersJson || "[]");
        const ACC_SECTYPES_LIST: AccSecTypeClass[] = !isAccountExp ? [] : ReturnAccSecTypesList(MARGIN_TILES || [], selectedSecuitries || []);
        return {
            SessionID: item.SessionID,
            FromDay: +(item.FromDay),
            ToDay: +(item.ToDay),
            FromHour: +(item.FromHour),
            ToHour: +(item.ToHour),
            FromMinute: +(item.FromMinute),
            ToMinute: +(item.ToMinute),
            MarginTiers: isAccountExp ? ReturnMarginTiersWithTitles(ACC_SECTYPES_LIST || [], SecurityTypeDict || {}) : item.Tiers,
            MarginTiles: MARGIN_TILES,
            levels: MARGIN_TILES?.length || 0,
            isEdit: true,
        };
    })
    return newList;
}
export function ReturnSymbolMarginTiersData(item: TierClass) { // no need  for casting //as JSON Tiers is enough 
    let _list: IMarginTiles[] = [];
    const LIST_TITLES: any[] = item.MarginTiers ? item.MarginTiers.split(';') : [];
    let _levels: number = LIST_TITLES.length ? LIST_TITLES.length - 1 : 0;
    item.levels = `${_levels}`;
    for (let i: number = 0; i < +(LIST_TITLES.length); i++) {
        if (!!LIST_TITLES?.[i]) {
            let _value: any = LIST_TITLES[i];
            _value = _value.split('=');
            const ELEMENT = _value[1]?.split(':');
            _list.push({ level: `${i}`, Leverage: ELEMENT[1], Trenches: ELEMENT[0] });
        }
    }
    item.MarginTiles = _list;

    return { MarginTiles: _list, levels: `${_levels}` };
}
export function ReturnTimeDisplay(Time: any) {
    if (!Time || +(Time) < 0) return "00";
    if (`${Time}`.length < 2) return `0${Time}`;
    return Time;
}
//#endregion

//#region bonus Excluded Account Types 
export function CheckIfCommaSeparatedList(text: string) {
    if (!text) return false;
    if (text === "*") return true;
    if (text.startsWith(" ") || text.endsWith(" ")) return false;
    const SPLITED_LIST = text.split(',');
    for (let str of SPLITED_LIST) {
        if (!str) return false;
        if (str.startsWith(" ") || str.endsWith(" ")) return false;
    }
    return true;
}
//#endregion
export function ReturnCountriesOptionByTranslatedLabel(label: any, list: any[], t: Function) {
    if (!list || list.length === 0) return { value: -1, label: "No Data" };
    for (let i: number = 0; i < list.length; i++) {
        if (String(t(label))?.toLowerCase() === String(t(list[i]?.CountryCode ? ReturnCountryCode(list[i]?.CountryCode) : list[i].CountryName))?.toLowerCase())
            return list[i];
    }
    return { value: -1, label: "Select" };
}

//#region EasyWire
export const BANK_NAME_EASYWIRE = [
    { label: "FNB", value: "FNB" },
    { label: "ABSA", value: "ABSA" },
    { label: "Standard", value: "Standard" },
    { label: "Nedbank", value: "Nedbank" },
    { label: "Capitec", value: "Capitec" },
    { label: "Investec", value: "Investec" },
    { label: "Mercantile", value: "Mercantile" },
    { label: "Bidvest", value: "Bidvest" },
    { label: "Tyme", value: "Tyme" },
    { label: "Windhoek", value: "Windhoek" },
    { label: "Afribank", value: "Afribank" },
    { label: "Oldmutual", value: "Oldmutual" },
    { label: "Discovery", value: "Discovery" },
    { label: "Grindrod", value: "Grindrod" },
    { label: "Ubank", value: "Ubank" },
    { label: "Imperial", value: "Imperial" },
    { label: "Firstrand", value: "Firstrand" },
    { label: "Hsbc", value: "Hsbc" },
    { label: "Sasfin", value: "Sasfin" },
    { label: "Access", value: "Access" },
];
export const ACCOUNT_TYPES_EASYWIRE = [
    { value: "cheque", label: "cheque" },
    { value: "savings", label: "savings" },
    { value: "transmission", label: "transmission" },
];
export const BANKING_BRANCHS_EASYWIRE = [
    { label: "FNB", value: "250655" },
    { label: "ABSA", value: "632005" },
    { label: "Standard", value: "051001" },
    { label: "Nedbank", value: "198765" },
    { label: "Capitec", value: "470010" },
    { label: "Investec", value: "580105" },
    { label: "Mercantile", value: "450105" },
    { label: "Bidvest", value: "462005" },
    { label: "Tyme", value: "678910" },
    { label: "Windhoek", value: "483872" },
    { label: "Afribank", value: "430000" },
    { label: "Oldmutual", value: "462005" },
    { label: "Discovery", value: "679000" },
    { label: "Grindrod", value: "584000" },
    { label: "Ubank", value: "431010" },
    { label: "Imperial", value: "39001" },
    { label: "Firstrand", value: "201419" },
    { label: "Hsbc", value: "587000" },
    { label: "Sasfin", value: "683000" },
    { label: "Access", value: "410506" }
];
//#endregion
//#region reports
export function GetDayPriorBy(days: number): Date {
    try {
        const _date = new Date();
        _date.setDate(new Date().getDate() - days);
        return _date;
    } catch (e) {
        console.error('GET_DAY_PRIOR_BY', e);
        return new Date()
    }
}

export function ReturnTotalRounded(value: any) {
    const fix = (num: any) => Number(//
        num?.toFixed(2)?.match(/\d+(?:\.\d+)?/)?.[0]
    ).toFixed(2);
    if (value === 0) return value;
    if (!!value) return value > 0 ? fix(+value) : `-${fix(+value)}`;
    return "0.00";
}

export function GetDayPostBy(days: number): Date {
    try {
        const _date = new Date();
        _date.setDate(new Date().getDate() + days);
        return _date;
    } catch (e) {
        console.error('GET_DAY_PRIOR_BY', e);
        return new Date()
    }
}
//#endregion
export function ReturnDateBeforeYears(min: number) {
    let YearsAgo = new Date();
    YearsAgo.setFullYear(YearsAgo.getFullYear() - min);
    //return new Date( YearsAgo, 1, 1, 0, 0, 0); will check year with wrong values 
    YearsAgo.setHours(0);
    YearsAgo.setMinutes(0);
    YearsAgo.setSeconds(0);
    return YearsAgo;
}
export const ZahaPayBank = [
    { value: "-1", label: "-- Select Your Bank --" },
    { value: "BBL", label: "Bangkok Bank (BBL)" },
    { value: "KBANK", label: "Kasikorn Bank (KBANK)" },
    { value: "KTB", label: "Krung Thai Bank (KTB)" },
    { value: "TTB", label: "TMB & Tanachat Bank (TTB)" },
    { value: "SCB", label: "Siam Commercial Bank (SCB)" },
    { value: "CIMBT", label: "CIMB Thai Bank (CIMBT)" },
    { value: "UOBT", label: "United Overseas Bank (Thai) (UOBT)" },
    { value: "BAY", label: "Bank of Ayudhya (KrungSri) (BAY)" },
    { value: "GSB", label: "Goverment Savings Bank (GSB)" },
    { value: "GHB", label: "Goverment Housing Bank (GHB)" },
    { value: "BAAC", label: "Bank for Agriculture and Agricultural Cooperatives (BAAC)" },
];
export const ZahaPayBankDict: any = {
    "-1": "None",
    "BBL": "Bangkok Bank (BBL)",
    "KBANK": "Kasikorn Bank (KBANK)",
    "KTB": "Krung Thai Bank (KTB)",
    "TTB": "TMB & Tanachat Bank (TTB)",
    "SCB": "Siam Commercial Bank (SCB)",
    "CIMBT": "CIMB Thai Bank (CIMBT)",
    "UOBT": "United Overseas Bank (Thai) (UOBT)",
    "BAY": "Bank of Ayudhya (KrungSri) (BAY)",
    "GSB": "Goverment Savings Bank (GSB)",
    "GHB": "Goverment Housing Bank (GHB)",
    "BAAC": "Bank for Agriculture and Agricultural Cooperatives (BAAC)"
};
export const DusuPayMobileMoneyWorks = [
    { value: "-1", label: "-- Select Your Bank --" },
    { value: "KE", label: "Kenya" },
    { value: "TZ", label: "Tanzania" },
    { value: "RW", label: "Rwanda" },
    { value: "BI", label: "Burundi" },
    { value: "GH", label: "Ghana" },
    { value: "UG", label: "Uganda" },
    { value: "CM", label: "Cameroon" },
    { value: "ZM", label: "Zambia" },
];
export const DusuPayBankWorks = [
    { value: "-1", label: "-- Select Your Bank --" },
    { value: "ZA", label: "South Africa" },
    { value: "NG", label: "Nigeria" },
];
export function DusuPayPaymentTypes(type?: string) {
    if (type === "dusupay-bank" || type === "dusupayv2-bank")
        return [
            { value: "Bank", label: "Bank" },
        ]
    if (type === "dusupay-mobile" || type === "dusupayv2-mobile")
        return [
            { value: "MobileMoney", label: "Mobile Money" },
        ]
    return [
        { value: "Bank", label: "Bank" },
        { value: "MobileMoney", label: "Mobile Money" },
    ]
};
export const CashUSDT = require("../../src/Assets/imgs/CashUSDT.png") as string;
export const SurepayCountries = [
    { value: "Malaysia", label: "Malaysia" },
    { value: "Singapore", label: "Singapore" },
    { value: "Thailand", label: "Thailand" },
    { value: "Vietnam", label: "Vietnam" },
    { value: "Indonesia", label: "Indonesia" },
    { value: "Cambodia", label: "Cambodia" }];
export const SurepayBankCode = [
    { value: "MAYBANK", Type: "DP", label: "Maybank", Country: "Malaysia" },
    { value: "CIMB", Type: "DP", label: "CIMB Group Holdings", Country: "Malaysia" },
    { value: "PBE", Type: "DP", label: "Public Bank Berhad", Country: "Malaysia" },
    { value: "RHB", Type: "DP", label: "RHB Bank", Country: "Malaysia" },
    { value: "HLB", Type: "DP", label: "Hong Leong Bank", Country: "Malaysia" },
    { value: "BSN", Type: "DP", label: "Bank Simpanan Nasional", Country: "Malaysia" },
    { value: "AFFIN", Type: "DP", label: "Affin Bank", Country: "Malaysia" },
    { value: "AMBANK", Type: "DP", label: "AmBank", Country: "Malaysia" },
    { value: "BKRM", Type: "DP", label: "Bank Rakyat Malaysia", Country: "Malaysia" },
    { value: "ALLIANCE", Type: "DP", label: "Alliance Bank MalaysiaBerhad", Country: "Malaysia" },
    { value: "BIMB", Type: "DP", label: "Bank Islam Berhad", Country: "Malaysia" },
    { value: "BMMB", Type: "P", label: "Bank Muamalat", Country: "Malaysia" },
    { value: "AGRO", Type: "P", label: "Bank of Agro", Country: "Malaysia" },
    { value: "HSBC", Type: "P", label: "HongKong And Shanghai Bank", Country: "Malaysia" },
    { value: "UOB", Type: "P", label: "United Overseas Bank", Country: "Malaysia" },
    { value: "OCBC", Type: "P", label: "Oversea-Chinese Banking Corporation", Country: "Malaysia" },

    { value: "DBS", Type: "DP", label: "DBS Bank Limited", Country: "Singapore" },
    { value: "UOB", Type: "DP", label: "United Overseas Bank Limited", Country: "Singapore" },
    { value: "OCBC", Type: "DP", label: "OCBC Bank", Country: "Singapore" },
    { value: "ANZ", Type: "P", label: "Australia And New Zealand Bank (Australia)", Country: "Singapore" },
    { value: "BKCH", Type: "P", label: "Bank Of China", Country: "Singapore" },
    { value: "BNPASG", Type: "P", label: "BNP Paribas", Country: "Singapore" },
    { value: "CIMBSG", Type: "P", label: "CIMB", Country: "Singapore" },
    { value: "CITISG", Type: "P", label: "Citibank Singapore", Country: "Singapore" },
    { value: "DBK", Type: "P", label: "Deutsche Bank AG", Country: "Singapore" },
    { value: "GPAY", Type: "P", label: "GPAY", Country: "Singapore" },
    { value: "HLBBSG", Type: "P", label: "HLB Singapore", Country: "Singapore" },
    { value: "HSBCCORP", Type: "P", label: "HSBC Coorperation", Country: "Singapore" },
    { value: "HSBC", Type: "P", label: "HSBC Singapore - Personal", Country: "Singapore" },
    { value: "ICICIB", Type: "P", label: "ICICI Bank", Country: "Singapore" },
    { value: "ICBKSG", Type: "P", label: "Industrial and Commercial Bank", Country: "Singapore" },
    { value: "JPM", Type: "P", label: "Jpmorgan Chase Bank", Country: "Singapore" },
    { value: "LIQPAY", Type: "P", label: "Liquid Pay", Country: "Singapore" },
    { value: "MBBGB", Type: "P", label: "Malayan Banking Berhad, Singapore Branch", Country: "Singapore" },
    { value: "MMOVEPAY", Type: "P", label: "Match Move Pay", Country: "Singapore" },
    { value: "MBBE", Type: "P", label: "Maybank Singapore (maybank)", Country: "Singapore" },
    { value: "MHCBSG", Type: "P", label: "Mizuho Bank Singapore", Country: "Singapore" },
    { value: "SIVFSG", Type: "P", label: "Singapore Investments & Finance Limited", Country: "Singapore" },
    { value: "SINGCASH", Type: "P", label: "Sing Cash", Country: "Singapore" },
    { value: "SCBLSG", Type: "P", label: "Standard Chartered Bank Singapore", Country: "Singapore" },
    { value: "SMBCSG", Type: "P", label: "Sumitomo Mitsui", Country: "Singapore" },
    { value: "BOTKSG", Type: "P", label: "The Bank Of Tokyo-Mitsubishi", Country: "Singapore" },
    { value: "WISE", Type: "P", label: "Wise Asia Pacific", Country: "Singapore" },

    { value: "PROMPTPAY", Type: "P", label: "PROMPTPAY", Country: "Thailand" },
    { value: "KBANK", Type: "P", label: "KASIKORNBANK", Country: "Thailand" },
    { value: "KTB", Type: "P", label: "KRUNGTHAIBANKPUBLICCOMPANYLTD.", Country: "Thailand" },
    { value: "BBL", Type: "P", label: "BANGKOKBANKPUBLICCOMPANYLTD.", Country: "Thailand" },
    { value: "SCB", Type: "P", label: "SiamCommercialBank", Country: "Thailand" },
    { value: "BAAC", Type: "P", label: "BANKFORAGRICULTUREANDAGRICULTURALCO-OPERATIVES (AGRI)", Country: "Thailand" },
    { value: "BOC", Type: "P", label: "BankofChina(Thai)PublicCompanyLimited", Country: "Thailand" },
    { value: "CITI", Type: "P", label: "CITIBANKN.A.", Country: "Thailand" },
    { value: "CIMBTH", Type: "P", label: "CIMBTHAIBANKPUBLICCOMPANYLIMITED", Country: "Thailand" },
    { value: "GHB", Type: "P", label: "GOVERNMENTHOUSINGBANK", Country: "Thailand" },
    { value: "MHCB", Type: "P", label: "MIZUHOCORPORATEBANK,LTD.", Country: "Thailand" },
    { value: "KKB", Type: "P", label: "KIATNAKINBANKPUBLICCOMPANYLIMITED", Country: "Thailand" },
    { value: "TISCO", Type: "P", label: "TISCOBANKPUBLICCOMPANYLIMITED", Country: "Thailand" },
    { value: "GSB", Type: "P", label: "GOVERNMENTSAVINGBANK", Country: "Thailand" },
    { value: "TMB", Type: "P", label: "TMBThanachartBankPublicCompanyLimited", Country: "Thailand" },
    { value: "SCBT", Type: "P", label: "STANDARDCHARTEREDBANK(THAI)PCL.", Country: "Thailand" },
    { value: "TCRB", Type: "P", label: "THETHAICREDITRETAILBANKPUBLICCOMPANYLIMITED(TCRB)", Country: "Thailand" },
    { value: "SMBC", Type: "P", label: "SUMITOMOMITSUIBANGKINGCORPORATION", Country: "Thailand" },
    { value: "LHBA", Type: "P", label: "LandandHousesBankPublicCompanyLimited", Country: "Thailand" },
    { value: "TIBT", Type: "P", label: "ISLAMICBANKOFTHAILAND", Country: "Thailand" },
    { value: "HSBCTH", Type: "P", label: "HONGKONGANDSHANGHAICORPORATIONLTD.", Country: "Thailand" },
    { value: "DBTH", Type: "P", label: "DEUTSCHEBANKAG,BANGKOKBRANCH", Country: "Thailand" },
    { value: "ICBC", Type: "P", label: "IndustrialandCommercialBankofChina(Thai)Public CompanyLimited", Country: "Thailand" },
    { value: "UOBTH", Type: "P", label: "UNITEDOVERSEASBANK(THAI)PCL.", Country: "Thailand" },
    { value: "BAY", Type: "P", label: "BANKOFAYUDHAYAPUBLICCOMPANYLTD.", Country: "Thailand" },

    { value: "VIETCOM", Type: "DP", label: "Vietcom Bank", Country: "Vietnam" },
    { value: "SACOM", Type: "DP", label: "Sacom Bank", Country: "Vietnam" },
    { value: "TECHCOM", Type: "DP", label: "Techcom Bank", Country: "Vietnam" },
    { value: "VIETIN", Type: "DP", label: "Vietin Bank", Country: "Vietnam" },
    { value: "BIDV", Type: "DP", label: "Bank for Investment and Development of Vietnam", Country: "Vietnam" },

    { value: "BMR", Type: "P", label: "Bank Mandiri", Country: "Indonesia" },
    { value: "BRI", Type: "P", label: "Bank Rakyat Indonesia", Country: "Indonesia" },
    { value: "BCA", Type: "P", label: "Bank Central Asia", Country: "Indonesia" },
    { value: "BNI", Type: "P", label: "Bank Negara Indonesia", Country: "Indonesia" },

    { value: "ACLEDA", Type: "p", label: "ACLEDA Bank", Country: "Cambodia" },
    { value: "CNDBANK", Type: "p", label: "Canadia Bank", Country: "Cambodia" },
    { value: "FTB", Type: "p", label: "The Foreign Trade Bank of Cambodia", Country: "Cambodia" },
    { value: "UCB", Type: "p", label: "Union Commercial Bank", Country: "Cambodia" },
    { value: "JTRUST", Type: "p", label: "Trust Royal Bank", Country: "Cambodia" },
];
export const SurepayBankCodeDict: any = {
    "MAYBANK": { Type: "DP", label: "Maybank", Country: "Malaysia" },
    "CIMB": { Type: "DP", label: "CIMB Group Holdings", Country: "Malaysia" },
    "PBE": { Type: "DP", label: "Public Bank Berhad", Country: "Malaysia" },
    "RHB": { Type: "DP", label: "RHB Bank", Country: "Malaysia" },
    "HLB": { Type: "DP", label: "Hong Leong Bank", Country: "Malaysia" },
    "BSN": { Type: "DP", label: "Bank Simpanan Nasional", Country: "Malaysia" },
    "AFFIN": { Type: "DP", label: "Affin Bank", Country: "Malaysia" },
    "AMBANK": { Type: "DP", label: "AmBank", Country: "Malaysia" },
    "BKRM": { Type: "DP", label: "Bank Rakyat Malaysia", Country: "Malaysia" },
    "ALLIANCE": { Type: "DP", label: "Alliance Bank MalaysiaBerhad", Country: "Malaysia" },
    "BIMB": { Type: "DP", label: "Bank Islam Berhad", Country: "Malaysia" },
    "BMMB": { Type: "P", label: "Bank Muamalat", Country: "Malaysia" },
    "AGRO": { Type: "P", label: "Bank of Agro", Country: "Malaysia" },
    "HSBC": { Type: "P", label: "HongKong And Shanghai Bank", Country: "Malaysia" },
    "UOB": { Type: "P", label: "United Overseas Bank", Country: "Malaysia" },
    "OCBC": { Type: "P", label: "Oversea-Chinese Banking Corporation", Country: "Malaysia" },

    "DBS": { Type: "DP", label: "DBS Bank Limited", Country: "Singapore" },
    //"UOB": { Type: "DP", label: "United Overseas Bank Limited", Country: "Singapore" },
    //"OCBC": { Type: "DP", label: "OCBC Bank", Country: "Singapore" },
    "ANZ": { Type: "P", label: "Australia And New Zealand Bank (Australia)", Country: "Singapore" },
    "BKCH": { Type: "P", label: "Bank Of China", Country: "Singapore" },
    "BNPASG": { Type: "P", label: "BNP Paribas", Country: "Singapore" },
    "CIMBSG": { Type: "P", label: "CIMB", Country: "Singapore" },
    "CITISG": { Type: "P", label: "Citibank Singapore", Country: "Singapore" },
    "DBK": { Type: "P", label: "Deutsche Bank AG", Country: "Singapore" },
    "GPAY": { Type: "P", label: "GPAY", Country: "Singapore" },
    "HLBBSG": { Type: "P", label: "HLB Singapore", Country: "Singapore" },
    "HSBCCORP": { Type: "P", label: "HSBC Coorperation", Country: "Singapore" },
    "HSBCSingapore": { Type: "P", label: "HSBC Singapore - Personal", Country: "Singapore" },
    "ICICIB": { Type: "P", label: "ICICI Bank", Country: "Singapore" },
    "ICBKSG": { Type: "P", label: "Industrial and Commercial Bank", Country: "Singapore" },
    "JPM": { Type: "P", label: "Jpmorgan Chase Bank", Country: "Singapore" },
    "LIQPAY": { Type: "P", label: "Liquid Pay", Country: "Singapore" },
    "MBBGB": { Type: "P", label: "Malayan Banking Berhad, Singapore Branch", Country: "Singapore" },
    "MMOVEPAY": { Type: "P", label: "Match Move Pay", Country: "Singapore" },
    "MBBE": { Type: "P", label: "Maybank Singapore (maybank)", Country: "Singapore" },
    "MHCBSG": { Type: "P", label: "Mizuho Bank Singapore", Country: "Singapore" },
    "SIVFSG": { Type: "P", label: "Singapore Investments & Finance Limited", Country: "Singapore" },
    "SINGCASH": { Type: "P", label: "Sing Cash", Country: "Singapore" },
    "SCBLSG": { Type: "P", label: "Standard Chartered Bank Singapore", Country: "Singapore" },
    "SMBCSG": { Type: "P", label: "Sumitomo Mitsui", Country: "Singapore" },
    "BOTKSG": { Type: "P", label: "The Bank Of Tokyo-Mitsubishi", Country: "Singapore" },
    "WISE": { Type: "P", label: "Wise Asia Pacific", Country: "Singapore" },

    "PROMPTPAY": { Type: "P", label: "PROMPTPAY", Country: "Thailand" },
    "KBANK": { Type: "P", label: "KASIKORNBANK", Country: "Thailand" },
    "KTB": { Type: "P", label: "KRUNGTHAIBANKPUBLICCOMPANYLTD.", Country: "Thailand" },
    "BBL": { Type: "P", label: "BANGKOKBANKPUBLICCOMPANYLTD.", Country: "Thailand" },
    "SCB": { Type: "P", label: "SiamCommercialBank", Country: "Thailand" },
    "BAAC": { Type: "P", label: "BANKFORAGRICULTUREANDAGRICULTURALCO-OPERATIVES (AGRI)", Country: "Thailand" },
    "BOC": { Type: "P", label: "BankofChina(Thai)PublicCompanyLimited", Country: "Thailand" },
    "CITI": { Type: "P", label: "CITIBANKN.A.", Country: "Thailand" },
    "CIMBTH": { Type: "P", label: "CIMBTHAIBANKPUBLICCOMPANYLIMITED", Country: "Thailand" },
    "GHB": { Type: "P", label: "GOVERNMENTHOUSINGBANK", Country: "Thailand" },
    "MHCB": { Type: "P", label: "MIZUHOCORPORATEBANK,LTD.", Country: "Thailand" },
    "KKB": { Type: "P", label: "KIATNAKINBANKPUBLICCOMPANYLIMITED", Country: "Thailand" },
    "TISCO": { Type: "P", label: "TISCOBANKPUBLICCOMPANYLIMITED", Country: "Thailand" },
    "GSB": { Type: "P", label: "GOVERNMENTSAVINGBANK", Country: "Thailand" },
    "TMB": { Type: "P", label: "TMBThanachartBankPublicCompanyLimited", Country: "Thailand" },
    "SCBT": { Type: "P", label: "STANDARDCHARTEREDBANK(THAI)PCL.", Country: "Thailand" },
    "TCRB": { Type: "P", label: "THETHAICREDITRETAILBANKPUBLICCOMPANYLIMITED(TCRB)", Country: "Thailand" },
    "SMBC": { Type: "P", label: "SUMITOMOMITSUIBANGKINGCORPORATION", Country: "Thailand" },
    "LHBA": { Type: "P", label: "LandandHousesBankPublicCompanyLimited", Country: "Thailand" },
    "TIBT": { Type: "P", label: "ISLAMICBANKOFTHAILAND", Country: "Thailand" },
    "HSBCTH": { Type: "P", label: "HONGKONGANDSHANGHAICORPORATIONLTD.", Country: "Thailand" },
    "DBTH": { Type: "P", label: "DEUTSCHEBANKAG,BANGKOKBRANCH", Country: "Thailand" },
    "ICBC": { Type: "P", label: "IndustrialandCommercialBankofChina(Thai)Public CompanyLimited", Country: "Thailand" },
    "UOBTH": { Type: "P", label: "UNITEDOVERSEASBANK(THAI)PCL.", Country: "Thailand" },
    "BAY": { Type: "P", label: "BANKOFAYUDHAYAPUBLICCOMPANYLTD.", Country: "Thailand" },

    "VIETCOM": { Type: "DP", label: "Vietcom Bank", Country: "Vietnam" },
    "SACOM": { Type: "DP", label: "Sacom Bank", Country: "Vietnam" },
    "TECHCOM": { Type: "DP", label: "Techcom Bank", Country: "Vietnam" },
    "VIETIN": { Type: "DP", label: "Vietin Bank", Country: "Vietnam" },
    "BIDV": { Type: "DP", label: "Bank for Investment and Development of Vietnam", Country: "Vietnam" },

    "BMR": { Type: "P", label: "Bank Mandiri", Country: "Indonesia" },
    "BRI": { Type: "P", label: "Bank Rakyat Indonesia", Country: "Indonesia" },
    "BCA": { Type: "P", label: "Bank Central Asia", Country: "Indonesia" },
    "BNI": { Type: "P", label: "Bank Negara Indonesia", Country: "Indonesia" },

    "ACLEDA": { Type: "p", label: "ACLEDA Bank", Country: "Cambodia" },
    "CNDBANK": { Type: "p", label: "Canadia Bank", Country: "Cambodia" },
    "FTB": { Type: "p", label: "The Foreign Trade Bank of Cambodia", Country: "Cambodia" },
    "UCB": { Type: "p", label: "Union Commercial Bank", Country: "Cambodia" },
    "JTRUST": { Type: "p", label: "Trust Royal Bank", Country: "Cambodia" },
};
//#endregion

export function GenerateManagerPassword(length?: number) {//8 characters
    let charset = "abcdefghijklmnopqrstuvwxyz",
        Captial = "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
        numeric = '0123456789',
        SpecialSet = "!@#$%^&",
        retVal = "";
    //for (var i = 0, n = SpecialSet.length; i < 5; ++i) {
    //    retVal += SpecialSet.charAt(Math.floor(Math.random() * n));
    //}
    for (var i = 0, n = charset.length; i < 4; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    for (var i = 4, n = Captial.length; i < 6; ++i) {
        retVal += Captial.charAt(Math.floor(Math.random() * n));
    }
    for (var i = 6, n = numeric.length; i < 8; ++i) {
        retVal += numeric.charAt(Math.floor(Math.random() * n));
    }
    if (+(length || 0) > 8) {
        for (var i = 8, n = SpecialSet.length; i < +(length || 0); ++i) {
            retVal += SpecialSet.charAt(Math.floor(Math.random() * n));
        }
    }
    return retVal.split('').sort(() => Math.random() - 0.5).join(''); //return them shuffled 
}
//#region fast2pays
export const FAST2PAYS_DEPOSIT_TYPES = [
    { value: 'CARD', label: 'Card' },
    { value: 'BANK', label: 'Bank' }
];
export const FAST2PAYS_DEPOSIT_BANKCODE = [
    { value: 'VCB', label: 'Joint Stock Commercial Bank for Foreign Trade of Vietnam' },
    { value: 'TECHCOMBANK', label: 'Vietnam Technological and Commercial Joint Stock Bank' },
    { value: 'TPBANK', label: 'TienPhong Commercial Joint Stock Bank' },
    { value: 'VIETINBANK', label: 'Vietnam Joint Stock Commercial Bank of Industry and Trade' },
    { value: 'VIB', label: 'Vietnam International Commercial Joint Stock Bank' },
    { value: 'DAB', label: 'DONG A Commercial Joint Stock Bank' },
    { value: 'HDBANK', label: 'Ho Chi Minh city Development Joint Stock Commercial Bank' },
    { value: 'MB', label: 'Military Commercial Joint Stock Bank' },
    { value: 'VIETABANK', label: 'Vietnam Asia Commercial Joint' },
    { value: 'MARITIMEBANK', label: 'Vietnam Maritime Commercial Joint Stock Bank' },
    { value: 'EXIMBANK', label: 'Vietnam Export Import Commercial Joint Stock' },
    { value: 'SHB', label: 'Saigon-Hanoi Commercial Joint Stock Bank' },
    { value: 'VPBANK', label: 'Vietnam Prosperity Joint Stock Commercial Bank' },
    { value: 'ABBANK', label: 'An Binh Commercial Joint Stock Bank' },
    { value: 'SACOMBANK', label: 'Saigon Thuong Tin Commercial Joint Stock Bank' },
    { value: 'NAMA', label: 'Nam A Commercial Joint Stock Bank' },
    { value: 'OCEANBANK', label: 'Ocean Commercial One Member Limited Liability Bank' },
    { value: 'BIDV', label: 'Joint Stock Commercial Bank for Investment and Development of Vietnam' },
    { value: 'SEABANK', label: 'Southeast Asia Commercial Joint Stock Bank' },
    { value: 'BACA', label: 'BAC A Commercial Joint Stock Bank' },
    { value: 'NAVIBANK', label: 'NaviBank' },
    { value: 'AGRIBANK', label: 'Vietnam Bank for Agriculture and Rural Development' },
    { value: 'SAIGONBANK', label: 'Saigon Bank for Industry and Trade' },
    { value: 'PVBANK', label: 'Vietnam Public Joint Stock Commercial Bank' },
    { value: 'ACB', label: 'Asia Commercial Joint Stock Bank' },
    { value: 'LPB', label: 'Lien Viet Post Joint Stock Commercial Bank' },
    { value: 'BVBANK', label: 'Bao Viet Joint Stock commercial Bank' },
    { value: 'OCB', label: 'Orient Commercial Joint Stock Bank' },
    { value: 'KIENLONGBANK', label: 'Kien Long Commercial Joint Stock Bank' },
    { value: 'VRB', label: 'Vietnam Russia Joint Venture Bank' },
    { value: 'NCB', label: 'National Citizen Commercial Joint Stock Bank' },
    { value: 'PGBANK', label: 'Petrolimex Group Commercial Joint Stock Bank' },
    { value: 'GPBANK', label: 'Global Petro Sole Member Limited Commercial Bank' },
    { value: 'WOORIBANK', label: 'Woori Bank Vietnam Limited' },
    { value: 'VIETCAPITALBANK', label: 'Viet Capital Commercial Joint Stock Bank' },
    { value: 'PVBANK', label: 'PVcombank' },
    { value: 'BIDV', label: 'Joint Stock Commercial Bank for Investment and Development of Vietnam' },
    { value: 'VPBANK', label: 'Vietnam Prosperity Joint Stock Commercial Bank' },
    { value: 'TECHCOMBANK', label: 'Vietnam Technological and Commercial Joint Stock Bank' },
    { value: 'VISA', label: 'Visa' },
    { value: 'MASTERCARD', label: 'Mastercard' },
    { value: 'VCB', label: 'Joint Stock Commercial Bank for Foreign Trade of Vietnam' },
    { value: 'MOMO', label: 'Momo Wallet' },
    { value: 'TECHCOMBANK', label: 'Vietnam Technological and Commercial Joint Stock Bank' },
    { value: 'MB', label: 'Military Commercial Joint Stock Bank' },
    { value: 'VPBANK', label: 'Vietnam Prosperity Joint Stock Commercial Bank' },
    { value: 'BIDV', label: 'Joint Stock Commercial Bank for Investment and Development of Vietnam' },
    { value: 'SCARD_VT', label: 'THẺ VIETTEL' },
    { value: 'SCARD_Vina', label: 'THẺ VINAPHONE' },
    { value: 'SCARD_Mobi', label: 'THẺ MOBIFONE' },
    { value: 'SCARD_GTE', label: 'THẺ GATE' },
    { value: 'SCARD_ISEC', label: 'THẺ ISEC' },
    { value: 'USDT', label: 'Tether USDT' },
    { value: 'BUSD', label: 'Binance USD' },
    { value: 'USDC', label: 'USD Coin' },
];
export const FAST2PAYS_WITHDRAWAL_BANKCODE = [
    { value: 'VCB', label: 'Joint Stock Commercial Bank for Foreign Trade of Vietnam' },
    { value: 'TECHCOMBANK', label: 'Vietnam Technological and Commercial Joint Stock Bank' },
    { value: 'TPBANK', label: 'TienPhong Commercial Joint Stock Bank' },
    { value: 'VIETINBANK', label: 'Vietnam Joint Stock Commercial Bank of Industry and Trade' },
    { value: 'VIB', label: 'Vietnam International Commercial Joint Stock Bank' },
    { value: 'HDBANK', label: 'Ho Chi Minh city Development Joint Stock Commercial Bank' },
    { value: 'MB', label: 'Military Commercial Joint Stock Bank' },
    { value: 'VIETABANK', label: 'Vietnam Asia Commercial Joint' },
    { value: 'MARITIMEBANK', label: 'Vietnam Maritime Commercial Joint Stock Bank' },
    { value: 'EXIMBANK', label: 'Vietnam Export Import Commercial Joint Stock' },
    { value: 'SCB', label: 'Sai Gon Joint Stock Commercial Bank' },
    { value: 'VPBANK', label: 'Vietnam Prosperity Joint Stock Commercial Bank' },
    { value: 'ABBANK', label: 'An Binh Commercial Joint Stock Bank' },
    { value: 'SACOMBANK', label: 'Saigon Thuong Tin Commercial Joint Stock Bank' },
    { value: 'OCEANBANK', label: 'Ocean Commercial One Member Limited Liability Bank' },
    { value: 'BIDV', label: 'Joint Stock Commercial Bank for Investment and Development of Vietnam' },
    { value: 'SEABANK', label: 'Southeast Asia Commercial Joint Stock Bank' },
    { value: 'BACA', label: 'BAC A Commercial Joint Stock Bank' },
    { value: 'AGRIBANK', label: 'Vietnam Bank for Agriculture and Rural Development' },
    { value: 'SAIGONBANK', label: 'Saigon Bank for Industry and Trade' },
    { value: 'PVBANK', label: 'Vietnam Public Joint Stock Commercial Bank' },
    { value: 'ACB', label: 'Asia Commercial Joint Stock Bank' },
    { value: 'BVBANK', label: 'Bao Viet Joint Stock commercial Bank' },
    { value: 'GPBANK', label: 'Global Petro Sole Member Limited Commercial Bank' },
    { value: 'LPB', label: 'Lien Viet Post Joint Stock Commercial Bank' },
    { value: 'NCB', label: 'National Citizen Commercial Joint Stock Bank' },
    { value: 'HONGLEONG', label: 'Hong Leong Bank Vietnam Limited' },
    { value: 'PBVN', label: 'Public Bank Vietnam' },
    { value: 'OCB', label: 'Orient Commercial Joint Stock Bank' },
    { value: 'SHB', label: 'Saigon-Hanoi Commercial Joint Stock Bank' },
    { value: 'SHINHAN', label: 'Shinhan Bank Vietnam Limited' },
    { value: 'VIETBANK', label: 'Vietnam Thuong Tin Commercial Joint Stock Bank' },
    { value: 'VIETCAPITALBANK', label: 'Viet Capital Commercial Joint Stock Bank' },
    { value: 'KIENLONGBANK', label: 'Kien Long Commercial Joint Stock Bank' },
    { value: 'PGBANK', label: 'Petrolimex Group Commercial Joint Stock Bank' },
    { value: 'VRB', label: 'Vietnam Russia Joint Venture Bank' },
    { value: 'NAMABANK', label: 'Nam A Commercial Joint Stock Bank' },
    { value: 'IVB', label: 'Indovina Bank' },
    { value: 'WOORIBANK', label: 'Woori Bank Vietnam Limited' },
    { value: 'UOB', label: 'United Overseas Bank (Vietnam) Limited' },
    { value: 'COOPBANK', label: 'Co-operative Bank of Viet Nam' },
    { value: 'CIMB', label: 'CIMB Bank Vietnam Limited' },
    { value: 'IBK', label: 'Industrial Bank of Korea' },
    { value: 'DAB', label: 'DONG A Commercial Joint Stock Bank' },
];
export const FAST2PAYS_WITHDRAWAL_BANKCODE_DICTIONARY: any = {
    'VCB': 'Joint Stock Commercial Bank for Foreign Trade of Vietnam',
    'TECHCOMBANK': 'Vietnam Technological and Commercial Joint Stock Bank',
    'TPBANK': 'TienPhong Commercial Joint Stock Bank',
    'VIETINBANK': 'Vietnam Joint Stock Commercial Bank of Industry and Trade',
    'VIB': 'Vietnam International Commercial Joint Stock Bank',
    'HDBANK': 'Ho Chi Minh city Development Joint Stock Commercial Bank',
    'MB': 'Military Commercial Joint Stock Bank',
    'VIETABANK': 'Vietnam Asia Commercial Joint',
    'MARITIMEBANK': 'Vietnam Maritime Commercial Joint Stock Bank',
    'EXIMBANK': 'Vietnam Export Import Commercial Joint Stock',
    'SCB': 'Sai Gon Joint Stock Commercial Bank',
    'VPBANK': 'Vietnam Prosperity Joint Stock Commercial Bank',
    'ABBANK': 'An Binh Commercial Joint Stock Bank',
    'SACOMBANK': 'Saigon Thuong Tin Commercial Joint Stock Bank',
    'OCEANBANK': 'Ocean Commercial One Member Limited Liability Bank',
    'BIDV': 'Joint Stock Commercial Bank for Investment and Development of Vietnam',
    'SEABANK': 'Southeast Asia Commercial Joint Stock Bank',
    'BACA': 'BAC A Commercial Joint Stock Bank',
    'AGRIBANK': 'Vietnam Bank for Agriculture and Rural Development',
    'SAIGONBANK': 'Saigon Bank for Industry and Trade',
    'PVBANK': 'Vietnam Public Joint Stock Commercial Bank',
    'ACB': 'Asia Commercial Joint Stock Bank',
    'BVBANK': 'Bao Viet Joint Stock commercial Bank',
    'GPBANK': 'Global Petro Sole Member Limited Commercial Bank',
    'LPB': 'Lien Viet Post Joint Stock Commercial Bank',
    'NCB': 'National Citizen Commercial Joint Stock Bank',
    'HONGLEONG': 'Hong Leong Bank Vietnam Limited',
    'PBVN': 'Public Bank Vietnam',
    'OCB': 'Orient Commercial Joint Stock Bank',
    'SHB': 'Saigon-Hanoi Commercial Joint Stock Bank',
    'SHINHAN': 'Shinhan Bank Vietnam Limited',
    'VIETBANK': 'Vietnam Thuong Tin Commercial Joint Stock Bank',
    'VIETCAPITALBANK': 'Viet Capital Commercial Joint Stock Bank',
    'KIENLONGBANK': 'Kien Long Commercial Joint Stock Bank',
    'PGBANK': 'Petrolimex Group Commercial Joint Stock Bank',
    'VRB': 'Vietnam Russia Joint Venture Bank',
    'NAMABANK': 'Nam A Commercial Joint Stock Bank',
    'IVB': 'Indovina Bank',
    'WOORIBANK': 'Woori Bank Vietnam Limited',
    'UOB': 'United Overseas Bank (Vietnam) Limited',
    'COOPBANK': 'Co-operative Bank of Viet Nam',
    'CIMB': 'CIMB Bank Vietnam Limited',
    'IBK': 'Industrial Bank of Korea',
    'DAB': 'DONG A Commercial Joint Stock Bank',
};
export const FAST2PAYS_WITHDRAWAL_TYPES = [
    { value: 'CARD_NUMBER', label: 'Card' },
    { value: 'BANK_ACCOUNT', label: 'Bank' }
];
export const FAST2PAYS_WITHDRAWAL_TYPES_DICTIONARY: any = {
    'CARD_NUMBER': 'Card',
    'BANK_ACCOUNT': 'Bank'
};
export const FAST2PAYS_TRANSLATIONS: any = {
    "Joint Stock Commercial Bank for Foreign Trade of Vietnam": "Ngân hàng thương mại cổ phần Ngoại thương Việt Nam (VCB)",
    "Vietnam Technological and Commercial Joint Stock Bank": "Ngân hàng Kỹ Thương (Techcombank)",
    "TienPhong Commercial Joint Stock Bank": "Ngân hàng Tiên Phong (TPBank)",
    "Vietnam Joint Stock Commercial Bank of Industry and Trade": "Ngân hàng Công thương Việt Nam (VietinBank)",
    "Vietnam International Commercial Joint Stock Bank": "Ngân hàng Quốc Tế  (VIB)",
    "Ho Chi Minh city Development Joint Stock Commercial Bank": "Ngân hàng Phát triển TPHồ Chí Minh (HDBank)",
    "Military Commercial Joint Stock Bank": "Ngân hàng Quân Đội (MB)",
    "Vietnam Asia Commercial Joint": "Ngân hàng TMCP Việt Á (VAB)",
    "Vietnam Maritime Commercial Joint Stock Bank": "Ngân hàng TMCP Hàng Hải (MSB)",
    "Vietnam Export Import Commercial Joint Stock": "Ngân hàng Xuất Nhập Khẩu (Eximbank)",
    "Sai Gon Joint Stock Commercial Bank": "Ngân hàng Sài Gòn (SCB)",
    "Vietnam Prosperity Joint Stock Commercial Bank": "Ngân hàng TMCP Thịnh Vượng (VPBank)",
    "An Binh Commercial Joint Stock Bank": "Ngân hàng An Bình (ABBANK)",
    "Saigon Thuong Tin Commercial Joint Stock Bank": "Ngân hàng Sài Gòn Thương Tín (Sacombank)",
    "Ocean Commercial One Member Limited Liability Bank": "Ngân hàng Đại Dương (OceanBank)",
    "Joint Stock Commercial Bank for Investment and Development of Vietnam": "Ngân hàng Đầu tư và Phát triển Việt Nam (BIDV)",
    "Southeast Asia Commercial Joint Stock Bank": "Ngân hàng Đông Nam Á (SeABank)",
    "BAC A Commercial Joint Stock Bank": "Ngân hàng Bắc Á (Bac A Bank)",
    "Vietnam Bank for Agriculture and Rural Development": "Ngân hàng NN&PT Nông thôn Việt Nam (Agribank)",
    "Saigon Bank for Industry and Trade": "Ngân hàng Sài Gòn Công Thương (SAIGONBANK)",
    "Vietnam Public Joint Stock Commercial Bank": "Ngân hàng TMCP Đại chúng Việt Nam (PVCombank)",
    "Asia Commercial Joint Stock Bank": "Ngân hàng Á Châu (ACB)",
    "Bao Viet Joint Stock commercial Bank": "Ngân hàng Bảo Việt  (BAOVIET Bank)",
    "Global Petro Sole Member Limited Commercial Bank": "Ngân hàng Dầu khí toàn cầu  (GPBank)",
    "Lien Viet Post Joint Stock Commercial Bank": "Ngân hàng TMCP Liên Việt (LVB)",
    "National Citizen Commercial Joint Stock Bank": "Ngân hàng Thương mại Cổ phần Quốc Dân (NCB)",
    "Hong Leong Bank Vietnam Limited": "Ngân hàng Hong Leong Việt Nam (HLBVN)",
    "Public Vietnam Bank": "Ngân hàng Đại Chúng Việt Nam (PVcomBank)",
    "Orient Commercial Joint Stock Bank": "Ngân hàng Phương Đông (OCB)",
    "Saigon-Hanoi Commercial Joint Stock Bank": "Ngân hàng Sài Gòn – Hà Nội (SHB)",
    "Shinhan Bank Vietnam Limited": "Ngân hàng Shinhan Việt Nam (SHBVN)",
    "Vietnam Thuong Tin Commercial Joint Stock Bank": "Ngân hàng Việt Nam Thương Tín (Vietbank)",
    "Viet Capital Commercial Joint Stock Bank": "Ngân hàng Bản Việt (Viet Capital Bank)",
    "Kien Long Commercial Joint Stock Bank": "Ngân hàng Kiên Long (Kienlongbank)",
    "Petrolimex Group Commercial Joint Stock Bank": "Ngân hàng Xăng dầu Petrolimex (PG Bank)",
    "Vietnam Russia Joint Venture Bank": "Ngân hàng Việt – Nga (VRB)",
    "Nam A Commercial Joint Stock Bank": "Ngân hàng Nam Á (Nam A Bank)",
    "Indovina Bank": "Ngân hàng Indovina (IVB)",
    "Woori Bank Vietnam Limited": "Ngân hàng Woori Việt Nam (Woori)",
    "United Overseas Bank (Vietnam) Limited": "Ngân Hàng United Overseas (Uob)",
    "Co-operative bank of VietNam": "Ngân hàng Hợp tác xã Việt Nam  (Co-opBank)",
    "CIMB Bank Vietnam Limited": "Ngân hàng TNHH MTV CIMB Việt Nam",
    "Industrial Bank of Korea": "Ngân hàng Công nghiệp Hàn Quốc",
    "DONG A Commercial Joint Stock Bank": "Ngân hàng Đông Á (DongA Bank)"
};
export const NinePay_WITHDRAWAL_TYPES = [
    { value: 0, label: 'Account' },
    { value: 1, label: 'Card' }
];
export const NinePay_BANK_ACOUNTS = [
    {
        "No.": 1,
        "value": "9PAY",
        "BankName": "9Pay",
        "label": "9Pay"
    },
    {
        "No.": 2,
        "value": "ABBANK",
        "BankName": "ABBANK - NH An Binh",
        "label": "ABBANK - An Binh Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },

    {
        "No.": 3,
        "value": "ACB",
        "BankName": "ACB - NH A Chau",
        "label": "ACB - Asia Commercial Joint Stock Bank",
        "SupportToBankAccount": true
    },
    {
        "No.": 4,
        "value": "AGRIBANK",
        "BankName": "AGRIBANK - NH Nong Nghiep va PTNT VN",
        "label": "AGRIBANK - Vietnam Bank for Agriculture and Rural Development",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 5,
        "value": "BAB",
        "BankName": "BAB - NH Bac A",
        "label": "BAB - Bac A Commercial Joint Stock Bank",
        "SupportToBankAccount": true
    },
    {
        "No.": 6,
        "value": "BANVIET",
        "BankName": "BANVIET - VIETCAPITALBA NK - NH Ban Viet",
        "label": "BANVIET - Viet Capital Commercial Joint Stock Bank",
        "SupportToBankAccount": true
    },
    {
        "No.": 7,
        "value": "BAOVIETB ANK",
        "BankName": "BAOVIET BANK - NH Bao Viet",
        "label": "BAOVIET BANK - Bao Viet Joint Stock Commercial Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },

    {
        "No.": 8,
        "value": "BIDV",
        "BankName": "BIDV - NH Dau Tu va Phat Trien VN",
        "label": "BIDV - Bank for Investment and Development of Vietnam",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 9,
        "value": "CBBANK",
        "BankName": "CB BANK - NH Xay Dung VN",
        "label": "CB BANK - Vietnam Construction Bank",
        "SupportToATMCards": true
    },
    {
        "No.": 10,
        "value": "CIMB",
        "BankName": "CIMB - NH CIMB Bank",
        "label": "CIMB - CIMB Bank (Vietnam) Limited",
        "SupportToATMCards": true
    },
    {
        "No.": 11,
        "value": "DONGABA NK",
        "BankName": "DONGA BANK - NH Dong A",
        "label": "DONGA BANK - Dong A Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 12,
        "value": "EXIMBANK",
        "BankName": "EXIMBANK - NH Xuat Nhap Khau Dau Khi Toan Cau",
        "label": "EXIMBANK - Vietnam Export Import Commercial Joint - Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 13,
        "value": "GPBANK",
        "BankName": "GP BANK - NH",
        "label": "GP BANK - Global Petro Bank Limited",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 14,
        "value": "HDBANK",
        "BankName": "HDBANK - NH Phat Trien Tp HCM",
        "label": "HDBANK - Ho Chi Minh City Development Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 15,
        "value": "HLB",
        "BankName": "HLB - NH Hongleong Bank",
        "label": "HLB - Hong Leong Bank Vietnam Limited",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 16,
        "value": "IVB",
        "BankName": "IVB - NH Indovina",
        "label": "IVB - Indovina Bank Ltd",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 17,
        "value": "KIENLONG BANK",
        "BankName": "KIENLONG BANK - NH Kien Long",
        "label": "KIENLONG BANK - Kien Long Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 18,
        "value": "LIENVIETP OSTBANK",
        "BankName": "LIENVIETPOSTB ANK - NH Buu Dien Lien Viet",
        "label": "LIENVIETPOSTBANK - Lien Viet Postal Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 19,
        "value": "MBBANK",
        "BankName": "MBBANK - NH Quan Doi",
        "label": "MBBANK - Military Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 20,
        "value": "MSB",
        "BankName": "MSB- NH Hang Hai",
        "label": "MSB- Vietnam Maritime Joint - Stock Commercial Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 21,
        "value": "NAMABAN K",
        "BankName": "NAMABANK - NH Nam A",
        "label": "NAMABANK - South East Asia Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 22,
        "value": "NAVIBANK",
        "BankName": "NAVI BANK - NH Nam Viet",
        "label": "NAVI BANK - Nam Viet Commercial Joint Stock Bank",
        "SupportToATMCards": true
    },
    {
        "No.": 23,
        "value": "NCB",
        "BankName": "NCB - NH Quốc Dân",
        "label": "NCB - National Citizen Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 24,
        "value": "OCB",
        "BankName": "OCB - NH Phuong Dong",
        "label": "OCB - Orient Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 25,
        "value": "OCEANBA NK",
        "BankName": "OCEANBANK - NH Dai Duong",
        "label": "OCEANBANK - Ocean Commercial One Member Limited Liability Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 26,
        "value": "PGBANK",
        "BankName": "PGBANK - NH Xang Dau Petrolimex",
        "label": "PGBANK - Petrolimex Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 27,
        "value": "PUBLICBA NK",
        "BankName": "PUBLIC BANK - NH MTV Public Viet Nam",
        "label": "PUBLIC BANK - Public Bank Vietnam Limited",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 28,
        "value": "PVCOMBA NK",
        "BankName": "PVCOMBANK - NH Dai Chung Viet Nam",
        "label": "PVCOMBANK - Vietnam Public Joint Stock Commercial Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 29,
        "value": "SACOMBA NK",
        "BankName": "SACOMBANK - NH Sai gon Thuong Tin",
        "label": "SACOMBANK - Sai Gon Thuong Tin Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 30,
        "value": "SAIGONBA NK",
        "BankName": "SAIGON BANK - NH Sai Gon Cong Thuong",
        "label": "SAIGON BANK - Saigon Bank for Industry and Trade",
        "SupportToBankAccount": true
    },
    {
        "No.": 31,
        "value": "SCB",
        "BankName": "SCB - NH Sai Gon",
        "label": "SCB - Sai Gon Commercial Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 32,
        "value": "SEABANK",
        "BankName": "SEABANK - NH Dong Nam A",
        "label": "SEABANK - Southeast Asia Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 33,
        "value": "SHB",
        "BankName": "SHB - NH Sai Gon Ha Noi",
        "label": "SHB - Saigon - Hanoi Commercial Joint Stock Bank",
        "SupportToBankAccount": true
    },
    {
        "No.": 34,
        "value": "SHINHANB ANK",
        "BankName": "SHINHAN BANK - NH Shinhan Bank",
        "label": "SHINHAN BANK - Shinhan Bank Vietnam Limited",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 35,
        "value": "STANDAR D CHARTER ED",
        "BankName": "Standard Chartered Viet Nam",
        "label": "Standard Chartered Viet Nam",
        "SupportToATMCards": true
    },
    {
        "No.": 36,
        "value": "TECHCOM BANK",
        "BankName": "TECHCOMBANK - NH Ky Thuong",
        "label": "TECHCOMBANK - VietNam Technological and Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 37,
        "value": "TPBANK",
        "BankName": "TPBANK - NH Tien Phong",
        "label": "TPBANK - TienPhong Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 38,
        "value": "UOB",
        "BankName": "UOB - NH UOB Viet Nam",
        "label": "UOB - United Overseas Bank Vietnam Limited",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 39,
        "value": "VBSP",
        "BankName": "VBSP - NH Chinh Sach Xa Hoi",
        "label": "VBSP - Vietnam Bank for Social Policies",
        "SupportToATMCards": true
    },
    {
        "No.": 40,
        "value": "VDB",
        "BankName": "VDB - NH Phat Trien Viet Nam",
        "label": "VDB - Vietnam Development Bank",
        "SupportToATMCards": true
    },
    {
        "No.": 41,
        "value": "VIB",
        "BankName": "VIB - NH Quoc Te",
        "label": "VIB - Vietnam International and Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 42,
        "value": "VIETABAN K",
        "BankName": "VIETABANK - NH Viet A",
        "label": "VIETABANK - Viet A Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 43,
        "value": "VIETBANK",
        "BankName": "VIET BANK - NH Viet Nam Thuong Tin",
        "label": "VIET BANK - Vietnam Thuong Tin Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 44,
        "value": "VIETCOMBANK",
        "BankName": "VIETCOMBANK - NH Ngoai Thuong Viet Nam",
        "label": "VIETCOMBANK - Bank for Foreign Trade of Vietnam",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 45,
        "value": "VIETINBANK",
        "BankName": "VIETINBANK - NH Cong Thuong VN",
        "label": "VIETINBANK - Vietnam Joint Stock Commercial Bank for Industry and Trade",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 46,
        "value": "VINASIAM",
        "BankName": "VINASIAM - NH Lien Doanh Viet Thai",
        "label": "VINASIAM - VinaSiam Bank",
        "SupportToATMCards": true
    },
    {
        "No.": 47,
        "value": "VPBANK",
        "BankName": "VPBANK - NH Viet Nam Thinh Vuong",
        "label": "VPBANK - Vietnam Prosperity Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 48,
        "value": "VRB",
        "BankName": "VRB - NH Lien Doanh Viet Nga",
        "label": "VRB - Vietnam Russia Joint Venture Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 49,
        "value": "WOORIBA NK",
        "BankName": "WOORI BANK - NH Woori",
        "label": "WOORI BANK - Woori Bank Vietnam Limited",
        "SupportToBankAccount": true
    }
];
export const NINEPAY_WITHDRAWAL_BANKCODE_DICTIONARY: any = {
    "9PAY": {
        "No.": 1,
        "value": "9PAY",
        "BankName": "9Pay",
        "label": "9Pay"
    },
    "ABBANK": {
        "No.": 2,
        "value": "ABBANK",
        "BankName": "ABBANK - NH An Binh",
        "label": "ABBANK - An Binh Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "ACB": {
        "No.": 3,
        "value": "ACB",
        "BankName": "ACB - NH A Chau",
        "label": "ACB - Asia Commercial Joint Stock Bank",
        "SupportToBankAccount": true
    },
    "AGRIBANK": {
        "No.": 4,
        "value": "AGRIBANK",
        "BankName": "AGRIBANK - NH Nong Nghiep va PTNT VN",
        "label": "AGRIBANK - Vietnam Bank for Agriculture and Rural Development",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "BAB": {
        "No.": 5,
        "value": "BAB",
        "BankName": "BAB - NH Bac A",
        "label": "BAB - Bac A Commercial Joint Stock Bank",
        "SupportToBankAccount": true
    },
    "BANVIET": {
        "No.": 6,
        "value": "BANVIET",
        "BankName": "BANVIET - VIETCAPITALBA NK - NH Ban Viet",
        "label": "BANVIET - Viet Capital Commercial Joint Stock Bank",
        "SupportToBankAccount": true
    },
    "BAOVIETB ANK": {
        "No.": 7,
        "value": "BAOVIETB ANK",
        "BankName": "BAOVIET BANK - NH Bao Viet",
        "label": "BAOVIET BANK - Bao Viet Joint Stock Commercial Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "BIDV": {
        "No.": 8,
        "value": "BIDV",
        "BankName": "BIDV - NH Dau Tu va Phat Trien VN",
        "label": "BIDV - Bank for Investment and Development of Vietnam",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "CBBANK": {
        "No.": 9,
        "value": "CBBANK",
        "BankName": "CB BANK - NH Xay Dung VN",
        "label": "CB BANK - Vietnam Construction Bank",
        "SupportToATMCards": true
    },
    "CIMB": {
        "No.": 10,
        "value": "CIMB",
        "BankName": "CIMB - NH CIMB Bank",
        "label": "CIMB - CIMB Bank (Vietnam) Limited",
        "SupportToATMCards": true
    },
    "DONGABA NK": {
        "No.": 11,
        "value": "DONGABA NK",
        "BankName": "DONGA BANK - NH Dong A",
        "label": "DONGA BANK - Dong A Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "EXIMBANK": {
        "No.": 12,
        "value": "EXIMBANK",
        "BankName": "EXIMBANK - NH Xuat Nhap Khau Dau Khi Toan Cau",
        "label": "EXIMBANK - Vietnam Export Import Commercial Joint - Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "GPBANK": {
        "No.": 13,
        "value": "GPBANK",
        "BankName": "GP BANK - NH",
        "label": "GP BANK - Global Petro Bank Limited",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "HDBANK": {
        "No.": 14,
        "value": "HDBANK",
        "BankName": "HDBANK - NH Phat Trien Tp HCM",
        "label": "HDBANK - Ho Chi Minh City Development Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "HLB": {
        "No.": 15,
        "value": "HLB",
        "BankName": "HLB - NH Hongleong Bank",
        "label": "HLB - Hong Leong Bank Vietnam Limited",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "IVB": {
        "No.": 16,
        "value": "IVB",
        "BankName": "IVB - NH Indovina",
        "label": "IVB - Indovina Bank Ltd",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "KIENLONG BANK": {
        "No.": 17,
        "value": "KIENLONG BANK",
        "BankName": "KIENLONG BANK - NH Kien Long",
        "label": "KIENLONG BANK - Kien Long Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "LIENVIETP OSTBANK": {
        "No.": 18,
        "value": "LIENVIETP OSTBANK",
        "BankName": "LIENVIETPOSTB ANK - NH Buu Dien Lien Viet",
        "label": "LIENVIETPOSTBANK - Lien Viet Postal Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "MBBANK": {
        "No.": 19,
        "value": "MBBANK",
        "BankName": "MBBANK - NH Quan Doi",
        "label": "MBBANK - Military Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "MSB": {
        "No.": 20,
        "value": "MSB",
        "BankName": "MSB- NH Hang Hai",
        "label": "MSB- Vietnam Maritime Joint - Stock Commercial Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "NAMABAN K": {
        "No.": 21,
        "value": "NAMABAN K",
        "BankName": "NAMABANK - NH Nam A",
        "label": "NAMABANK - South East Asia Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "NAVIBANK": {
        "No.": 22,
        "value": "NAVIBANK",
        "BankName": "NAVI BANK - NH Nam Viet",
        "label": "NAVI BANK - Nam Viet Commercial Joint Stock Bank",
        "SupportToATMCards": true
    },
    "NCB": {
        "No.": 23,
        "value": "NCB",
        "BankName": "NCB - NH Quốc Dân",
        "label": "NCB - National Citizen Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "OCB": {
        "No.": 24,
        "value": "OCB",
        "BankName": "OCB - NH Phuong Dong",
        "label": "OCB - Orient Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "OCEANBA NK": {
        "No.": 25,
        "value": "OCEANBA NK",
        "BankName": "OCEANBANK - NH Dai Duong",
        "label": "OCEANBANK - Ocean Commercial One Member Limited Liability Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "PGBANK": {
        "No.": 26,
        "value": "PGBANK",
        "BankName": "PGBANK - NH Xang Dau Petrolimex",
        "label": "PGBANK - Petrolimex Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "PUBLICBA NK": {
        "No.": 27,
        "value": "PUBLICBA NK",
        "BankName": "PUBLIC BANK - NH MTV Public Viet Nam",
        "label": "PUBLIC BANK - Public Bank Vietnam Limited",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "PVCOMBA NK": {
        "No.": 28,
        "value": "PVCOMBA NK",
        "BankName": "PVCOMBANK - NH Dai Chung Viet Nam",
        "label": "PVCOMBANK - Vietnam Public Joint Stock Commercial Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "SACOMBA NK": {
        "No.": 29,
        "value": "SACOMBA NK",
        "BankName": "SACOMBANK - NH Sai gon Thuong Tin",
        "label": "SACOMBANK - Sai Gon Thuong Tin Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "SAIGONBA NK": {
        "No.": 30,
        "value": "SAIGONBA NK",
        "BankName": "SAIGON BANK - NH Sai Gon Cong Thuong",
        "label": "SAIGON BANK - Saigon Bank for Industry and Trade",
        "SupportToBankAccount": true
    },
    "SCB": {
        "No.": 31,
        "value": "SCB",
        "BankName": "SCB - NH Sai Gon",
        "label": "SCB - Sai Gon Commercial Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "SEABANK": {
        "No.": 32,
        "value": "SEABANK",
        "BankName": "SEABANK - NH Dong Nam A",
        "label": "SEABANK - Southeast Asia Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "SHB": {
        "No.": 33,
        "value": "SHB",
        "BankName": "SHB - NH Sai Gon Ha Noi",
        "label": "SHB - Saigon - Hanoi Commercial Joint Stock Bank",
        "SupportToBankAccount": true
    },
    "SHINHANB ANK": {
        "No.": 34,
        "value": "SHINHANB ANK",
        "BankName": "SHINHAN BANK - NH Shinhan Bank",
        "label": "SHINHAN BANK - Shinhan Bank Vietnam Limited",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "STANDAR D CHARTER ED": {
        "No.": 35,
        "value": "STANDAR D CHARTER ED",
        "BankName": "Standard Chartered Viet Nam",
        "label": "Standard Chartered Viet Nam",
        "SupportToATMCards": true
    },
    "TECHCOM BANK": {
        "No.": 36,
        "value": "TECHCOM BANK",
        "BankName": "TECHCOMBANK - NH Ky Thuong",
        "label": "TECHCOMBANK - VietNam Technological and Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "TPBANK": {
        "No.": 37,
        "value": "TPBANK",
        "BankName": "TPBANK - NH Tien Phong",
        "label": "TPBANK - TienPhong Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "UOB": {
        "No.": 38,
        "value": "UOB",
        "BankName": "UOB - NH UOB Viet Nam",
        "label": "UOB - United Overseas Bank Vietnam Limited",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "VBSP": {
        "No.": 39,
        "value": "VBSP",
        "BankName": "VBSP - NH Chinh Sach Xa Hoi",
        "label": "VBSP - Vietnam Bank for Social Policies",
        "SupportToATMCards": true
    },
    "VDB": {
        "No.": 40,
        "value": "VDB",
        "BankName": "VDB - NH Phat Trien Viet Nam",
        "label": "VDB - Vietnam Development Bank",
        "SupportToATMCards": true
    },
    "VIB": {
        "No.": 41,
        "value": "VIB",
        "BankName": "VIB - NH Quoc Te",
        "label": "VIB - Vietnam International and Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "VIETABAN K": {
        "No.": 42,
        "value": "VIETABAN K",
        "BankName": "VIETABANK - NH Viet A",
        "label": "VIETABANK - Viet A Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "VIETBANK": {
        "No.": 43,
        "value": "VIETBANK",
        "BankName": "VIET BANK - NH Viet Nam Thuong Tin",
        "label": "VIET BANK - Vietnam Thuong Tin Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "VIETCOMB ANK": {
        "No.": 44,
        "value": "VIETCOMB ANK",
        "BankName": "VIETCOMBANK - NH Ngoai Thuong Viet Nam",
        "label": "VIETCOMBANK - Bank for Foreign Trade of Vietnam",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "VIETINBAN K": {
        "No.": 45,
        "value": "VIETINBAN K",
        "BankName": "VIETINBANK - NH Cong Thuong VN",
        "label": "VIETINBANK - Vietnam Joint Stock Commercial Bank for Industry and Trade",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "VINASIAM": {
        "No.": 46,
        "value": "VINASIAM",
        "BankName": "VINASIAM - NH Lien Doanh Viet Thai",
        "label": "VINASIAM - VinaSiam Bank",
        "SupportToATMCards": true
    },
    "VPBANK": {
        "No.": 47,
        "value": "VPBANK",
        "BankName": "VPBANK - NH Viet Nam Thinh Vuong",
        "label": "VPBANK - Vietnam Prosperity Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "VRB": {
        "No.": 48,
        "value": "VRB",
        "BankName": "VRB - NH Lien Doanh Viet Nga",
        "label": "VRB - Vietnam Russia Joint Venture Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "WOORIBA NK": {
        "No.": 49,
        "value": "WOORIBA NK",
        "BankName": "WOORI BANK - NH Woori",
        "label": "WOORI BANK - Woori Bank Vietnam Limited",
        "SupportToBankAccount": true
    }
};
//#endregion
//#region PDF
export function downloadPDF(pdf: string, fileName: string) {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement("a");
    const FileName = `${fileName}.pdf`;
    downloadLink.href = linkSource;
    downloadLink.download = FileName;
    downloadLink.click();
}
export const XLTrades_Secure_Client_Area_Payment_Details = `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`;
//#region Match2Pay
export const MATCH2PAY_NETWORKS = [
    { value: "Bitcoin", label: "Bitcoin - BTC" },
    { value: "Ethereum", label: "Ethereum (ERC-20)" },
    { value: "BinanceSmartChain", label: "Binance Smart Chain (BEP-20)" },
    { value: "TRON", label: "TRON (TRC-20)" },
];

export const MATCH2PAY_CRYPTO_CURRENCY = [
    { value: "Tether - USDT ERC20 - UST", label: "Tether - USDT ERC20 - UST", parent: "Ethereum", paymentCurrency: "UST", paymentGatewayName: "USDT ERC20" },
    { value: "USD Coin - USDC ERC20 - UCC", label: "USD Coin - USDC ERC20 - UCC", parent: "Ethereum", paymentCurrency: "UCC", paymentGatewayName: "USDC ERC20" },
    { value: "Ether - ETH", label: "Ether - ETH", parent: "Ethereum", paymentCurrency: "ETH", paymentGatewayName: "ETH" },

    { value: "Tether - USDT BEP20 - USB", label: "Tether - USDT BEP20 - USB", parent: "BinanceSmartChain", paymentCurrency: "USB", paymentGatewayName: "USDT BEP20" },
    {
        value: "USD Coin - USDC BEP20 - USB",
        label: "USD Coin - USDC BEP20 - USB",
        parent: "BinanceSmartChain",
        paymentCurrency: "USB",
        paymentGatewayName: "USDC BEP20"
    },
    { value: "Binance USD - BUSD - USB", label: "Binance USD - BUSD - USB", parent: "BinanceSmartChain", paymentCurrency: "USB", paymentGatewayName: "BUSD BEP20" },
    { value: "Binance Coin - BNB", label: "Binance Coin - BNB", parent: "BinanceSmartChain", paymentCurrency: "BNB", paymentGatewayName: "BNB" },

    { value: "Tether - USDT TRC20 - USX", label: "Tether - USDT TRC20 - USX", parent: "TRON", paymentCurrency: "USX", paymentGatewayName: "USDT TRC20" },
    { value: "USD Coin - USDC TRC20 - UCX (deposits only)", label: "USD Coin - USDC TRC20 - UCX (deposits only)", parent: "TRON", paymentCurrency: "UCX", paymentGatewayName: "USDC TRC20" },
    { value: "Tronix - TRX (deposits only)", label: "Tronix - TRX ", parent: "TRON", paymentCurrency: "TRX", paymentGatewayName: "TRX" },
];
//#endregion
//#region help2Pay 
export const HELP2PAY_DEPOSIT_BANKCODES = [
    { label: "Bangkok Bank", value: "BBL", Currency: "THB", BankCode: "BBL", BankName: "Bangkok Bank" },
    { label: "Bank of Ayudhya (Krungsri)", value: "BOA", Currency: "THB", BankCode: "BOA", BankName: "Bank of Ayudhya (Krungsri)" },
    { label: "CIMB Thai", value: "CIMBT", Currency: "THB", BankCode: "CIMBT", BankName: "CIMB Thai" },
    { label: "Karsikorn Bank (K-Bank)", value: "KKR", Currency: "THB", BankCode: "KKR", BankName: "Karsikorn Bank (K-Bank)" },
    { label: "Kiatnakin Bank", value: "KNK", Currency: "THB", BankCode: "KNK", BankName: "Kiatnakin Bank" },
    { label: "Krung Thai Bank", value: "KTB", Currency: "THB", BankCode: "KTB", BankName: "Krung Thai Bank" },
    { label: "Siam Commercial Bank", value: "SCB", Currency: "THB", BankCode: "SCB", BankName: "Siam Commercial Bank" },
    { label: "TMBThanachart Bank(TTB)", value: "TMB", Currency: "THB", BankCode: "TMB", BankName: "TMBThanachart Bank(TTB)" },
    { label: "Asia Commercial Bank", value: "ACB", Currency: "VND", BankCode: "ACB", BankName: "Asia Commercial Bank" },
    { label: "Agribank", value: "AGB", Currency: "VND", BankCode: "AGB", BankName: "Agribank" },
    { label: "Bank for Investment and Development of Vietnam", value: "BIDV", Currency: "VND", BankCode: "BIDV", BankName: "Bank for Investment and Development of Vietnam" },
    { label: "DongA Bank", value: "DAB", Currency: "VND", BankCode: "DAB", BankName: "DongA Bank" },
    { label: "Eximbank Vietnam", value: "EXIM", Currency: "VND", BankCode: "EXIM", BankName: "Eximbank Vietnam" },
    { label: "Military Commercial Joint Stock Bank", value: "MB", Currency: "VND", BankCode: "MB", BankName: "Military Commercial Joint Stock Bank" },
    { label: "Maritime Bank", value: "MTMB", Currency: "VND", BankCode: "MTMB", BankName: "Maritime Bank" },
    { label: "Sacombank", value: "SACOM", Currency: "VND", BankCode: "SACOM", BankName: "Sacombank" },
    { label: "Techcombank", value: "TCB", Currency: "VND", BankCode: "TCB", BankName: "Techcombank" },
    { label: "Tien Phong Bank", value: "TPB", Currency: "VND", BankCode: "TPB", BankName: "Tien Phong Bank" },
    { label: "Vietcombank", value: "VCB", Currency: "VND", BankCode: "VCB", BankName: "Vietcombank" },
    { label: "Vietnam International Bank", value: "VIB", Currency: "VND", BankCode: "VIB", BankName: "Vietnam International Bank" },
    { label: "VP Bank", value: "VPB", Currency: "VND", BankCode: "VPB", BankName: "VP Bank" },
    { label: "Vietinbank", value: "VTB", Currency: "VND", BankCode: "VTB", BankName: "Vietinbank" },
    { label: "Banco de Oro ", value: "BDO", Currency: "PHP", BankCode: "BDO", BankName: "Banco de Oro " },
    { label: "Bank of the Philippine Islands", value: "BPI", Currency: "PHP", BankCode: "BPI", BankName: "Bank of the Philippine Islands" },
    { label: "Land Bank of the Philippines", value: "LBP", Currency: "PHP", BankCode: "LBP", BankName: "Land Bank of the Philippines" },
    { label: "MetroBank", value: "MTB", Currency: "PHP", BankCode: "MTB", BankName: "MetroBank" },
    { label: "Rizal Commercial Banking Corporation", value: "RCBC", Currency: "PHP", BankCode: "RCBC", BankName: "Rizal Commercial Banking Corporation" },
    { label: "Security Bank Corporation", value: "SBC", Currency: "PHP", BankCode: "SBC", BankName: "Security Bank Corporation" },
    { label: "Promptpay", value: "PPTP", Currency: "THB", BankCode: "PPTP", BankName: "Promptpay" },
];
//#endregion 
export const CHIMARA_ACCOUNT_TYPE_GROUPS = [
    { value: "AMA", label: "AMA" },
    { value: "EVAL", label: "EVAL" },
    { value: "PLUS", label: "PLUS" },
];
export function ReturnImageName() {
    if (CheckIfCompanyIs("Icon")) {
        return `Logo_ICONFX.png`
    }
    if (CheckIfCompanyIs("Malfex")) {
        return `Maleyat_Table_NoData.png`
    }
    if (CheckIfCompanyIs("XAMarkets")) {
        return `NoData_XAMarkets.png`
    }
    if (CheckIfCompanyIs("Chimara")) {
        return `Chimara_Table_NoData.png`
    }
    if (CheckIfCompanyIs("PureNorth")) {
        return `Empty-PureNorth-NoData.png`
    }
    if (CheckIfCompanyIs("FXOpulence"))
        return "Main-NoData-FXOpulence.png";
    return "NoData.png";
}
export const BIGPAY_BANK_NAMES = [
    { label: "VIETCOMBANK", value: "VIETCOMBANK" },
    { label: "ACB", value: "ACB" },
    { label: "TECHCOMBANK", value: "TECHCOMBANK" },
    { label: "MB", value: "MB" },
];
export const CAPITAL_WALLET_CURRENCIES = [
    {
        "label": "USDT-TRC20",
        "value": "TRXUSDT",
        "keyType": "TRC20"
    },
    {
        "label": "USDT-ERC20",
        "value": "USDT",
        "keyType": "ERC20"
    },
    {
        "label": "USDC-TRC20",
        "value": "TRXUSDC",
        "keyType": "TRC20"
    },
    {
        "label": "USDC-ERC20",
        "value": "USDC",
        "keyType": "ERC20"
    },
    {
        "label": "BitcoinCash",
        "value": "BCH",
        "keyType": ""
    },
    {
        "label": "Bitcoin",
        "value": "BTC",
        "keyType": ""
    },
    {
        "label": "Ethereum",
        "value": "ETH",
        "keyType": "ERC20"
    },
    {
        "label": "Dogecoin",
        "value": "DOGE",
        "keyType": ""
    },
    {
        "label": "MaticToken",
        "value": "MATIC",
        "keyType": "ERC20"
    },
    {
        "label": "TRON",
        "value": "TRX",
        "keyType": ""
    },
    {
        "label": "BinanceUSD",
        "value": "BUSD",
        "keyType": "ERC20"
    },
    {
        "label": "Litecoin",
        "value": "LTC",
        "keyType": ""
    }
];
export const CAPTIAL_WALLET_DICTIONARY: any = {
    "TRXUSDT": {
        "label": "USDT-TRC20",
        "value": "TRXUSDT",
        "keyType": "TRC20"
    },
    "USDT": {
        "label": "USDT-ERC20",
        "value": "USDT",
        "keyType": "ERC20"
    },
    "TRXUSDC": {
        "label": "USDC-TRC20",
        "value": "TRXUSDC",
        "keyType": "TRC20"
    },
    "USDC": {
        "label": "USDC-ERC20",
        "value": "USDC",
        "keyType": "ERC20"
    },
    "BCH": {
        "label": "BitcoinCash",
        "value": "BCH",
        "keyType": ""
    },
    "BTC": {
        "label": "Bitcoin",
        "value": "BTC",
        "keyType": ""
    },
    "ETH": {
        "label": "Ethereum",
        "value": "ETH",
        "keyType": "ERC20"
    },
    "DOGE": {
        "label": "Dogecoin",
        "value": "DOGE",
        "keyType": ""
    },
    "MATIC": {
        "label": "MaticToken",
        "value": "MATIC",
        "keyType": "ERC20"
    },
    "TRX": {
        "label": "TRON",
        "value": "TRX",
        "keyType": ""
    },
    "BUSD": {
        "label": "BinanceUSD",
        "value": "BUSD",
        "keyType": "ERC20"
    },
    "LTC": {
        "label": "Litecoin",
        "value": "LTC",
        "keyType": ""
    }
};
export const OZOW_WITHDRAWAL_BANKS = [
    {
        "value": "42f71bf8-0e09-43d5-a6eb-4f7370cb5b20",
        "label": "Cash Vouchers",
        "universalBranchCode": null
    },
    {
        "value": "155ace7d-eb87-481e-94be-a185215afd48",
        "label": "Direct Deposit",
        "universalBranchCode": null
    },
    {
        "value": "c296d0d8-ad0b-43b4-96c2-de30ad039561",
        "label": "Standard Chartered Bank",
        "universalBranchCode": "730020"
    },
    {
        "value": "3284a0ad-ba78-4838-8c2b-102981286a2b",
        "label": "ABSA",
        "universalBranchCode": "632005"
    },
    {
        "value": "33a0840b-0cf4-4b8c-86e0-ec6c4be8c60e",
        "label": "African Bank",
        "universalBranchCode": "430000"
    },
    {
        "value": "44356c06-1081-4ced-8669-760cf3165712",
        "label": "Albaraka Bank",
        "universalBranchCode": "800000"
    },
    {
        "value": "8d77e501-5990-4cd1-bb08-3d3fe402fb20",
        "label": "BankOfAthens",
        "universalBranchCode": "410506"
    },
    {
        "value": "29c5ee92-46ec-4879-8ad9-5cd3f5502727",
        "label": "Bidvest Bank",
        "universalBranchCode": "462005"
    },
    {
        "value": "913999fa-3a32-4e3d-82f0-a1df7e9e4f7b",
        "label": "Capitec Bank",
        "universalBranchCode": "470010"
    },
    {
        "value": "7fc2d14c-5021-497d-a73e-1788d6ce3ff3",
        "label": "CitiBank",
        "universalBranchCode": "350005"
    },
    {
        "value": "b8f152a2-8bd2-46c4-930f-4cd5b2b37ef9",
        "label": "Discovery Bank",
        "universalBranchCode": "679000"
    },
    {
        "value": "4816019c-3314-4c80-8b6b-b2cd16dcc4ec",
        "label": "FNB",
        "universalBranchCode": "250655"
    },
    {
        "value": "2c7bbd14-cd96-4b4f-96f9-ad9ba228366d",
        "label": "HSBC Bank",
        "universalBranchCode": "587000"
    },
    {
        "value": "4b45be85-b616-4bd1-9027-f8fcf8f9af7b",
        "label": "Investec",
        "universalBranchCode": "580105"
    },
    {
        "value": "9e1917ad-29d1-4d11-80b5-0f6c33ae1083",
        "label": "Mercantile Bank",
        "universalBranchCode": "450105"
    },
    {
        "value": "bf0561fd-4203-4a0c-9174-cb26fcd87a60",
        "label": "Nedbank",
        "universalBranchCode": "198765"
    },
    {
        "value": "c36c2423-8a06-4393-bf2d-f5da82d67bc7",
        "label": "Olympus Mobile",
        "universalBranchCode": "585001"
    },
    {
        "value": "cc08d678-09cb-49c8-bcd8-2ec9e3bd0a82",
        "label": "RMB",
        "universalBranchCode": "250655"
    },
    {
        "value": "54a18018-a9fe-4adb-b752-38004ed735d6",
        "label": "Sasfin Bank",
        "universalBranchCode": "683000"
    },
    {
        "value": "ad7d8da4-1723-4066-94bb-6662d845e483",
        "label": "Standard Bank",
        "universalBranchCode": "051001"
    },
    {
        "value": "28fcc8fa-985b-480b-82fd-7d09bc19c9d0",
        "label": "TymeBank",
        "universalBranchCode": "678910"
    },
    {
        "value": "8ff9fbc7-9e14-47bc-8d91-cbc81cf131e9",
        "label": "Ubank Limited",
        "universalBranchCode": "431010"
    }
];
export function validateCardExpiration(expirationDate: string) {
    if (!expirationDate) return false;
    let regex = /^(0[1-9]|1[0-2])\/\d{2}$/; // Regular expression for MM/YY format
    return regex.test(expirationDate);
}
export const OZOW_WITHDRAWAL_BANKS_DICT: any = {
    "42f71bf8-0e09-43d5-a6eb-4f7370cb5b20": {
        "value": "42f71bf8-0e09-43d5-a6eb-4f7370cb5b20",
        "label": "Cash Vouchers",
        "universalBranchCode": null
    },
    "155ace7d-eb87-481e-94be-a185215afd48": {
        "value": "155ace7d-eb87-481e-94be-a185215afd48",
        "label": "Direct Deposit",
        "universalBranchCode": null
    },
    "c296d0d8-ad0b-43b4-96c2-de30ad039561": {
        "value": "c296d0d8-ad0b-43b4-96c2-de30ad039561",
        "label": "Standard Chartered Bank",
        "universalBranchCode": "730020"
    },
    "3284a0ad-ba78-4838-8c2b-102981286a2b": {
        "value": "3284a0ad-ba78-4838-8c2b-102981286a2b",
        "label": "ABSA",
        "universalBranchCode": "632005"
    },
    "33a0840b-0cf4-4b8c-86e0-ec6c4be8c60e": {
        "value": "33a0840b-0cf4-4b8c-86e0-ec6c4be8c60e",
        "label": "African Bank",
        "universalBranchCode": "430000"
    },
    "44356c06-1081-4ced-8669-760cf3165712": {
        "value": "44356c06-1081-4ced-8669-760cf3165712",
        "label": "Albaraka Bank",
        "universalBranchCode": "800000"
    },
    "8d77e501-5990-4cd1-bb08-3d3fe402fb20": {
        "value": "8d77e501-5990-4cd1-bb08-3d3fe402fb20",
        "label": "BankOfAthens",
        "universalBranchCode": "410506"
    },
    "29c5ee92-46ec-4879-8ad9-5cd3f5502727": {
        "value": "29c5ee92-46ec-4879-8ad9-5cd3f5502727",
        "label": "Bidvest Bank",
        "universalBranchCode": "462005"
    },
    "913999fa-3a32-4e3d-82f0-a1df7e9e4f7b": {
        "value": "913999fa-3a32-4e3d-82f0-a1df7e9e4f7b",
        "label": "Capitec Bank",
        "universalBranchCode": "470010"
    },
    "7fc2d14c-5021-497d-a73e-1788d6ce3ff3": {
        "value": "7fc2d14c-5021-497d-a73e-1788d6ce3ff3",
        "label": "CitiBank",
        "universalBranchCode": "350005"
    },
    "b8f152a2-8bd2-46c4-930f-4cd5b2b37ef9": {
        "value": "b8f152a2-8bd2-46c4-930f-4cd5b2b37ef9",
        "label": "Discovery Bank",
        "universalBranchCode": "679000"
    },
    "4816019c-3314-4c80-8b6b-b2cd16dcc4ec": {
        "value": "4816019c-3314-4c80-8b6b-b2cd16dcc4ec",
        "label": "FNB",
        "universalBranchCode": "250655"
    },
    "2c7bbd14-cd96-4b4f-96f9-ad9ba228366d": {
        "value": "2c7bbd14-cd96-4b4f-96f9-ad9ba228366d",
        "label": "HSBC Bank",
        "universalBranchCode": "587000"
    },
    "4b45be85-b616-4bd1-9027-f8fcf8f9af7b": {
        "value": "4b45be85-b616-4bd1-9027-f8fcf8f9af7b",
        "label": "Investec",
        "universalBranchCode": "580105"
    },
    "9e1917ad-29d1-4d11-80b5-0f6c33ae1083": {
        "value": "9e1917ad-29d1-4d11-80b5-0f6c33ae1083",
        "label": "Mercantile Bank",
        "universalBranchCode": "450105"
    },
    "bf0561fd-4203-4a0c-9174-cb26fcd87a60": {
        "value": "bf0561fd-4203-4a0c-9174-cb26fcd87a60",
        "label": "Nedbank",
        "universalBranchCode": "198765"
    },
    "c36c2423-8a06-4393-bf2d-f5da82d67bc7": {
        "value": "c36c2423-8a06-4393-bf2d-f5da82d67bc7",
        "label": "Olympus Mobile",
        "universalBranchCode": "585001"
    },
    "cc08d678-09cb-49c8-bcd8-2ec9e3bd0a82": {
        "value": "cc08d678-09cb-49c8-bcd8-2ec9e3bd0a82",
        "label": "RMB",
        "universalBranchCode": "250655"
    },
    "54a18018-a9fe-4adb-b752-38004ed735d6": {
        "value": "54a18018-a9fe-4adb-b752-38004ed735d6",
        "label": "Sasfin Bank",
        "universalBranchCode": "683000"
    },
    "ad7d8da4-1723-4066-94bb-6662d845e483": {
        "value": "ad7d8da4-1723-4066-94bb-6662d845e483",
        "label": "Standard Bank",
        "universalBranchCode": "051001"
    },
    "28fcc8fa-985b-480b-82fd-7d09bc19c9d0": {
        "value": "28fcc8fa-985b-480b-82fd-7d09bc19c9d0",
        "label": "TymeBank",
        "universalBranchCode": "678910"
    },
    "8ff9fbc7-9e14-47bc-8d91-cbc81cf131e9": {
        "value": "8ff9fbc7-9e14-47bc-8d91-cbc81cf131e9",
        "label": "Ubank Limited",
        "universalBranchCode": "431010"
    }
};
export const BRIDGER_PAYMENT_OPERATOR_CODE_OPTIONS: any[] = [
    { label: "CN_ABC (Agricultural Bank of China)", value: "CN_ABC (Agricultural Bank of China)", BankCode: "CN_ABC", BankName: "Agricultural Bank of China" },
    { label: "CN_BCOM (Bank of Communications)", value: "CN_BCOM (Bank of Communications)", BankCode: "CN_BCOM", BankName: "Bank of Communications" },
    { label: "CN_BOC (Bank of China)", value: "CN_BOC (Bank of China)", BankCode: "CN_BOC", BankName: "Bank of China" },
    { label: "CN_CCB (China Construction Bank)", value: "CN_CCB (China Construction Bank)", BankCode: "CN_CCB", BankName: "China Construction Bank" },
    { label: "CN_CEB (China Everbright Bank)", value: "CN_CEB (China Everbright Bank)", BankCode: "CN_CEB", BankName: "China Everbright Bank" },
    { label: "CN_CGB (China Guangfa Bank)", value: "CN_CGB (China Guangfa Bank)", BankCode: "CN_CGB", BankName: "China Guangfa Bank" },
    { label: "CN_CIB (China Industrial Bank)", value: "CN_CIB (China Industrial Bank)", BankCode: "CN_CIB", BankName: "China Industrial Bank" },
    { label: "CN_CITIC (China CITIC Bank)", value: "CN_CITIC (China CITIC Bank)", BankCode: "CN_CITIC", BankName: "China CITIC Bank" },
    { label: "CN_CMB (China Merchants Bank)", value: "CN_CMB (China Merchants Bank)", BankCode: "CN_CMB", BankName: "China Merchants Bank" },
    { label: "CN_CMBC (China Minsheng Bank)", value: "CN_CMBC (China Minsheng Bank)", BankCode: "CN_CMBC", BankName: "China Minsheng Bank" },
    { label: "CN_ICBC (Industrial and Commercial Bank of China)", value: "CN_ICBC (Industrial and Commercial Bank of China)", BankCode: "CN_ICBC", BankName: "Industrial and Commercial Bank of China" },
    { label: "CN_PAB (Ping An Bank)", value: "CN_PAB (Ping An Bank)", BankCode: "CN_PAB", BankName: "Ping An Bank" },
    { label: "CN_PSBC (Postal Savings Bank of China)", value: "CN_PSBC (Postal Savings Bank of China)", BankCode: "CN_PSBC", BankName: "Postal Savings Bank of China" },
    { label: "CN_SPDB (Shanghai Pudong Development Bank)", value: "CN_SPDB (Shanghai Pudong Development Bank)", BankCode: "CN_SPDB", BankName: "Shanghai Pudong Development Bank" },
    { label: "IDR_002 (Bank Rakyat Indonesia (BRI))", value: "IDR_002 (Bank Rakyat Indonesia (BRI))", BankCode: "IDR_002", BankName: "Bank Rakyat Indonesia (BRI)" },
    { label: "IDR_003 (Bank Ekspor Indonesia)", value: "IDR_003 (Bank Ekspor Indonesia)", BankCode: "IDR_003", BankName: "Bank Ekspor Indonesia" },
    { label: "IDR_008 (Bank Mandiri)", value: "IDR_008 (Bank Mandiri)", BankCode: "IDR_008", BankName: "Bank Mandiri" },
    { label: "IDR_009 (Bank Negara Indonesia (BNI))", value: "IDR_009 (Bank Negara Indonesia (BNI))", BankCode: "IDR_009", BankName: "Bank Negara Indonesia (BNI)" },
    { label: "IDR_011 (Bank Danamon)", value: "IDR_011 (Bank Danamon)", BankCode: "IDR_011", BankName: "Bank Danamon" },
    { label: "IDR_013 (Bank Permata)", value: "IDR_013 (Bank Permata)", BankCode: "IDR_013", BankName: "Bank Permata" },
    { label: "IDR_014 (Bank Central Asia (BCA))", value: "IDR_014 (Bank Central Asia (BCA))", BankCode: "IDR_014", BankName: "Bank Central Asia (BCA)" },
    { label: "IDR_016 (Maybank Indonesia)", value: "IDR_016 (Maybank Indonesia)", BankCode: "IDR_016", BankName: "Maybank Indonesia" },
    { label: "IDR_019 (Bank Panin)", value: "IDR_019 (Bank Panin)", BankCode: "IDR_019", BankName: "Bank Panin" },
    { label: "IDR_020 (Bank Arta Niaga Kencana)", value: "IDR_020 (Bank Arta Niaga Kencana)", BankCode: "IDR_020", BankName: "Bank Arta Niaga Kencana" },
    { label: "IDR_022 (Bank CIMB Niaga)", value: "IDR_022 (Bank CIMB Niaga)", BankCode: "IDR_022", BankName: "Bank CIMB Niaga" },
    { label: "IDR_023 (Bank UOB Indonesia / Bank Buana Indonesia)", value: "IDR_023 (Bank UOB Indonesia / Bank Buana Indonesia)", BankCode: "IDR_023", BankName: "Bank UOB Indonesia / Bank Buana Indonesia" },
    { label: "IDR_026 (Bank Lippo)", value: "IDR_026 (Bank Lippo)", BankCode: "IDR_026", BankName: "Bank Lippo" },
    { label: "IDR_028 (Bank OCBC NISP)", value: "IDR_028 (Bank OCBC NISP)", BankCode: "IDR_028", BankName: "Bank OCBC NISP" },
    { label: "IDR_030 (American Express Bank LTD)", value: "IDR_030 (American Express Bank LTD)", BankCode: "IDR_030", BankName: "American Express Bank LTD" },
    { label: "IDR_031 (Citibank Indonesia)", value: "IDR_031 (Citibank Indonesia)", BankCode: "IDR_031", BankName: "Citibank Indonesia" },
    { label: "IDR_032 (JP Morgan Chase Bank N.A.)", value: "IDR_032 (JP Morgan Chase Bank N.A.)", BankCode: "IDR_032", BankName: "JP Morgan Chase Bank N.A." },
    { label: "IDR_033 (Bank of America N.A.)", value: "IDR_033 (Bank of America N.A.)", BankCode: "IDR_033", BankName: "Bank of America N.A." },
    { label: "IDR_034 (ING Indonesia Bank)", value: "IDR_034 (ING Indonesia Bank)", BankCode: "IDR_034", BankName: "ING Indonesia Bank" },
    { label: "IDR_036 (Bank Multicor / Bank CCB Indonesia)", value: "IDR_036 (Bank Multicor / Bank CCB Indonesia)", BankCode: "IDR_036", BankName: "Bank Multicor / Bank CCB Indonesia" },
    { label: "IDR_037 (Bank Artha Graha Internasional)", value: "IDR_037 (Bank Artha Graha Internasional)", BankCode: "IDR_037", BankName: "Bank Artha Graha Internasional" },
    { label: "IDR_039 (Bank Credit Agricole Indosuez)", value: "IDR_039 (Bank Credit Agricole Indosuez)", BankCode: "IDR_039", BankName: "Bank Credit Agricole Indosuez" },
    { label: "IDR_040 (Bangkok Bank)", value: "IDR_040 (Bangkok Bank)", BankCode: "IDR_040", BankName: "Bangkok Bank" },
    { label: "IDR_041 (Bank HSBC Indonesia)", value: "IDR_041 (Bank HSBC Indonesia)", BankCode: "IDR_041", BankName: "Bank HSBC Indonesia" },
    { label: "IDR_042 (Bank of Tokyo/MUFG Bank/Mitsubishi UFJ LTD)", value: "IDR_042 (Bank of Tokyo/MUFG Bank/Mitsubishi UFJ LTD)", BankCode: "IDR_042", BankName: "Bank of Tokyo/MUFG Bank/Mitsubishi UFJ LTD" },
    { label: "IDR_045 (Bank Sumitomo Mitsui Indonesia)", value: "IDR_045 (Bank Sumitomo Mitsui Indonesia)", BankCode: "IDR_045", BankName: "Bank Sumitomo Mitsui Indonesia" },
    { label: "IDR_046 (Bank DBS Indonesia)", value: "IDR_046 (Bank DBS Indonesia)", BankCode: "IDR_046", BankName: "Bank DBS Indonesia" },
    { label: "IDR_047 (Bank Resona Perdania)", value: "IDR_047 (Bank Resona Perdania)", BankCode: "IDR_047", BankName: "Bank Resona Perdania" },
    { label: "IDR_048 (Bank Mizuho Indonesia)", value: "IDR_048 (Bank Mizuho Indonesia)", BankCode: "IDR_048", BankName: "Bank Mizuho Indonesia" },
    { label: "IDR_050 (Standard Chartered Bank)", value: "IDR_050 (Standard Chartered Bank)", BankCode: "IDR_050", BankName: "Standard Chartered Bank" },
    { label: "IDR_052 (Bank ABN Amro)", value: "IDR_052 (Bank ABN Amro)", BankCode: "IDR_052", BankName: "Bank ABN Amro" },
    { label: "IDR_053 (Bank Keppel Tatlee Buana)", value: "IDR_053 (Bank Keppel Tatlee Buana)", BankCode: "IDR_053", BankName: "Bank Keppel Tatlee Buana" },
    { label: "IDR_054 (Bank Capital Indonesia)", value: "IDR_054 (Bank Capital Indonesia)", BankCode: "IDR_054", BankName: "Bank Capital Indonesia" },
    { label: "IDR_057 (Bank BNP Paribas Indonesia)", value: "IDR_057 (Bank BNP Paribas Indonesia)", BankCode: "IDR_057", BankName: "Bank BNP Paribas Indonesia" },
    { label: "IDR_059 (Korea Exchange Bank Danamon)", value: "IDR_059 (Korea Exchange Bank Danamon)", BankCode: "IDR_059", BankName: "Korea Exchange Bank Danamon" },
    { label: "IDR_060 (Bank Rabobank International Indonesia)", value: "IDR_060 (Bank Rabobank International Indonesia)", BankCode: "IDR_060", BankName: "Bank Rabobank International Indonesia" },
    { label: "IDR_061 (Bank ANZ Indonesia)", value: "IDR_061 (Bank ANZ Indonesia)", BankCode: "IDR_061", BankName: "Bank ANZ Indonesia" },
    { label: "IDR_067 (Deutsche Bank)", value: "IDR_067 (Deutsche Bank)", BankCode: "IDR_067", BankName: "Deutsche Bank" },
    { label: "IDR_068 (Bank Woori Saudara)", value: "IDR_068 (Bank Woori Saudara)", BankCode: "IDR_068", BankName: "Bank Woori Saudara" },
    { label: "IDR_069 (Bank of China)", value: "IDR_069 (Bank of China)", BankCode: "IDR_069", BankName: "Bank of China" },
    { label: "IDR_076 (Bank Bumi Arta)", value: "IDR_076 (Bank Bumi Arta)", BankCode: "IDR_076", BankName: "Bank Bumi Arta" },
    { label: "IDR_087 (Bank Ekonomi Raharja)", value: "IDR_087 (Bank Ekonomi Raharja)", BankCode: "IDR_087", BankName: "Bank Ekonomi Raharja" },
    { label: "IDR_088 (Bank Antardaerah)", value: "IDR_088 (Bank Antardaerah)", BankCode: "IDR_088", BankName: "Bank Antardaerah" },
    { label: "IDR_089 (Bank Haga)", value: "IDR_089 (Bank Haga)", BankCode: "IDR_089", BankName: "Bank Haga" },
    { label: "IDR_093 (Bank IFI)", value: "IDR_093 (Bank IFI)", BankCode: "IDR_093", BankName: "Bank IFI" },
    { label: "IDR_095 (J Trust Bank / Bank Jtrust Indonesia)", value: "IDR_095 (J Trust Bank / Bank Jtrust Indonesia)", BankCode: "IDR_095", BankName: "J Trust Bank / Bank Jtrust Indonesia" },
    { label: "IDR_097 (Bank Mayapada)", value: "IDR_097 (Bank Mayapada)", BankCode: "IDR_097", BankName: "Bank Mayapada" },
    { label: "IDR_110 (Bank Jabar / Bank BJB)", value: "IDR_110 (Bank Jabar / Bank BJB)", BankCode: "IDR_110", BankName: "Bank Jabar / Bank BJB" },
    { label: "IDR_111 (Bank DKI)", value: "IDR_111 (Bank DKI)", BankCode: "IDR_111", BankName: "Bank DKI" },
    { label: "IDR_112 (BPD Daerah Istimewa Yogyakarta (DIY))", value: "IDR_112 (BPD Daerah Istimewa Yogyakarta (DIY))", BankCode: "IDR_112", BankName: "BPD Daerah Istimewa Yogyakarta (DIY)" },
    { label: "IDR_113 (BPD Jawa Tengah)", value: "IDR_113 (BPD Jawa Tengah)", BankCode: "IDR_113", BankName: "BPD Jawa Tengah" },
    { label: "IDR_114 (BPD Jawa Timur)", value: "IDR_114 (BPD Jawa Timur)", BankCode: "IDR_114", BankName: "BPD Jawa Timur" },
    { label: "IDR_115 (BPD Jambi UUS)", value: "IDR_115 (BPD Jambi UUS)", BankCode: "IDR_115", BankName: "BPD Jambi UUS" },
    { label: "IDR_116 (Bank Aceh Syariah)", value: "IDR_116 (Bank Aceh Syariah)", BankCode: "IDR_116", BankName: "Bank Aceh Syariah" },
    { label: "IDR_117 (BPD Sumatra Utara)", value: "IDR_117 (BPD Sumatra Utara)", BankCode: "IDR_117", BankName: "BPD Sumatra Utara" },
    { label: "IDR_118 (Bank Nagari / Bank Sumbar)", value: "IDR_118 (Bank Nagari / Bank Sumbar)", BankCode: "IDR_118", BankName: "Bank Nagari / Bank Sumbar" },
    { label: "IDR_119 (BPD Riau Dan Kepri)", value: "IDR_119 (BPD Riau Dan Kepri)", BankCode: "IDR_119", BankName: "BPD Riau Dan Kepri" },
    { label: "IDR_120 (BPD Sumsel Dan Babel)", value: "IDR_120 (BPD Sumsel Dan Babel)", BankCode: "IDR_120", BankName: "BPD Sumsel Dan Babel" },
    { label: "IDR_121 (BPD Lampung)", value: "IDR_121 (BPD Lampung)", BankCode: "IDR_121", BankName: "BPD Lampung" },
    { label: "IDR_122 (BPD Kalimantan Selatan)", value: "IDR_122 (BPD Kalimantan Selatan)", BankCode: "IDR_122", BankName: "BPD Kalimantan Selatan" },
    { label: "IDR_123 (BPD Kalimantan Barat)", value: "IDR_123 (BPD Kalimantan Barat)", BankCode: "IDR_123", BankName: "BPD Kalimantan Barat" },
    { label: "IDR_124 (BPD Kalimantan Timur)", value: "IDR_124 (BPD Kalimantan Timur)", BankCode: "IDR_124", BankName: "BPD Kalimantan Timur" },
    { label: "IDR_125 (BPD Kalimantan Tengah)", value: "IDR_125 (BPD Kalimantan Tengah)", BankCode: "IDR_125", BankName: "BPD Kalimantan Tengah" },
    { label: "IDR_126 (Bank Sulawesi Selatan Dan Barat)", value: "IDR_126 (Bank Sulawesi Selatan Dan Barat)", BankCode: "IDR_126", BankName: "Bank Sulawesi Selatan Dan Barat" },
    { label: "IDR_127 (Bank Sulawesi Utara Dan Gorontalo)", value: "IDR_127 (Bank Sulawesi Utara Dan Gorontalo)", BankCode: "IDR_127", BankName: "Bank Sulawesi Utara Dan Gorontalo" },
    { label: "IDR_128 (BPD Nusa Tenggara Barat)", value: "IDR_128 (BPD Nusa Tenggara Barat)", BankCode: "IDR_128", BankName: "BPD Nusa Tenggara Barat" },
    { label: "IDR_129 (BPD Bali)", value: "IDR_129 (BPD Bali)", BankCode: "IDR_129", BankName: "BPD Bali" },
    { label: "IDR_130 (BPD Nusa Tenggara Timur)", value: "IDR_130 (BPD Nusa Tenggara Timur)", BankCode: "IDR_130", BankName: "BPD Nusa Tenggara Timur" },
    { label: "IDR_131 (Bank Maluku Malut)", value: "IDR_131 (Bank Maluku Malut)", BankCode: "IDR_131", BankName: "Bank Maluku Malut" },
    { label: "IDR_132 (Bank Papua)", value: "IDR_132 (Bank Papua)", BankCode: "IDR_132", BankName: "Bank Papua" },
    { label: "IDR_133 (BPD Bengkulu)", value: "IDR_133 (BPD Bengkulu)", BankCode: "IDR_133", BankName: "BPD Bengkulu" },
    { label: "IDR_134 (BPD Sulawesi Tengah)", value: "IDR_134 (BPD Sulawesi Tengah)", BankCode: "IDR_134", BankName: "BPD Sulawesi Tengah" },
    { label: "IDR_135 (BPD Sulawesi Tenggara)", value: "IDR_135 (BPD Sulawesi Tenggara)", BankCode: "IDR_135", BankName: "BPD Sulawesi Tenggara" },
    { label: "IDR_137 (BPD Banten)", value: "IDR_137 (BPD Banten)", BankCode: "IDR_137", BankName: "BPD Banten" },
    { label: "IDR_145 (Bank Nusantara Parahyangan / BNP)", value: "IDR_145 (Bank Nusantara Parahyangan / BNP)", BankCode: "IDR_145", BankName: "Bank Nusantara Parahyangan / BNP" },
    { label: "IDR_146 (Bank Swadesi (Bank of India Indonesia))", value: "IDR_146 (Bank Swadesi (Bank of India Indonesia))", BankCode: "IDR_146", BankName: "Bank Swadesi (Bank of India Indonesia)" },
    { label: "IDR_147 (Bank Muamalat Indonesia)", value: "IDR_147 (Bank Muamalat Indonesia)", BankCode: "IDR_147", BankName: "Bank Muamalat Indonesia" },
    { label: "IDR_151 (Bank Mestika Dharma)", value: "IDR_151 (Bank Mestika Dharma)", BankCode: "IDR_151", BankName: "Bank Mestika Dharma" },
    { label: "IDR_152 (Bank Metro Express / Shinhan)", value: "IDR_152 (Bank Metro Express / Shinhan)", BankCode: "IDR_152", BankName: "Bank Metro Express / Shinhan" },
    { label: "IDR_153 (Bank Sinarmas)", value: "IDR_153 (Bank Sinarmas)", BankCode: "IDR_153", BankName: "Bank Sinarmas" },
    { label: "IDR_157 (Bank Maspion Indonesia)", value: "IDR_157 (Bank Maspion Indonesia)", BankCode: "IDR_157", BankName: "Bank Maspion Indonesia" },
    { label: "IDR_159 (Bank Hagakita)", value: "IDR_159 (Bank Hagakita)", BankCode: "IDR_159", BankName: "Bank Hagakita" },
    { label: "IDR_161 (Bank Ganesha)", value: "IDR_161 (Bank Ganesha)", BankCode: "IDR_161", BankName: "Bank Ganesha" },
    { label: "IDR_162 (Bank of Windu Kentjana)", value: "IDR_162 (Bank of Windu Kentjana)", BankCode: "IDR_162", BankName: "Bank of Windu Kentjana" },
    { label: "IDR_164 (Bank ICBC Indonesia)", value: "IDR_164 (Bank ICBC Indonesia)", BankCode: "IDR_164", BankName: "Bank ICBC Indonesia" },
    { label: "IDR_166 (Bank Harmoni International)", value: "IDR_166 (Bank Harmoni International)", BankCode: "IDR_166", BankName: "Bank Harmoni International" },
    { label: "IDR_167 (Bank QNB Indonesia)", value: "IDR_167 (Bank QNB Indonesia)", BankCode: "IDR_167", BankName: "Bank QNB Indonesia" },
    { label: "IDR_200 (Bank BTN)", value: "IDR_200 (Bank BTN)", BankCode: "IDR_200", BankName: "Bank BTN" },
    { label: "IDR_212 (Bank Himpunan Saudara 1906)", value: "IDR_212 (Bank Himpunan Saudara 1906)", BankCode: "IDR_212", BankName: "Bank Himpunan Saudara 1906" },
    { label: "IDR_213 (Bank BTPN)", value: "IDR_213 (Bank BTPN)", BankCode: "IDR_213", BankName: "Bank BTPN" },
    { label: "IDR_333 (Koperasi Intidana)", value: "IDR_333 (Koperasi Intidana)", BankCode: "IDR_333", BankName: "Koperasi Intidana" },
    { label: "IDR_405 (Bank Victoria Syariah / Bank Swaguna)", value: "IDR_405 (Bank Victoria Syariah / Bank Swaguna)", BankCode: "IDR_405", BankName: "Bank Victoria Syariah / Bank Swaguna" },
    { label: "IDR_422 (Bank BRI Syariah (BRIS))", value: "IDR_422 (Bank BRI Syariah (BRIS))", BankCode: "IDR_422", BankName: "Bank BRI Syariah (BRIS)" },
    { label: "IDR_425 (Bank BJB Syariah)", value: "IDR_425 (Bank BJB Syariah)", BankCode: "IDR_425", BankName: "Bank BJB Syariah" },
    { label: "IDR_426 (Bank Mega)", value: "IDR_426 (Bank Mega)", BankCode: "IDR_426", BankName: "Bank Mega" },
    { label: "IDR_427 (Bank BNI Syariah)", value: "IDR_427 (Bank BNI Syariah)", BankCode: "IDR_427", BankName: "Bank BNI Syariah" },
    { label: "IDR_441 (Bank Bukopin)", value: "IDR_441 (Bank Bukopin)", BankCode: "IDR_441", BankName: "Bank Bukopin" },
    { label: "IDR_451 (Bank Syariah Indonesia (BSI))", value: "IDR_451 (Bank Syariah Indonesia (BSI))", BankCode: "IDR_451", BankName: "Bank Syariah Indonesia (BSI)" },
    { label: "IDR_459 (Bank Bisnis Internasional)", value: "IDR_459 (Bank Bisnis Internasional)", BankCode: "IDR_459", BankName: "Bank Bisnis Internasional" },
    { label: "IDR_466 (Bank Sri Partha / Bank Andara)", value: "IDR_466 (Bank Sri Partha / Bank Andara)", BankCode: "IDR_466", BankName: "Bank Sri Partha / Bank Andara" },
    { label: "IDR_472 (Bank Jasa Jakarta)", value: "IDR_472 (Bank Jasa Jakarta)", BankCode: "IDR_472", BankName: "Bank Jasa Jakarta" },
    { label: "IDR_484 (Bank KEB Hana Indonesia / Bank Bintang Manunggal)", value: "IDR_484 (Bank KEB Hana Indonesia / Bank Bintang Manunggal)", BankCode: "IDR_484", BankName: "Bank KEB Hana Indonesia / Bank Bintang Manunggal" },
    { label: "IDR_485 (Bank MNC Internasional / Bank Bumiputera)", value: "IDR_485 (Bank MNC Internasional / Bank Bumiputera)", BankCode: "IDR_485", BankName: "Bank MNC Internasional / Bank Bumiputera" },
    { label: "IDR_490 (Bank Yudha Bhakti (BYB))", value: "IDR_490 (Bank Yudha Bhakti (BYB))", BankCode: "IDR_490", BankName: "Bank Yudha Bhakti (BYB)" },
    { label: "IDR_491 (Bank Mitra Niaga)", value: "IDR_491 (Bank Mitra Niaga)", BankCode: "IDR_491", BankName: "Bank Mitra Niaga" },
    { label: "IDR_494 (Bank Agroniaga / Bank BRI Agro Niaga)", value: "IDR_494 (Bank Agroniaga / Bank BRI Agro Niaga)", BankCode: "IDR_494", BankName: "Bank Agroniaga / Bank BRI Agro Niaga" },
    { label: "IDR_498 (Bank SBI Indonesia / Bank Indo Monex)", value: "IDR_498 (Bank SBI Indonesia / Bank Indo Monex)", BankCode: "IDR_498", BankName: "Bank SBI Indonesia / Bank Indo Monex" },
    { label: "IDR_503 (Bank National NOBU / Bank Alfindo)", value: "IDR_503 (Bank National NOBU / Bank Alfindo)", BankCode: "IDR_503", BankName: "Bank National NOBU / Bank Alfindo" },
    { label: "IDR_506 (Bank Mega Syariah)", value: "IDR_506 (Bank Mega Syariah)", BankCode: "IDR_506", BankName: "Bank Mega Syariah" },
    { label: "IDR_513 (Bank Ina Perdana)", value: "IDR_513 (Bank Ina Perdana)", BankCode: "IDR_513", BankName: "Bank Ina Perdana" },
    { label: "IDR_517 (Panin Dubai Syariah Bank / Bank Harfa)", value: "IDR_517 (Panin Dubai Syariah Bank / Bank Harfa)", BankCode: "IDR_517", BankName: "Panin Dubai Syariah Bank / Bank Harfa" },
    { label: "IDR_520 (Prima Master Bank)", value: "IDR_520 (Prima Master Bank)", BankCode: "IDR_520", BankName: "Prima Master Bank" },
    { label: "IDR_521 (Bank Syariah Bukopin)", value: "IDR_521 (Bank Syariah Bukopin)", BankCode: "IDR_521", BankName: "Bank Syariah Bukopin" },
    { label: "IDR_523 (Bank Sahabat Sampoerna)", value: "IDR_523 (Bank Sahabat Sampoerna)", BankCode: "IDR_523", BankName: "Bank Sahabat Sampoerna" },
    { label: "IDR_525 (Bank Barclays / Bank Akita)", value: "IDR_525 (Bank Barclays / Bank Akita)", BankCode: "IDR_525", BankName: "Bank Barclays / Bank Akita" },
    { label: "IDR_526 (Bank Dinar / Liman International Bank)", value: "IDR_526 (Bank Dinar / Liman International Bank)", BankCode: "IDR_526", BankName: "Bank Dinar / Liman International Bank" },
    { label: "IDR_531 (Anglomas International Bank)", value: "IDR_531 (Anglomas International Bank)", BankCode: "IDR_531", BankName: "Anglomas International Bank" },
    { label: "IDR_535 (Bank Kesejahteraan Ekonomi)", value: "IDR_535 (Bank Kesejahteraan Ekonomi)", BankCode: "IDR_535", BankName: "Bank Kesejahteraan Ekonomi" },
    { label: "IDR_536 (Bank Central Asia (BCA) Syariah)", value: "IDR_536 (Bank Central Asia (BCA) Syariah)", BankCode: "IDR_536 (Bank Central Asia", BankName: "BCA) Syariah" },
    { label: "IDR_542 (Bank Artos Indonesia)", value: "IDR_542 (Bank Artos Indonesia)", BankCode: "IDR_542", BankName: "Bank Artos Indonesia" },
    { label: "IDR_547 (BANK BTPN SYARIAH / BANK PURBA DANARTA)", value: "IDR_547 (BANK BTPN SYARIAH / BANK PURBA DANARTA)", BankCode: "IDR_547", BankName: "BANK BTPN SYARIAH / BANK PURBA DANARTA" },
    { label: "IDR_548 (Bank Multiarta Sentosa)", value: "IDR_548 (Bank Multiarta Sentosa)", BankCode: "IDR_548", BankName: "Bank Multiarta Sentosa" },
    { label: "IDR_553 (Bank Mayora Indonesia)", value: "IDR_553 (Bank Mayora Indonesia)", BankCode: "IDR_553", BankName: "Bank Mayora Indonesia" },
    { label: "IDR_555 (Bank Index Selindo)", value: "IDR_555 (Bank Index Selindo)", BankCode: "IDR_555", BankName: "Bank Index Selindo" },
    { label: "IDR_558 (Bank Eksekutif)", value: "IDR_558 (Bank Eksekutif)", BankCode: "IDR_558", BankName: "Bank Eksekutif" },
    { label: "IDR_559 (Centratama Nasional Bank)", value: "IDR_559 (Centratama Nasional Bank)", BankCode: "IDR_559", BankName: "Centratama Nasional Bank" },
    { label: "IDR_562 (Bank Fama Internasional)", value: "IDR_562 (Bank Fama Internasional)", BankCode: "IDR_562", BankName: "Bank Fama Internasional" },
    { label: "IDR_564 (Bank Sinar Harapan Bali / Bank Mandiri Taspen Pos)", value: "IDR_564 (Bank Sinar Harapan Bali / Bank Mandiri Taspen Pos)", BankCode: "IDR_564", BankName: "Bank Sinar Harapan Bali / Bank Mandiri Taspen Pos" },
    { label: "IDR_566 (Bank Victoria Internasional)", value: "IDR_566 (Bank Victoria Internasional)", BankCode: "IDR_566", BankName: "Bank Victoria Internasional" },
    { label: "IDR_567 (Bank Harda Internasional)", value: "IDR_567 (Bank Harda Internasional)", BankCode: "IDR_567", BankName: "Bank Harda Internasional" },
    { label: "IDR_688 (BPR KS (Karyajatnika Sedaya))", value: "IDR_688 (BPR KS (Karyajatnika Sedaya))", BankCode: "IDR_688", BankName: "BPR KS (Karyajatnika Sedaya)" },
    { label: "IDR_770 (ALTO Pay)", value: "IDR_770 (ALTO Pay)", BankCode: "IDR_770", BankName: "ALTO Pay" },
    { label: "IDR_775 (SGDO Pay)", value: "IDR_775 (SGDO Pay)", BankCode: "IDR_775", BankName: "SGDO Pay" },
    { label: "IDR_777 (Finnet)", value: "IDR_777 (Finnet)", BankCode: "IDR_777", BankName: "Finnet" },
    { label: "IDR_778 (Bank DKI UUS)", value: "IDR_778 (Bank DKI UUS)", BankCode: "IDR_778", BankName: "Bank DKI UUS" },
    { label: "IDR_789 (Indosat (dompetku))", value: "IDR_789 (Indosat (dompetku))", BankCode: "IDR_789", BankName: "Indosat (dompetku)" },
    { label: "IDR_867 (Bank Eka Bumi Artha)", value: "IDR_867 (Bank Eka Bumi Artha)", BankCode: "IDR_867", BankName: "Bank Eka Bumi Artha" },
    { label: "IDR_899 (Doku)", value: "IDR_899 (Doku)", BankCode: "IDR_899", BankName: "Doku" },
    { label: "IDR_911 (Linkaja / Telcomsel (Tcash))", value: "IDR_911 (Linkaja / Telcomsel (Tcash))", BankCode: "IDR_911", BankName: "Linkaja / Telcomsel (Tcash)" },
    { label: "IDR_945 (IBK Bank Indonesia / Bank Finconesia)", value: "IDR_945 (IBK Bank Indonesia / Bank Finconesia)", BankCode: "IDR_945", BankName: "IBK Bank Indonesia / Bank Finconesia" },
    { label: "IDR_946 (Bank Merincorp)", value: "IDR_946 (Bank Merincorp)", BankCode: "IDR_946", BankName: "Bank Merincorp" },
    { label: "IDR_947 (Bank Maybank Syariah Indonesia)", value: "IDR_947 (Bank Maybank Syariah Indonesia)", BankCode: "IDR_947", BankName: "Bank Maybank Syariah Indonesia" },
    { label: "IDR_948 (Bank OCBC Indonesia)", value: "IDR_948 (Bank OCBC Indonesia)", BankCode: "IDR_948", BankName: "Bank OCBC Indonesia" },
    { label: "IDR_949 (Bank CTBC Indonesia)", value: "IDR_949 (Bank CTBC Indonesia)", BankCode: "IDR_949", BankName: "Bank CTBC Indonesia" },
    { label: "IDR_950 (Bank Commonwealth)", value: "IDR_950 (Bank Commonwealth)", BankCode: "IDR_950", BankName: "Bank Commonwealth" },
    { label: "ALHB (Allahabad Bank)", value: "ALHB (Allahabad Bank)", BankCode: "ALHB", BankName: "Allahabad Bank" },
    { label: "ANDB (Andhra Bank)", value: "ANDB (Andhra Bank)", BankCode: "ANDB", BankName: "Andhra Bank" },
    { label: "AXIS (Axis Bank)", value: "AXIS (Axis Bank)", BankCode: "AXIS", BankName: "Axis Bank" },
    { label: "BOIN (Bank of India)", value: "BOIN (Bank of India)", BankCode: "BOIN", BankName: "Bank of India" },
    { label: "BRDA (Bank of Baroda)", value: "BRDA (Bank of Baroda)", BankCode: "BRDA", BankName: "Bank of Baroda" },
    { label: "CANBK (Canara Bank)", value: "CANBK (Canara Bank)", BankCode: "CANBK", BankName: "Canara Bank" },
    { label: "CBOI (Central Bank of India)", value: "CBOI (Central Bank of India)", BankCode: "CBOI", BankName: "Central Bank of India" },
    { label: "CITI (Citi Bank)", value: "CITI (Citi Bank)", BankCode: "CITI", BankName: "Citi Bank" },
    { label: "CORB (Corporation Bank)", value: "CORB (Corporation Bank)", BankCode: "CORB", BankName: "Corporation Bank" },
    { label: "CSYB (Catholic Syrian Bank)", value: "CSYB (Catholic Syrian Bank)", BankCode: "CSYB", BankName: "Catholic Syrian Bank" },
    { label: "DENB (Dena Bank)", value: "DENB (Dena Bank)", BankCode: "DENB", BankName: "Dena Bank" },
    { label: "DNLM (Dhanlaxmi Bank)", value: "DNLM (Dhanlaxmi Bank)", BankCode: "DNLM", BankName: "Dhanlaxmi Bank" },
    { label: "FEDB (Federal Bank)", value: "FEDB (Federal Bank)", BankCode: "FEDB", BankName: "Federal Bank" },
    { label: "HDFC (HDFC Bank)", value: "HDFC (HDFC Bank)", BankCode: "HDFC", BankName: "HDFC Bank" },
    { label: "ICICI (ICICI Bank)", value: "ICICI (ICICI Bank)", BankCode: "ICICI", BankName: "ICICI Bank" },
    { label: "IDBI (IDBI Bank)", value: "IDBI (IDBI Bank)", BankCode: "IDBI", BankName: "IDBI Bank" },
    { label: "INDNB (Indian Bank)", value: "INDNB (Indian Bank)", BankCode: "INDNB", BankName: "Indian Bank" },
    { label: "INDU (IndusInd Bank)", value: "INDU (IndusInd Bank)", BankCode: "INDU", BankName: "IndusInd Bank" },
    { label: "INOB (Indian Overseas Bank)", value: "INOB (Indian Overseas Bank)", BankCode: "INOB", BankName: "Indian Overseas Bank" },
    { label: "IN_APGVB (Andhra Pradesh Grameena Vikas Bank)", value: "IN_APGVB (Andhra Pradesh Grameena Vikas Bank)", BankCode: "IN_APGVB", BankName: "Andhra Pradesh Grameena Vikas Bank" },
    { label: "IN_CUB (City Union Bank)", value: "IN_CUB (City Union Bank)", BankCode: "IN_CUB", BankName: "City Union Bank" },
    { label: "IN_HSBC (Hongkong and Shanghai Banking Corporation Limited India)", value: "IN_HSBC (Hongkong and Shanghai Banking Corporation Limited India)", BankCode: "IN_HSBC", BankName: "Hongkong and Shanghai Banking Corporation Limited India" },
    { label: "IN_IDFC (IDFC First Bank)", value: "IN_IDFC (IDFC First Bank)", BankCode: "IN_IDFC", BankName: "IDFC First Bank" },
    { label: "IN_KVB (Karur Vysya Bank)", value: "IN_KVB (Karur Vysya Bank)", BankCode: "IN_KVB", BankName: "Karur Vysya Bank" },
    { label: "IN_LVB (Lakshmi Vilas Bank)", value: "IN_LVB (Lakshmi Vilas Bank)", BankCode: "IN_LVB", BankName: "Lakshmi Vilas Bank" },
    { label: "IN_PMCB (Punjab and Maharashtra Co-operative Bank Limited)", value: "IN_PMCB (Punjab and Maharashtra Co-operative Bank Limited)", BankCode: "IN_PMCB", BankName: "Punjab and Maharashtra Co-operative Bank Limited" },
    { label: "IN_USFB (Ujjivan Small Finance Bank)", value: "IN_USFB (Ujjivan Small Finance Bank)", BankCode: "IN_USFB", BankName: "Ujjivan Small Finance Bank" },
    { label: "JAKB (Jammu and Kashmir Bank)", value: "JAKB (Jammu and Kashmir Bank)", BankCode: "JAKB", BankName: "Jammu and Kashmir Bank" },
    { label: "KARBK (Karnataka Bank)", value: "KARBK (Karnataka Bank)", BankCode: "KARBK", BankName: "Karnataka Bank" },
    { label: "KOTBK (Kotak Mahindra Bank)", value: "KOTBK (Kotak Mahindra Bank)", BankCode: "KOTBK", BankName: "Kotak Mahindra Bank" },
    { label: "MHRT (Bank of Maharashtra)", value: "MHRT (Bank of Maharashtra)", BankCode: "MHRT", BankName: "Bank of Maharashtra" },
    { label: "OBOC (Oriental Bank of Commerce)", value: "OBOC (Oriental Bank of Commerce)", BankCode: "OBOC", BankName: "Oriental Bank of Commerce" },
    { label: "PASB (Punjab and Sind Bank)", value: "PASB (Punjab and Sind Bank)", BankCode: "PASB", BankName: "Punjab and Sind Bank" },
    { label: "PNJB (Punjab National Bank)", value: "PNJB (Punjab National Bank)", BankCode: "PNJB", BankName: "Punjab National Bank" },
    { label: "SBBJ (State Bank of Bikaner and Jaipur)", value: "SBBJ (State Bank of Bikaner and Jaipur)", BankCode: "SBBJ", BankName: "State Bank of Bikaner and Jaipur" },
    { label: "SBIN (State Bank)", value: "SBIN (State Bank)", BankCode: "SBIN", BankName: "State Bank" },
    { label: "SBOH (State Bank of Hyderabad)", value: "SBOH (State Bank of Hyderabad)", BankCode: "SBOH", BankName: "State Bank of Hyderabad" },
    { label: "SBOT (State Bank of Travancore)", value: "SBOT (State Bank of Travancore)", BankCode: "SBOT", BankName: "State Bank of Travancore" },
    { label: "SCTRD (Standard Chartered Bank)", value: "SCTRD (Standard Chartered Bank)", BankCode: "SCTRD", BankName: "Standard Chartered Bank" },
    { label: "SIBK (South Indian Bank)", value: "SIBK (South Indian Bank)", BankCode: "SIBK", BankName: "South Indian Bank" },
    { label: "SYNB (Syndicate Bank)", value: "SYNB (Syndicate Bank)", BankCode: "SYNB", BankName: "Syndicate Bank" },
    { label: "TAMB (Tamilnadu Mercantile Bank)", value: "TAMB (Tamilnadu Mercantile Bank)", BankCode: "TAMB", BankName: "Tamilnadu Mercantile Bank" },
    { label: "UCOB (UCO Bank)", value: "UCOB (UCO Bank)", BankCode: "UCOB", BankName: "UCO Bank" },
    { label: "UNBOI (Union Bank of India)", value: "UNBOI (Union Bank of India)", BankCode: "UNBOI", BankName: "Union Bank of India" },
    { label: "VJYB (Vijaya Bank)", value: "VJYB (Vijaya Bank)", BankCode: "VJYB", BankName: "Vijaya Bank" },
    { label: "YESB (YES Bank)", value: "YESB (YES Bank)", BankCode: "YESB", BankName: "YES Bank" },
    { label: "JP_BOF (Bank of Fukuoka)", value: "JP_BOF (Bank of Fukuoka)", BankCode: "JP_BOF", BankName: "Bank of Fukuoka" },
    { label: "JP_BOY (Bank of Yokohama)", value: "JP_BOY (Bank of Yokohama)", BankCode: "JP_BOY", BankName: "Bank of Yokohama" },
    { label: "JP_CBB (Chiba Bank)", value: "JP_CBB (Chiba Bank)", BankCode: "JP_CBB", BankName: "Chiba Bank" },
    { label: "JP_HKB (Hokkaido Bank)", value: "JP_HKB (Hokkaido Bank)", BankCode: "JP_HKB", BankName: "Hokkaido Bank" },
    { label: "JP_HNB (Higashi-Nippon Bank)", value: "JP_HNB (Higashi-Nippon Bank)", BankCode: "JP_HNB", BankName: "Higashi-Nippon Bank" },
    { label: "JP_HRB (Hokuriku Bank)", value: "JP_HRB (Hokuriku Bank)", BankCode: "JP_HRB", BankName: "Hokuriku Bank" },
    { label: "JP_JPB (Japan Post Bank)", value: "JP_JPB (Japan Post Bank)", BankCode: "JP_JPB", BankName: "Japan Post Bank" },
    { label: "JP_KMB (Kansai Mirai Bank Ltd)", value: "JP_KMB (Kansai Mirai Bank Ltd)", BankCode: "JP_KMB", BankName: "Kansai Mirai Bank Ltd" },
    { label: "JP_MNB (Minna Bank)", value: "JP_MNB (Minna Bank)", BankCode: "JP_MNB", BankName: "Minna Bank" },
    { label: "JP_MUFG (MUFG Bank)", value: "JP_MUFG (MUFG Bank)", BankCode: "JP_MUFG", BankName: "MUFG Bank" },
    { label: "JP_MZB (Mizuho Bank)", value: "JP_MZB (Mizuho Bank)", BankCode: "JP_MZB", BankName: "Mizuho Bank" },
    { label: "JP_RSB (Resona Bank)", value: "JP_RSB (Resona Bank)", BankCode: "JP_RSB", BankName: "Resona Bank" },
    { label: "JP_SMFC (Sumitomo Mitsui Banking Corporation)", value: "JP_SMFC (Sumitomo Mitsui Banking Corporation)", BankCode: "JP_SMFC", BankName: "Sumitomo Mitsui Banking Corporation" },
    { label: "JP_TJSB (The Juhachi-Shinwa Bank Ltd)", value: "JP_TJSB (The Juhachi-Shinwa Bank Ltd)", BankCode: "JP_TJSB", BankName: "The Juhachi-Shinwa Bank Ltd" },
    { label: "JP_TKB (The Kumamoto Bank Ltd)", value: "JP_TKB (The Kumamoto Bank Ltd)", BankCode: "JP_TKB", BankName: "The Kumamoto Bank Ltd" },
    { label: "JP_TNB (The Norinchukin Bank)", value: "JP_TNB (The Norinchukin Bank)", BankCode: "JP_TNB", BankName: "The Norinchukin Bank" },
    { label: "KR_BANKOFCOREA (Bank of Korea)", value: "KR_BANKOFCOREA (Bank of Korea)", BankCode: "KR_BANKOFCOREA", BankName: "Bank of Korea" },
    { label: "KR_BNK (Busan Bank)", value: "KR_BNK (Busan Bank)", BankCode: "KR_BNK", BankName: "Busan Bank" },
    { label: "KR_CTK (Citibank Korea)", value: "KR_CTK (Citibank Korea)", BankCode: "KR_CTK", BankName: "Citibank Korea" },
    { label: "KR_DGB (DAEGU Bank)", value: "KR_DGB (DAEGU Bank)", BankCode: "KR_DGB", BankName: "DAEGU Bank" },
    { label: "KR_HBG (KEB Hana Bank)", value: "KR_HBG (KEB Hana Bank)", BankCode: "KR_HBG", BankName: "KEB Hana Bank" },
    { label: "KR_IBK (Industrial Bank of Korea)", value: "KR_IBK (Industrial Bank of Korea)", BankCode: "KR_IBK", BankName: "Industrial Bank of Korea" },
    { label: "KR_KDB (Korea Development Bank)", value: "KR_KDB (Korea Development Bank)", BankCode: "KR_KDB", BankName: "Korea Development Bank" },
    { label: "KR_KKB (KB Kookmin Bank)", value: "KR_KKB (KB Kookmin Bank)", BankCode: "KR_KKB", BankName: "KB Kookmin Bank" },
    { label: "KR_KWB (Kwangju Bank)", value: "KR_KWB (Kwangju Bank)", BankCode: "KR_KWB", BankName: "Kwangju Bank" },
    { label: "KR_NOB (Nonghyup Bank)", value: "KR_NOB (Nonghyup Bank)", BankCode: "KR_NOB", BankName: "Nonghyup Bank" },
    { label: "KR_SHB (Shinhan Bank)", value: "KR_SHB (Shinhan Bank)", BankCode: "KR_SHB", BankName: "Shinhan Bank" },
    { label: "KR_WOB (Woori Bank)", value: "KR_WOB (Woori Bank)", BankCode: "KR_WOB", BankName: "Woori Bank" },
    { label: "MY_AMB (AmBank)", value: "MY_AMB (AmBank)", BankCode: "MY_AMB", BankName: "AmBank" },
    { label: "MY_CIMB (CIMB Bank)", value: "MY_CIMB (CIMB Bank)", BankCode: "MY_CIMB", BankName: "CIMB Bank" },
    { label: "MY_HLB (Hong Leong Bank)", value: "MY_HLB (Hong Leong Bank)", BankCode: "MY_HLB", BankName: "Hong Leong Bank" },
    { label: "MY_HSBC (HSBC Bank)", value: "MY_HSBC (HSBC Bank)", BankCode: "MY_HSBC", BankName: "HSBC Bank" },
    { label: "MY_MAYB (Maybank)", value: "MY_MAYB (Maybank)", BankCode: "MY_MAYB", BankName: "Maybank" },
    { label: "MY_OCBC (OCBC Bank)", value: "MY_OCBC (OCBC Bank)", BankCode: "MY_OCBC", BankName: "OCBC Bank" },
    { label: "MY_PUBLIC (Public Bank)", value: "MY_PUBLIC (Public Bank)", BankCode: "MY_PUBLIC", BankName: "Public Bank" },
    { label: "MY_RHB (RHB Bank)", value: "MY_RHB (RHB Bank)", BankCode: "MY_RHB", BankName: "RHB Bank" },
    { label: "MY_UOBIB (United Overseas Bank (UOB))", value: "MY_UOBIB (United Overseas Bank (UOB))", BankCode: "MY_UOBIB", BankName: "United Overseas Bank (UOB)" },
    { label: "TH_BANGKOK (Bangkok Bank)", value: "TH_BANGKOK (Bangkok Bank)", BankCode: "TH_BANGKOK", BankName: "Bangkok Bank" },
    { label: "TH_CIMB (CIMB THAI Bank)", value: "TH_CIMB (CIMB THAI Bank)", BankCode: "TH_CIMB", BankName: "CIMB THAI Bank" },
    { label: "TH_GOVERNMENTSAVINGS (Government Savings Bank)", value: "TH_GOVERNMENTSAVINGS (Government Savings Bank)", BankCode: "TH_GOVERNMENTSAVINGS", BankName: "Government Savings Bank" },
    { label: "TH_KASIKORN (Kasikorn Bank)", value: "TH_KASIKORN (Kasikorn Bank)", BankCode: "TH_KASIKORN", BankName: "Kasikorn Bank" },
    { label: "TH_KRUNGSRI (Bank of Ayudhya (Krungsri))", value: "TH_KRUNGSRI (Bank of Ayudhya (Krungsri))", BankCode: "TH_KRUNGSRI", BankName: "Bank of Ayudhya (Krungsri)" },
    { label: "TH_KRUNGTHAI (Krungthai Bank)", value: "TH_KRUNGTHAI (Krungthai Bank)", BankCode: "TH_KRUNGTHAI", BankName: "Krungthai Bank" },
    { label: "TH_SIAM (Siam Commercial Bank)", value: "TH_SIAM (Siam Commercial Bank)", BankCode: "TH_SIAM", BankName: "Siam Commercial Bank" },
    { label: "TH_TTBDIRECT (TMBThanachart Bank (ttb))", value: "TH_TTBDIRECT (TMBThanachart Bank (ttb))", BankCode: "TH_TTBDIRECT", BankName: "TMBThanachart Bank (ttb)" },
    { label: "TH_UOBT (United Overseas Bank (UOB))", value: "TH_UOBT (United Overseas Bank (UOB))", BankCode: "TH_UOBT", BankName: "United Overseas Bank (UOB))" },
    { label: "VN_ACB (Asia Commercial Bank)", value: "VN_ACB (Asia Commercial Bank)", BankCode: "VN_ACB", BankName: "Asia Commercial Bank" },
    { label: "VN_BIDV (BIDV)", value: "VN_BIDV (BIDV)", BankCode: "VN_BIDV", BankName: "BIDV" },
    { label: "VN_DONGA (DongA Bank)", value: "VN_DONGA (DongA Bank)", BankCode: "VN_DONGA", BankName: "DongA Bank" },
    { label: "VN_EXIM (Eximbank)", value: "VN_EXIM (Eximbank)", BankCode: "VN_EXIM", BankName: "Eximbank" },
    { label: "VN_SACOM (Sacombank)", value: "VN_SACOM (Sacombank)", BankCode: "VN_SACOM", BankName: "Sacombank" },
    { label: "VN_TECHCOM (Techcombank)", value: "VN_TECHCOM (Techcombank)", BankCode: "VN_TECHCOM", BankName: "Techcombank" },
    { label: "VN_TP (TPBank)", value: "VN_TP (TPBank)", BankCode: "VN_TP", BankName: "TPBank" },
    { label: "VN_VIETCOM (Vietcombank)", value: "VN_VIETCOM (Vietcombank)", BankCode: "VN_VIETCOM", BankName: "Vietcombank" },
    { label: "VN_VIETIN (VietinBank)", value: "VN_VIETIN (VietinBank)", BankCode: "VN_VIETIN", BankName: "VietinBank" },
    { label: "VN_VP (VPBank)", value: "VN_VP (VPBank)", BankCode: "VN_VP", BankName: "VPBank" },
];
export const BRIDGER_PAYMENT_OPERATOR_CODE_DICT: any = {
    "CN_ABC (Agricultural Bank of China)": {
        "label": "CN_ABC (Agricultural Bank of China)",
        "value": "CN_ABC (Agricultural Bank of China)"
    },
    "CN_BCOM (Bank of Communications)": {
        "label": "CN_BCOM (Bank of Communications)",
        "value": "CN_BCOM (Bank of Communications)"
    },
    "CN_BOC (Bank of China)": {
        "label": "CN_BOC (Bank of China)",
        "value": "CN_BOC (Bank of China)"
    },
    "CN_CCB (China Construction Bank)": {
        "label": "CN_CCB (China Construction Bank)",
        "value": "CN_CCB (China Construction Bank)"
    },
    "CN_CEB (China Everbright Bank)": {
        "label": "CN_CEB (China Everbright Bank)",
        "value": "CN_CEB (China Everbright Bank)"
    },
    "CN_CGB (China Guangfa Bank)": {
        "label": "CN_CGB (China Guangfa Bank)",
        "value": "CN_CGB (China Guangfa Bank)"
    },
    "CN_CIB (China Industrial Bank)": {
        "label": "CN_CIB (China Industrial Bank)",
        "value": "CN_CIB (China Industrial Bank)"
    },
    "CN_CITIC (China CITIC Bank)": {
        "label": "CN_CITIC (China CITIC Bank)",
        "value": "CN_CITIC (China CITIC Bank)"
    },
    "CN_CMB (China Merchants Bank)": {
        "label": "CN_CMB (China Merchants Bank)",
        "value": "CN_CMB (China Merchants Bank)"
    },
    "CN_CMBC (China Minsheng Bank)": {
        "label": "CN_CMBC (China Minsheng Bank)",
        "value": "CN_CMBC (China Minsheng Bank)"
    },
    "CN_ICBC (Industrial and Commercial Bank of China)": {
        "label": "CN_ICBC (Industrial and Commercial Bank of China)",
        "value": "CN_ICBC (Industrial and Commercial Bank of China)"
    },
    "CN_PAB (Ping An Bank)": {
        "label": "CN_PAB (Ping An Bank)",
        "value": "CN_PAB (Ping An Bank)"
    },
    "CN_PSBC (Postal Savings Bank of China)": {
        "label": "CN_PSBC (Postal Savings Bank of China)",
        "value": "CN_PSBC (Postal Savings Bank of China)"
    },
    "CN_SPDB (Shanghai Pudong Development Bank)": {
        "label": "CN_SPDB (Shanghai Pudong Development Bank)",
        "value": "CN_SPDB (Shanghai Pudong Development Bank)"
    },
    "IDR_002 (Bank Rakyat Indonesia (BRI))": {
        "label": "IDR_002 (Bank Rakyat Indonesia (BRI))",
        "value": "IDR_002 (Bank Rakyat Indonesia (BRI))"
    },
    "IDR_003 (Bank Ekspor Indonesia)": {
        "label": "IDR_003 (Bank Ekspor Indonesia)",
        "value": "IDR_003 (Bank Ekspor Indonesia)"
    },
    "IDR_008 (Bank Mandiri)": {
        "label": "IDR_008 (Bank Mandiri)",
        "value": "IDR_008 (Bank Mandiri)"
    },
    "IDR_009 (Bank Negara Indonesia (BNI))": {
        "label": "IDR_009 (Bank Negara Indonesia (BNI))",
        "value": "IDR_009 (Bank Negara Indonesia (BNI))"
    },
    "IDR_011 (Bank Danamon)": {
        "label": "IDR_011 (Bank Danamon)",
        "value": "IDR_011 (Bank Danamon)"
    },
    "IDR_013 (Bank Permata)": {
        "label": "IDR_013 (Bank Permata)",
        "value": "IDR_013 (Bank Permata)"
    },
    "IDR_014 (Bank Central Asia (BCA))": {
        "label": "IDR_014 (Bank Central Asia (BCA))",
        "value": "IDR_014 (Bank Central Asia (BCA))"
    },
    "IDR_016 (Maybank Indonesia)": {
        "label": "IDR_016 (Maybank Indonesia)",
        "value": "IDR_016 (Maybank Indonesia)"
    },
    "IDR_019 (Bank Panin)": {
        "label": "IDR_019 (Bank Panin)",
        "value": "IDR_019 (Bank Panin)"
    },
    "IDR_020 (Bank Arta Niaga Kencana)": {
        "label": "IDR_020 (Bank Arta Niaga Kencana)",
        "value": "IDR_020 (Bank Arta Niaga Kencana)"
    },
    "IDR_022 (Bank CIMB Niaga)": {
        "label": "IDR_022 (Bank CIMB Niaga)",
        "value": "IDR_022 (Bank CIMB Niaga)"
    },
    "IDR_023 (Bank UOB Indonesia / Bank Buana Indonesia)": {
        "label": "IDR_023 (Bank UOB Indonesia / Bank Buana Indonesia)",
        "value": "IDR_023 (Bank UOB Indonesia / Bank Buana Indonesia)"
    },
    "IDR_026 (Bank Lippo)": {
        "label": "IDR_026 (Bank Lippo)",
        "value": "IDR_026 (Bank Lippo)"
    },
    "IDR_028 (Bank OCBC NISP)": {
        "label": "IDR_028 (Bank OCBC NISP)",
        "value": "IDR_028 (Bank OCBC NISP)"
    },
    "IDR_030 (American Express Bank LTD)": {
        "label": "IDR_030 (American Express Bank LTD)",
        "value": "IDR_030 (American Express Bank LTD)"
    },
    "IDR_031 (Citibank Indonesia)": {
        "label": "IDR_031 (Citibank Indonesia)",
        "value": "IDR_031 (Citibank Indonesia)"
    },
    "IDR_032 (JP Morgan Chase Bank N.A.)": {
        "label": "IDR_032 (JP Morgan Chase Bank N.A.)",
        "value": "IDR_032 (JP Morgan Chase Bank N.A.)"
    },
    "IDR_033 (Bank of America N.A.)": {
        "label": "IDR_033 (Bank of America N.A.)",
        "value": "IDR_033 (Bank of America N.A.)"
    },
    "IDR_034 (ING Indonesia Bank)": {
        "label": "IDR_034 (ING Indonesia Bank)",
        "value": "IDR_034 (ING Indonesia Bank)"
    },
    "IDR_036 (Bank Multicor / Bank CCB Indonesia)": {
        "label": "IDR_036 (Bank Multicor / Bank CCB Indonesia)",
        "value": "IDR_036 (Bank Multicor / Bank CCB Indonesia)"
    },
    "IDR_037 (Bank Artha Graha Internasional)": {
        "label": "IDR_037 (Bank Artha Graha Internasional)",
        "value": "IDR_037 (Bank Artha Graha Internasional)"
    },
    "IDR_039 (Bank Credit Agricole Indosuez)": {
        "label": "IDR_039 (Bank Credit Agricole Indosuez)",
        "value": "IDR_039 (Bank Credit Agricole Indosuez)"
    },
    "IDR_040 (Bangkok Bank)": {
        "label": "IDR_040 (Bangkok Bank)",
        "value": "IDR_040 (Bangkok Bank)"
    },
    "IDR_041 (Bank HSBC Indonesia)": {
        "label": "IDR_041 (Bank HSBC Indonesia)",
        "value": "IDR_041 (Bank HSBC Indonesia)"
    },
    "IDR_042 (Bank of Tokyo/MUFG Bank/Mitsubishi UFJ LTD)": {
        "label": "IDR_042 (Bank of Tokyo/MUFG Bank/Mitsubishi UFJ LTD)",
        "value": "IDR_042 (Bank of Tokyo/MUFG Bank/Mitsubishi UFJ LTD)"
    },
    "IDR_045 (Bank Sumitomo Mitsui Indonesia)": {
        "label": "IDR_045 (Bank Sumitomo Mitsui Indonesia)",
        "value": "IDR_045 (Bank Sumitomo Mitsui Indonesia)"
    },
    "IDR_046 (Bank DBS Indonesia)": {
        "label": "IDR_046 (Bank DBS Indonesia)",
        "value": "IDR_046 (Bank DBS Indonesia)"
    },
    "IDR_047 (Bank Resona Perdania)": {
        "label": "IDR_047 (Bank Resona Perdania)",
        "value": "IDR_047 (Bank Resona Perdania)"
    },
    "IDR_048 (Bank Mizuho Indonesia)": {
        "label": "IDR_048 (Bank Mizuho Indonesia)",
        "value": "IDR_048 (Bank Mizuho Indonesia)"
    },
    "IDR_050 (Standard Chartered Bank)": {
        "label": "IDR_050 (Standard Chartered Bank)",
        "value": "IDR_050 (Standard Chartered Bank)"
    },
    "IDR_052 (Bank ABN Amro)": {
        "label": "IDR_052 (Bank ABN Amro)",
        "value": "IDR_052 (Bank ABN Amro)"
    },
    "IDR_053 (Bank Keppel Tatlee Buana)": {
        "label": "IDR_053 (Bank Keppel Tatlee Buana)",
        "value": "IDR_053 (Bank Keppel Tatlee Buana)"
    },
    "IDR_054 (Bank Capital Indonesia)": {
        "label": "IDR_054 (Bank Capital Indonesia)",
        "value": "IDR_054 (Bank Capital Indonesia)"
    },
    "IDR_057 (Bank BNP Paribas Indonesia)": {
        "label": "IDR_057 (Bank BNP Paribas Indonesia)",
        "value": "IDR_057 (Bank BNP Paribas Indonesia)"
    },
    "IDR_059 (Korea Exchange Bank Danamon)": {
        "label": "IDR_059 (Korea Exchange Bank Danamon)",
        "value": "IDR_059 (Korea Exchange Bank Danamon)"
    },
    "IDR_060 (Bank Rabobank International Indonesia)": {
        "label": "IDR_060 (Bank Rabobank International Indonesia)",
        "value": "IDR_060 (Bank Rabobank International Indonesia)"
    },
    "IDR_061 (Bank ANZ Indonesia)": {
        "label": "IDR_061 (Bank ANZ Indonesia)",
        "value": "IDR_061 (Bank ANZ Indonesia)"
    },
    "IDR_067 (Deutsche Bank)": {
        "label": "IDR_067 (Deutsche Bank)",
        "value": "IDR_067 (Deutsche Bank)"
    },
    "IDR_068 (Bank Woori Saudara)": {
        "label": "IDR_068 (Bank Woori Saudara)",
        "value": "IDR_068 (Bank Woori Saudara)"
    },
    "IDR_069 (Bank of China)": {
        "label": "IDR_069 (Bank of China)",
        "value": "IDR_069 (Bank of China)"
    },
    "IDR_076 (Bank Bumi Arta)": {
        "label": "IDR_076 (Bank Bumi Arta)",
        "value": "IDR_076 (Bank Bumi Arta)"
    },
    "IDR_087 (Bank Ekonomi Raharja)": {
        "label": "IDR_087 (Bank Ekonomi Raharja)",
        "value": "IDR_087 (Bank Ekonomi Raharja)"
    },
    "IDR_088 (Bank Antardaerah)": {
        "label": "IDR_088 (Bank Antardaerah)",
        "value": "IDR_088 (Bank Antardaerah)"
    },
    "IDR_089 (Bank Haga)": {
        "label": "IDR_089 (Bank Haga)",
        "value": "IDR_089 (Bank Haga)"
    },
    "IDR_093 (Bank IFI)": {
        "label": "IDR_093 (Bank IFI)",
        "value": "IDR_093 (Bank IFI)"
    },
    "IDR_095 (J Trust Bank / Bank Jtrust Indonesia)": {
        "label": "IDR_095 (J Trust Bank / Bank Jtrust Indonesia)",
        "value": "IDR_095 (J Trust Bank / Bank Jtrust Indonesia)"
    },
    "IDR_097 (Bank Mayapada)": {
        "label": "IDR_097 (Bank Mayapada)",
        "value": "IDR_097 (Bank Mayapada)"
    },
    "IDR_110 (Bank Jabar / Bank BJB)": {
        "label": "IDR_110 (Bank Jabar / Bank BJB)",
        "value": "IDR_110 (Bank Jabar / Bank BJB)"
    },
    "IDR_111 (Bank DKI)": {
        "label": "IDR_111 (Bank DKI)",
        "value": "IDR_111 (Bank DKI)"
    },
    "IDR_112 (BPD Daerah Istimewa Yogyakarta (DIY))": {
        "label": "IDR_112 (BPD Daerah Istimewa Yogyakarta (DIY))",
        "value": "IDR_112 (BPD Daerah Istimewa Yogyakarta (DIY))"
    },
    "IDR_113 (BPD Jawa Tengah)": {
        "label": "IDR_113 (BPD Jawa Tengah)",
        "value": "IDR_113 (BPD Jawa Tengah)"
    },
    "IDR_114 (BPD Jawa Timur)": {
        "label": "IDR_114 (BPD Jawa Timur)",
        "value": "IDR_114 (BPD Jawa Timur)"
    },
    "IDR_115 (BPD Jambi UUS)": {
        "label": "IDR_115 (BPD Jambi UUS)",
        "value": "IDR_115 (BPD Jambi UUS)"
    },
    "IDR_116 (Bank Aceh Syariah)": {
        "label": "IDR_116 (Bank Aceh Syariah)",
        "value": "IDR_116 (Bank Aceh Syariah)"
    },
    "IDR_117 (BPD Sumatra Utara)": {
        "label": "IDR_117 (BPD Sumatra Utara)",
        "value": "IDR_117 (BPD Sumatra Utara)"
    },
    "IDR_118 (Bank Nagari / Bank Sumbar)": {
        "label": "IDR_118 (Bank Nagari / Bank Sumbar)",
        "value": "IDR_118 (Bank Nagari / Bank Sumbar)"
    },
    "IDR_119 (BPD Riau Dan Kepri)": {
        "label": "IDR_119 (BPD Riau Dan Kepri)",
        "value": "IDR_119 (BPD Riau Dan Kepri)"
    },
    "IDR_120 (BPD Sumsel Dan Babel)": {
        "label": "IDR_120 (BPD Sumsel Dan Babel)",
        "value": "IDR_120 (BPD Sumsel Dan Babel)"
    },
    "IDR_121 (BPD Lampung)": {
        "label": "IDR_121 (BPD Lampung)",
        "value": "IDR_121 (BPD Lampung)"
    },
    "IDR_122 (BPD Kalimantan Selatan)": {
        "label": "IDR_122 (BPD Kalimantan Selatan)",
        "value": "IDR_122 (BPD Kalimantan Selatan)"
    },
    "IDR_123 (BPD Kalimantan Barat)": {
        "label": "IDR_123 (BPD Kalimantan Barat)",
        "value": "IDR_123 (BPD Kalimantan Barat)"
    },
    "IDR_124 (BPD Kalimantan Timur)": {
        "label": "IDR_124 (BPD Kalimantan Timur)",
        "value": "IDR_124 (BPD Kalimantan Timur)"
    },
    "IDR_125 (BPD Kalimantan Tengah)": {
        "label": "IDR_125 (BPD Kalimantan Tengah)",
        "value": "IDR_125 (BPD Kalimantan Tengah)"
    },
    "IDR_126 (Bank Sulawesi Selatan Dan Barat)": {
        "label": "IDR_126 (Bank Sulawesi Selatan Dan Barat)",
        "value": "IDR_126 (Bank Sulawesi Selatan Dan Barat)"
    },
    "IDR_127 (Bank Sulawesi Utara Dan Gorontalo)": {
        "label": "IDR_127 (Bank Sulawesi Utara Dan Gorontalo)",
        "value": "IDR_127 (Bank Sulawesi Utara Dan Gorontalo)"
    },
    "IDR_128 (BPD Nusa Tenggara Barat)": {
        "label": "IDR_128 (BPD Nusa Tenggara Barat)",
        "value": "IDR_128 (BPD Nusa Tenggara Barat)"
    },
    "IDR_129 (BPD Bali)": {
        "label": "IDR_129 (BPD Bali)",
        "value": "IDR_129 (BPD Bali)"
    },
    "IDR_130 (BPD Nusa Tenggara Timur)": {
        "label": "IDR_130 (BPD Nusa Tenggara Timur)",
        "value": "IDR_130 (BPD Nusa Tenggara Timur)"
    },
    "IDR_131 (Bank Maluku Malut)": {
        "label": "IDR_131 (Bank Maluku Malut)",
        "value": "IDR_131 (Bank Maluku Malut)"
    },
    "IDR_132 (Bank Papua)": {
        "label": "IDR_132 (Bank Papua)",
        "value": "IDR_132 (Bank Papua)"
    },
    "IDR_133 (BPD Bengkulu)": {
        "label": "IDR_133 (BPD Bengkulu)",
        "value": "IDR_133 (BPD Bengkulu)"
    },
    "IDR_134 (BPD Sulawesi Tengah)": {
        "label": "IDR_134 (BPD Sulawesi Tengah)",
        "value": "IDR_134 (BPD Sulawesi Tengah)"
    },
    "IDR_135 (BPD Sulawesi Tenggara)": {
        "label": "IDR_135 (BPD Sulawesi Tenggara)",
        "value": "IDR_135 (BPD Sulawesi Tenggara)"
    },
    "IDR_137 (BPD Banten)": {
        "label": "IDR_137 (BPD Banten)",
        "value": "IDR_137 (BPD Banten)"
    },
    "IDR_145 (Bank Nusantara Parahyangan / BNP)": {
        "label": "IDR_145 (Bank Nusantara Parahyangan / BNP)",
        "value": "IDR_145 (Bank Nusantara Parahyangan / BNP)"
    },
    "IDR_146 (Bank Swadesi (Bank of India Indonesia))": {
        "label": "IDR_146 (Bank Swadesi (Bank of India Indonesia))",
        "value": "IDR_146 (Bank Swadesi (Bank of India Indonesia))"
    },
    "IDR_147 (Bank Muamalat Indonesia)": {
        "label": "IDR_147 (Bank Muamalat Indonesia)",
        "value": "IDR_147 (Bank Muamalat Indonesia)"
    },
    "IDR_151 (Bank Mestika Dharma)": {
        "label": "IDR_151 (Bank Mestika Dharma)",
        "value": "IDR_151 (Bank Mestika Dharma)"
    },
    "IDR_152 (Bank Metro Express / Shinhan)": {
        "label": "IDR_152 (Bank Metro Express / Shinhan)",
        "value": "IDR_152 (Bank Metro Express / Shinhan)"
    },
    "IDR_153 (Bank Sinarmas)": {
        "label": "IDR_153 (Bank Sinarmas)",
        "value": "IDR_153 (Bank Sinarmas)"
    },
    "IDR_157 (Bank Maspion Indonesia)": {
        "label": "IDR_157 (Bank Maspion Indonesia)",
        "value": "IDR_157 (Bank Maspion Indonesia)"
    },
    "IDR_159 (Bank Hagakita)": {
        "label": "IDR_159 (Bank Hagakita)",
        "value": "IDR_159 (Bank Hagakita)"
    },
    "IDR_161 (Bank Ganesha)": {
        "label": "IDR_161 (Bank Ganesha)",
        "value": "IDR_161 (Bank Ganesha)"
    },
    "IDR_162 (Bank of Windu Kentjana)": {
        "label": "IDR_162 (Bank of Windu Kentjana)",
        "value": "IDR_162 (Bank of Windu Kentjana)"
    },
    "IDR_164 (Bank ICBC Indonesia)": {
        "label": "IDR_164 (Bank ICBC Indonesia)",
        "value": "IDR_164 (Bank ICBC Indonesia)"
    },
    "IDR_166 (Bank Harmoni International)": {
        "label": "IDR_166 (Bank Harmoni International)",
        "value": "IDR_166 (Bank Harmoni International)"
    },
    "IDR_167 (Bank QNB Indonesia)": {
        "label": "IDR_167 (Bank QNB Indonesia)",
        "value": "IDR_167 (Bank QNB Indonesia)"
    },
    "IDR_200 (Bank BTN)": {
        "label": "IDR_200 (Bank BTN)",
        "value": "IDR_200 (Bank BTN)"
    },
    "IDR_212 (Bank Himpunan Saudara 1906)": {
        "label": "IDR_212 (Bank Himpunan Saudara 1906)",
        "value": "IDR_212 (Bank Himpunan Saudara 1906)"
    },
    "IDR_213 (Bank BTPN)": {
        "label": "IDR_213 (Bank BTPN)",
        "value": "IDR_213 (Bank BTPN)"
    },
    "IDR_333 (Koperasi Intidana)": {
        "label": "IDR_333 (Koperasi Intidana)",
        "value": "IDR_333 (Koperasi Intidana)"
    },
    "IDR_405 (Bank Victoria Syariah / Bank Swaguna)": {
        "label": "IDR_405 (Bank Victoria Syariah / Bank Swaguna)",
        "value": "IDR_405 (Bank Victoria Syariah / Bank Swaguna)"
    },
    "IDR_422 (Bank BRI Syariah (BRIS))": {
        "label": "IDR_422 (Bank BRI Syariah (BRIS))",
        "value": "IDR_422 (Bank BRI Syariah (BRIS))"
    },
    "IDR_425 (Bank BJB Syariah)": {
        "label": "IDR_425 (Bank BJB Syariah)",
        "value": "IDR_425 (Bank BJB Syariah)"
    },
    "IDR_426 (Bank Mega)": {
        "label": "IDR_426 (Bank Mega)",
        "value": "IDR_426 (Bank Mega)"
    },
    "IDR_427 (Bank BNI Syariah)": {
        "label": "IDR_427 (Bank BNI Syariah)",
        "value": "IDR_427 (Bank BNI Syariah)"
    },
    "IDR_441 (Bank Bukopin)": {
        "label": "IDR_441 (Bank Bukopin)",
        "value": "IDR_441 (Bank Bukopin)"
    },
    "IDR_451 (Bank Syariah Indonesia (BSI))": {
        "label": "IDR_451 (Bank Syariah Indonesia (BSI))",
        "value": "IDR_451 (Bank Syariah Indonesia (BSI))"
    },
    "IDR_459 (Bank Bisnis Internasional)": {
        "label": "IDR_459 (Bank Bisnis Internasional)",
        "value": "IDR_459 (Bank Bisnis Internasional)"
    },
    "IDR_466 (Bank Sri Partha / Bank Andara)": {
        "label": "IDR_466 (Bank Sri Partha / Bank Andara)",
        "value": "IDR_466 (Bank Sri Partha / Bank Andara)"
    },
    "IDR_472 (Bank Jasa Jakarta)": {
        "label": "IDR_472 (Bank Jasa Jakarta)",
        "value": "IDR_472 (Bank Jasa Jakarta)"
    },
    "IDR_484 (Bank KEB Hana Indonesia / Bank Bintang Manunggal)": {
        "label": "IDR_484 (Bank KEB Hana Indonesia / Bank Bintang Manunggal)",
        "value": "IDR_484 (Bank KEB Hana Indonesia / Bank Bintang Manunggal)"
    },
    "IDR_485 (Bank MNC Internasional / Bank Bumiputera)": {
        "label": "IDR_485 (Bank MNC Internasional / Bank Bumiputera)",
        "value": "IDR_485 (Bank MNC Internasional / Bank Bumiputera)"
    },
    "IDR_490 (Bank Yudha Bhakti (BYB))": {
        "label": "IDR_490 (Bank Yudha Bhakti (BYB))",
        "value": "IDR_490 (Bank Yudha Bhakti (BYB))"
    },
    "IDR_491 (Bank Mitra Niaga)": {
        "label": "IDR_491 (Bank Mitra Niaga)",
        "value": "IDR_491 (Bank Mitra Niaga)"
    },
    "IDR_494 (Bank Agroniaga / Bank BRI Agro Niaga)": {
        "label": "IDR_494 (Bank Agroniaga / Bank BRI Agro Niaga)",
        "value": "IDR_494 (Bank Agroniaga / Bank BRI Agro Niaga)"
    },
    "IDR_498 (Bank SBI Indonesia / Bank Indo Monex)": {
        "label": "IDR_498 (Bank SBI Indonesia / Bank Indo Monex)",
        "value": "IDR_498 (Bank SBI Indonesia / Bank Indo Monex)"
    },
    "IDR_503 (Bank National NOBU / Bank Alfindo)": {
        "label": "IDR_503 (Bank National NOBU / Bank Alfindo)",
        "value": "IDR_503 (Bank National NOBU / Bank Alfindo)"
    },
    "IDR_506 (Bank Mega Syariah)": {
        "label": "IDR_506 (Bank Mega Syariah)",
        "value": "IDR_506 (Bank Mega Syariah)"
    },
    "IDR_513 (Bank Ina Perdana)": {
        "label": "IDR_513 (Bank Ina Perdana)",
        "value": "IDR_513 (Bank Ina Perdana)"
    },
    "IDR_517 (Panin Dubai Syariah Bank / Bank Harfa)": {
        "label": "IDR_517 (Panin Dubai Syariah Bank / Bank Harfa)",
        "value": "IDR_517 (Panin Dubai Syariah Bank / Bank Harfa)"
    },
    "IDR_520 (Prima Master Bank)": {
        "label": "IDR_520 (Prima Master Bank)",
        "value": "IDR_520 (Prima Master Bank)"
    },
    "IDR_521 (Bank Syariah Bukopin)": {
        "label": "IDR_521 (Bank Syariah Bukopin)",
        "value": "IDR_521 (Bank Syariah Bukopin)"
    },
    "IDR_523 (Bank Sahabat Sampoerna)": {
        "label": "IDR_523 (Bank Sahabat Sampoerna)",
        "value": "IDR_523 (Bank Sahabat Sampoerna)"
    },
    "IDR_525 (Bank Barclays / Bank Akita)": {
        "label": "IDR_525 (Bank Barclays / Bank Akita)",
        "value": "IDR_525 (Bank Barclays / Bank Akita)"
    },
    "IDR_526 (Bank Dinar / Liman International Bank)": {
        "label": "IDR_526 (Bank Dinar / Liman International Bank)",
        "value": "IDR_526 (Bank Dinar / Liman International Bank)"
    },
    "IDR_531 (Anglomas International Bank)": {
        "label": "IDR_531 (Anglomas International Bank)",
        "value": "IDR_531 (Anglomas International Bank)"
    },
    "IDR_535 (Bank Kesejahteraan Ekonomi)": {
        "label": "IDR_535 (Bank Kesejahteraan Ekonomi)",
        "value": "IDR_535 (Bank Kesejahteraan Ekonomi)"
    },
    "IDR_536 (Bank Central Asia (BCA) Syariah)": {
        "label": "IDR_536 (Bank Central Asia (BCA) Syariah)",
        "value": "IDR_536 (Bank Central Asia (BCA) Syariah)"
    },
    "IDR_542 (Bank Artos Indonesia)": {
        "label": "IDR_542 (Bank Artos Indonesia)",
        "value": "IDR_542 (Bank Artos Indonesia)"
    },
    "IDR_547 (BANK BTPN SYARIAH / BANK PURBA DANARTA)": {
        "label": "IDR_547 (BANK BTPN SYARIAH / BANK PURBA DANARTA)",
        "value": "IDR_547 (BANK BTPN SYARIAH / BANK PURBA DANARTA)"
    },
    "IDR_548 (Bank Multiarta Sentosa)": {
        "label": "IDR_548 (Bank Multiarta Sentosa)",
        "value": "IDR_548 (Bank Multiarta Sentosa)"
    },
    "IDR_553 (Bank Mayora Indonesia)": {
        "label": "IDR_553 (Bank Mayora Indonesia)",
        "value": "IDR_553 (Bank Mayora Indonesia)"
    },
    "IDR_555 (Bank Index Selindo)": {
        "label": "IDR_555 (Bank Index Selindo)",
        "value": "IDR_555 (Bank Index Selindo)"
    },
    "IDR_558 (Bank Eksekutif)": {
        "label": "IDR_558 (Bank Eksekutif)",
        "value": "IDR_558 (Bank Eksekutif)"
    },
    "IDR_559 (Centratama Nasional Bank)": {
        "label": "IDR_559 (Centratama Nasional Bank)",
        "value": "IDR_559 (Centratama Nasional Bank)"
    },
    "IDR_562 (Bank Fama Internasional)": {
        "label": "IDR_562 (Bank Fama Internasional)",
        "value": "IDR_562 (Bank Fama Internasional)"
    },
    "IDR_564 (Bank Sinar Harapan Bali / Bank Mandiri Taspen Pos)": {
        "label": "IDR_564 (Bank Sinar Harapan Bali / Bank Mandiri Taspen Pos)",
        "value": "IDR_564 (Bank Sinar Harapan Bali / Bank Mandiri Taspen Pos)"
    },
    "IDR_566 (Bank Victoria Internasional)": {
        "label": "IDR_566 (Bank Victoria Internasional)",
        "value": "IDR_566 (Bank Victoria Internasional)"
    },
    "IDR_567 (Bank Harda Internasional)": {
        "label": "IDR_567 (Bank Harda Internasional)",
        "value": "IDR_567 (Bank Harda Internasional)"
    },
    "IDR_688 (BPR KS (Karyajatnika Sedaya))": {
        "label": "IDR_688 (BPR KS (Karyajatnika Sedaya))",
        "value": "IDR_688 (BPR KS (Karyajatnika Sedaya))"
    },
    "IDR_770 (ALTO Pay)": {
        "label": "IDR_770 (ALTO Pay)",
        "value": "IDR_770 (ALTO Pay)"
    },
    "IDR_775 (SGDO Pay)": {
        "label": "IDR_775 (SGDO Pay)",
        "value": "IDR_775 (SGDO Pay)"
    },
    "IDR_777 (Finnet)": {
        "label": "IDR_777 (Finnet)",
        "value": "IDR_777 (Finnet)"
    },
    "IDR_778 (Bank DKI UUS)": {
        "label": "IDR_778 (Bank DKI UUS)",
        "value": "IDR_778 (Bank DKI UUS)"
    },
    "IDR_789 (Indosat (dompetku))": {
        "label": "IDR_789 (Indosat (dompetku))",
        "value": "IDR_789 (Indosat (dompetku))"
    },
    "IDR_867 (Bank Eka Bumi Artha)": {
        "label": "IDR_867 (Bank Eka Bumi Artha)",
        "value": "IDR_867 (Bank Eka Bumi Artha)"
    },
    "IDR_899 (Doku)": {
        "label": "IDR_899 (Doku)",
        "value": "IDR_899 (Doku)"
    },
    "IDR_911 (Linkaja / Telcomsel (Tcash))": {
        "label": "IDR_911 (Linkaja / Telcomsel (Tcash))",
        "value": "IDR_911 (Linkaja / Telcomsel (Tcash))"
    },
    "IDR_945 (IBK Bank Indonesia / Bank Finconesia)": {
        "label": "IDR_945 (IBK Bank Indonesia / Bank Finconesia)",
        "value": "IDR_945 (IBK Bank Indonesia / Bank Finconesia)"
    },
    "IDR_946 (Bank Merincorp)": {
        "label": "IDR_946 (Bank Merincorp)",
        "value": "IDR_946 (Bank Merincorp)"
    },
    "IDR_947 (Bank Maybank Syariah Indonesia)": {
        "label": "IDR_947 (Bank Maybank Syariah Indonesia)",
        "value": "IDR_947 (Bank Maybank Syariah Indonesia)"
    },
    "IDR_948 (Bank OCBC Indonesia)": {
        "label": "IDR_948 (Bank OCBC Indonesia)",
        "value": "IDR_948 (Bank OCBC Indonesia)"
    },
    "IDR_949 (Bank CTBC Indonesia)": {
        "label": "IDR_949 (Bank CTBC Indonesia)",
        "value": "IDR_949 (Bank CTBC Indonesia)"
    },
    "IDR_950 (Bank Commonwealth)": {
        "label": "IDR_950 (Bank Commonwealth)",
        "value": "IDR_950 (Bank Commonwealth)"
    },
    "ALHB (Allahabad Bank)": {
        "label": "ALHB (Allahabad Bank)",
        "value": "ALHB (Allahabad Bank)"
    },
    "ANDB (Andhra Bank)": {
        "label": "ANDB (Andhra Bank)",
        "value": "ANDB (Andhra Bank)"
    },
    "AXIS (Axis Bank)": {
        "label": "AXIS (Axis Bank)",
        "value": "AXIS (Axis Bank)"
    },
    "BOIN (Bank of India)": {
        "label": "BOIN (Bank of India)",
        "value": "BOIN (Bank of India)"
    },
    "BRDA (Bank of Baroda)": {
        "label": "BRDA (Bank of Baroda)",
        "value": "BRDA (Bank of Baroda)"
    },
    "CANBK (Canara Bank)": {
        "label": "CANBK (Canara Bank)",
        "value": "CANBK (Canara Bank)"
    },
    "CBOI (Central Bank of India)": {
        "label": "CBOI (Central Bank of India)",
        "value": "CBOI (Central Bank of India)"
    },
    "CITI (Citi Bank)": {
        "label": "CITI (Citi Bank)",
        "value": "CITI (Citi Bank)"
    },
    "CORB (Corporation Bank)": {
        "label": "CORB (Corporation Bank)",
        "value": "CORB (Corporation Bank)"
    },
    "CSYB (Catholic Syrian Bank)": {
        "label": "CSYB (Catholic Syrian Bank)",
        "value": "CSYB (Catholic Syrian Bank)"
    },
    "DENB (Dena Bank)": {
        "label": "DENB (Dena Bank)",
        "value": "DENB (Dena Bank)"
    },
    "DNLM (Dhanlaxmi Bank)": {
        "label": "DNLM (Dhanlaxmi Bank)",
        "value": "DNLM (Dhanlaxmi Bank)"
    },
    "FEDB (Federal Bank)": {
        "label": "FEDB (Federal Bank)",
        "value": "FEDB (Federal Bank)"
    },
    "HDFC (HDFC Bank)": {
        "label": "HDFC (HDFC Bank)",
        "value": "HDFC (HDFC Bank)"
    },
    "ICICI (ICICI Bank)": {
        "label": "ICICI (ICICI Bank)",
        "value": "ICICI (ICICI Bank)"
    },
    "IDBI (IDBI Bank)": {
        "label": "IDBI (IDBI Bank)",
        "value": "IDBI (IDBI Bank)"
    },
    "INDNB (Indian Bank)": {
        "label": "INDNB (Indian Bank)",
        "value": "INDNB (Indian Bank)"
    },
    "INDU (IndusInd Bank)": {
        "label": "INDU (IndusInd Bank)",
        "value": "INDU (IndusInd Bank)"
    },
    "INOB (Indian Overseas Bank)": {
        "label": "INOB (Indian Overseas Bank)",
        "value": "INOB (Indian Overseas Bank)"
    },
    "IN_APGVB (Andhra Pradesh Grameena Vikas Bank)": {
        "label": "IN_APGVB (Andhra Pradesh Grameena Vikas Bank)",
        "value": "IN_APGVB (Andhra Pradesh Grameena Vikas Bank)"
    },
    "IN_CUB (City Union Bank)": {
        "label": "IN_CUB (City Union Bank)",
        "value": "IN_CUB (City Union Bank)"
    },
    "IN_HSBC (Hongkong and Shanghai Banking Corporation Limited India)": {
        "label": "IN_HSBC (Hongkong and Shanghai Banking Corporation Limited India)",
        "value": "IN_HSBC (Hongkong and Shanghai Banking Corporation Limited India)"
    },
    "IN_IDFC (IDFC First Bank)": {
        "label": "IN_IDFC (IDFC First Bank)",
        "value": "IN_IDFC (IDFC First Bank)"
    },
    "IN_KVB (Karur Vysya Bank)": {
        "label": "IN_KVB (Karur Vysya Bank)",
        "value": "IN_KVB (Karur Vysya Bank)"
    },
    "IN_LVB (Lakshmi Vilas Bank)": {
        "label": "IN_LVB (Lakshmi Vilas Bank)",
        "value": "IN_LVB (Lakshmi Vilas Bank)"
    },
    "IN_PMCB (Punjab and Maharashtra Co-operative Bank Limited)": {
        "label": "IN_PMCB (Punjab and Maharashtra Co-operative Bank Limited)",
        "value": "IN_PMCB (Punjab and Maharashtra Co-operative Bank Limited)"
    },
    "IN_USFB (Ujjivan Small Finance Bank)": {
        "label": "IN_USFB (Ujjivan Small Finance Bank)",
        "value": "IN_USFB (Ujjivan Small Finance Bank)"
    },
    "JAKB (Jammu and Kashmir Bank)": {
        "label": "JAKB (Jammu and Kashmir Bank)",
        "value": "JAKB (Jammu and Kashmir Bank)"
    },
    "KARBK (Karnataka Bank)": {
        "label": "KARBK (Karnataka Bank)",
        "value": "KARBK (Karnataka Bank)"
    },
    "KOTBK (Kotak Mahindra Bank)": {
        "label": "KOTBK (Kotak Mahindra Bank)",
        "value": "KOTBK (Kotak Mahindra Bank)"
    },
    "MHRT (Bank of Maharashtra)": {
        "label": "MHRT (Bank of Maharashtra)",
        "value": "MHRT (Bank of Maharashtra)"
    },
    "OBOC (Oriental Bank of Commerce)": {
        "label": "OBOC (Oriental Bank of Commerce)",
        "value": "OBOC (Oriental Bank of Commerce)"
    },
    "PASB (Punjab and Sind Bank)": {
        "label": "PASB (Punjab and Sind Bank)",
        "value": "PASB (Punjab and Sind Bank)"
    },
    "PNJB (Punjab National Bank)": {
        "label": "PNJB (Punjab National Bank)",
        "value": "PNJB (Punjab National Bank)"
    },
    "SBBJ (State Bank of Bikaner and Jaipur)": {
        "label": "SBBJ (State Bank of Bikaner and Jaipur)",
        "value": "SBBJ (State Bank of Bikaner and Jaipur)"
    },
    "SBIN (State Bank)": {
        "label": "SBIN (State Bank)",
        "value": "SBIN (State Bank)"
    },
    "SBOH (State Bank of Hyderabad)": {
        "label": "SBOH (State Bank of Hyderabad)",
        "value": "SBOH (State Bank of Hyderabad)"
    },
    "SBOT (State Bank of Travancore)": {
        "label": "SBOT (State Bank of Travancore)",
        "value": "SBOT (State Bank of Travancore)"
    },
    "SCTRD (Standard Chartered Bank)": {
        "label": "SCTRD (Standard Chartered Bank)",
        "value": "SCTRD (Standard Chartered Bank)"
    },
    "SIBK (South Indian Bank)": {
        "label": "SIBK (South Indian Bank)",
        "value": "SIBK (South Indian Bank)"
    },
    "SYNB (Syndicate Bank)": {
        "label": "SYNB (Syndicate Bank)",
        "value": "SYNB (Syndicate Bank)"
    },
    "TAMB (Tamilnadu Mercantile Bank)": {
        "label": "TAMB (Tamilnadu Mercantile Bank)",
        "value": "TAMB (Tamilnadu Mercantile Bank)"
    },
    "UCOB (UCO Bank)": {
        "label": "UCOB (UCO Bank)",
        "value": "UCOB (UCO Bank)"
    },
    "UNBOI (Union Bank of India)": {
        "label": "UNBOI (Union Bank of India)",
        "value": "UNBOI (Union Bank of India)"
    },
    "VJYB (Vijaya Bank)": {
        "label": "VJYB (Vijaya Bank)",
        "value": "VJYB (Vijaya Bank)"
    },
    "YESB (YES Bank)": {
        "label": "YESB (YES Bank)",
        "value": "YESB (YES Bank)"
    },
    "JP_BOF (Bank of Fukuoka)": {
        "label": "JP_BOF (Bank of Fukuoka)",
        "value": "JP_BOF (Bank of Fukuoka)"
    },
    "JP_BOY (Bank of Yokohama)": {
        "label": "JP_BOY (Bank of Yokohama)",
        "value": "JP_BOY (Bank of Yokohama)"
    },
    "JP_CBB (Chiba Bank)": {
        "label": "JP_CBB (Chiba Bank)",
        "value": "JP_CBB (Chiba Bank)"
    },
    "JP_HKB (Hokkaido Bank)": {
        "label": "JP_HKB (Hokkaido Bank)",
        "value": "JP_HKB (Hokkaido Bank)"
    },
    "JP_HNB (Higashi-Nippon Bank)": {
        "label": "JP_HNB (Higashi-Nippon Bank)",
        "value": "JP_HNB (Higashi-Nippon Bank)"
    },
    "JP_HRB (Hokuriku Bank)": {
        "label": "JP_HRB (Hokuriku Bank)",
        "value": "JP_HRB (Hokuriku Bank)"
    },
    "JP_JPB (Japan Post Bank)": {
        "label": "JP_JPB (Japan Post Bank)",
        "value": "JP_JPB (Japan Post Bank)"
    },
    "JP_KMB (Kansai Mirai Bank Ltd)": {
        "label": "JP_KMB (Kansai Mirai Bank Ltd)",
        "value": "JP_KMB (Kansai Mirai Bank Ltd)"
    },
    "JP_MNB (Minna Bank)": {
        "label": "JP_MNB (Minna Bank)",
        "value": "JP_MNB (Minna Bank)"
    },
    "JP_MUFG (MUFG Bank)": {
        "label": "JP_MUFG (MUFG Bank)",
        "value": "JP_MUFG (MUFG Bank)"
    },
    "JP_MZB (Mizuho Bank)": {
        "label": "JP_MZB (Mizuho Bank)",
        "value": "JP_MZB (Mizuho Bank)"
    },
    "JP_RSB (Resona Bank)": {
        "label": "JP_RSB (Resona Bank)",
        "value": "JP_RSB (Resona Bank)"
    },
    "JP_SMFC (Sumitomo Mitsui Banking Corporation)": {
        "label": "JP_SMFC (Sumitomo Mitsui Banking Corporation)",
        "value": "JP_SMFC (Sumitomo Mitsui Banking Corporation)"
    },
    "JP_TJSB (The Juhachi-Shinwa Bank Ltd)": {
        "label": "JP_TJSB (The Juhachi-Shinwa Bank Ltd)",
        "value": "JP_TJSB (The Juhachi-Shinwa Bank Ltd)"
    },
    "JP_TKB (The Kumamoto Bank Ltd)": {
        "label": "JP_TKB (The Kumamoto Bank Ltd)",
        "value": "JP_TKB (The Kumamoto Bank Ltd)"
    },
    "JP_TNB (The Norinchukin Bank)": {
        "label": "JP_TNB (The Norinchukin Bank)",
        "value": "JP_TNB (The Norinchukin Bank)"
    },
    "KR_BANKOFCOREA (Bank of Korea)": {
        "label": "KR_BANKOFCOREA (Bank of Korea)",
        "value": "KR_BANKOFCOREA (Bank of Korea)"
    },
    "KR_BNK (Busan Bank)": {
        "label": "KR_BNK (Busan Bank)",
        "value": "KR_BNK (Busan Bank)"
    },
    "KR_CTK (Citibank Korea)": {
        "label": "KR_CTK (Citibank Korea)",
        "value": "KR_CTK (Citibank Korea)"
    },
    "KR_DGB (DAEGU Bank)": {
        "label": "KR_DGB (DAEGU Bank)",
        "value": "KR_DGB (DAEGU Bank)"
    },
    "KR_HBG (KEB Hana Bank)": {
        "label": "KR_HBG (KEB Hana Bank)",
        "value": "KR_HBG (KEB Hana Bank)"
    },
    "KR_IBK (Industrial Bank of Korea)": {
        "label": "KR_IBK (Industrial Bank of Korea)",
        "value": "KR_IBK (Industrial Bank of Korea)"
    },
    "KR_KDB (Korea Development Bank)": {
        "label": "KR_KDB (Korea Development Bank)",
        "value": "KR_KDB (Korea Development Bank)"
    },
    "KR_KKB (KB Kookmin Bank)": {
        "label": "KR_KKB (KB Kookmin Bank)",
        "value": "KR_KKB (KB Kookmin Bank)"
    },
    "KR_KWB (Kwangju Bank)": {
        "label": "KR_KWB (Kwangju Bank)",
        "value": "KR_KWB (Kwangju Bank)"
    },
    "KR_NOB (Nonghyup Bank)": {
        "label": "KR_NOB (Nonghyup Bank)",
        "value": "KR_NOB (Nonghyup Bank)"
    },
    "KR_SHB (Shinhan Bank)": {
        "label": "KR_SHB (Shinhan Bank)",
        "value": "KR_SHB (Shinhan Bank)"
    },
    "KR_WOB (Woori Bank)": {
        "label": "KR_WOB (Woori Bank)",
        "value": "KR_WOB (Woori Bank)"
    },
    "MY_AMB (AmBank)": {
        "label": "MY_AMB (AmBank)",
        "value": "MY_AMB (AmBank)"
    },
    "MY_CIMB (CIMB Bank)": {
        "label": "MY_CIMB (CIMB Bank)",
        "value": "MY_CIMB (CIMB Bank)"
    },
    "MY_HLB (Hong Leong Bank)": {
        "label": "MY_HLB (Hong Leong Bank)",
        "value": "MY_HLB (Hong Leong Bank)"
    },
    "MY_HSBC (HSBC Bank)": {
        "label": "MY_HSBC (HSBC Bank)",
        "value": "MY_HSBC (HSBC Bank)"
    },
    "MY_MAYB (Maybank)": {
        "label": "MY_MAYB (Maybank)",
        "value": "MY_MAYB (Maybank)"
    },
    "MY_OCBC (OCBC Bank)": {
        "label": "MY_OCBC (OCBC Bank)",
        "value": "MY_OCBC (OCBC Bank)"
    },
    "MY_PUBLIC (Public Bank)": {
        "label": "MY_PUBLIC (Public Bank)",
        "value": "MY_PUBLIC (Public Bank)"
    },
    "MY_RHB (RHB Bank)": {
        "label": "MY_RHB (RHB Bank)",
        "value": "MY_RHB (RHB Bank)"
    },
    "MY_UOBIB (United Overseas Bank (UOB))": {
        "label": "MY_UOBIB (United Overseas Bank (UOB))",
        "value": "MY_UOBIB (United Overseas Bank (UOB))"
    },
    "TH_BANGKOK (Bangkok Bank)": {
        "label": "TH_BANGKOK (Bangkok Bank)",
        "value": "TH_BANGKOK (Bangkok Bank)"
    },
    "TH_CIMB (CIMB THAI Bank)": {
        "label": "TH_CIMB (CIMB THAI Bank)",
        "value": "TH_CIMB (CIMB THAI Bank)"
    },
    "TH_GOVERNMENTSAVINGS (Government Savings Bank)": {
        "label": "TH_GOVERNMENTSAVINGS (Government Savings Bank)",
        "value": "TH_GOVERNMENTSAVINGS (Government Savings Bank)"
    },
    "TH_KASIKORN (Kasikorn Bank)": {
        "label": "TH_KASIKORN (Kasikorn Bank)",
        "value": "TH_KASIKORN (Kasikorn Bank)"
    },
    "TH_KRUNGSRI (Bank of Ayudhya (Krungsri))": {
        "label": "TH_KRUNGSRI (Bank of Ayudhya (Krungsri))",
        "value": "TH_KRUNGSRI (Bank of Ayudhya (Krungsri))"
    },
    "TH_KRUNGTHAI (Krungthai Bank)": {
        "label": "TH_KRUNGTHAI (Krungthai Bank)",
        "value": "TH_KRUNGTHAI (Krungthai Bank)"
    },
    "TH_SIAM (Siam Commercial Bank)": {
        "label": "TH_SIAM (Siam Commercial Bank)",
        "value": "TH_SIAM (Siam Commercial Bank)"
    },
    "TH_TTBDIRECT (TMBThanachart Bank (ttb))": {
        "label": "TH_TTBDIRECT (TMBThanachart Bank (ttb))",
        "value": "TH_TTBDIRECT (TMBThanachart Bank (ttb))"
    },
    "TH_UOBT (United Overseas Bank (UOB))": {
        "label": "TH_UOBT (United Overseas Bank (UOB))",
        "value": "TH_UOBT (United Overseas Bank (UOB))"
    },
    "VN_ACB (Asia Commercial Bank)": {
        "label": "VN_ACB (Asia Commercial Bank)",
        "value": "VN_ACB (Asia Commercial Bank)"
    },
    "VN_BIDV (BIDV)": {
        "label": "VN_BIDV (BIDV)",
        "value": "VN_BIDV (BIDV)"
    },
    "VN_DONGA (DongA Bank)": {
        "label": "VN_DONGA (DongA Bank)",
        "value": "VN_DONGA (DongA Bank)"
    },
    "VN_EXIM (Eximbank)": {
        "label": "VN_EXIM (Eximbank)",
        "value": "VN_EXIM (Eximbank)"
    },
    "VN_SACOM (Sacombank)": {
        "label": "VN_SACOM (Sacombank)",
        "value": "VN_SACOM (Sacombank)"
    },
    "VN_TECHCOM (Techcombank)": {
        "label": "VN_TECHCOM (Techcombank)",
        "value": "VN_TECHCOM (Techcombank)"
    },
    "VN_TP (TPBank)": {
        "label": "VN_TP (TPBank)",
        "value": "VN_TP (TPBank)"
    },
    "VN_VIETCOM (Vietcombank)": {
        "label": "VN_VIETCOM (Vietcombank)",
        "value": "VN_VIETCOM (Vietcombank)"
    },
    "VN_VIETIN (VietinBank)": {
        "label": "VN_VIETIN (VietinBank)",
        "value": "VN_VIETIN (VietinBank)"
    },
    "VN_VP (VPBank)": {
        "label": "VN_VP (VPBank)",
        "value": "VN_VP (VPBank)"
    }
};
export const BRIDGER_PAYMENT_ACCOUNT_TYPE_OPTIONS: any[] = [
    { label: "savings", value: "savings" },
    { label: "current", value: "current" },
    { label: "cheque", value: "cheque" },
    { label: "transmission", value: "transmission" },
    { label: "checking", value: "checking" },
    { label: "general", value: "general" },
    { label: "private", value: "private" },
    { label: "corporate", value: "corporate" },
];
export const BRIDGER_PAYMENT_ACCOUNT_TYPE_DICT: any = {
    "savings": {
        "label": "savings",
        "value": "savings"
    },
    "current": {
        "label": "current",
        "value": "current"
    },
    "cheque": {
        "label": "cheque",
        "value": "cheque"
    },
    "transmission": {
        "label": "transmission",
        "value": "transmission"
    },
    "checking": {
        "label": "checking",
        "value": "checking"
    },
    "general": {
        "label": "general",
        "value": "general"
    },
    "private": {
        "label": "private",
        "value": "private"
    },
    "corporate": {
        "label": "corporate",
        "value": "corporate"
    }
};
export function validateBridgerCurrencyAmount({ currency, amount }: { currency: string; amount: number; }): boolean {
    switch (currency.toUpperCase()) {
        case "CNY":
            return amount >= 10000 && amount <= 50000;
        case "IDR":
            return amount >= 500000 && amount <= 25000000;
        case "INR":
            return amount >= 1000 && amount <= 500000;
        case "JPY":
            return amount >= 5000 && amount <= 1000000;
        case "KRW":
            return amount >= 10000 && amount <= 6000000;
        case "MYR":
            return amount >= 50 && amount <= 20000;
        case "THB":
            return amount >= 100 && amount <= 100000;
        case "VND":
            return amount >= 100000 && amount <= 100000000;
        default:
            return false; // Currency not supported
    }
}
export function ReturnBridgerCurrencyAmount({ currency }: { currency: string; }): string {
    switch (currency.toUpperCase()) {
        case "CNY":
            return "amount should be between 10,000 and 50,000";
        case "IDR":
            return "amount should be between 500,000 and 25,000,000";
        case "INR":
            return "amount should be between 1,000 and 500,000";
        case "JPY":
            return "amount should be between 5,000 and 1,000,000";
        case "KRW":
            return "amount should be between 10,000 and 6,000,000";
        case "MYR":
            return "amount should be between 50 and 20,000";
        case "THB":
            return "amount should be between 100 and 100,000";
        case "VND":
            return "amount should be between 100000 and 100,000,000";
        default:
            return ""; // Currency not supported
    }
}
export function validateNamesRegex(text: string) {
    if (!text || text === "") return false;

    var _regexComma = /^([\\D\\-\\.,']*[^0-9]*)+$/g;
    return text.match(_regexComma) ? true : false;
}
export const NACE_CRYPTO_CURRENCIES = [
    // {
    //     "label": "BTC",
    //     "value": "btc",
    //     "BTCBlockchain": "mainnet"
    // },
    // {
    //     "label": "BCH",
    //     "value": "bch",
    //     "BTCBlockchain": "mainnet"
    // },
    // {
    //     "label": "ETH",
    //     "value": "eth",
    //     "BTCBlockchain": "mainnet"
    // },
    // {
    //     "label": "LTC",
    //     "value": "ltc",
    //     "BTCBlockchain": "mainnet"
    // },
    // {
    //     "label": "DODGE",
    //     "value": "doge",
    //     "BTCBlockchain": "mainnet"
    // },
    {
        "label": "USDT",
        "value": "erc20/usdt",
        "BTCBlockchain": "mainnet"
    },
    // {
    //     "label": "XRP",
    //     "value": "xrp",
    //     "BTCBlockchain": "mainnet"
    // },
    // {
    //     "label": "USDC",
    //     "value": "erc20/usdc",
    //     "BTCBlockchain": "mainnet"
    // },
    {
        "label": "USDT (TRC20)",
        "value": "usdt_tron",
        "BTCBlockchain": "mainnet"
    },
    // {
    //     "label": "SOL",
    //     "value": "sol",
    //     "BTCBlockchain": "mainnet"
    // },
    // {
    //     "label": "BNB",
    //     "value": "bnb",
    //     "BTCBlockchain": "mainnet"
    // },
    // {
    //     "label": "DASH",
    //     "value": "dash",
    //     "BTCBlockchain": "mainnet"
    // },
    // {
    //     "label": "ADA Cardano",
    //     "value": "ada",
    //     "BTCBlockchain": "mainnet"
    // },
    // {
    //     "label": "AVAX Avalanche",
    //     "value": "avax",
    //     "BTCBlockchain": "mainnet"
    // },
    // {
    //     "label": "Polygon (Matic)",
    //     "value": "matic_poly",
    //     "BTCBlockchain": "mainnet"
    // },
    // {
    //     "label": "SHIB",
    //     "value": "erc20/shib",
    //     "BTCBlockchain": "mainnet"
    // }
];
export function isMarketEquityPaymentVisible(PoolID: number, PaymentName: string) {
    if (PoolID === EMARKET_EQUITY_POOLS.DefaultPool) {
        return MARKET_EQUITY_PAYMENT_POOLS.DefaultPool.find((item: string) => item === PaymentName.toLowerCase());
    }
    if (PoolID === EMARKET_EQUITY_POOLS.DefaultWG) {
        return MARKET_EQUITY_PAYMENT_POOLS.DefaultWG.find((item: string) => item === PaymentName.toLowerCase());
    }
    if (PoolID === EMARKET_EQUITY_POOLS.ROW) {
        return MARKET_EQUITY_PAYMENT_POOLS.ROW.find((item: string) => item === PaymentName.toLowerCase());
    }
    if (PoolID === EMARKET_EQUITY_POOLS.GCC) {
        return MARKET_EQUITY_PAYMENT_POOLS.GCC.find((item: string) => item === PaymentName.toLowerCase());
    }
    if (PoolID === EMARKET_EQUITY_POOLS.FEE_FREE) {
        return MARKET_EQUITY_PAYMENT_POOLS.FEE_FREE.find((item: string) => item === PaymentName.toLowerCase());
    }
    if (PoolID === EMARKET_EQUITY_POOLS.IB_USER) return MARKET_EQUITY_PAYMENT_POOLS.IB_USER.find((item: string) => item === PaymentName.toLowerCase());;
    if (PoolID === EMARKET_EQUITY_POOLS.Bonus) return false;

    return false;
}
export function isIQXPaymentVisible(acctypeId: number, PaymentName: string) {
    if (!!Object.values(E_IQX_ACCOUNT_TYPES).some(value => value === acctypeId))
        return PaymentName.toLowerCase() === EPayments.UPay || PaymentName.toLowerCase() === EPayments.ASIA_PAYMENT;
    //keep rest same
    return true;
}
export function isIQXPaymentVisibleForWallet(poolId: number, PaymentName: string, Deposit: boolean) {
    if (!Deposit && poolId === E_IQX_POOLS.PH_Default) return PaymentName.toLowerCase() === EPayments.ASIA_PAYMENT;
    if (Deposit && poolId === E_IQX_POOLS.PH_Default) return false;
    return true;
}
export const encryptParams = (params: any, key: string) => {
    console.log('encryptParams', key)
    if (!key) return "";
    try {
        const cipher = crypto.createCipheriv('des-ede3', key.substring(0, 24), '');
        let encrypted = cipher.update(params, 'utf8', 'base64');
        encrypted += cipher.final('base64');
        return encrypted;
    } catch (e) {
        console.error(e);
        return '';
    }
}


export const decryptParams = (encryptedData: any, key: string) => {
    console.log('decryptParams', key)
    if (!key) return "";
    try {
        const decipher = crypto.createDecipheriv('des-ede3', key.substring(0, 24), '');
        let decrypted = decipher.update(encryptedData, 'base64', 'utf8');
        decrypted += decipher.final('utf8');
        return decrypted;
    } catch (e) {
        console.error(e);
        return '';
    }
}

export const OTHERS_CRYPTO_PAYMENTS_ICONFX = [
    { value: "0xD663A5e5D86E335a68101D153A0B1b913688Eb23", label: "BEP20" },
    { value: "TA6QAtNe2hWhRf9AzZjo5avseQJeChSytf", label: "TRC20" },
    { value: "0xD663A5e5D86E335a68101D153A0B1b913688Eb23", label: "ERC20" },
];

export const OTHERS_CRYPTO_PAYMENTS_WinPro = [
    { value: "0xea7243c6a8dc1e49c1568adee39d89fac91656ec", label: "ETH (ERC20)" },
    { value: "TVHEDuswbS9cLY1E5uovcBg28y8p9PUHQq", label: "USDT (TRC20)" },
    { value: "0xea7243c6a8dc1e49c1568adee39d89fac91656ec", label: "USDT (ERC20)" },
    { value: "1HPj5eZxJztpSCa6QG1VHWGz1wP4ELrX5Z", label: "Bitcoin" },
];
export function ReturnWalletsPerCompany(companyName: string) {
    if (companyName?.toLowerCase() === "icon") return OTHERS_CRYPTO_PAYMENTS_ICONFX;
    if (companyName?.toLowerCase() === "winpro") return OTHERS_CRYPTO_PAYMENTS_WinPro;
    return [];

}
export const OTHERS_PAYMENTS = ["other1", "other2", "other3", "other4", "other5", "other6", "other7", "other8"];
export function ReturnOthersPaymentLabel(paymentName: string): any {
    const _paymentName = paymentName.toLowerCase();
    if (_paymentName === "other1") {
        return "Front Side Number (10 digits)";
    }
    if (_paymentName === "other2") {
        return "Wallet address";
    }
    if (_paymentName === "other3") {
        return "Wallet ID";
    }
    if (_paymentName === "other4") {
        return "Payeer ID";
    }
    if (_paymentName === "other5") {
        return "Phone number";//3 fields
    }
    if (_paymentName === "other6") {
        return "Wallet ID";
    }
    return "WalletAddress";
}
export function ReturnOthers2ndFieldPaymentLabel(paymentName: string): any {
    const _paymentName = paymentName.toLowerCase();
    if (_paymentName === "other1") {
        return "Phone number (linked with Qi card account)";
    }

    return "Phone number (linked with Qi card account)";
}
export function ReturnOthersPaymentNoteLabel(paymentName: string): any {
    const _paymentName = paymentName.toLowerCase();
    if (_paymentName === "other1") {
        return "Name on Card";
    }
    return "Note";
}
export function GET_FLW_BANKS(isAccount?: boolean) {
    //if (isAccount)
    //    return [
    //        {
    //            "label": "Bank",
    //            "value": "bank",
    //        },
    //        {
    //            "label": "Barter",
    //            "value": "barter",
    //        },
    //        {
    //            "label": "Mobile money",
    //            "value": "momo",
    //        },
    //    ];
    return [
        {
            "label": "Bank",
            "value": "bank",
        },
        {
            "label": "Barter",
            "value": "barter",
        },
        {
            "label": "Mobile money",
            "value": "momo",
        },
        {
            "label": "Wallet-to-wallet",
            "value": "wtw",
        },
    ]
};
export const FLW_Dict: any = {
    "bank": "Bank",
    "barter": "Barter",
    "momo": "Mobile money",
    "wtw": "Wallet-to-wallet",
};
export const FLW_COUNTRIES = [{ value: "Rwanda (RWF)", label: "Rwanda (RWF)", Code: "RWF" },
{ value: "Tanzania (TZS)", label: "Tanzania (TZS)", Code: "TZS" },
{ value: "Uganda (UGX)", label: "Uganda (UGX)", Code: "UGX" },
{ value: "Zambia (ZMW)	MPS", label: "Zambia (ZMW)	MPS", Code: "ZMW" },
{ value: "Kenya (KES)", label: "Kenya (KES)", Code: "KES" },
{ value: "M-Pesa (MPS)", label: "M-Pesa (MPS)", Code: "MPS" },
{ value: "Airtel Kenya (MPX)", label: "Airtel Kenya (MPX)", Code: "MPX" },
{ value: "Ghana (GHS)", label: "Ghana (GHS)", Code: "GHS" },
{ value: "MTN", label: "MTN", Code: "MTN" },
{ value: "TIGO", label: "TIGO", Code: "TIGO" },
{ value: "VODAFONE", label: "VODAFONE", Code: "VODAFONE" },
{ value: "AIRTEL", label: "AIRTEL", Code: "AIRTEL" },
{ value: "Cameroon (XAF)", label: "Cameroon (XAF)", Code: "XAF" },
{ value: "Cote d'Ivoire (XOF)	FMM", label: "Cote d'Ivoire (XOF)	FMM", Code: "XOF" },
{ value: "Senegal (XOF)", label: "Senegal (XOF)", Code: "XOF" },
{ value: "ORANGEMONEY", label: "ORANGEMONEY", Code: "ORANGEMONEY" },
{ value: "EMONEY", label: "EMONEY", Code: "" },
{ value: "FREEMONEY", label: "FREEMONEY", Code: "FREEMONEY" }];

export function getFlwMOMOPaymentMethods(selectedValue: any) {
    if (["Rwanda (RWF)", "Tanzania (TZS)", "Uganda (UGX)", "Zambia (ZMW)"].includes(selectedValue)) {
        return [{ value: "mps", label: "MPS" }];
    }

    if (["Kenya (KES)"].includes(selectedValue)) {
        return [
            { value: "mps", label: "M-Pesa (MPS)" },
            { value: "mpx", label: "Airtel Kenya (MPX)" },
        ];
    }

    if (["Ghana (GHS)"].includes(selectedValue)) {
        return [
            { value: "mtn", label: "MTN" },
            { value: "tigo", label: "TIGO" },
            { value: "vodafone", label: "VODAFONE" },
            { value: "airtel", label: "AIRTEL" },
        ];
    }

    if (["Cameroon (XAF)", "Cote d'Ivoire (XOF)"].includes(selectedValue)) {
        return [{ value: "fmm", label: "FMM" }];
    }

    if (["Senegal (XOF)"].includes(selectedValue)) {
        return [
            { value: "ORANGEMONEY", label: "ORANGEMONEY" },
            { value: "EMONEY", label: "EMONEY" },
            { value: "FREEMONEY", label: "FREEMONEY" },
        ];
    }

    return [];
};
export const Bank_FLW_COUNTRIES = [
    { value: "NG", label: "Nigeria" },
    { value: "GH", label: "Ghana" },
    { value: "KE", label: "Kenya" },
    { value: "UG", label: "Uganda" },
    { value: "ZA", label: "South Africa" },
    { value: "TZ", label: "Tanzania" }
];
export const FLW_Banks_DATA = {
    "First City Monumemt Bank (FCMB)": {
        "sender": { value: "", type: "string", required: "true", title: "Sender" },
        "sender_address": { value: "", type: "string", required: "true", title: "Address" },
        "sender_country": { value: "", type: "string", required: "true", title: "Country" },
        "sender_id_number": { value: "", type: "string", required: "true", title: "ID number" },
        "sender_id_type": { value: "", type: "string", required: "true", title: "ID type" },
        "sender_id_expiry": { value: "", type: "string", required: "true", title: "ID expiry" },
        "sender_mobile_number": { value: "", type: "string", required: "true", title: "Mobile number" },
        "sender_occupation": { value: "", type: "string", required: "true", title: "Occupation" },
        "sender_beneficiary_relationship": { value: "", type: "string", required: "true", title: "Beneficiary relationship" },
        "recipient_address": { value: "", type: "string", required: "true", title: "Recipient address" },
        "beneficiary_country": { value: "", type: "string", required: "true", title: "Beneficiary country" },
        "routing_number": { value: "", type: "string", required: "true", title: "Routing number" },
        "transfer_purpose": { value: "", type: "string", required: "true", title: "Transfer purpose" },
        "beneficiary_name": { value: "", type: "string", required: "true", title: "Beneficiary name" },
    },
    "Fidelity Bank and Union Bank of Nigeria": {
        "sender": { value: "", type: "string", required: "true", title: "Sender" },
        "sender_city": { value: "", type: "string", required: "true", title: "Sender city" },
        //"first_name": { value: "", type: "string", required: "true" ,title:"xxx"},
        //"last_name": { value: "", type: "string", required: "true" ,title:"xxx"},
        //"email": { value: "", type: "string", required: "true" ,title:"xxx"},
        "beneficiary_country": { value: "", type: "string", required: "true", title: "Beneficiary country" },
        //"mobile_number": { value: "", type: "string", required: "true" ,title:"xxx"},
        "merchant_name": { value: "", type: "string", required: "true", title: "Merchant name" },
        "beneficiary_name": { value: "", type: "string", required: "true", title: "Beneficiary name" },
    },
    "Providus Bank": {
        "sender": { value: "", type: "string", required: "true", title: "sender" },
        "sender_address": { value: "", type: "string", required: "true", title: "Sender address" },
        "sender_city": { value: "", type: "string", required: "true", title: "Sender city" },
        "sender_country": { value: "", type: "string", required: "true", title: "Sender country" },
        "sender_id_number": { value: "", type: "string", required: "true", title: "ID number" },
        "sender_mobile_number": { value: "", type: "string", required: "true", title: "sender mobile number" },
        "sender_email_address": { value: "", type: "string", required: "true", title: "sender email address" },
        //"first_name": { value: "", type: "string", required: "true" ,title:"Recipient address"},
        //"last_name": { value: "", type: "string", required: "true" ,title:"Beneficiary state"},
        "recipient_address": { value: "", type: "string", required: "true", title: "Beneficiary state" },
        "beneficiary_state": { value: "", type: "string", required: "true", title: "Beneficiary country" },
        "beneficiary_country": { value: "", type: "string", required: "true", title: "beneficiary mobile number" },
        "beneficiary_mobile_number": { value: "", type: "string", required: "true", title: "Routing number" },
        "routing_number": { value: "", type: "string", required: "true", title: "Routing number" },
        "account_number": { value: "", type: "string", required: "true", title: "Account number" },
        "beneficiary_name": { value: "", type: "string", required: "true", title: "Beneficiary name" },
    },
    "Other Banks": {
        "sender": { value: "", type: "string", required: "true", title: "sender" },
        //"first_name": { value: "", type: "string", required: "true" ,title:"xxx"},
        //"last_name": { value: "", type: "string", required: "true" ,title:"xxx"},
        //"email": { value: "", type: "string", required: "true" ,title:"xxx"},
        "beneficiary_country": { value: "", type: "string", required: "true", title: "Beneficiary country" },
        //"mobile_number": { value: "", type: "string", required: "true" ,title:"xxx"},
        "merchant_name": { value: "", type: "string", required: "true", title: "Merchant name" },
        "beneficiary_name": { value: "", type: "string", required: "true", title: "Beneficiary name" },
    },
    "US": {
        "AccountNumber": { value: "", type: "string", required: "true", title: "Account Number" },
        "RoutingNumber": { value: "", type: "string", required: "true", title: "Routing Number" },
        "SwiftCode": { value: "", type: "string", required: "true", title: "Swift Code" },
        "BeneficiaryName": { value: "", type: "string", required: "true", title: "Beneficiary Name" },
        "BeneficiaryAddress": { value: "", type: "string", required: "true", title: "Beneficiary Address" },
        "BeneficiaryCountry": { value: "", type: "string", required: "true", title: "Beneficiary Country" },
    },
    "EURGBP": {
        "AccountNumber": { value: "", type: "string", required: "true", title: "Account Number" },
        "RoutingNumber": { value: "", type: "string", required: "true", title: "Routing Number" },
        "SwiftCode": { value: "", type: "string", required: "true", title: "Swift Code" },
        "BankName": { value: "", type: "string", required: "true", title: "BankName" },
        "BeneficiaryName": { value: "", type: "string", required: "true", title: "Beneficiary Name" },
        "BeneficiaryCountry": { value: "", type: "string", required: "true", title: "Beneficiary Country" },
        "PostalCode": { value: "", type: "string", required: "true", title: "Postal Code" },
        "StreetNumber": { value: "", type: "string", required: "true", title: "Street Number" },
        "StreetName": { value: "", type: "string", required: "true", title: "Street Name" },
        "City": { value: "", type: "string", required: "true", title: "City" },
        "beneficiary_name": { value: "", type: "string", required: "true", title: "Beneficiary name" },
    },
    "KES": {
        "sender": { value: "", type: "string", required: "true", title: "sender" },
        "sender_country": { value: "", type: "string", required: "true", title: "Sender_country" },
        //"mobile_number": { value: "", type: "string", required: "true" ,title:"xxx"},
        "beneficiary_name": { value: "", type: "string", required: "true", title: "Beneficiary name" },
    },
    "GHS_UGX_ZMW_TZS": {
        "destination_branch_code": { value: "", type: "string", required: "true", title: "Destination branchcode" },
        "beneficiary_name": { value: "", type: "string", required: "true", title: "Beneficiary name" },
    },
    "ZAR": {
        //"first_name": { value: "", type: "string", required: "true" ,title:"xxx"},
        //"last_name": { value: "", type: "string", required: "true" ,title:"xxx"},
        //"email": { value: "", type: "string", required: "true" ,title:"xxx"},
        //"mobile_number": { value: "", type: "string", required: "true" ,title:"xxx"},
        "recipient_address": { value: "", type: "string", required: "true", title: "Recipient address" },
    }
};
export const FLW_Banks_DATA_TITLES: any = {
    "sender": "Sender",
    "sender_address": "Address",
    "sender_country": "Country",
    "sender_id_number": "ID number",
    "sender_id_type": "ID type",
    "sender_id_expiry": "ID expiry",
    "sender_mobile_number": "Mobile number",
    "sender_occupation": "Occupation",
    "sender_beneficiary_relationship": "Beneficiary relationship",
    "recipient_address": "Recipient address",
    "beneficiary_country": "Beneficiary country",
    "routing_number": "Routing number",
    "transfer_purpose": "Transfer purpose",
    "beneficiary_name": "Beneficiary name",
    "sender_city": "Sender city",
    "merchant_name": "Merchant name",
    "sender_email_address": "sender email address",
    "beneficiary_state": "Beneficiary country",
    "beneficiary_mobile_number": "Routing number",
    "account_number": "Account number",
    "AccountNumber": "Account Number",
    "RoutingNumber": "Routing Number",
    "SwiftCode": "Swift Code",
    "BeneficiaryName": "Beneficiary Name",
    "BeneficiaryAddress": "Beneficiary Address",
    "BeneficiaryCountry": "Beneficiary Country",
    "BankName": "BankName",
    "PostalCode": "Postal Code",
    "StreetNumber": "Street Number",
    "StreetName": "Street Name",
    "City": "City",
    "destination_branch_code": "Destination branch code"
};
export const COUNTRIES_ISO_3166_1_ALPHA_2_COUNTRY_CODES: any = [
    { value: "AF", label: "Afghanistan" },
    { value: "AX", label: "Aland Islands" },
    { value: "AL", label: "Albania" },
    { value: "DZ", label: "Algeria" },
    { value: "AS", label: "American Samoa" },
    { value: "AD", label: "Andorra" },
    { value: "AO", label: "Angola" },
    { value: "AI", label: "Anguilla" },
    { value: "AQ", label: "Antarctica" },
    { value: "AG", label: "Antigua And Barbuda" },
    { value: "AR", label: "Argentina" },
    { value: "AM", label: "Armenia" },
    { value: "AW", label: "Aruba" },
    { value: "AU", label: "Australia" },
    { value: "AT", label: "Austria" },
    { value: "AZ", label: "Azerbaijan" },
    { value: "BS", label: "Bahamas" },
    { value: "BH", label: "Bahrain" },
    { value: "BD", label: "Bangladesh" },
    { value: "BB", label: "Barbados" },
    { value: "BY", label: "Belarus" },
    { value: "BE", label: "Belgium" },
    { value: "BZ", label: "Belize" },
    { value: "BJ", label: "Benin" },
    { value: "BM", label: "Bermuda" },
    { value: "BT", label: "Bhutan" },
    { value: "BO", label: "Bolivia" },
    { value: "BA", label: "Bosnia And Herzegovina" },
    { value: "BW", label: "Botswana" },
    { value: "BV", label: "Bouvet Island" },
    { value: "BR", label: "Brazil" },
    { value: "IO", label: "British Indian Ocean Territory" },
    { value: "BN", label: "Brunei Darussalam" },
    { value: "BG", label: "Bulgaria" },
    { value: "BF", label: "Burkina Faso" },
    { value: "BI", label: "Burundi" },
    { value: "KH", label: "Cambodia" },
    { value: "CM", label: "Cameroon" },
    { value: "CA", label: "Canada" },
    { value: "CV", label: "Cape Verde" },
    { value: "KY", label: "Cayman Islands" },
    { value: "CF", label: "Central African Republic" },
    { value: "TD", label: "Chad" },
    { value: "CL", label: "Chile" },
    { value: "CN", label: "China" },
    { value: "CX", label: "Christmas Island" },
    { value: "CC", label: "Cocos (Keeling) Islands" },
    { value: "CO", label: "Colombia" },
    { value: "KM", label: "Comoros" },
    { value: "CG", label: "Congo" },
    { value: "CD", label: "Congo, Democratic Republic" },
    { value: "CK", label: "Cook Islands" },
    { value: "CR", label: "Costa Rica" },
    { value: "CI", label: "Cote D\"Ivoire" },
    { value: "HR", label: "Croatia" },
    { value: "CU", label: "Cuba" },
    { value: "CY", label: "Cyprus" },
    { value: "CZ", label: "Czech Republic" },
    { value: "DK", label: "Denmark" },
    { value: "DJ", label: "Djibouti" },
    { value: "DM", label: "Dominica" },
    { value: "DO", label: "Dominican Republic" },
    { value: "EC", label: "Ecuador" },
    { value: "EG", label: "Egypt" },
    { value: "SV", label: "El Salvador" },
    { value: "GQ", label: "Equatorial Guinea" },
    { value: "ER", label: "Eritrea" },
    { value: "EE", label: "Estonia" },
    { value: "ET", label: "Ethiopia" },
    { value: "FK", label: "Falkland Islands (Malvinas)" },
    { value: "FO", label: "Faroe Islands" },
    { value: "FJ", label: "Fiji" },
    { value: "FI", label: "Finland" },
    { value: "FR", label: "France" },
    { value: "GF", label: "French Guiana" },
    { value: "PF", label: "French Polynesia" },
    { value: "TF", label: "French Southern Territories" },
    { value: "GA", label: "Gabon" },
    { value: "GM", label: "Gambia" },
    { value: "GE", label: "Georgia" },
    { value: "DE", label: "Germany" },
    { value: "GH", label: "Ghana" },
    { value: "GI", label: "Gibraltar" },
    { value: "GR", label: "Greece" },
    { value: "GL", label: "Greenland" },
    { value: "GD", label: "Grenada" },
    { value: "GP", label: "Guadeloupe" },
    { value: "GU", label: "Guam" },
    { value: "GT", label: "Guatemala" },
    { value: "GG", label: "Guernsey" },
    { value: "GN", label: "Guinea" },
    { value: "GW", label: "Guinea-Bissau" },
    { value: "GY", label: "Guyana" },
    { value: "HT", label: "Haiti" },
    { value: "HM", label: "Heard Island & Mcdonald Islands" },
    { value: "VA", label: "Holy See (Vatican City State)" },
    { value: "HN", label: "Honduras" },
    { value: "HK", label: "Hong Kong" },
    { value: "HU", label: "Hungary" },
    { value: "IS", label: "Iceland" },
    { value: "IN", label: "India" },
    { value: "ID", label: "Indonesia" },
    { value: "IR", label: "Iran, Islamic Republic Of" },
    { value: "IQ", label: "Iraq" },
    { value: "IE", label: "Ireland" },
    { value: "IM", label: "Isle Of Man" },
    { value: "IL", label: "Israel" },
    { value: "IT", label: "Italy" },
    { value: "JM", label: "Jamaica" },
    { value: "JP", label: "Japan" },
    { value: "JE", label: "Jersey" },
    { value: "JO", label: "Jordan" },
    { value: "KZ", label: "Kazakhstan" },
    { value: "KE", label: "Kenya" },
    { value: "KI", label: "Kiribati" },
    { value: "KR", label: "Korea" },
    { value: "KP", label: "North Korea" },
    { value: "KW", label: "Kuwait" },
    { value: "KG", label: "Kyrgyzstan" },
    { value: "LA", label: "Lao People\"s Democratic Republic" },
    { value: "LV", label: "Latvia" },
    { value: "LB", label: "Lebanon" },
    { value: "LS", label: "Lesotho" },
    { value: "LR", label: "Liberia" },
    { value: "LY", label: "Libyan Arab Jamahiriya" },
    { value: "LI", label: "Liechtenstein" },
    { value: "LT", label: "Lithuania" },
    { value: "LU", label: "Luxembourg" },
    { value: "MO", label: "Macao" },
    { value: "MK", label: "Macedonia" },
    { value: "MG", label: "Madagascar" },
    { value: "MW", label: "Malawi" },
    { value: "MY", label: "Malaysia" },
    { value: "MV", label: "Maldives" },
    { value: "ML", label: "Mali" },
    { value: "MT", label: "Malta" },
    { value: "MH", label: "Marshall Islands" },
    { value: "MQ", label: "Martinique" },
    { value: "MR", label: "Mauritania" },
    { value: "MU", label: "Mauritius" },
    { value: "YT", label: "Mayotte" },
    { value: "MX", label: "Mexico" },
    { value: "FM", label: "Micronesia, Federated States Of" },
    { value: "MD", label: "Moldova" },
    { value: "MC", label: "Monaco" },
    { value: "MN", label: "Mongolia" },
    { value: "ME", label: "Montenegro" },
    { value: "MS", label: "Montserrat" },
    { value: "MA", label: "Morocco" },
    { value: "MZ", label: "Mozambique" },
    { value: "MM", label: "Myanmar" },
    { value: "NA", label: "Namibia" },
    { value: "NR", label: "Nauru" },
    { value: "NP", label: "Nepal" },
    { value: "NL", label: "Netherlands" },
    { value: "AN", label: "Netherlands Antilles" },
    { value: "NC", label: "New Caledonia" },
    { value: "NZ", label: "New Zealand" },
    { value: "NI", label: "Nicaragua" },
    { value: "NE", label: "Niger" },
    { value: "NG", label: "Nigeria" },
    { value: "NU", label: "Niue" },
    { value: "NF", label: "Norfolk Island" },
    { value: "MP", label: "Northern Mariana Islands" },
    { value: "NO", label: "Norway" },
    { value: "OM", label: "Oman" },
    { value: "PK", label: "Pakistan" },
    { value: "PW", label: "Palau" },
    { value: "PS", label: "Palestinian Territory, Occupied" },
    { value: "PA", label: "Panama" },
    { value: "PG", label: "Papua New Guinea" },
    { value: "PY", label: "Paraguay" },
    { value: "PE", label: "Peru" },
    { value: "PH", label: "Philippines" },
    { value: "PN", label: "Pitcairn" },
    { value: "PL", label: "Poland" },
    { value: "PT", label: "Portugal" },
    { value: "PR", label: "Puerto Rico" },
    { value: "QA", label: "Qatar" },
    { value: "RE", label: "Reunion" },
    { value: "RO", label: "Romania" },
    { value: "RU", label: "Russian Federation" },
    { value: "RW", label: "Rwanda" },
    { value: "BL", label: "Saint Barthelemy" },
    { value: "SH", label: "Saint Helena" },
    { value: "KN", label: "Saint Kitts And Nevis" },
    { value: "LC", label: "Saint Lucia" },
    { value: "MF", label: "Saint Martin" },
    { value: "PM", label: "Saint Pierre And Miquelon" },
    { value: "VC", label: "Saint Vincent And Grenadines" },
    { value: "WS", label: "Samoa" },
    { value: "SM", label: "San Marino" },
    { value: "ST", label: "Sao Tome And Principe" },
    { value: "SA", label: "Saudi Arabia" },
    { value: "SN", label: "Senegal" },
    { value: "RS", label: "Serbia" },
    { value: "SC", label: "Seychelles" },
    { value: "SL", label: "Sierra Leone" },
    { value: "SG", label: "Singapore" },
    { value: "SK", label: "Slovakia" },
    { value: "SI", label: "Slovenia" },
    { value: "SB", label: "Solomon Islands" },
    { value: "SO", label: "Somalia" },
    { value: "ZA", label: "South Africa" },
    { value: "GS", label: "South Georgia And Sandwich Isl." },
    { value: "ES", label: "Spain" },
    { value: "LK", label: "Sri Lanka" },
    { value: "SD", label: "Sudan" },
    { value: "SR", label: "Suriname" },
    { value: "SJ", label: "Svalbard And Jan Mayen" },
    { value: "SZ", label: "Swaziland" },
    { value: "SE", label: "Sweden" },
    { value: "CH", label: "Switzerland" },
    { value: "SY", label: "Syrian Arab Republic" },
    { value: "TW", label: "Taiwan" },
    { value: "TJ", label: "Tajikistan" },
    { value: "TZ", label: "Tanzania" },
    { value: "TH", label: "Thailand" },
    { value: "TL", label: "Timor-Leste" },
    { value: "TG", label: "Togo" },
    { value: "TK", label: "Tokelau" },
    { value: "TO", label: "Tonga" },
    { value: "TT", label: "Trinidad And Tobago" },
    { value: "TN", label: "Tunisia" },
    { value: "TR", label: "Turkey" },
    { value: "TM", label: "Turkmenistan" },
    { value: "TC", label: "Turks And Caicos Islands" },
    { value: "TV", label: "Tuvalu" },
    { value: "UG", label: "Uganda" },
    { value: "UA", label: "Ukraine" },
    { value: "AE", label: "United Arab Emirates" },
    { value: "GB", label: "United Kingdom" },
    { value: "US", label: "United States" },
    { value: "UM", label: "United States Outlying Islands" },
    { value: "UY", label: "Uruguay" },
    { value: "UZ", label: "Uzbekistan" },
    { value: "VU", label: "Vanuatu" },
    { value: "VE", label: "Venezuela" },
    { value: "VN", label: "Vietnam" },
    { value: "VG", label: "Virgin Islands, British" },
    { value: "VI", label: "Virgin Islands, U.S." },
    { value: "WF", label: "Wallis And Futuna" },
    { value: "EH", label: "Western Sahara" },
    { value: "YE", label: "Yemen" },
    { value: "ZM", label: "Zambia" },
    { value: "ZW", label: "Zimbabwe" }
];
export const COUNTRIES_ISO_3166_1_ALPHA_2_COUNTRY_CODES_DICT: any = {
    "AF": "Afghanistan",
    "AX": "Aland Islands",
    "AL": "Albania",
    "DZ": "Algeria",
    "AS": "American Samoa",
    "AD": "Andorra",
    "AO": "Angola",
    "AI": "Anguilla",
    "AQ": "Antarctica",
    "AG": "Antigua And Barbuda",
    "AR": "Argentina",
    "AM": "Armenia",
    "AW": "Aruba",
    "AU": "Australia",
    "AT": "Austria",
    "AZ": "Azerbaijan",
    "BS": "Bahamas",
    "BH": "Bahrain",
    "BD": "Bangladesh",
    "BB": "Barbados",
    "BY": "Belarus",
    "BE": "Belgium",
    "BZ": "Belize",
    "BJ": "Benin",
    "BM": "Bermuda",
    "BT": "Bhutan",
    "BO": "Bolivia",
    "BA": "Bosnia And Herzegovina",
    "BW": "Botswana",
    "BV": "Bouvet Island",
    "BR": "Brazil",
    "IO": "British Indian Ocean Territory",
    "BN": "Brunei Darussalam",
    "BG": "Bulgaria",
    "BF": "Burkina Faso",
    "BI": "Burundi",
    "KH": "Cambodia",
    "CM": "Cameroon",
    "CA": "Canada",
    "CV": "Cape Verde",
    "KY": "Cayman Islands",
    "CF": "Central African Republic",
    "TD": "Chad",
    "CL": "Chile",
    "CN": "China",
    "CX": "Christmas Island",
    "CC": "Cocos (Keeling) Islands",
    "CO": "Colombia",
    "KM": "Comoros",
    "CG": "Congo",
    "CD": "Congo, Democratic Republic",
    "CK": "Cook Islands",
    "CR": "Costa Rica",
    "CI": "Cote D\"Ivoire",
    "HR": "Croatia",
    "CU": "Cuba",
    "CY": "Cyprus",
    "CZ": "Czech Republic",
    "DK": "Denmark",
    "DJ": "Djibouti",
    "DM": "Dominica",
    "DO": "Dominican Republic",
    "EC": "Ecuador",
    "EG": "Egypt",
    "SV": "El Salvador",
    "GQ": "Equatorial Guinea",
    "ER": "Eritrea",
    "EE": "Estonia",
    "ET": "Ethiopia",
    "FK": "Falkland Islands (Malvinas)",
    "FO": "Faroe Islands",
    "FJ": "Fiji",
    "FI": "Finland",
    "FR": "France",
    "GF": "French Guiana",
    "PF": "French Polynesia",
    "TF": "French Southern Territories",
    "GA": "Gabon",
    "GM": "Gambia",
    "GE": "Georgia",
    "DE": "Germany",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GR": "Greece",
    "GL": "Greenland",
    "GD": "Grenada",
    "GP": "Guadeloupe",
    "GU": "Guam",
    "GT": "Guatemala",
    "GG": "Guernsey",
    "GN": "Guinea",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HT": "Haiti",
    "HM": "Heard Island & Mcdonald Islands",
    "VA": "Holy See (Vatican City State)",
    "HN": "Honduras",
    "HK": "Hong Kong",
    "HU": "Hungary",
    "IS": "Iceland",
    "IN": "India",
    "ID": "Indonesia",
    "IR": "Iran, Islamic Republic Of",
    "IQ": "Iraq",
    "IE": "Ireland",
    "IM": "Isle Of Man",
    "IL": "Israel",
    "IT": "Italy",
    "JM": "Jamaica",
    "JP": "Japan",
    "JE": "Jersey",
    "JO": "Jordan",
    "KZ": "Kazakhstan",
    "KE": "Kenya",
    "KI": "Kiribati",
    "KR": "Korea",
    "KP": "North Korea",
    "KW": "Kuwait",
    "KG": "Kyrgyzstan",
    "LA": "Lao People\"s Democratic Republic",
    "LV": "Latvia",
    "LB": "Lebanon",
    "LS": "Lesotho",
    "LR": "Liberia",
    "LY": "Libyan Arab Jamahiriya",
    "LI": "Liechtenstein",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "MO": "Macao",
    "MK": "Macedonia",
    "MG": "Madagascar",
    "MW": "Malawi",
    "MY": "Malaysia",
    "MV": "Maldives",
    "ML": "Mali",
    "MT": "Malta",
    "MH": "Marshall Islands",
    "MQ": "Martinique",
    "MR": "Mauritania",
    "MU": "Mauritius",
    "YT": "Mayotte",
    "MX": "Mexico",
    "FM": "Micronesia, Federated States Of",
    "MD": "Moldova",
    "MC": "Monaco",
    "MN": "Mongolia",
    "ME": "Montenegro",
    "MS": "Montserrat",
    "MA": "Morocco",
    "MZ": "Mozambique",
    "MM": "Myanmar",
    "NA": "Namibia",
    "NR": "Nauru",
    "NP": "Nepal",
    "NL": "Netherlands",
    "AN": "Netherlands Antilles",
    "NC": "New Caledonia",
    "NZ": "New Zealand",
    "NI": "Nicaragua",
    "NE": "Niger",
    "NG": "Nigeria",
    "NU": "Niue",
    "NF": "Norfolk Island",
    "MP": "Northern Mariana Islands",
    "NO": "Norway",
    "OM": "Oman",
    "PK": "Pakistan",
    "PW": "Palau",
    "PS": "Palestinian Territory, Occupied",
    "PA": "Panama",
    "PG": "Papua New Guinea",
    "PY": "Paraguay",
    "PE": "Peru",
    "PH": "Philippines",
    "PN": "Pitcairn",
    "PL": "Poland",
    "PT": "Portugal",
    "PR": "Puerto Rico",
    "QA": "Qatar",
    "RE": "Reunion",
    "RO": "Romania",
    "RU": "Russian Federation",
    "RW": "Rwanda",
    "BL": "Saint Barthelemy",
    "SH": "Saint Helena",
    "KN": "Saint Kitts And Nevis",
    "LC": "Saint Lucia",
    "MF": "Saint Martin",
    "PM": "Saint Pierre And Miquelon",
    "VC": "Saint Vincent And Grenadines",
    "WS": "Samoa",
    "SM": "San Marino",
    "ST": "Sao Tome And Principe",
    "SA": "Saudi Arabia",
    "SN": "Senegal",
    "RS": "Serbia",
    "SC": "Seychelles",
    "SL": "Sierra Leone",
    "SG": "Singapore",
    "SK": "Slovakia",
    "SI": "Slovenia",
    "SB": "Solomon Islands",
    "SO": "Somalia",
    "ZA": "South Africa",
    "GS": "South Georgia And Sandwich Isl.",
    "ES": "Spain",
    "LK": "Sri Lanka",
    "SD": "Sudan",
    "SR": "Suriname",
    "SJ": "Svalbard And Jan Mayen",
    "SZ": "Swaziland",
    "SE": "Sweden",
    "CH": "Switzerland",
    "SY": "Syrian Arab Republic",
    "TW": "Taiwan",
    "TJ": "Tajikistan",
    "TZ": "Tanzania",
    "TH": "Thailand",
    "TL": "Timor-Leste",
    "TG": "Togo",
    "TK": "Tokelau",
    "TO": "Tonga",
    "TT": "Trinidad And Tobago",
    "TN": "Tunisia",
    "TR": "Turkey",
    "TM": "Turkmenistan",
    "TC": "Turks And Caicos Islands",
    "TV": "Tuvalu",
    "UG": "Uganda",
    "UA": "Ukraine",
    "AE": "United Arab Emirates",
    "GB": "United Kingdom",
    "US": "United States",
    "UM": "United States Outlying Islands",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "VU": "Vanuatu",
    "VE": "Venezuela",
    "VN": "Vietnam",
    "VG": "Virgin Islands, British",
    "VI": "Virgin Islands, U.S.",
    "WF": "Wallis And Futuna",
    "EH": "Western Sahara",
    "YE": "Yemen",
    "ZM": "Zambia",
    "ZW": "Zimbabwe"
};
// alpha-3 mapping for ISO 3166-1 alpha-2 codes
export const COUNTRIES_ALPHA2_TO_ALPHA3: any = {
    AF: 'AFG', AX: 'ALA', AL: 'ALB', DZ: 'DZA', AS: 'ASM', AD: 'AND', AO: 'AGO', AI: 'AIA', AQ: 'ATA', AG: 'ATG', AR: 'ARG', AM: 'ARM', AW: 'ABW', AU: 'AUS', AT: 'AUT', AZ: 'AZE',
    BS: 'BHS', BH: 'BHR', BD: 'BGD', BB: 'BRB', BY: 'BLR', BE: 'BEL', BZ: 'BLZ', BJ: 'BEN', BM: 'BMU', BT: 'BTN', BO: 'BOL', BA: 'BIH', BW: 'BWA', BV: 'BVT', BR: 'BRA', IO: 'IOT', BN: 'BRN', BG: 'BGR', BF: 'BFA', BI: 'BDI',
    KH: 'KHM', CM: 'CMR', CA: 'CAN', CV: 'CPV', KY: 'CYM', CF: 'CAF', TD: 'TCD', CL: 'CHL', CN: 'CHN', CX: 'CXR', CC: 'CCK', CO: 'COL', KM: 'COM', CG: 'COG', CD: 'COD', CK: 'COK', CR: 'CRI', CI: 'CIV', HR: 'HRV', CU: 'CUB',
    CY: 'CYP', CZ: 'CZE', DK: 'DNK', DJ: 'DJI', DM: 'DMA', DO: 'DOM', EC: 'ECU', EG: 'EGY', SV: 'SLV', GQ: 'GNQ', ER: 'ERI', EE: 'EST', ET: 'ETH', FK: 'FLK', FO: 'FRO', FJ: 'FJI', FI: 'FIN', FR: 'FRA', GF: 'GUF', PF: 'PYF', TF: 'ATF',
    GA: 'GAB', GM: 'GMB', GE: 'GEO', DE: 'DEU', GH: 'GHA', GI: 'GIB', GR: 'GRC', GL: 'GRL', GD: 'GRD', GP: 'GLP', GU: 'GUM', GT: 'GTM', GG: 'GGY', GN: 'GIN', GW: 'GNB', GY: 'GUY', HT: 'HTI', HM: 'HMD', VA: 'VAT', HN: 'HND',
    HK: 'HKG', HU: 'HUN', IS: 'ISL', IN: 'IND', ID: 'IDN', IR: 'IRN', IQ: 'IRQ', IE: 'IRL', IM: 'IMN', IL: 'ISR', IT: 'ITA', JM: 'JAM', JP: 'JPN', JE: 'JEY', JO: 'JOR', KZ: 'KAZ', KE: 'KEN', KI: 'KIR', KP: 'PRK', KR: 'KOR', KW: 'KWT',
    KG: 'KGZ', LA: 'LAO', LV: 'LVA', LB: 'LBN', LS: 'LSO', LR: 'LBR', LY: 'LBY', LI: 'LIE', LT: 'LTU', LU: 'LUX', MO: 'MAC', MK: 'MKD', MG: 'MDG', MW: 'MWI', MY: 'MYS', MV: 'MDV', ML: 'MLI', MT: 'MLT', MH: 'MHL', MQ: 'MTQ', MR: 'MRT',
    MU: 'MUS', YT: 'MYT', MX: 'MEX', FM: 'FSM', MD: 'MDA', MC: 'MCO', MN: 'MNG', ME: 'MNE', MS: 'MSR', MA: 'MAR', MZ: 'MOZ', MM: 'MMR', NA: 'NAM', NR: 'NRU', NP: 'NPL', NL: 'NLD', AN: 'ANT', NC: 'NCL', NZ: 'NZL', NI: 'NIC', NE: 'NER',
    NG: 'NGA', NU: 'NIU', NF: 'NFK', MP: 'MNP', NO: 'NOR', OM: 'OMN', PK: 'PAK', PW: 'PLW', PS: 'PSE', PA: 'PAN', PG: 'PNG', PY: 'PRY', PE: 'PER', PH: 'PHL', PN: 'PCN', PL: 'POL', PT: 'PRT', PR: 'PRI', QA: 'QAT', RE: 'REU', RO: 'ROU',
    RU: 'RUS', RW: 'RWA', BL: 'BLM', SH: 'SHN', KN: 'KNA', LC: 'LCA', MF: 'MAF', PM: 'SPM', VC: 'VCT', WS: 'WSM', SM: 'SMR', ST: 'STP', SA: 'SAU', SN: 'SEN', RS: 'SRB', SC: 'SYC', SL: 'SLE', SG: 'SGP', SK: 'SVK', SI: 'SVN', SB: 'SLB',
    SO: 'SOM', ZA: 'ZAF', GS: 'SGS', ES: 'ESP', LK: 'LKA', SD: 'SDN', SR: 'SUR', SJ: 'SJM', SZ: 'SWZ', SE: 'SWE', CH: 'CHE', SY: 'SYR', TW: 'TWN', TJ: 'TJK', TZ: 'TZA', TH: 'THA', TL: 'TLS', TG: 'TGO', TK: 'TKL', TO: 'TON', TT: 'TTO',
    TN: 'TUN', TR: 'TUR', TM: 'TKM', TC: 'TCA', TV: 'TUV', UG: 'UGA', UA: 'UKR', AE: 'ARE', GB: 'GBR', US: 'USA', UM: 'UMI', UY: 'URY', UZ: 'UZB', VU: 'VUT', VE: 'VEN', VN: 'VNM', VG: 'VGB', VI: 'VIR', WF: 'WLF', EH: 'ESH', YE: 'YEM', ZM: 'ZMB', ZW: 'ZWE'
};
export const US_STATES: any = [
    { value: "AL", label: "Alabama" },
    { value: "AK", label: "Alaska" },
    { value: "AZ", label: "Arizona" },
    { value: "AR", label: "Arkansas" },
    { value: "CA", label: "California" },
    { value: "CO", label: "Colorado" },
    { value: "CT", label: "Connecticut" },
    { value: "DE", label: "Delaware" },
    { value: "FL", label: "Florida" },
    { value: "GA", label: "Georgia" },
    { value: "HI", label: "Hawaii" },
    { value: "ID", label: "Idaho" },
    { value: "IL", label: "Illinois" },
    { value: "IN", label: "Indiana" },
    { value: "IA", label: "Iowa" },
    { value: "KS", label: "Kansas" },
    { value: "KY", label: "Kentucky" },
    { value: "LA", label: "Louisiana" },
    { value: "ME", label: "Maine" },
    { value: "MD", label: "Maryland" },
    { value: "MA", label: "Massachusetts" },
    { value: "MI", label: "Michigan" },
    { value: "MN", label: "Minnesota" },
    { value: "MS", label: "Mississippi" },
    { value: "MO", label: "Missouri" },
    { value: "MT", label: "Montana" },
    { value: "NE", label: "Nebraska" },
    { value: "NV", label: "Nevada" },
    { value: "NH", label: "New Hampshire" },
    { value: "NJ", label: "New Jersey" },
    { value: "NM", label: "New Mexico" },
    { value: "NY", label: "New York" },
    { value: "NC", label: "North Carolina" },
    { value: "ND", label: "North Dakota" },
    { value: "OH", label: "Ohio" },
    { value: "OK", label: "Oklahoma" },
    { value: "OR", label: "Oregon" },
    { value: "PA", label: "Pennsylvania" },
    { value: "RI", label: "Rhode Island" },
    { value: "SC", label: "South Carolina" },
    { value: "SD", label: "South Dakota" },
    { value: "TN", label: "Tennessee" },
    { value: "TX", label: "Texas" },
    { value: "UT", label: "Utah" },
    { value: "VT", label: "Vermont" },
    { value: "VA", label: "Virginia" },
    { value: "WA", label: "Washington" },
    { value: "WV", label: "West Virginia" },
    { value: "WI", label: "Wisconsin" },
    { value: "WY", label: "Wyoming" },
];
export const CA_STATES = [
    { "value": "AB", "label": "Alberta" },
    { "value": "BC", "label": "British Columbia" },
    { "value": "MB", "label": "Manitoba" },
    { "value": "NB", "label": "New Brunswick" },
    { "value": "NL", "label": "Newfoundland and Labrador" },
    { "value": "NS", "label": "Nova Scotia" },
    { "value": "NT", "label": "Northwest Territories" },
    { "value": "NU", "label": "Nunavut" },
    { "value": "ON", "label": "Ontario" },
    { "value": "PE", "label": "Prince Edward Island" },
    { "value": "QC", "label": "Quebec" },
    { "value": "SK", "label": "Saskatchewan" },
    { "value": "YT", "label": "Yukon" }
]
export const US_STATES_DICT: any = {
    "AL": "Alabama",
    "AK": "Alaska",
    "AZ": "Arizona",
    "AR": "Arkansas",
    "CA": "California",
    "CO": "Colorado",
    "CT": "Connecticut",
    "DE": "Delaware",
    "FL": "Florida",
    "GA": "Georgia",
    "HI": "Hawaii",
    "ID": "Idaho",
    "IL": "Illinois",
    "IN": "Indiana",
    "IA": "Iowa",
    "KS": "Kansas",
    "KY": "Kentucky",
    "LA": "Louisiana",
    "ME": "Maine",
    "MD": "Maryland",
    "MA": "Massachusetts",
    "MI": "Michigan",
    "MN": "Minnesota",
    "MS": "Mississippi",
    "MO": "Missouri",
    "MT": "Montana",
    "NE": "Nebraska",
    "NV": "Nevada",
    "NH": "New Hampshire",
    "NJ": "New Jersey",
    "NM": "New Mexico",
    "NY": "New York",
    "NC": "North Carolina",
    "ND": "North Dakota",
    "OH": "Ohio",
    "OK": "Oklahoma",
    "OR": "Oregon",
    "PA": "Pennsylvania",
    "RI": "Rhode Island",
    "SC": "South Carolina",
    "SD": "South Dakota",
    "TN": "Tennessee",
    "TX": "Texas",
    "UT": "Utah",
    "VT": "Vermont",
    "VA": "Virginia",
    "WA": "Washington",
    "WV": "West Virginia",
    "WI": "Wisconsin",
    "WY": "Wyoming",
    //Canada
    "AB": "Alberta",
    "BC": "British Columbia",
    "MB": "Manitoba",
    "NB": "New Brunswick",
    "NL": "Newfoundland and Labrador",
    "NS": "Nova Scotia",
    "NT": "Northwest Territories",
    "NU": "Nunavut",
    "ON": "Ontario",
    "PE": "Prince Edward Island",
    "QC": "Quebec",
    "SK": "Saskatchewan",
    "YT": "Yukon"
};

// Remove trailing slash
export function removeTrailingSlash(url: any) {
    return url.replace(/\/$/, ''); // This regular expression removes the trailing slash
}

// Add trailing slash
export function addTrailingSlash(url: any) {
    if (!url.endsWith('/')) {
        return url + '/';
    }
    return url; // URL already has a trailing slash, no need to add another
}
export const CRYPTO_CURRENCY = [
    { currency: "BTC", value: "BTC-BTC", label: "BTC network", network: "BTC" },
    { currency: "ETH", value: "ETH-ETH", label: "ETH network", network: "ETH" },
    { currency: "TRC20", value: "USDT-TRC20", label: "USDT-TRC20 network", network: "USDT" },
    { currency: "ERC20", value: "USDT-ERC20", label: "USDT-ERC20 network", network: "USDT" },
    { currency: "BEP20", value: "USDT-BEP20", label: "USDT-BEP20 network", network: "USDT" },
    { currency: "ERC20", value: "USDC-ERC20", label: "USDC-ERC20 network", network: "USDC" },
    { currency: "BEP20", value: "USDC-BEP20", label: "USDC-BEP20 network", network: "USDC" },
    { currency: "BEP20", value: "BUSD-BEP20", label: "BUSD-BEP20 network", network: "BUSD" },
    { currency: "BEP20", value: "BNB-BEP20", label: "BNB-BEP20 network", network: "BNB" }

]; export const CRYPTO_CURRENCY_DICT: any = {
    "BTC-BTC": { currency: "BTC", value: "BTC-BTC", label: "BTC network", network: "BTC" },
    "ETH-ETH": { currency: "ETH", value: "ETH-ETH", label: "ETH network", network: "ETH" },
    "USDT-TRC20": { currency: "TRC20", value: "USDT-TRC20", label: "USDT-TRC20 network", network: "USDT" },
    "USDT-ERC20": { currency: "ERC20", value: "USDT-ERC20", label: "USDT-ERC20 network", network: "USDT" },
    "USDT-BEP20": { currency: "BEP20", value: "USDT-BEP20", label: "USDT-BEP20 network", network: "USDT" },
    "USDC-ERC20": { currency: "ERC20", value: "USDC-ERC20", label: "USDC-ERC20 network", network: "USDC" },
    "USDC-BEP20": { currency: "BEP20", value: "USDC-BEP20", label: "USDC-BEP20 network", network: "USDC" },
    "BUSD-BEP20": { currency: "BEP20", value: "BUSD-BEP20", label: "BUSD-BEP20 network", network: "BUSD" },
    "BNB-BEP20": { currency: "BEP20", value: "BNB-BEP20", label: "BNB-BEP20 network", network: "BNB" }
};
function base64ToBlob(base64Data: string, contentType: string) {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
}
export function downloadBase64Excel(base64Data: string, fileName: string) {
    const blob = base64ToBlob(base64Data, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
}
export const VND_PAYMENT_BANK_NAMES = [
    {
        "value": "ABBANK",
        "label": "ABBANK - NH An Binh"
    },
    {
        "value": "ACB",
        "label": "ACB - NH A Chau"
    },
    {
        "value": "AGRIBANK",
        "label": "AGRIBANK - NH Nong Nghiep va PTNT VN"
    },
    {
        "value": "BAB",
        "label": "BAB - NH Bac A"
    },
    {
        "value": "BANVIET",
        "label": "BANVIET - VIETCAPITALBANK - NH Ban Viet"
    },
    {
        "value": "BAOVIETBANK",
        "label": "BAOVIET BANK - NH Bao Viet"
    },
    {
        "value": "BIDV",
        "label": "BIDV - NH Dau Tu va Phat Trien VN"
    },
    {
        "value": "CIMB",
        "label": "CIMB - NH CIMB Bank"
    },
    {
        "value": "DONGABANK",
        "label": "DONGA BANK - NH Dong A"
    },
    {
        "value": "EXIMBANK",
        "label": "EXIMBANK - NH Xuat Nhap Khau"
    },
    {
        "value": "GPBANK",
        "label": "GP BANK - NH Dau Khi Toan Cau"
    },
    {
        "value": "HDBANK",
        "label": "HDBANK - NH Phat Trien Tp HCM"
    },
    {
        "value": "HLB",
        "label": "HLB - NH Hongleong Bank"
    },
    {
        "value": "IVB",
        "label": "IVB - NH Indovina"
    },
    {
        "value": "KIENLONGBANK",
        "label": "KIENLONG BANK - NH Kien Long"
    },
    {
        "value": "LIENVIETPOSTBANK",
        "label": "LIENVIETPOSTBANK - NH Buu Dien Lien Viet"
    },
    {
        "value": "MBBANK",
        "label": "MBBANK - NH Quan Doi"
    },
    {
        "value": "MSB",
        "label": "MSB- NH Hang Hai"
    },
    {
        "value": "NAMABANK",
        "label": "NAMABANK - NH Nam A"
    },
    {
        "value": "NCB",
        "label": "NCB - NH Quốc Dân"
    },
    {
        "value": "OCB",
        "label": "OCB - NH Phuong Dong"
    },
    {
        "value": "OCEANBANK",
        "label": "OCEANBANK - NH Dai Duong"
    },
    {
        "value": "PGBANK",
        "label": "PGBANK - NH Xang Dau Petrolimex"
    },
    {
        "value": "PUBLICBANK",
        "label": "PUBLIC BANK - NH MTV Public Viet Nam"
    },
    {
        "value": "PVCOMBANK",
        "label": "PVCOMBANK - NH Dai Chung Viet Nam"
    },
    {
        "value": "SACOMBANK",
        "label": "SACOMBANK - NH Sai gon Thuong Tin"
    },
    {
        "value": "SAIGONBANK",
        "label": "SAIGON BANK - NH Sai Gon Cong Thuong"
    },
    {
        "value": "SCB",
        "label": "SCB - NH Sai Gon"
    },
    {
        "value": "SEABANK",
        "label": "SEABANK - NH Dong Nam A"
    },
    {
        "value": "SHB",
        "label": "SHB - NH Sai Gon Ha Noi"
    },
    {
        "value": "SHINHANBANK",
        "label": "SHINHAN BANK - NH Shinhan Bank"
    },
    {
        "value": "TECHCOMBANK",
        "label": "TECHCOMBANK - NH Ky Thuong"
    },
    {
        "value": "TPBANK",
        "label": "TPBANK - NH Tien Phong"
    },
    {
        "value": "UOB",
        "label": "UOB - NH UOB Viet Nam"
    },
    {
        "value": "VIB",
        "label": "VIB - NH Quoc Te"
    },
    {
        "value": "VIETABANK",
        "label": "VIETABANK - NH Viet A"
    },
    {
        "value": "VIETBANK",
        "label": "VIET BANK - NH Viet Nam Thuong Tin"
    },
    {
        "value": "VIETCOMBANK",
        "label": "VIETCOMBANK - NH Ngoai Thuong Viet Nam"
    },
    {
        "value": "VIETINBANK",
        "label": "VIETINBANK - NH Cong Thuong VN"
    },
    {
        "value": "VPBANK",
        "label": "VPBANK - NH Viet Nam Thinh Vuong"
    },
    {
        "value": "VRB",
        "label": "VRB - NH Lien Doanh Viet Nga"
    },
    {
        "value": "WOORIBANK",
        "label": "WOORI BANK - NH Woori"
    }
];
export const VND_PAYMENT_BANK_DICT: any = {
    "ABBANK": {
        "value": "ABBANK",
        "label": "ABBANK - NH An Binh"
    },
    "ACB": {
        "value": "ACB",
        "label": "ACB - NH A Chau"
    },
    "AGRIBANK": {
        "value": "AGRIBANK",
        "label": "AGRIBANK - NH Nong Nghiep va PTNT VN"
    },
    "BAB": {
        "value": "BAB",
        "label": "BAB - NH Bac A"
    },
    "BANVIET": {
        "value": "BANVIET",
        "label": "BANVIET - VIETCAPITALBANK - NH Ban Viet"
    },
    "BAOVIETBANK": {
        "value": "BAOVIETBANK",
        "label": "BAOVIET BANK - NH Bao Viet"
    },
    "BIDV": {
        "value": "BIDV",
        "label": "BIDV - NH Dau Tu va Phat Trien VN"
    },
    "CIMB": {
        "value": "CIMB",
        "label": "CIMB - NH CIMB Bank"
    },
    "DONGABANK": {
        "value": "DONGABANK",
        "label": "DONGA BANK - NH Dong A"
    },
    "EXIMBANK": {
        "value": "EXIMBANK",
        "label": "EXIMBANK - NH Xuat Nhap Khau"
    },
    "GPBANK": {
        "value": "GPBANK",
        "label": "GP BANK - NH Dau Khi Toan Cau"
    },
    "HDBANK": {
        "value": "HDBANK",
        "label": "HDBANK - NH Phat Trien Tp HCM"
    },
    "HLB": {
        "value": "HLB",
        "label": "HLB - NH Hongleong Bank"
    },
    "IVB": {
        "value": "IVB",
        "label": "IVB - NH Indovina"
    },
    "KIENLONGBANK": {
        "value": "KIENLONGBANK",
        "label": "KIENLONG BANK - NH Kien Long"
    },
    "LIENVIETPOSTBANK": {
        "value": "LIENVIETPOSTBANK",
        "label": "LIENVIETPOSTBANK - NH Buu Dien Lien Viet"
    },
    "MBBANK": {
        "value": "MBBANK",
        "label": "MBBANK - NH Quan Doi"
    },
    "MSB": {
        "value": "MSB",
        "label": "MSB- NH Hang Hai"
    },
    "NAMABANK": {
        "value": "NAMABANK",
        "label": "NAMABANK - NH Nam A"
    },
    "NCB": {
        "value": "NCB",
        "label": "NCB - NH Quốc Dân"
    },
    "OCB": {
        "value": "OCB",
        "label": "OCB - NH Phuong Dong"
    },
    "OCEANBANK": {
        "value": "OCEANBANK",
        "label": "OCEANBANK - NH Dai Duong"
    },
    "PGBANK": {
        "value": "PGBANK",
        "label": "PGBANK - NH Xang Dau Petrolimex"
    },
    "PUBLICBANK": {
        "value": "PUBLICBANK",
        "label": "PUBLIC BANK - NH MTV Public Viet Nam"
    },
    "PVCOMBANK": {
        "value": "PVCOMBANK",
        "label": "PVCOMBANK - NH Dai Chung Viet Nam"
    },
    "SACOMBANK": {
        "value": "SACOMBANK",
        "label": "SACOMBANK - NH Sai gon Thuong Tin"
    },
    "SAIGONBANK": {
        "value": "SAIGONBANK",
        "label": "SAIGON BANK - NH Sai Gon Cong Thuong"
    },
    "SCB": {
        "value": "SCB",
        "label": "SCB - NH Sai Gon"
    },
    "SEABANK": {
        "value": "SEABANK",
        "label": "SEABANK - NH Dong Nam A"
    },
    "SHB": {
        "value": "SHB",
        "label": "SHB - NH Sai Gon Ha Noi"
    },
    "SHINHANBANK": {
        "value": "SHINHANBANK",
        "label": "SHINHAN BANK - NH Shinhan Bank"
    },
    "TECHCOMBANK": {
        "value": "TECHCOMBANK",
        "label": "TECHCOMBANK - NH Ky Thuong"
    },
    "TPBANK": {
        "value": "TPBANK",
        "label": "TPBANK - NH Tien Phong"
    },
    "UOB": {
        "value": "UOB",
        "label": "UOB - NH UOB Viet Nam"
    },
    "VIB": {
        "value": "VIB",
        "label": "VIB - NH Quoc Te"
    },
    "VIETABANK": {
        "value": "VIETABANK",
        "label": "VIETABANK - NH Viet A"
    },
    "VIETBANK": {
        "value": "VIETBANK",
        "label": "VIET BANK - NH Viet Nam Thuong Tin"
    },
    "VIETCOMBANK": {
        "value": "VIETCOMBANK",
        "label": "VIETCOMBANK - NH Ngoai Thuong Viet Nam"
    },
    "VIETINBANK": {
        "value": "VIETINBANK",
        "label": "VIETINBANK - NH Cong Thuong VN"
    },
    "VPBANK": {
        "value": "VPBANK",
        "label": "VPBANK - NH Viet Nam Thinh Vuong"
    },
    "VRB": {
        "value": "VRB",
        "label": "VRB - NH Lien Doanh Viet Nga"
    },
    "WOORIBANK": {
        "value": "WOORIBANK",
        "label": "WOORI BANK - NH Woori"
    }
};
export const VNDPaymen_dit: any = {
    "bigpay": { value: "bigpay", label: "BigPay" },
    "bigpayv2": { value: "bigpayv2", label: "BigPayV2" },
    "ninepay": { value: "ninepay", label: "9Pay" },
    "fast2pays": { value: "fast2pays", label: "PayBNB" },
};
export const VNDPaymen_Options: any = [
    { value: "bigpay", label: "BigPay" },
    { value: "bigpayv2", label: "BigPayV2" },
    { value: "ninepay", label: "9Pay" },
    { value: "fast2pays", label: "PayBNB" },
];
export function isPlainEnglish(input: string): boolean {
    // Regular expression to match only English letters (both uppercase and lowercase)
    const englishRegex = /^[a-zA-Z\s]+$/;
    return englishRegex.test(input);
}
export const DEFAULT_NETWORKS = [
    { network: "0xbb94121b455c12d1b17dbed512e5fff72cdd8da0", value: "ERC20", label: "Ethereum (ERC-20)" },
    { network: "0x2a88754e12bf4bb4227b857c5161af72aafb0a9c", value: "BEP20", label: "Binance Smart Chain (BEP-20)" },
    { network: "TUdZHDATDyXprttURoCcbvmduNhtFtu6Wx", value: "TRC20", label: "TRON (TRC-20)" },
];

export const CFX_CRYPTO_CURRENCIES = [
    //{ value: "BTC", label: "Bitcoin (BTC)" },
    { value: "USDT", label: "Tether (USDT)" },
    //{ value: "ETH", label: "Ethereum (ETH)" },
];

export const _XLTrades_Wise_Transfer_Details = `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`;

//#region Signals PF
export const PF_PERIODS: any[] = [//Add translations
    { label: 'Monthly', value: 'mnth' },
    { label: '3Months', value: '3mnths' },
    { label: '6Months', value: '6mnths' },
];
export const PF_PERCENTAGES: any[] = [
    { value: '0', label: '0%' },
    { value: '5', label: '5%' },
    { value: '10', label: '10%' },
    { value: '15', label: '15%' },
    { value: '20', label: '20%' },
    { value: '25', label: '25%' },
    { value: '30', label: '30%' },
];
//#endregion



export const ICONFX_CRYPTO_CURRENCIES: string[] = ['usdterc20', 'usdttrc20', 'usdt-bep20'];

//#region AsiaPay
export const Philippines_Regions__ISO_3166_2 = [
    { value: "14", label: "Autonomous Region in Muslim Mindanao" },
    { value: "05", label: "Bicol Region" },
    { value: "02", label: "Cagayan Valley" },
    { value: "40", label: "Calabarzon" },
    { value: "13", label: "Caraga" },
    { value: "03", label: "Central Luzon" },
    { value: "07", label: "Central Visayas" },
    { value: "15", label: "Cordillera Administrative Region" },
    { value: "11", label: "Davao Region" },
    { value: "08", label: "Eastern Visayas" },
    { value: "01", label: "Ilocos Region" },
    { value: "41", label: "Mimaropa" },
    { value: "00", label: "National Capital Region (Metro Manila)" },
    { value: "10", label: "Northern Mindanao" },
    { value: "12", label: "Soccsksargen" },
    { value: "06", label: "Western Visayas" },
    { value: "09", label: "Zamboanga Peninsula" }
];
export const Philippines_Regions__ISO_3166_2_Dict: any = {
    "14": "Autonomous Region in Muslim Mindanao",
    "05": "Bicol Region",
    "02": "Cagayan Valley",
    "40": "Calabarzon",
    "13": "Caraga",
    "03": "Central Luzon",
    "07": "Central Visayas",
    "15": "Cordillera Administrative Region",
    "11": "Davao Region",
    "08": "Eastern Visayas",
    "01": "Ilocos Region",
    "41": "Mimaropa",
    "00": "National Capital Region (Metro Manila)",
    "10": "Northern Mindanao",
    "12": "Soccsksargen",
    "06": "Western Visayas",
    "09": "Zamboanga Peninsula"
};
export const ASIA_PAYEMNT__BANKS: any = [
    { "currency": "PHP", "value": "AGRB", "label": "Agribusiness Rural Bank" },
    { "currency": "PHP", "value": "ALIAGA", "label": "Aliaga Farmers Rural Bank" },
    { "currency": "PHP", "value": "ALLBANK", "label": "AllBank" },
    { "currency": "PHP", "value": "ARDCI", "label": "ARDCIBank" },
    { "currency": "PHP", "value": "ASPAC", "label": "ASPAC Rural Bank" },
    { "currency": "PHP", "value": "AURORA", "label": "AuroraBank" },
    { "currency": "PHP", "value": "BALANGA", "label": "Balanga Rural Bank" },
    {
        "currency": "PHP",
        "value": "BANKONE",
        "label": "Bank One Savings Corporation"
    },
    { "currency": "PHP", "value": "BANKWAYS", "label": "Bankways" },
    { "currency": "PHP", "value": "BATAAN", "label": "Bataan Development Bank" },
    { "currency": "PHP", "value": "BDO", "label": "BDO Unibank Inc." },
    { "currency": "PHP", "value": "BDON", "label": "BDO Network Bank" },
    { "currency": "PHP", "value": "BHF", "label": "BHF Rural Bank" },
    { "currency": "PHP", "value": "BOF", "label": "BOF" },
    { "currency": "PHP", "value": "BOM", "label": "Bank of Makati" },
    { "currency": "PHP", "value": "BPDB", "label": "BPI Direct BanKo" },
    {
        "currency": "PHP",
        "value": "BPI",
        "label": "Bank of the Philippine Islands (BPI)"
    },
    { "currency": "PHP", "value": "CAMALIG", "label": "Camalig Bank" },
    { "currency": "PHP", "value": "CANTILAN", "label": "Cantilan Bank" },
    { "currency": "PHP", "value": "CARD", "label": "CARD SME Bank" },
    { "currency": "PHP", "value": "CARDB", "label": "CARD Bank" },
    { "currency": "PHP", "value": "CBC", "label": "China Bank" },
    { "currency": "PHP", "value": "CBCS", "label": "China Bank Savings" },
    {
        "currency": "PHP",
        "value": "CENTURY",
        "label": "Century Savings Bank Corporation"
    },
    { "currency": "PHP", "value": "CITYSTATE", "label": "Citystate Savings Bank" },
    { "currency": "PHP", "value": "CORD", "label": "Cordillera Savings Bank" },
    { "currency": "PHP", "value": "CSB", "label": "City Savings Bank" },
    {
        "currency": "PHP",
        "value": "DBP",
        "label": "Development Bank of the Philippines"
    },
    { "currency": "PHP", "value": "DIPOLOG", "label": "Banco Dipolog" },
    {
        "currency": "PHP",
        "value": "DUM",
        "label": "Dumaguete City Development Bank"
    },
    { "currency": "PHP", "value": "EWRB", "label": "EastWest Rural Bank" },
    { "currency": "PHP", "value": "FCB", "label": "First Consolidated Bank" },
    { "currency": "PHP", "value": "HIYAS", "label": "Hiyas Banking Corporation" },
    {
        "currency": "PHP",
        "value": "HSBC",
        "label": "HSBC Savings Bank Philippines Inc."
    },
    { "currency": "PHP", "value": "ISLA", "label": "Isla Bank" },
    { "currency": "PHP", "value": "KABAYAN", "label": "Bangko Kabayan" },
    { "currency": "PHP", "value": "LAGUNA", "label": "Banco Laguna" },
    { "currency": "PHP", "value": "LBP", "label": "LANDBANK" },
    { "currency": "PHP", "value": "LEGAZPI", "label": "Legazpi Savings Bank" },
    {
        "currency": "PHP",
        "value": "LEMERY",
        "label": "Lemery Savings and Loan Bank"
    },
    { "currency": "PHP", "value": "LIFE", "label": "Life Savings Bank" },
    { "currency": "PHP", "value": "LUZON", "label": "Luzon Development Bank" },
    { "currency": "PHP", "value": "MABUHAY", "label": "Banco Mabuhay" },
    {
        "currency": "PHP",
        "value": "MAKILING",
        "label": "Makiling Development Bank Corporation"
    },
    { "currency": "PHP", "value": "MALAYAN", "label": "Malayan Savings Bank" },
    { "currency": "PHP", "value": "MBTC", "label": "Metrobank" },
    { "currency": "PHP", "value": "MEXICO", "label": "Banco Mexico" },
    { "currency": "PHP", "value": "NDB", "label": "NorthPoint Development Bank" },
    { "currency": "PHP", "value": "OFB", "label": "Overseas Filipino Bank" },
    { "currency": "PHP", "value": "PASB", "label": "Pacific Ace Savings Bank" },
    { "currency": "PHP", "value": "PBB", "label": "Philippine Business Bank" },
    { "currency": "PHP", "value": "PDB", "label": "Pampanga Development Bank" },
    { "currency": "PHP", "value": "PENBANK", "label": "Penbank" },
    { "currency": "PHP", "value": "PHIL", "label": "Phil Star Development Bank" },
    {
        "currency": "PHP",
        "value": "PNB",
        "label": "Philippine National Bank (PNB)"
    },
    {
        "currency": "PHP",
        "value": "PSB",
        "label": "Philippine Savings Bank (PSBank)"
    },
    {
        "currency": "PHP",
        "value": "PSBC",
        "label": "Producers Savings Bank Corporation"
    },
    {
        "currency": "PHP",
        "value": "QUEEN",
        "label": "Queen City Development Bank (QueenBank)"
    },
    { "currency": "PHP", "value": "QUEZON", "label": "Quezon Coconut Bank" },
    {
        "currency": "PHP",
        "value": "RCBC",
        "label": "Rizal Commercial Banking Corporation (RCBC)"
    },
    { "currency": "PHP", "value": "RIZAL", "label": "Rizal MicroBank" },
    { "currency": "PHP", "value": "SBA", "label": "Sterling Bank of Asia" },
    { "currency": "PHP", "value": "SBC", "label": "Security Bank" },
    { "currency": "PHP", "value": "SEABANK", "label": "Seabank Philippines" },
    { "currency": "PHP", "value": "SUN", "label": "Sun Savings Bank" },
    { "currency": "PHP", "value": "TONIK", "label": "Tonik Digital Bank" },
    { "currency": "PHP", "value": "UBP", "label": "UnionBank" },
    { "currency": "PHP", "value": "USB", "label": "University Savings Bank" },
    { "currency": "PHP", "value": "VALLEY", "label": "1st Valley Bank" },
    {
        "currency": "PHP",
        "value": "WDBC",
        "label": "Wealth Development Bank Corporation"
    },
    {
        "currency": "PHP",
        "value": "YUANTA",
        "label": "Yuanta Savings Bank Philippines"
    }
]
    ;
export const ASIA_PAYEMNT__BANKS_Dict: any = {
    "AGRB": "Agribusiness Rural Bank",
    "ALIAGA": "Aliaga Farmers Rural Bank",
    "ALLBANK": "AllBank",
    "ARDCI": "ARDCIBank",
    "ASPAC": "ASPAC Rural Bank",
    "AURORA": "AuroraBank",
    "BALANGA": "Balanga Rural Bank",
    "BANKONE": "Bank One Savings Corporation",
    "BANKWAYS": "Bankways",
    "BATAAN": "Bataan Development Bank",
    "BDO": "BDO Unibank Inc.",
    "BDON": "BDO Network Bank",
    "BHF": "BHF Rural Bank",
    "BOF": "BOF",
    "BOM": "Bank of Makati",
    "BPDB": "BPI Direct BanKo",
    "BPI": "Bank of the Philippine Islands (BPI)",
    "CAMALIG": "Camalig Bank",
    "CANTILAN": "Cantilan Bank",
    "CARD": "CARD SME Bank",
    "CARDB": "CARD Bank",
    "CBC": "China Bank",
    "CBCS": "China Bank Savings",
    "CENTURY": "Century Savings Bank Corporation",
    "CITYSTATE": "Citystate Savings Bank",
    "CORD": "Cordillera Savings Bank",
    "CSB": "City Savings Bank",
    "DBP": "Development Bank of the Philippines",
    "DIPOLOG": "Banco Dipolog",
    "DUM": "Dumaguete City Development Bank",
    "EWRB": "EastWest Rural Bank",
    "FCB": "First Consolidated Bank",
    "HIYAS": "Hiyas Banking Corporation",
    "HSBC": "HSBC Savings Bank Philippines Inc.",
    "ISLA": "Isla Bank",
    "KABAYAN": "Bangko Kabayan",
    "LAGUNA": "Banco Laguna",
    "LBP": "LANDBANK",
    "LEGAZPI": "Legazpi Savings Bank",
    "LEMERY": "Lemery Savings and Loan Bank",
    "LIFE": "Life Savings Bank",
    "LUZON": "Luzon Development Bank",
    "MABUHAY": "Banco Mabuhay",
    "MAKILING": "Makiling Development Bank Corporation",
    "MALAYAN": "Malayan Savings Bank",
    "MBTC": "Metrobank",
    "MEXICO": "Banco Mexico",
    "NDB": "NorthPoint Development Bank",
    "OFB": "Overseas Filipino Bank",
    "PASB": "Pacific Ace Savings Bank",
    "PBB": "Philippine Business Bank",
    "PDB": "Pampanga Development Bank",
    "PENBANK": "Penbank",
    "PHIL": "Phil Star Development Bank",
    "PNB": "Philippine National Bank (PNB)",
    "PSB": "Philippine Savings Bank (PSBank)",
    "PSBC": "Producers Savings Bank Corporation",
    "QUEEN": "Queen City Development Bank (QueenBank)",
    "QUEZON": "Quezon Coconut Bank",
    "RCBC": "Rizal Commercial Banking Corporation (RCBC)",
    "RIZAL": "Rizal MicroBank",
    "SBA": "Sterling Bank of Asia",
    "SBC": "Security Bank",
    "SEABANK": "Seabank Philippines",
    "SUN": "Sun Savings Bank",
    "TONIK": "Tonik Digital Bank",
    "UBP": "UnionBank",
    "USB": "University Savings Bank",
    "VALLEY": "1st Valley Bank",
    "WDBC": "Wealth Development Bank Corporation",
    "YUANTA": "Yuanta Savings Bank Philippines"
};
//#endregion
export function isMobileDevice() {
    try {
        if ((navigator as any)?.userAgentData?.mobile) {
            console.log("(navigator as any)?.userAgentData?.mobile")
            return true;
        }
        console.log("window.orientation", window.orientation)
        console.log(" /iPhone|iPad|iPod|Android|Mobi/i", /iPhone|iPad|iPod|Android|Mobi/i.test(navigator.userAgent))

        return (
            typeof window.orientation !== "undefined" ||
            /iPhone|iPad|iPod|Android|Mobi/i.test(navigator.userAgent)
        );
    } catch (e) {
        return false;
    }
}
export function getHourOffset(offsetMinutes: number) {
    try {
        if (!offsetMinutes) return '';
        return `(GMT${offsetMinutes / 60})`;
    } catch (e) {
        console.error("getHourOffset", e)
        return '';
    }
}
export const Unipayment_Networks = [
    {
        "value": "NETWORK_BTC",
        "label": "BTC",
    },
    {
        "value": "NETWORK_ETH",
        "label": "ETH",
    },
    {
        "value": "NETWORK_BSC",
        "label": "BSC",
    },
    {
        "value": "NETWORK_TRX",
        "label": "TRX",
    },
];
export const Unipayment_CRYPTO_CURRENCIES = [
    {
        "value": "BNB",
        "label": "BNB",
    },
    {
        "value": "BTC",
        "label": "Bitcoin",
    },
    {
        "value": "ETH",
        "label": "Ethereum",
    },
    {
        "value": "UCT",
        "label": "UCT",
    },
    {
        "value": "USDC",
        "label": "USD Coin",
    },
    {
        "value": "USDT",
        "label": "USDT",
    },
    {
        "value": "UTT",
        "label": "TestCoin",
    }
]
export const CasheerPay_PaymentOptions = [
    { label: "KNET-Core", value: "KWKNETDCCORE" },
    { label: "Credit Cards", value: "KWCYBERCC" },
];
export const BankAccountCurrencyList = [
    { value: 'AED', label: 'AED' },
    { value: 'AUD', label: 'AUD' },
    { value: 'USD', label: 'USD' },
    { value: 'CAD', label: 'CAD' },
    { value: 'CHF', label: 'CHF' },
    { value: 'EUR', label: 'EUR' },
    { value: 'HKD', label: 'HKD' },
    { value: 'GBP', label: 'GBP' },
    { value: 'SGD', label: 'SGD' },
    { value: 'MXN', label: 'MXN' },
    { value: 'THB', label: 'THB' },
    { value: 'IDR', label: 'IDR' },
    { value: 'MYR', label: 'MYR' },
    { value: 'PHP', label: 'PHP' },
    { value: 'VND', label: 'VND' },
];
export const OverChain_WITHDRAWAL_CRYPTO_CURRENCY = [
    { value: 'BTC', label: 'Bitcoin', network: 'Bitcoin' },
    { value: 'ETH', label: 'Ethereum', network: 'Ethereum' },
    { value: 'USDT-ERC20', label: 'Tether', network: 'Ethereum' },
    { value: 'USDC', label: 'USD Coin', network: 'Ethereum' },
    { value: 'USDT-TRC20', label: 'Tether', network: 'Tron' },
    { value: 'TRX', label: 'Tron', network: 'Tron' },
    { value: 'USDT-BEP20', label: 'Tether', network: 'BNB Chain' },
    { value: 'BNB', label: 'BNB', network: 'BNB Chain' },
    { value: 'LTC', label: 'Litecoin', network: 'Litecoin' },
] as const;